(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.it.b5 === region.ec.b5)
	{
		return 'on line ' + region.it.b5;
	}
	return 'on lines ' + region.it.b5 + ' through ' + region.ec.b5;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.g6,
		impl.i6,
		impl.iz,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		ht: func(record.ht),
		dL: record.dL,
		dw: record.dw
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.ht;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dL;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dw) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.g6,
		impl.i6,
		impl.iz,
		function(sendToApp, initialModel) {
			var view = impl.jb;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.g6,
		impl.i6,
		impl.iz,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dD && impl.dD(sendToApp)
			var view = impl.jb;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.aW);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.j) && (_VirtualDom_doc.title = title = doc.j);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.hN;
	var onUrlRequest = impl.hO;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dD: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eZ === next.eZ
							&& curr.et === next.et
							&& curr.eV.a === next.eV.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		g6: function(flags)
		{
			return A3(impl.g6, flags, _Browser_getUrl(), key);
		},
		jb: impl.jb,
		i6: impl.i6,
		iz: impl.iz
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { gW: 'hidden', gg: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { gW: 'mozHidden', gg: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { gW: 'msHidden', gg: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { gW: 'webkitHidden', gg: 'webkitvisibilitychange' }
		: { gW: 'hidden', gg: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fb: _Browser_getScene(),
		fw: {
			fD: _Browser_window.pageXOffset,
			jf: _Browser_window.pageYOffset,
			fA: _Browser_doc.documentElement.clientWidth,
			ep: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fA: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		ep: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fb: {
				fA: node.scrollWidth,
				ep: node.scrollHeight
			},
			fw: {
				fD: node.scrollLeft,
				jf: node.scrollTop,
				fA: node.clientWidth,
				ep: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fb: _Browser_getScene(),
			fw: {
				fD: x,
				jf: y,
				fA: _Browser_doc.documentElement.clientWidth,
				ep: _Browser_doc.documentElement.clientHeight
			},
			gC: {
				fD: x + rect.left,
				jf: y + rect.top,
				fA: rect.width,
				ep: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.a_.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.a_.b, xhr)); });
		$elm$core$Maybe$isJust(request.fq) && _Http_track(router, xhr, request.fq.a);

		try {
			xhr.open(request.eF, request.aH, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.aH));
		}

		_Http_configureRequest(xhr, request);

		request.aW.a && xhr.setRequestHeader('Content-Type', request.aW.a);
		xhr.send(request.aW.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.eo; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.fn.a || 0;
	xhr.responseType = request.a_.d;
	xhr.withCredentials = request.fR;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		aH: xhr.responseURL,
		iu: xhr.status,
		iv: xhr.statusText,
		eo: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			$8: event.loaded,
			il: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			hY: event.loaded,
			il: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\u000A    ',
		A2($elm$core$String$split, '\u000A', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\u000A\u000A(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\u0027' + (f + '\u0027]'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\u000A\u000A',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\u000A\u000A';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\u000A\u000A    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\u000A\u000A' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.D) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.J);
		} else {
			var treeLen = builder.D * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.M) : builder.M;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.D);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.J);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{M: nodeList, D: (len / $elm$core$Array$branchFactor) | 0, J: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ei: fragment, et: host, eS: path, eV: port_, eZ: protocol, e_: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$document = _Browser_document;
var $author$project$Ziege$Model$ErrorView = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ziege$Model$LoginMode = 2;
var $author$project$Ziege$Model$StartView = {$: 1};
var $author$project$Ziege$Model$Tick = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ziege$Model$Unloaded = {$: 0};
var $author$project$Ziege$Model$UpdateTimeZone = function (a) {
	return {$: 12, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$Date = $elm$core$Basics$identity;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$Day = $elm$core$Basics$identity;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$Year = $elm$core$Basics$identity;
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.it, posixMinutes) < 0) {
					return posixMinutes + era.hK;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		gu: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		hz: month,
		ji: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).gu;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hz;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ji;
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromPosix = function (posix) {
	return {
		gu: A2($elm$time$Time$toDay, $elm$time$Time$utc, posix),
		hz: A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix),
		ji: A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)
	};
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$fromPosix = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromPosix;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Ziege$Model$CryptoStarting = 0;
var $author$project$Ziege$Model$initialCryptoStatus = {d_: '', d0: false, gd: false, ed: '', bn: 0, e$: '', e0: false, i9: $elm$core$Maybe$Nothing};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Main$Flags = function (userId) {
	return function (deviceId) {
		return function (version) {
			return function (accountManagementUrl) {
				return function (rememberedRole) {
					return function (logo) {
						return function (roomVersions) {
							return function (clients) {
								return function (patternclientconfig) {
									return function (invitations) {
										return function (accessToken) {
											return function (notificationPermission) {
												return {a8: accessToken, a9: accountManagementUrl, c: clients, bY: deviceId, cD: invitations, al: logo, ay: notificationPermission, ap: patternclientconfig, e1: rememberedRole, aR: roomVersions, bu: userId, aI: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Ziege$PatternServerClient$PatternClientConfig = F4(
	function (url, ingesturl, favoriteurl, researchurl) {
		return {cy: favoriteurl, eu: ingesturl, e6: researchurl, aH: url};
	});
var $author$project$Main$RawFlags = F8(
	function (state, patternclientconfig, userId, deviceId, version, accessToken, notificationPermission, accountManagementUrl) {
		return {a8: accessToken, a9: accountManagementUrl, bY: deviceId, ay: notificationPermission, ap: patternclientconfig, bK: state, bu: userId, aI: version};
	});
var $author$project$Main$StoredState = F5(
	function (clients, invitations, role, logo, roomVersions) {
		return {c: clients, cD: invitations, al: logo, dB: role, aR: roomVersions};
	});
var $author$project$Ziege$TodoInterval$CompletionHistory = F2(
	function (start, completions) {
		return {cm: completions, it: start};
	});
var $author$project$Ziege$Model$ToDo = F7(
	function (name, title, completionHistory, interval, text, expires, id) {
		return {q: completionHistory, L: expires, bA: id, l: interval, I: name, K: text, j: title};
	});
var $author$project$Ziege$ModelEncodeDecode$dayNumberLimit = 1000000000;
var $author$project$Ziege$FastCalendar$millisPerDay = 86400000;
var $author$project$Ziege$FastCalendar$fromDayNumber = function (n) {
	return $PanagiotisGeorgiadis$elm_datetime$Calendar$fromPosix(
		$elm$time$Time$millisToPosix(n * $author$project$Ziege$FastCalendar$millisPerDay));
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Ziege$ModelEncodeDecode$decodeDate = A2(
	$elm$json$Json$Decode$map,
	function (n) {
		return (_Utils_cmp(n, $author$project$Ziege$ModelEncodeDecode$dayNumberLimit) < 0) ? $author$project$Ziege$FastCalendar$fromDayNumber(n) : $PanagiotisGeorgiadis$elm_datetime$Calendar$fromPosix(
			$elm$time$Time$millisToPosix(n));
	},
	$elm$json$Json$Decode$int);
var $author$project$Ziege$Pattern$Anytime = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ziege$Pattern$Day = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ziege$Pattern$Month = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ziege$Pattern$Week = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ziege$Pattern$Weekday = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ziege$Pattern$Weekend = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Ziege$ModelEncodeDecode$decodeInterval = function () {
	var decodeIntervalWithEveryAndTimes = function (base) {
		return A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (every, times) {
					return A2(base, every, times);
				}),
			A2($elm$json$Json$Decode$field, 'every', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'times', $elm$json$Json$Decode$int));
	};
	var decodeIntervalHelper = function (base) {
		switch (base) {
			case 'day':
				return decodeIntervalWithEveryAndTimes($author$project$Ziege$Pattern$Day);
			case 'week':
				return decodeIntervalWithEveryAndTimes($author$project$Ziege$Pattern$Week);
			case 'weekend':
				return decodeIntervalWithEveryAndTimes($author$project$Ziege$Pattern$Weekend);
			case 'weekday':
				return decodeIntervalWithEveryAndTimes($author$project$Ziege$Pattern$Weekday);
			case 'month':
				return decodeIntervalWithEveryAndTimes($author$project$Ziege$Pattern$Month);
			case 'anytime':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Ziege$Pattern$Anytime,
					A2($elm$json$Json$Decode$field, 'times', $elm$json$Json$Decode$int));
			default:
				return $elm$json$Json$Decode$fail('unknown base for interval');
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeIntervalHelper,
		A2($elm$json$Json$Decode$field, 'base', $elm$json$Json$Decode$string));
}();
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map8 = _Json_map8;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Ziege$ModelEncodeDecode$decodeTodo = function () {
	var makeTodo = F5(
		function (name, titel, completionStart, completions, interval) {
			return A4(
				$author$project$Ziege$Model$ToDo,
				A2($elm$core$Maybe$withDefault, '', name),
				titel,
				A2($author$project$Ziege$TodoInterval$CompletionHistory, completionStart, completions),
				interval);
		});
	return A9(
		$elm$json$Json$Decode$map8,
		makeTodo,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'titel', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'completionStart', $author$project$Ziege$ModelEncodeDecode$decodeDate),
		A2(
			$elm$json$Json$Decode$field,
			'completions',
			$elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeDate)),
		A2($elm$json$Json$Decode$field, 'interval', $author$project$Ziege$ModelEncodeDecode$decodeInterval),
		A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'expires', $author$project$Ziege$ModelEncodeDecode$decodeDate),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed('')
				])));
}();
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt = function (_v0) {
	var day = _v0;
	return day;
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getDay = function (_v0) {
	var date = _v0;
	return date.gu;
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$getDay = A2($elm$core$Basics$composeL, $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt, $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getDay);
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getMonth = function (_v0) {
	var month = _v0.hz;
	return month;
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$getMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getMonth;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getYear = function (_v0) {
	var year = _v0.ji;
	return year;
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt = function (_v0) {
	var year = _v0;
	return year;
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$getYear = A2($elm$core$Basics$composeL, $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt, $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getYear);
var $elm$core$Basics$modBy = _Basics_modBy;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$monthToInt = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$monthToInt;
var $author$project$Ziege$FastCalendar$dayNumber = function (date) {
	var month = $PanagiotisGeorgiadis$elm_datetime$Calendar$monthToInt(
		$PanagiotisGeorgiadis$elm_datetime$Calendar$getMonth(date));
	var year = (month <= 2) ? ($PanagiotisGeorgiadis$elm_datetime$Calendar$getYear(date) - 1) : $PanagiotisGeorgiadis$elm_datetime$Calendar$getYear(date);
	var era = (((year >= 0) ? year : (year - 399)) / 400) | 0;
	var yearOfEra = year - (era * 400);
	var dayOfYear = (((((153 * A2($elm$core$Basics$modBy, 12, month + 9)) + 2) / 5) | 0) + $PanagiotisGeorgiadis$elm_datetime$Calendar$getDay(date)) - 1;
	var dayOfEra = (((yearOfEra * 365) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0)) + dayOfYear;
	return ((era * 146097) + dayOfEra) - 719468;
};
var $author$project$Ziege$FastCalendar$toDayNumber = $author$project$Ziege$FastCalendar$dayNumber;
var $author$project$Ziege$ModelEncodeDecode$withTodoIds = function (todos) {
	var total = $elm$core$List$length(todos);
	var fill = F2(
		function (index, todo) {
			return $elm$core$String$isEmpty(todo.bA) ? _Utils_update(
				todo,
				{
					bA: todo.I + ('@' + ($elm$core$String$fromInt(
						$author$project$Ziege$FastCalendar$toDayNumber(todo.q.it)) + ('#' + $elm$core$String$fromInt(total - index))))
				}) : todo;
		});
	return A2($elm$core$List$indexedMap, fill, todos);
};
var $author$project$Ziege$ModelEncodeDecode$decodeClient = function () {
	var makeClient = F6(
		function (id, firstname, lastname, todos, roomid, note) {
			return {
				gL: '',
				c8: firstname,
				dn: lastname,
				m: id,
				eK: '',
				eL: '',
				b7: A2($elm$core$Maybe$withDefault, '', note),
				i: A2($elm$core$Maybe$withDefault, '', roomid),
				ih: false,
				v: todos
			};
		});
	return A7(
		$elm$json$Json$Decode$map6,
		makeClient,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'firstname', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'lastname', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'todos',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Ziege$ModelEncodeDecode$withTodoIds,
				$elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeTodo))),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string)),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'note', $elm$json$Json$Decode$string)));
}();
var $author$project$Ziege$ModelEncodeDecode$decodeClientList = $elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeClient);
var $author$project$Ziege$Model$NewClientInviteRecord = F7(
	function (id, invitation_id, invitation_uri, valid_until, username, note, qrCode) {
		return {bA: id, he: invitation_id, hf: invitation_uri, b7: note, hX: qrCode, i7: username, i8: valid_until};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Ziege$ModelEncodeDecode$decodeNewClientInviteRecord = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Ziege$Model$NewClientInviteRecord,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'invitation_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'invitation_uri', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$time$Time$millisToPosix,
		A2($elm$json$Json$Decode$field, 'valid_until', $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'username', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'note', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'qrCode', $elm$json$Json$Decode$string));
var $author$project$Ziege$Model$ClientMode = 0;
var $author$project$Ziege$Model$CounselorMode = 1;
var $author$project$Main$decodeRole = A2(
	$elm$json$Json$Decode$andThen,
	function (role) {
		switch (role) {
			case 'berater':
				return $elm$json$Json$Decode$succeed(1);
			case 'klient':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$fail('unbekannte Rolle ' + role);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Main$decodeState = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Main$StoredState,
	A2($elm$json$Json$Decode$field, 'clients', $author$project$Ziege$ModelEncodeDecode$decodeClientList),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(_List_Nil),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'invitations',
				$elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeNewClientInviteRecord)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'role', $author$project$Main$decodeRole)),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'logo', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'roomVersions',
				$elm$json$Json$Decode$dict(
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$string))),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			])));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Main$deocodePatternServerClientConfig = function (x) {
	return A5(
		$elm$json$Json$Decode$map4,
		x,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'ingesturl', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'favoriteurl', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'researchurl', $elm$json$Json$Decode$string));
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Main$decodeFlags = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Main$RawFlags,
	A2($elm$json$Json$Decode$field, 'state', $author$project$Main$decodeState),
	A2(
		$elm$json$Json$Decode$field,
		'patternclientconfig',
		$author$project$Main$deocodePatternServerClientConfig($author$project$Ziege$PatternServerClient$PatternClientConfig)),
	A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'deviceId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'access_token', $elm$json$Json$Decode$value),
	A2($elm$json$Json$Decode$field, 'notification_permission', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'accountManagementUrl', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			])));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Main$parseFlags = function (v) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$decodeFlags, v);
	if (!_v0.$) {
		var rawflags = _v0.a;
		return $elm$core$Result$Ok(
			$author$project$Main$Flags(rawflags.bu)(rawflags.bY)(rawflags.aI)(rawflags.a9)(rawflags.bK.dB)(rawflags.bK.al)(rawflags.bK.aR)(
				$elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (c) {
							return _Utils_Tuple2(c.m, c);
						},
						rawflags.bK.c)))(rawflags.ap)(rawflags.bK.cD)(rawflags.a8)(rawflags.ay));
	} else {
		var error = _v0.a;
		return $elm$core$Result$Err(
			'Daten kaputt: ' + $elm$json$Json$Decode$errorToString(error));
	}
};
var $author$project$Ziege$Model$ClientTodoList = {$: 0};
var $author$project$Ziege$Model$Client = function (matrixId) {
	return function (firstname) {
		return function (lastname) {
			return function (newToDoName) {
				return function (todos) {
					return function (newtoDoError) {
						return function (roomId) {
							return function (note) {
								return function (extraCounsellorMatrixId) {
									return function (severanceRequested) {
										return {gL: extraCounsellorMatrixId, c8: firstname, dn: lastname, m: matrixId, eK: newToDoName, eL: newtoDoError, b7: note, i: roomId, ih: severanceRequested, v: todos};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Main$updateActiveClientForClientMode = function (model) {
	var maybeSingleClient = $elm$core$List$head(
		$elm$core$Dict$toList(model.c));
	var maybeSingleClientID = A2(
		$elm$core$Maybe$map,
		function (thing) {
			return thing.a;
		},
		maybeSingleClient);
	if (!maybeSingleClientID.$) {
		var aClientID = maybeSingleClientID.a;
		return _Utils_update(
			model,
			{O: aClientID});
	} else {
		return _Utils_update(
			model,
			{
				O: model.n,
				c: A2(
					$elm$core$Dict$singleton,
					model.n,
					$author$project$Ziege$Model$Client(model.n)('')('')('')(_List_Nil)('')('')('')('')(false))
			});
	}
};
var $author$project$Main$startIn = F2(
	function (mode, model) {
		if (!mode) {
			return $author$project$Main$updateActiveClientForClientMode(
				_Utils_update(
					model,
					{f: $author$project$Ziege$Model$ClientTodoList, g: 0}));
		} else {
			return _Utils_update(
				model,
				{g: mode});
		}
	});
var $author$project$Ziege$FastCalendar$toMillis = function (date) {
	return $author$project$Ziege$FastCalendar$dayNumber(date) * $author$project$Ziege$FastCalendar$millisPerDay;
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Main$init = function (flags) {
	var parseResult = $author$project$Main$parseFlags(flags);
	var roomVersions = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.aR;
		} else {
			return $elm$core$Dict$empty;
		}
	}();
	var startMode = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return A2($elm$core$Maybe$withDefault, 2, flg.e1);
		} else {
			return 2;
		}
	}();
	var version = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.aI;
		} else {
			return '';
		}
	}();
	var ownUserId = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.bu;
		} else {
			var s = parseResult.a;
			return s;
		}
	}();
	var ownDeviceId = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.bY;
		} else {
			return '';
		}
	}();
	var notificationPermission = function () {
		if (!parseResult.$) {
			var r = parseResult.a;
			return r.ay;
		} else {
			return '';
		}
	}();
	var logo = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.al;
		} else {
			return '';
		}
	}();
	var initialAccessToken = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.a8;
		} else {
			return $elm$json$Json$Encode$null;
		}
	}();
	var clients = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.c;
		} else {
			return $elm$core$Dict$empty;
		}
	}();
	var lastStart = A2(
		$elm$core$Maybe$map,
		$elm$time$Time$millisToPosix,
		$elm$core$List$maximum(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.q;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.it;
						},
						$author$project$Ziege$FastCalendar$toMillis)),
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.v;
						},
						$elm$core$Dict$values(clients))))));
	var activeView = function () {
		if (!parseResult.$) {
			return $author$project$Ziege$Model$StartView;
		} else {
			var s = parseResult.a;
			return A2($author$project$Ziege$Model$ErrorView, s, true);
		}
	}();
	var accountManagementUrl = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return flg.a9;
		} else {
			return '';
		}
	}();
	var _v0 = function () {
		if (!parseResult.$) {
			var flg = parseResult.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(flg.ap),
				flg.cD);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
		}
	}();
	var patternclientconfig = _v0.a;
	return _Utils_Tuple2(
		A2(
			$author$project$Main$startIn,
			startMode,
			{
				aJ: false,
				a8: initialAccessToken,
				a9: accountManagementUrl,
				O: '',
				f: activeView,
				g: 2,
				c: clients,
				bd: false,
				aZ: false,
				aM: $author$project$Ziege$Model$initialCryptoStatus,
				c3: _List_Nil,
				aN: $elm$core$Dict$empty,
				ab: $elm$core$Set$empty,
				bg: false,
				b3: $elm$core$Maybe$Nothing,
				b4: $elm$core$Dict$empty,
				al: logo,
				bB: false,
				bC: $elm$core$Maybe$Nothing,
				bE: '',
				bF: '',
				hC: '',
				bk: '',
				ay: notificationPermission,
				bG: $elm$core$Set$empty,
				cG: ownDeviceId,
				n: ownUserId,
				ap: patternclientconfig,
				N: $author$project$Ziege$Model$Unloaded,
				bH: '',
				bp: _List_Nil,
				aQ: $elm$core$Dict$empty,
				aR: roomVersions,
				cO: false,
				bL: true,
				bM: A2(
					$elm$core$Maybe$withDefault,
					$elm$time$Time$millisToPosix(1656778788892),
					lastStart),
				cR: $elm$time$Time$utc,
				af: $PanagiotisGeorgiadis$elm_datetime$Calendar$fromPosix(
					A2(
						$elm$core$Maybe$withDefault,
						$elm$time$Time$millisToPosix(1656778788892),
						lastStart)),
				cU: false,
				aI: version,
				cf: $elm$core$Maybe$Nothing
			}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Ziege$Model$Tick, $elm$time$Time$now),
					A2($elm$core$Task$perform, $author$project$Ziege$Model$UpdateTimeZone, $elm$time$Time$here)
				])));
};
var $author$project$Ziege$Model$BrowserNavigated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ziege$Model$MatrixError = function (a) {
	return {$: 36, a: a};
};
var $author$project$Ziege$Model$MatrixLeaveRoom = function (a) {
	return {$: 55, a: a};
};
var $author$project$Ziege$Model$MatrixStatusUpdate = function (a) {
	return {$: 42, a: a};
};
var $author$project$Ziege$Model$ReceivedAccessToken = function (a) {
	return {$: 43, a: a};
};
var $author$project$Ziege$Model$ReceivedCryptoStatus = function (a) {
	return {$: 57, a: a};
};
var $author$project$Ziege$Model$ReceivedDecryptionProblems = function (a) {
	return {$: 68, a: a};
};
var $author$project$Ziege$Model$ReceivedDevices = function (a) {
	return {$: 72, a: a};
};
var $author$project$Ziege$Model$ReceivedRoomInvites = function (a) {
	return {$: 64, a: a};
};
var $author$project$Ziege$Model$ReceivedRoomMembership = function (a) {
	return {$: 66, a: a};
};
var $author$project$Ziege$Model$ResendRoomState = function (a) {
	return {$: 69, a: a};
};
var $author$project$Ziege$Model$RoomGone = function (a) {
	return {$: 38, a: a};
};
var $author$project$Ziege$Model$StatusSize = function (a) {
	return {$: 37, a: a};
};
var $author$project$Ziege$Model$UpdateNotificationPermission = function (a) {
	return {$: 74, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ziege$NavigationPort$browserNavigated = _Platform_incomingPort('browserNavigated', $elm$json$Json$Decode$int);
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {eY: processes, fl: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.eY;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.fl);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Ziege$MatrixPort$notificationPermissionChanged = _Platform_incomingPort('notificationPermissionChanged', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveAccessToken = _Platform_incomingPort('receiveAccessToken', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveCryptoStatus = _Platform_incomingPort('receiveCryptoStatus', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveDecryptionProblems = _Platform_incomingPort('receiveDecryptionProblems', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveDevices = _Platform_incomingPort('receiveDevices', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveMatrixError = _Platform_incomingPort('receiveMatrixError', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveRoomGone = _Platform_incomingPort('receiveRoomGone', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveRoomInvites = _Platform_incomingPort('receiveRoomInvites', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveRoomMembership = _Platform_incomingPort('receiveRoomMembership', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveRoomSeverance = _Platform_incomingPort('receiveRoomSeverance', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveStatusSize = _Platform_incomingPort('receiveStatusSize', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$receiveStatusUpdate = _Platform_incomingPort('receiveStatusUpdate', $elm$json$Json$Decode$value);
var $author$project$Ziege$MatrixPort$resendRoomState = _Platform_incomingPort('resendRoomState', $elm$json$Json$Decode$string);
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.bL ? A2($elm$time$Time$every, 1000, $author$project$Ziege$Model$Tick) : $elm$core$Platform$Sub$none,
				$author$project$Ziege$MatrixPort$receiveMatrixError($author$project$Ziege$Model$MatrixError),
				$author$project$Ziege$MatrixPort$receiveStatusUpdate($author$project$Ziege$Model$MatrixStatusUpdate),
				$author$project$Ziege$MatrixPort$receiveStatusSize($author$project$Ziege$Model$StatusSize),
				$author$project$Ziege$MatrixPort$receiveRoomGone($author$project$Ziege$Model$RoomGone),
				$author$project$Ziege$MatrixPort$receiveRoomSeverance($author$project$Ziege$Model$MatrixLeaveRoom),
				$author$project$Ziege$MatrixPort$receiveAccessToken($author$project$Ziege$Model$ReceivedAccessToken),
				$author$project$Ziege$MatrixPort$receiveCryptoStatus($author$project$Ziege$Model$ReceivedCryptoStatus),
				$author$project$Ziege$MatrixPort$receiveRoomInvites($author$project$Ziege$Model$ReceivedRoomInvites),
				$author$project$Ziege$MatrixPort$receiveRoomMembership($author$project$Ziege$Model$ReceivedRoomMembership),
				$author$project$Ziege$MatrixPort$receiveDecryptionProblems($author$project$Ziege$Model$ReceivedDecryptionProblems),
				$author$project$Ziege$MatrixPort$resendRoomState($author$project$Ziege$Model$ResendRoomState),
				$author$project$Ziege$MatrixPort$receiveDevices($author$project$Ziege$Model$ReceivedDevices),
				$author$project$Ziege$MatrixPort$notificationPermissionChanged($author$project$Ziege$Model$UpdateNotificationPermission),
				$author$project$Ziege$NavigationPort$browserNavigated($author$project$Ziege$Model$BrowserNavigated)
			]));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Ziege$NavigationPort$navigateTo = _Platform_outgoingPort('navigateTo', $elm$json$Json$Encode$int);
var $author$project$Main$pageDepth = function (model) {
	var _v0 = _Utils_Tuple2(model.g, model.f);
	_v0$7:
	while (true) {
		switch (_v0.b.$) {
			case 1:
				var _v1 = _v0.b;
				return 0;
			case 4:
				var _v2 = _v0.b;
				return 0;
			case 2:
				if (_v0.a === 1) {
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					return 1;
				} else {
					break _v0$7;
				}
			case 5:
				if (_v0.a === 1) {
					var _v7 = _v0.a;
					return 3;
				} else {
					break _v0$7;
				}
			case 0:
				if (_v0.a === 1) {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return 1;
				} else {
					var _v9 = _v0.b;
					return 0;
				}
			default:
				if (_v0.a === 1) {
					var _v8 = _v0.a;
					return 2;
				} else {
					break _v0$7;
				}
		}
	}
	return 1;
};
var $author$project$Main$navigationDepth = function (model) {
	return $author$project$Main$pageDepth(model) + (model.aJ ? 1 : 0);
};
var $author$project$Ziege$Model$AddPendingTodoWithId = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Ziege$Model$DevicesLoading = {$: 0};
var $author$project$Ziege$Editor$EPlaceholder = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ziege$Model$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ziege$Model$Loadfail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ziege$Model$PatternEditorView = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ziege$Model$PatternSelectorView = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Main$addFavorite = F2(
	function (name, m) {
		return _Utils_update(
			m,
			{
				ab: A2(
					$elm$core$Set$insert,
					$elm$core$String$trim(name),
					m.ab)
			});
	});
var $author$project$Ziege$Model$FavoritesReceived = F2(
	function (a, b) {
		return {$: 47, a: a, b: b};
	});
var $author$project$Main$getAccessToken = function (model) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'access_token', $elm$json$Json$Decode$string),
		model.a8);
	if (!_v0.$) {
		var s = _v0.a;
		return s;
	} else {
		return '';
	}
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.iu));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $author$project$Ziege$PatternServerClient$favoritesDecoder = A2(
	$elm$json$Json$Decode$field,
	'favorites',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {e4: reqs, fk: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.fq;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.e4));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fk)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					fR: r.fR,
					aW: r.aW,
					a_: A2(_Http_mapExpect, func, r.a_),
					eo: r.eo,
					eF: r.eF,
					fn: r.fn,
					fq: r.fq,
					aH: r.aH
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{fR: false, aW: r.aW, a_: r.a_, eo: r.eo, eF: r.eF, fn: r.fn, fq: r.fq, aH: r.aH}));
};
var $author$project$Ziege$PatternServerClient$jsonRequest = F2(
	function (method, _v0) {
		var expect = _v0.a_;
		var body = _v0.aW;
		var url = _v0.aH;
		return $elm$http$Http$request(
			{aW: body, a_: expect, eo: _List_Nil, eF: method, fn: $elm$core$Maybe$Nothing, fq: $elm$core$Maybe$Nothing, aH: url});
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ziege$PatternServerClient$sendAddFavorite = F5(
	function (config, mid, accessToken, patternName, msg) {
		return A2(
			$author$project$Ziege$PatternServerClient$jsonRequest,
			'POST',
			{
				aW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pattern_name',
								$elm$json$Json$Encode$string(patternName)),
								_Utils_Tuple2(
								'matrix_id',
								$elm$json$Json$Encode$string(mid)),
								_Utils_Tuple2(
								'access_token',
								$elm$json$Json$Encode$string(accessToken))
							]))),
				a_: A2($elm$http$Http$expectJson, msg, $author$project$Ziege$PatternServerClient$favoritesDecoder),
				aH: config.cy
			});
	});
var $author$project$Main$addFavoriteToPatternServer = F2(
	function (model, patternName) {
		var _v0 = model.ap;
		if (!_v0.$) {
			var pcc = _v0.a;
			return A5(
				$author$project$Ziege$PatternServerClient$sendAddFavorite,
				pcc,
				model.n,
				$author$project$Main$getAccessToken(model),
				patternName,
				$author$project$Ziege$Model$FavoritesReceived(model.ab));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Ziege$TodoInterval$addCompletion = F2(
	function (d, h) {
		return _Utils_update(
			h,
			{
				cm: A2($elm$core$List$cons, d, h.cm)
			});
	});
var $author$project$Main$addTodoCompletion = F3(
	function (today, todoId, client) {
		var complete = function (todo) {
			return _Utils_eq(todo.bA, todoId) ? _Utils_update(
				todo,
				{
					q: A2($author$project$Ziege$TodoInterval$addCompletion, today, todo.q)
				}) : todo;
		};
		return _Utils_update(
			client,
			{
				v: A2($elm$core$List$map, complete, client.v)
			});
	});
var $author$project$Ziege$MatrixPort$answerRoomInvite = _Platform_outgoingPort('answerRoomInvite', $elm$core$Basics$identity);
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Main$NextUpdateInfo = F3(
	function (begin, end, title) {
		return {d1: begin, ec: end, j: title};
	});
var $author$project$Ziege$TodoInterval$DateInterval = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ziege$TodoInterval$isWeekdayNumber = function (n) {
	return A2($elm$core$Basics$modBy, 7, n + 3) < 5;
};
var $author$project$Ziege$TodoInterval$addWeekdays = F2(
	function (from, count) {
		var step = F2(
			function (d, left) {
				step:
				while (true) {
					if (!left) {
						return d;
					} else {
						if ($author$project$Ziege$TodoInterval$isWeekdayNumber(d + 1)) {
							var $temp$d = d + 1,
								$temp$left = left - 1;
							d = $temp$d;
							left = $temp$left;
							continue step;
						} else {
							var $temp$d = d + 1,
								$temp$left = left;
							d = $temp$d;
							left = $temp$left;
							continue step;
						}
					}
				}
			});
		return A2(
			step,
			from + (((count / 5) | 0) * 7),
			A2($elm$core$Basics$modBy, 5, count));
	});
var $author$project$Ziege$FastCalendar$decrementDay = function (date) {
	return $author$project$Ziege$FastCalendar$fromDayNumber(
		$author$project$Ziege$FastCalendar$dayNumber(date) - 1);
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Basics$not = _Basics_not;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$isLeapYear = function (_v0) {
	var _int = _v0;
	return (!A2($elm$core$Basics$modBy, 4, _int)) && ((!A2($elm$core$Basics$modBy, 400, _int)) || (!(!A2($elm$core$Basics$modBy, 100, _int))));
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf = F2(
	function (year, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$isLeapYear(year) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayFromInt = F3(
	function (year, month, day) {
		var maxValidDay = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt(
			A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, year, month));
		return ((day > 0) && (A2($elm$core$Basics$compare, day, maxValidDay) !== 2)) ? $elm$core$Maybe$Just(day) : $elm$core$Maybe$Nothing;
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays = F2(
	function (lhs, rhs) {
		return A2(
			$elm$core$Basics$compare,
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt(lhs),
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt(rhs));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromYearMonthDay = F3(
	function (y, m, d) {
		var maxDay = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, y, m);
		var _v0 = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays, d, maxDay);
		if (_v0 === 2) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(
				{gu: d, hz: m, ji: y});
		}
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromRawDay = F3(
	function (year, month, day) {
		return A2(
			$elm$core$Maybe$andThen,
			A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromYearMonthDay, year, month),
			A3($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayFromInt, year, month, day));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearFromInt = function (year) {
	return (year > 0) ? $elm$core$Maybe$Just(year) : $elm$core$Maybe$Nothing;
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromRawParts = function (_v0) {
	var day = _v0.gu;
	var month = _v0.hz;
	var year = _v0.ji;
	return A2(
		$elm$core$Maybe$andThen,
		function (y) {
			return A3($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromRawDay, y, month, day);
		},
		$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearFromInt(year));
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$fromRawParts = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromRawParts;
var $author$project$Ziege$TodoInterval$monthFromIndex = function (i) {
	switch (i) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		default:
			return 11;
	}
};
var $author$project$Ziege$TodoInterval$firstOfMonth = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Ziege$FastCalendar$fromDayNumber(0),
		$PanagiotisGeorgiadis$elm_datetime$Calendar$fromRawParts(
			{
				gu: 1,
				hz: $author$project$Ziege$TodoInterval$monthFromIndex(
					A2($elm$core$Basics$modBy, 12, index)),
				ji: (index / 12) | 0
			}));
};
var $author$project$Ziege$TodoInterval$firstWeekdayFrom = function (n) {
	firstWeekdayFrom:
	while (true) {
		if ($author$project$Ziege$TodoInterval$isWeekdayNumber(n)) {
			return n;
		} else {
			var $temp$n = n + 1;
			n = $temp$n;
			continue firstWeekdayFrom;
		}
	}
};
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $author$project$Ziege$FastCalendar$getWeekday = function (date) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		7,
		$author$project$Ziege$FastCalendar$dayNumber(date));
	switch (_v0) {
		case 0:
			return 3;
		case 1:
			return 4;
		case 2:
			return 5;
		case 3:
			return 6;
		case 4:
			return 0;
		case 5:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Ziege$Utils$gotoWeekday = F4(
	function (stepper, wd, forceGo, date) {
		gotoWeekday:
		while (true) {
			if (_Utils_eq(
				wd,
				$author$project$Ziege$FastCalendar$getWeekday(date)) && (!forceGo)) {
				return date;
			} else {
				var $temp$stepper = stepper,
					$temp$wd = wd,
					$temp$forceGo = false,
					$temp$date = stepper(date);
				stepper = $temp$stepper;
				wd = $temp$wd;
				forceGo = $temp$forceGo;
				date = $temp$date;
				continue gotoWeekday;
			}
		}
	});
var $author$project$Ziege$Utils$lastWeekday = F3(
	function (wd, alwaysPast, date) {
		return A4($author$project$Ziege$Utils$gotoWeekday, $author$project$Ziege$FastCalendar$decrementDay, wd, alwaysPast, date);
	});
var $author$project$Ziege$Utils$lastMonday = A2($author$project$Ziege$Utils$lastWeekday, 0, false);
var $author$project$Ziege$TodoInterval$monthIndex = function (d) {
	return (($PanagiotisGeorgiadis$elm_datetime$Calendar$getYear(d) * 12) + $PanagiotisGeorgiadis$elm_datetime$Calendar$monthToInt(
		$PanagiotisGeorgiadis$elm_datetime$Calendar$getMonth(d))) - 1;
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Ziege$TodoInterval$weekdaysBetween = F2(
	function (from, to) {
		var weeks = ((to - from) / 7) | 0;
		var rest = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$author$project$Ziege$TodoInterval$isWeekdayNumber,
				A2($elm$core$List$range, from + (weeks * 7), to - 1)));
		return (weeks * 5) + rest;
	});
var $author$project$Ziege$TodoInterval$periodAt = F3(
	function (interval, start, day) {
		var t = $author$project$Ziege$FastCalendar$toDayNumber(day);
		var weekBlockStart = function (every) {
			var length = 7 * A2($elm$core$Basics$max, 1, every);
			var firstMonday = $author$project$Ziege$FastCalendar$toDayNumber(
				$author$project$Ziege$Utils$lastMonday(start));
			return firstMonday + ((((t - firstMonday) / length) | 0) * length);
		};
		var span = F2(
			function (from, length) {
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Ziege$TodoInterval$DateInterval,
						$author$project$Ziege$FastCalendar$fromDayNumber(from),
						$author$project$Ziege$FastCalendar$fromDayNumber((from + length) - 1)));
			});
		var s = $author$project$Ziege$FastCalendar$toDayNumber(start);
		if (_Utils_cmp(t, s) < 0) {
			return $elm$core$Maybe$Nothing;
		} else {
			switch (interval.$) {
				case 0:
					var every = interval.a;
					var length = A2($elm$core$Basics$max, 1, every);
					return A2(span, s + ((((t - s) / length) | 0) * length), length);
				case 1:
					var every = interval.a;
					return A2(
						span,
						weekBlockStart(every),
						7 * A2($elm$core$Basics$max, 1, every));
				case 3:
					var every = interval.a;
					var saturday = weekBlockStart(every) + 5;
					return ((_Utils_cmp(t, saturday) > -1) && (_Utils_cmp(t, saturday + 1) < 1)) ? A2(span, saturday, 2) : $elm$core$Maybe$Nothing;
				case 2:
					var every = interval.a;
					if ($author$project$Ziege$TodoInterval$isWeekdayNumber(t)) {
						var length = A2($elm$core$Basics$max, 1, every);
						var first = $author$project$Ziege$TodoInterval$firstWeekdayFrom(s);
						var blockStart = A2(
							$author$project$Ziege$TodoInterval$addWeekdays,
							first,
							((A2($author$project$Ziege$TodoInterval$weekdaysBetween, first, t) / length) | 0) * length);
						return $elm$core$Maybe$Just(
							A2(
								$author$project$Ziege$TodoInterval$DateInterval,
								$author$project$Ziege$FastCalendar$fromDayNumber(blockStart),
								$author$project$Ziege$FastCalendar$fromDayNumber(
									A2($author$project$Ziege$TodoInterval$addWeekdays, blockStart, length - 1))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				case 4:
					var every = interval.a;
					var length = A2($elm$core$Basics$max, 1, every);
					var first = $author$project$Ziege$TodoInterval$monthIndex(start);
					var block = first + (((($author$project$Ziege$TodoInterval$monthIndex(day) - first) / length) | 0) * length);
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Ziege$TodoInterval$DateInterval,
							$author$project$Ziege$TodoInterval$firstOfMonth(block),
							$author$project$Ziege$FastCalendar$decrementDay(
								$author$project$Ziege$TodoInterval$firstOfMonth(block + length))));
				default:
					return $elm$core$Maybe$Just(
						A2($author$project$Ziege$TodoInterval$DateInterval, start, day));
			}
		}
	});
var $author$project$Ziege$TodoInterval$currentDueInterval = F3(
	function (interval, history, today) {
		return A3($author$project$Ziege$TodoInterval$periodAt, interval, history.it, today);
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareMonths = F2(
	function (lhs, rhs) {
		return A2(
			$elm$core$Basics$compare,
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$monthToInt(lhs),
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$monthToInt(rhs));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareYears = F2(
	function (lhs, rhs) {
		return A2(
			$elm$core$Basics$compare,
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(lhs),
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(rhs));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compare = F2(
	function (lhs, rhs) {
		var _v0 = _Utils_Tuple3(
			A2(
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareYears,
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getYear(lhs),
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getYear(rhs)),
			A2(
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareMonths,
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getMonth(lhs),
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getMonth(rhs)),
			A2(
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays,
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getDay(lhs),
				$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getDay(rhs)));
		var yearsComparison = _v0.a;
		var monthsComparison = _v0.b;
		var daysComparison = _v0.c;
		if (yearsComparison === 1) {
			if (monthsComparison === 1) {
				return daysComparison;
			} else {
				return monthsComparison;
			}
		} else {
			return yearsComparison;
		}
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$compare = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compare;
var $author$project$Ziege$TodoInterval$inInterval = F2(
	function (_v0, d) {
		var start = _v0.a;
		var end = _v0.b;
		return (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, d) !== 2) && (!(!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, end, d)));
	});
var $author$project$Ziege$TodoInterval$currentCompletions = F3(
	function (today, interval, history) {
		var _v0 = A3($author$project$Ziege$TodoInterval$currentDueInterval, interval, history, today);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var itvl = _v0.a;
			return A2(
				$elm$core$List$filter,
				$author$project$Ziege$TodoInterval$inInterval(itvl),
				history.cm);
		}
	});
var $author$project$Ziege$TodoInterval$timesToBeDone = function (interval) {
	switch (interval.$) {
		case 0:
			var times = interval.b;
			return times;
		case 1:
			var times = interval.b;
			return times;
		case 3:
			var times = interval.b;
			return times;
		case 2:
			var times = interval.b;
			return times;
		case 5:
			var times = interval.a;
			return times;
		default:
			var times = interval.b;
			return times;
	}
};
var $author$project$Ziege$TodoInterval$isDone = F3(
	function (today, interval, history) {
		var severalDays = function () {
			var _v0 = A3($author$project$Ziege$TodoInterval$currentDueInterval, interval, history, today);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var first = _v1.a;
				var last = _v1.b;
				return A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, first, last) !== 1;
			} else {
				return false;
			}
		}();
		var completions = A3($author$project$Ziege$TodoInterval$currentCompletions, today, interval, history);
		var tickedToday = A2(
			$elm$core$List$any,
			function (d) {
				return A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, today, d) === 1;
			},
			completions);
		return (_Utils_cmp(
			$elm$core$List$length(completions),
			$author$project$Ziege$TodoInterval$timesToBeDone(interval)) > -1) || (tickedToday && severalDays);
	});
var $author$project$Ziege$TodoInterval$isDoneToday = F3(
	function (today, interval, history) {
		return A2(
			$elm$core$List$any,
			function (d) {
				return A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, today, d) === 1;
			},
			A3($author$project$Ziege$TodoInterval$currentCompletions, today, interval, history)) && A3($author$project$Ziege$TodoInterval$isDone, today, interval, history);
	});
var $author$project$Main$isDoneTodayToDo = F2(
	function (today, todo) {
		return A3($author$project$Ziege$TodoInterval$isDoneToday, today, todo.l, todo.q);
	});
var $author$project$Ziege$TodoInterval$isDue = F3(
	function (today, interval, history) {
		var _v0 = A3($author$project$Ziege$TodoInterval$currentDueInterval, interval, history, today);
		if (_v0.$ === 1) {
			return false;
		} else {
			return !A3($author$project$Ziege$TodoInterval$isDone, today, interval, history);
		}
	});
var $author$project$Main$calcNextUpdate = function (m) {
	var _v0 = $elm$core$List$head(
		$elm$core$Dict$values(m.c));
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var aClient = _v0.a;
		var today = m.af;
		var massageTodo = function (x) {
			var cdi = A3($author$project$Ziege$TodoInterval$currentDueInterval, x.l, x.q, today);
			if (cdi.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = cdi.a;
				var intervalStart = _v2.a;
				var intervalEnd = _v2.b;
				return $elm$core$Maybe$Just(
					A3(
						$author$project$Main$NextUpdateInfo,
						$author$project$Ziege$FastCalendar$toMillis(intervalStart),
						$author$project$Ziege$FastCalendar$toMillis(intervalEnd),
						x.j));
			}
		};
		var dueTodos = A2(
			$elm$core$List$filter,
			function (x) {
				return (!A2($author$project$Main$isDoneTodayToDo, today, x)) && A3($author$project$Ziege$TodoInterval$isDue, today, x.l, x.q);
			},
			aClient.v);
		return A2($elm$core$List$filterMap, massageTodo, dueTodos);
	}
};
var $author$project$Ziege$Editor$EDay = 0;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$rollMonthForward = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 0;
	}
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$incrementMonth = function (_v0) {
	var date = _v0;
	var updatedMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$rollMonthForward(date.hz);
	var updatedYear = function () {
		if (!updatedMonth) {
			return $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(date.ji) + 1;
		} else {
			return date.ji;
		}
	}();
	var lastDayOfUpdatedMonth = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, updatedYear, updatedMonth);
	var updatedDay = function () {
		var _v1 = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays, date.gu, lastDayOfUpdatedMonth);
		if (_v1 === 2) {
			return lastDayOfUpdatedMonth;
		} else {
			return date.gu;
		}
	}();
	return {gu: updatedDay, hz: updatedMonth, ji: updatedYear};
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$incrementMonth;
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $author$project$Main$createPendingTodo = F2(
	function (now, today) {
		return {
			cn: '',
			co: '',
			cp: '',
			U: {aV: 0, av: 1, a5: 1},
			L: $PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth(today),
			b_: true,
			b0: true,
			b1: false,
			b2: false,
			I: 'custom' + $elm$core$String$fromInt(
				A2($elm$time$Time$toMillis, $elm$time$Time$utc, now)),
			ao: $elm$core$Maybe$Nothing,
			K: _List_fromArray(
				[
					A2($author$project$Ziege$Editor$EPlaceholder, 'Beschreibung', '')
				]),
			j: '\u000A'
		};
	});
var $author$project$Ziege$Model$DecryptionProblem = F4(
	function (roomId, sender, senderName, kind) {
		return {hk: kind, i: roomId, id: sender, ie: senderName};
	});
var $author$project$Ziege$Model$MissingKey = 2;
var $author$project$Ziege$Model$OwnUnverified = 1;
var $author$project$Ziege$Model$SenderUnverified = 0;
var $author$project$Ziege$ModelEncodeDecode$decodeDecryptionProblem = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Ziege$Model$DecryptionProblem,
	A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'sender', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'sendername', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		function (kind) {
			switch (kind) {
				case 'sender_unverified':
					return 0;
				case 'own_unverified':
					return 1;
				default:
					return 2;
			}
		},
		A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string)));
var $author$project$Ziege$Model$DeviceInfo = F3(
	function (deviceId, name, verified) {
		return {bY: deviceId, I: name, ja: verified};
	});
var $author$project$Ziege$Model$DevicesFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ziege$Model$DevicesLoaded = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Ziege$ModelEncodeDecode$decodeDevices = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'userid', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Ziege$Model$DevicesFailed,
				A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Ziege$Model$DevicesLoaded,
				A2(
					$elm$json$Json$Decode$field,
					'devices',
					$elm$json$Json$Decode$list(
						A4(
							$elm$json$Json$Decode$map3,
							$author$project$Ziege$Model$DeviceInfo,
							A2($elm$json$Json$Decode$field, 'deviceid', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'verified', $elm$json$Json$Decode$bool)))))
			])));
var $author$project$Ziege$MatrixPort$DecodedRoomMessage = F4(
	function (roomid, userid, payload, staffed) {
		return {b8: payload, cI: roomid, is: staffed, dN: userid};
	});
var $author$project$Ziege$MatrixPort$decodeMessage = function (v) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A5(
			$elm$json$Json$Decode$map4,
			$author$project$Ziege$MatrixPort$DecodedRoomMessage,
			A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'userid', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$value),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'staffed', $elm$json$Json$Decode$bool),
						$elm$json$Json$Decode$succeed(true)
					]))),
		v);
	if (!_v0.$) {
		var x = _v0.a;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ziege$Model$RoomInvite = F3(
	function (roomId, inviter, inviterName) {
		return {hg: inviter, hh: inviterName, i: roomId};
	});
var $author$project$Ziege$ModelEncodeDecode$decodeRoomInvite = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Ziege$Model$RoomInvite,
	A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'inviter', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'invitername', $elm$json$Json$Decode$string));
var $author$project$Ziege$Model$RoomMembership = F3(
	function (userId, name, membership) {
		return {bj: membership, I: name, bu: userId};
	});
var $author$project$Ziege$ModelEncodeDecode$decodeRoomMembership = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'members',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Ziege$Model$RoomMembership,
				A2($elm$json$Json$Decode$field, 'userid', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'userid', $elm$json$Json$Decode$string)
						])),
				A2($elm$json$Json$Decode$field, 'membership', $elm$json$Json$Decode$string)))));
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Ziege$ModelEncodeDecode$decodeStatusMinimumVersion = function (payload) {
	return A2(
		$elm$core$Result$withDefault,
		'',
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'minv', $elm$json$Json$Decode$string),
			payload));
};
var $author$project$Ziege$Model$describeClient = function (c) {
	return (!$elm$core$String$isEmpty(c.dn)) ? _Utils_ap(
		c.dn,
		(!$elm$core$String$isEmpty(c.c8)) ? (', ' + c.c8) : '') : ((!$elm$core$String$isEmpty(c.b7)) ? c.b7 : c.m);
};
var $author$project$Ziege$ModelEncodeDecode$editInterval2Interval = function (einterval) {
	var _v0 = einterval.aV;
	switch (_v0) {
		case 0:
			return A2($author$project$Ziege$Pattern$Day, einterval.av, einterval.a5);
		case 1:
			return A2($author$project$Ziege$Pattern$Week, einterval.av, einterval.a5);
		case 2:
			return A2($author$project$Ziege$Pattern$Weekday, einterval.av, einterval.a5);
		case 3:
			return A2($author$project$Ziege$Pattern$Weekend, einterval.av, einterval.a5);
		case 4:
			return A2($author$project$Ziege$Pattern$Month, einterval.av, einterval.a5);
		default:
			return $author$project$Ziege$Pattern$Anytime(einterval.a5);
	}
};
var $author$project$Ziege$PatternServerClient$requestFavorites = F4(
	function (config, mid, accessToken, msg) {
		return A2(
			$author$project$Ziege$PatternServerClient$jsonRequest,
			'POST',
			{
				aW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'matrix_id',
								$elm$json$Json$Encode$string(mid)),
								_Utils_Tuple2(
								'access_token',
								$elm$json$Json$Encode$string(accessToken))
							]))),
				a_: A2($elm$http$Http$expectJson, msg, $author$project$Ziege$PatternServerClient$favoritesDecoder),
				aH: config.cy
			});
	});
var $author$project$Main$fetchFavoritesFromPatternServer = function (model) {
	var _v0 = model.ap;
	if (!_v0.$) {
		var pcc = _v0.a;
		return A4(
			$author$project$Ziege$PatternServerClient$requestFavorites,
			pcc,
			model.n,
			$author$project$Main$getAccessToken(model),
			$author$project$Ziege$Model$FavoritesReceived(model.ab));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $author$project$Main$getActiveClient = function (model) {
	return A2($elm$core$Dict$get, model.O, model.c);
};
var $author$project$Main$handleAccessToken = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a8: msg}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Ziege$Model$CryptoReady = 4;
var $author$project$Ziege$Model$CryptoUnverified = 3;
var $author$project$Ziege$Model$VerificationDone = 4;
var $author$project$Ziege$Model$CryptoStatus = F8(
	function (phase, busy, error, backupActive, recoveryKey, recoveryKeyReplaced, approvalUrl, verification) {
		return {d_: approvalUrl, d0: backupActive, gd: busy, ed: error, bn: phase, e$: recoveryKey, e0: recoveryKeyReplaced, i9: verification};
	});
var $author$project$Ziege$Model$CryptoSetup = 2;
var $author$project$Ziege$Model$CryptoUnavailable = 1;
var $author$project$Ziege$ModelEncodeDecode$decodeCryptoPhase = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'starting':
				return $elm$json$Json$Decode$succeed(0);
			case 'unavailable':
				return $elm$json$Json$Decode$succeed(1);
			case 'setup':
				return $elm$json$Json$Decode$succeed(2);
			case 'unverified':
				return $elm$json$Json$Decode$succeed(3);
			case 'ready':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Unbekannte Krypto-Phase: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Ziege$Model$Verification = F5(
	function (phase, otherApp, emojis, message, ownRequest) {
		return {gF: emojis, ht: message, hS: otherApp, hU: ownRequest, bn: phase};
	});
var $author$project$Ziege$Model$SasEmoji = F2(
	function (emoji, name) {
		return {gE: emoji, I: name};
	});
var $author$project$Ziege$ModelEncodeDecode$decodeSasEmoji = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Ziege$Model$SasEmoji,
	A2($elm$json$Json$Decode$field, 'emoji', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
var $author$project$Ziege$Model$VerificationCancelled = 5;
var $author$project$Ziege$Model$VerificationConfirmed = 3;
var $author$project$Ziege$Model$VerificationEmojis = 2;
var $author$project$Ziege$Model$VerificationIncoming = 0;
var $author$project$Ziege$Model$VerificationWaiting = 1;
var $author$project$Ziege$ModelEncodeDecode$decodeVerificationPhase = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'incoming':
				return $elm$json$Json$Decode$succeed(0);
			case 'waiting':
				return $elm$json$Json$Decode$succeed(1);
			case 'emojis':
				return $elm$json$Json$Decode$succeed(2);
			case 'confirmed':
				return $elm$json$Json$Decode$succeed(3);
			case 'done':
				return $elm$json$Json$Decode$succeed(4);
			case 'cancelled':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Unbekannte Verifikations-Phase: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Ziege$ModelEncodeDecode$decodeVerification = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Ziege$Model$Verification,
	A2($elm$json$Json$Decode$field, 'phase', $author$project$Ziege$ModelEncodeDecode$decodeVerificationPhase),
	A2($elm$json$Json$Decode$field, 'otherApp', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'emojis',
		$elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeSasEmoji)),
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ownRequest', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Ziege$ModelEncodeDecode$decodeCryptoStatus = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Ziege$Model$CryptoStatus,
	A2($elm$json$Json$Decode$field, 'phase', $author$project$Ziege$ModelEncodeDecode$decodeCryptoPhase),
	A2($elm$json$Json$Decode$field, 'busy', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'backupActive', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'recoveryKey', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'recoveryKeyReplaced', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'approvalUrl', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'verification',
		$elm$json$Json$Decode$nullable($author$project$Ziege$ModelEncodeDecode$decodeVerification)));
var $author$project$Ziege$MatrixPort$logError = _Platform_outgoingPort('logError', $elm$json$Json$Encode$string);
var $author$project$Ziege$MatrixPort$cryptoAction = _Platform_outgoingPort('cryptoAction', $elm$core$Basics$identity);
var $author$project$Main$sendCryptoAction = F2(
	function (action, extra) {
		return $author$project$Ziege$MatrixPort$cryptoAction(
			$elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'action',
						$elm$json$Json$Encode$string(action)),
					extra)));
	});
var $author$project$Main$handleCryptoStatus = F2(
	function (msg, model) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ziege$ModelEncodeDecode$decodeCryptoStatus, msg);
		if (!_v0.$) {
			var st = _v0.a;
			var verificationDone = _Utils_eq(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.bn;
					},
					st.i9),
				$elm$core$Maybe$Just(4));
			var leftUnverified = st.bn !== 3;
			var becameUnverified = (st.bn === 3) && (model.aM.bn !== 3);
			var becameReady = (st.bn === 4) && (model.aM.bn !== 4);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						bd: (model.bd || becameUnverified) && (!(becameReady || verificationDone)),
						aZ: model.aZ && (!st.gd),
						aM: st,
						bH: leftUnverified ? '' : model.bH
					}),
				verificationDone ? A2($author$project$Main$sendCryptoAction, 'closeVerification', _List_Nil) : $elm$core$Platform$Cmd$none);
		} else {
			var err = _v0.a;
			return _Utils_Tuple2(
				model,
				$author$project$Ziege$MatrixPort$logError(
					'Krypto-Status nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Main$handleMatrixLeaveRoom = F2(
	function (msg, model) {
		var roomid = function () {
			var _v3 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
				msg);
			if (_v3.$ === 1) {
				return 'NONONO    THIS IS NO ROOMID 🍌';
			} else {
				var rid = _v3.a;
				return rid;
			}
		}();
		var switchAway = function () {
			var _v1 = $elm$core$List$head(
				$elm$core$Dict$values(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (_v2, v) {
								return _Utils_eq(v.i, roomid);
							}),
						model.c)));
			if (_v1.$ === 1) {
				return false;
			} else {
				var aClient = _v1.a;
				return _Utils_eq(model.O, aClient.m);
			}
		}();
		var newClients = A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, v) {
					return !_Utils_eq(v.i, roomid);
				}),
			model.c);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					O: switchAway ? '' : model.O,
					f: switchAway ? ((!model.g) ? A2($author$project$Ziege$Model$ErrorView, 'Sie sind leider nicht mehr Teil von Ziege.', true) : $author$project$Ziege$Model$StartView) : model.f,
					c: newClients
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Ziege$ModelEncodeDecode$isLogoData = function (logo) {
	return ($elm$core$String$length(logo) <= 32768) && A2(
		$elm$core$List$any,
		function (prefix) {
			return A2($elm$core$String$startsWith, prefix, logo);
		},
		_List_fromArray(
			['data:image/png;base64,', 'data:image/jpeg;base64,', 'data:image/webp;base64,', 'data:image/svg+xml;base64,']));
};
var $author$project$Ziege$ModelEncodeDecode$decodeStatusLogo = function (payload) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'logo', $elm$json$Json$Decode$string),
		payload);
	if (!_v0.$) {
		var logo = _v0.a;
		return $author$project$Ziege$ModelEncodeDecode$isLogoData(logo) ? logo : '';
	} else {
		return '';
	}
};
var $author$project$Ziege$MatrixPort$encodeSeverance = function (roomid) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'roomid',
				$elm$json$Json$Encode$string(roomid))
			]));
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Ziege$MatrixPort$leaveRoom = _Platform_outgoingPort('leaveRoom', $elm$core$Basics$identity);
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Main$ownClientRoom = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.i;
			},
			A2($elm$core$Dict$get, model.n, model.c)));
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Ziege$ModelEncodeDecode$versionParts = function (version) {
	var _v0 = A2(
		$elm$core$List$map,
		$elm$core$String$toInt,
		A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$trim(version)));
	_v0$2:
	while (true) {
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			if (_v0.b.b.b) {
				if ((!_v0.b.b.a.$) && (!_v0.b.b.b.b)) {
					var major = _v0.a.a;
					var _v1 = _v0.b;
					var minor = _v1.a.a;
					var _v2 = _v1.b;
					var patch = _v2.a.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(major, minor, patch));
				} else {
					break _v0$2;
				}
			} else {
				var major = _v0.a.a;
				var _v3 = _v0.b;
				var minor = _v3.a.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(major, minor, 0));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Ziege$ModelEncodeDecode$versionAtLeast = F2(
	function (minimum, version) {
		var _v0 = _Utils_Tuple2(
			$author$project$Ziege$ModelEncodeDecode$versionParts(version),
			$author$project$Ziege$ModelEncodeDecode$versionParts(minimum));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var own = _v0.a.a;
			var required = _v0.b.a;
			return !(!A2($elm$core$Basics$compare, own, required));
		} else {
			return false;
		}
	});
var $author$project$Ziege$ModelEncodeDecode$readsDayNumbers = $author$project$Ziege$ModelEncodeDecode$versionAtLeast('2.9.0');
var $author$project$Main$readsDayNumbersInRoom = F2(
	function (model, roomId) {
		var versions = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Dict$get, roomId, model.aR));
		var _v0 = A2($elm$core$Dict$get, roomId, model.aQ);
		if (!_v0.$) {
			var members = _v0.a;
			var joined = A2(
				$elm$core$List$filter,
				function (m) {
					return m.bj === 'join';
				},
				members);
			return (!$elm$core$List$isEmpty(joined)) && A2(
				$elm$core$List$all,
				function (m) {
					return $author$project$Ziege$ModelEncodeDecode$readsDayNumbers(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Dict$get, m.bu, versions)));
				},
				joined);
		} else {
			return false;
		}
	});
var $author$project$Main$statusExtras = function (model) {
	return {
		al: model.al,
		bG: model.bG,
		ij: $elm$core$Set$fromList(
			A2(
				$elm$core$List$filter,
				$author$project$Main$readsDayNumbersInRoom(model),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.i;
					},
					$elm$core$Dict$values(model.c)))),
		aI: model.aI
	};
};
var $author$project$Ziege$ModelEncodeDecode$encodeInterval = function (i) {
	switch (i.$) {
		case 0:
			var every = i.a;
			var times = i.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'base',
						$elm$json$Json$Encode$string('day')),
						_Utils_Tuple2(
						'every',
						$elm$json$Json$Encode$int(every)),
						_Utils_Tuple2(
						'times',
						$elm$json$Json$Encode$int(times))
					]));
		case 1:
			var every = i.a;
			var times = i.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'base',
						$elm$json$Json$Encode$string('week')),
						_Utils_Tuple2(
						'every',
						$elm$json$Json$Encode$int(every)),
						_Utils_Tuple2(
						'times',
						$elm$json$Json$Encode$int(times))
					]));
		case 2:
			var every = i.a;
			var times = i.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'base',
						$elm$json$Json$Encode$string('weekday')),
						_Utils_Tuple2(
						'every',
						$elm$json$Json$Encode$int(every)),
						_Utils_Tuple2(
						'times',
						$elm$json$Json$Encode$int(times))
					]));
		case 3:
			var every = i.a;
			var times = i.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'base',
						$elm$json$Json$Encode$string('weekend')),
						_Utils_Tuple2(
						'every',
						$elm$json$Json$Encode$int(every)),
						_Utils_Tuple2(
						'times',
						$elm$json$Json$Encode$int(times))
					]));
		case 4:
			var every = i.a;
			var times = i.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'base',
						$elm$json$Json$Encode$string('month')),
						_Utils_Tuple2(
						'every',
						$elm$json$Json$Encode$int(every)),
						_Utils_Tuple2(
						'times',
						$elm$json$Json$Encode$int(times))
					]));
		default:
			var times = i.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'base',
						$elm$json$Json$Encode$string('anytime')),
						_Utils_Tuple2(
						'times',
						$elm$json$Json$Encode$int(times))
					]));
	}
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Ziege$ModelEncodeDecode$encodeTodoWith = F2(
	function (date, todo) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(todo.bA)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(todo.I)),
					_Utils_Tuple2(
					'titel',
					$elm$json$Json$Encode$string(todo.j)),
					_Utils_Tuple2(
					'completionStart',
					date(todo.q.it)),
					_Utils_Tuple2(
					'completions',
					A2($elm$json$Json$Encode$list, date, todo.q.cm)),
					_Utils_Tuple2(
					'interval',
					$author$project$Ziege$ModelEncodeDecode$encodeInterval(todo.l)),
					_Utils_Tuple2(
					'text',
					$elm$json$Json$Encode$string(todo.K)),
					_Utils_Tuple2(
					'expires',
					date(todo.L))
				]));
	});
var $author$project$Ziege$ModelEncodeDecode$clientFields = F2(
	function (date, client) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(client.m)),
				_Utils_Tuple2(
				'firstname',
				$elm$json$Json$Encode$string(client.c8)),
				_Utils_Tuple2(
				'lastname',
				$elm$json$Json$Encode$string(client.dn)),
				_Utils_Tuple2(
				'todos',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Ziege$ModelEncodeDecode$encodeTodoWith(date),
					client.v)),
				_Utils_Tuple2(
				'roomid',
				$elm$json$Json$Encode$string(client.i)),
				_Utils_Tuple2(
				'note',
				$elm$json$Json$Encode$string(client.b7))
			]);
	});
var $author$project$Ziege$ModelEncodeDecode$encodeDate = function (d) {
	return $elm$json$Json$Encode$int(
		$author$project$Ziege$FastCalendar$toMillis(d));
};
var $author$project$Ziege$ModelEncodeDecode$encodeDayNumber = function (d) {
	return $elm$json$Json$Encode$int(
		$author$project$Ziege$FastCalendar$toDayNumber(d));
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Ziege$ModelEncodeDecode$encodeClientStatus = F2(
	function (extras, client) {
		var date = A2($elm$core$Set$member, client.i, extras.ij) ? $author$project$Ziege$ModelEncodeDecode$encodeDayNumber : $author$project$Ziege$ModelEncodeDecode$encodeDate;
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				A2($author$project$Ziege$ModelEncodeDecode$clientFields, date, client),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'v',
						$elm$json$Json$Encode$string(extras.aI)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'minv',
							$elm$json$Json$Encode$string(
								A2($elm$core$Set$member, client.i, extras.ij) ? '2.9.0' : '2.0.0')),
						$author$project$Ziege$ModelEncodeDecode$isLogoData(extras.al) ? _List_fromArray(
							[
								_Utils_Tuple2(
								'logo',
								$elm$json$Json$Encode$string(extras.al))
							]) : _List_Nil))));
	});
var $author$project$Ziege$MatrixPort$encodeMessage = F3(
	function (roomid, userid, payload) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'roomid',
					$elm$json$Json$Encode$string(roomid)),
					_Utils_Tuple2(
					'userid',
					$elm$json$Json$Encode$string(userid)),
					_Utils_Tuple2('payload', payload)
				]));
	});
var $author$project$Ziege$MatrixPort$sendMessage = _Platform_outgoingPort('sendMessage', $elm$core$Basics$identity);
var $author$project$Ziege$MatrixPort$updateClientRoom = F2(
	function (extras, c) {
		return A2($elm$core$Set$member, c.i, extras.bG) ? $elm$core$Platform$Cmd$none : $author$project$Ziege$MatrixPort$sendMessage(
			A3(
				$author$project$Ziege$MatrixPort$encodeMessage,
				c.i,
				c.m,
				A2($author$project$Ziege$ModelEncodeDecode$encodeClientStatus, extras, c)));
	});
var $author$project$Main$handleMatrixStatusUpdate = F2(
	function (msg, model) {
		var updateClientData = F3(
			function (rid, oldClient, newClient) {
				return _Utils_update(
					oldClient,
					{c8: newClient.c8, dn: newClient.dn, m: newClient.m, b7: newClient.b7, i: rid, v: newClient.v});
			});
		var logoFrom = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.b8;
					},
					$author$project$Ziege$ModelEncodeDecode$decodeStatusLogo),
				$author$project$Ziege$MatrixPort$decodeMessage(msg)));
		var withLogo = function (m) {
			return ((!m.g) && (!$elm$core$String$isEmpty(logoFrom))) ? _Utils_update(
				m,
				{al: logoFrom}) : m;
		};
		var extractData = function (msgdata) {
			var _v6 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ziege$ModelEncodeDecode$decodeClient, msgdata.b8);
			if (_v6.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var c = _v6.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(msgdata.cI, msgdata.is, c));
			}
		};
		var newClientData = A2(
			$elm$core$Maybe$andThen,
			extractData,
			$author$project$Ziege$MatrixPort$decodeMessage(msg));
		var currentClientRoom = $author$project$Main$ownClientRoom(model);
		if (newClientData.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var _v1 = newClientData.a;
			var rid = _v1.a;
			var staffed = _v1.b;
			var aClient = _v1.c;
			if ((!model.g) && ($elm$core$String$isEmpty(currentClientRoom) && (!staffed))) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				if ((!model.g) && ((!$elm$core$String$isEmpty(currentClientRoom)) && (!_Utils_eq(currentClientRoom, rid)))) {
					var _v2 = model.b3;
					if (!_v2.$) {
						var joining = _v2.a;
						if (_Utils_eq(joining.i, rid)) {
							var ownTodos = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.v;
									},
									A2($elm$core$Dict$get, model.n, model.c)));
							var switched = joining.c$ ? _Utils_update(
								aClient,
								{m: model.n, i: rid, v: ownTodos}) : _Utils_update(
								aClient,
								{m: model.n, i: rid});
							return _Utils_Tuple2(
								withLogo(
									_Utils_update(
										model,
										{
											c: A2($elm$core$Dict$singleton, model.n, switched),
											b3: $elm$core$Maybe$Nothing
										})),
								$elm$core$Platform$Cmd$batch(
									A2(
										$elm$core$List$cons,
										$author$project$Ziege$MatrixPort$leaveRoom(
											$author$project$Ziege$MatrixPort$encodeSeverance(currentClientRoom)),
										joining.c$ ? _List_fromArray(
											[
												A2(
												$author$project$Ziege$MatrixPort$updateClientRoom,
												$author$project$Main$statusExtras(model),
												switched)
											]) : _List_Nil)));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var isBrandNew = $elm$core$Dict$isEmpty(
						A2(
							$elm$core$Dict$filter,
							F2(
								function (_v5, oldClientData) {
									return _Utils_eq(oldClientData.i, rid) || ($elm$core$String$isEmpty(oldClientData.i) && _Utils_eq(oldClientData.m, aClient.m));
								}),
							model.c));
					var newClients = function () {
						if (isBrandNew) {
							return A3(
								$elm$core$Dict$insert,
								aClient.m,
								_Utils_update(
									aClient,
									{i: rid}),
								model.c);
						} else {
							return A2(
								$elm$core$Dict$map,
								F2(
									function (_v4, oldClientData) {
										return (_Utils_eq(oldClientData.i, rid) || ($elm$core$String$isEmpty(oldClientData.i) && _Utils_eq(oldClientData.m, aClient.m))) ? A3(updateClientData, rid, oldClientData, aClient) : oldClientData;
									}),
								model.c);
						}
					}();
					return _Utils_Tuple2(
						withLogo(
							_Utils_update(
								model,
								{c: newClients})),
						$elm$core$Platform$Cmd$none);
				}
			}
		}
	});
var $author$project$Main$handleNotificationPermissionUpdate = F2(
	function (v, m) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, v);
		if (!_v0.$) {
			var s = _v0.a;
			return _Utils_update(
				m,
				{ay: s});
		} else {
			return _Utils_update(
				m,
				{ay: 'broken'});
		}
	});
var $author$project$Main$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'ungültige Adresse ' + url;
		case 1:
			return 'Zeitüberschreitung';
		case 2:
			return 'keine Verbindung';
		case 3:
			var status = error.a;
			return 'Antwort ' + $elm$core$String$fromInt(status);
		default:
			var message = error.a;
			return 'unerwartete Antwort: ' + message;
	}
};
var $author$project$Main$invitedByFormerPartner = F2(
	function (model, invite) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$any(
					function (m) {
						return _Utils_eq(m.bu, invite.hg) && (m.bj !== 'invite');
					}),
				A2(
					$elm$core$Dict$get,
					$author$project$Main$ownClientRoom(model),
					model.aQ)));
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Main$isoDate = function (d) {
	return $elm$core$String$fromInt(
		$PanagiotisGeorgiadis$elm_datetime$Calendar$getYear(d)) + ('-' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$PanagiotisGeorgiadis$elm_datetime$Calendar$monthToInt(
				$PanagiotisGeorgiadis$elm_datetime$Calendar$getMonth(d)))) + ('-' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$PanagiotisGeorgiadis$elm_datetime$Calendar$getDay(d))))));
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Ziege$Utils$massageMatrixUsername = function (u) {
	var trimmed = $elm$core$String$trim(u);
	var withoutAt = A2($elm$core$String$startsWith, '@', trimmed) ? A2($elm$core$String$dropLeft, 1, trimmed) : trimmed;
	var _v0 = function () {
		var _v1 = A2($elm$core$String$indexes, ':', withoutAt);
		if (_v1.b) {
			var i = _v1.a;
			return _Utils_Tuple2(
				A2($elm$core$String$left, i, withoutAt),
				A2($elm$core$String$dropLeft, i + 1, withoutAt));
		} else {
			return _Utils_Tuple2(withoutAt, 'ziege.social');
		}
	}();
	var localpart = _v0.a;
	var server = _v0.b;
	return $elm$core$String$isEmpty(trimmed) ? '' : ('@' + ($elm$core$String$toLower(localpart) + (':' + server)));
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Ziege$Model$noActiveClient = '';
var $author$project$Main$navigateBackTo = F2(
	function (depth, model) {
		navigateBackTo:
		while (true) {
			if (_Utils_cmp(
				$author$project$Main$navigationDepth(model),
				depth) < 1) {
				return model;
			} else {
				if (model.aJ) {
					var $temp$depth = depth,
						$temp$model = _Utils_update(
						model,
						{aJ: false, bB: false});
					depth = $temp$depth;
					model = $temp$model;
					continue navigateBackTo;
				} else {
					if ($author$project$Main$pageDepth(model) === 3) {
						var $temp$depth = depth,
							$temp$model = _Utils_update(
							model,
							{
								f: $author$project$Ziege$Model$PatternSelectorView($elm$core$Set$empty)
							});
						depth = $temp$depth;
						model = $temp$model;
						continue navigateBackTo;
					} else {
						if ($author$project$Main$pageDepth(model) === 2) {
							var $temp$depth = depth,
								$temp$model = _Utils_update(
								model,
								{f: $author$project$Ziege$Model$ClientTodoList});
							depth = $temp$depth;
							model = $temp$model;
							continue navigateBackTo;
						} else {
							if (model.g === 1) {
								return _Utils_update(
									model,
									{O: $author$project$Ziege$Model$noActiveClient, f: $author$project$Ziege$Model$StartView});
							} else {
								return _Utils_update(
									model,
									{f: $author$project$Ziege$Model$ClientTodoList});
							}
						}
					}
				}
			}
		}
	});
var $author$project$Ziege$Utils$isValidMatrixId = function (mxid) {
	var localpartChar = function (c) {
		return $elm$core$Char$isLower(c) || ($elm$core$Char$isDigit(c) || A2(
			$elm$core$String$contains,
			$elm$core$String$fromChar(c),
			'._=-/+'));
	};
	var hostChar = function (c) {
		return $elm$core$Char$isAlphaNum(c) || ((c === '.') || (c === '-'));
	};
	var validServer = function (server) {
		var _v3 = A2($elm$core$String$split, ':', server);
		_v3$2:
		while (true) {
			if (_v3.b) {
				if (!_v3.b.b) {
					var host = _v3.a;
					return (!$elm$core$String$isEmpty(host)) && A2($elm$core$String$all, hostChar, host);
				} else {
					if (!_v3.b.b.b) {
						var host = _v3.a;
						var _v4 = _v3.b;
						var portNumber = _v4.a;
						return (!$elm$core$String$isEmpty(host)) && (A2($elm$core$String$all, hostChar, host) && ((!$elm$core$String$isEmpty(portNumber)) && A2($elm$core$String$all, $elm$core$Char$isDigit, portNumber)));
					} else {
						break _v3$2;
					}
				}
			} else {
				break _v3$2;
			}
		}
		return false;
	};
	var _v0 = $elm$core$String$uncons(mxid);
	if ((!_v0.$) && ('@' === _v0.a.a)) {
		var _v1 = _v0.a;
		var rest = _v1.b;
		var _v2 = A2($elm$core$String$indexes, ':', rest);
		if (_v2.b) {
			var i = _v2.a;
			var localpart = A2($elm$core$String$left, i, rest);
			return (!$elm$core$String$isEmpty(localpart)) && (A2($elm$core$String$all, localpartChar, localpart) && validServer(
				A2($elm$core$String$dropLeft, i + 1, rest)));
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Main$newClientError = function (model) {
	var mxid = $author$project$Ziege$Utils$massageMatrixUsername(model.bk);
	return ($elm$core$String$isEmpty(
		$elm$core$String$trim(model.bE)) || ($elm$core$String$isEmpty(
		$elm$core$String$trim(model.bF)) || $elm$core$String$isEmpty(mxid))) ? 'Vor-, Nachname und Matrix-Benutzername angeben' : ((!$author$project$Ziege$Utils$isValidMatrixId(mxid)) ? 'Im Matrix-Benutzernamen sind nur a–z, 0–9 und ._=-/+ erlaubt, keine Leerzeichen oder Umlaute' : (_Utils_eq(mxid, model.n) ? 'Das ist Ihr eigenes Matrix-Konto' : (A2($elm$core$Dict$member, mxid, model.c) ? 'Mit diesem Matrix-Konto besteht schon eine Verbindung' : '')));
};
var $author$project$Ziege$TodoInterval$newCompletionHistory = function (d) {
	return A2($author$project$Ziege$TodoInterval$CompletionHistory, d, _List_Nil);
};
var $author$project$Ziege$Editor$EStatic = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ziege$FastCalendar$incrementDay = function (date) {
	return $author$project$Ziege$FastCalendar$fromDayNumber(
		$author$project$Ziege$FastCalendar$dayNumber(date) + 1);
};
var $author$project$Ziege$Utils$nextWeekday = F3(
	function (wd, alwaysFuture, date) {
		return A4($author$project$Ziege$Utils$gotoWeekday, $author$project$Ziege$FastCalendar$incrementDay, wd, alwaysFuture, date);
	});
var $author$project$Ziege$Utils$ntimes = F3(
	function (n, f, start) {
		return (!n) ? start : A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, elem) {
					return f(elem);
				}),
			start,
			A2($elm$core$List$range, 1, n));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$setDay = F2(
	function (day, date) {
		return $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$fromRawParts(
			{
				gu: day,
				hz: $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getMonth(date),
				ji: $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(
					$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getYear(date))
			});
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$setDay = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$setDay;
var $author$project$Main$findReasonableExpiry = F2(
	function (today, pending) {
		var futureDate = function () {
			var _v1 = pending.ao;
			if (_v1.$ === 1) {
				return $PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth(today);
			} else {
				var pattern = _v1.a;
				return A3($author$project$Ziege$Utils$ntimes, pattern.c1, $author$project$Ziege$FastCalendar$incrementDay, today);
			}
		}();
		var _v0 = pending.U.aV;
		switch (_v0) {
			case 1:
				return A3($author$project$Ziege$Utils$nextWeekday, 6, false, futureDate);
			case 4:
				return $author$project$Ziege$FastCalendar$decrementDay(
					$PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth(
						A2(
							$elm$core$Maybe$withDefault,
							futureDate,
							A2($PanagiotisGeorgiadis$elm_datetime$Calendar$setDay, 1, futureDate))));
			default:
				return futureDate;
		}
	});
var $author$project$Ziege$Editor$EAnytime = 5;
var $author$project$Ziege$Editor$EMonth = 4;
var $author$project$Ziege$Editor$EWeek = 1;
var $author$project$Ziege$Editor$EWeekday = 2;
var $author$project$Ziege$Editor$EWeekend = 3;
var $author$project$Ziege$ModelEncodeDecode$interval2EditInterval = function (interval) {
	switch (interval.$) {
		case 0:
			var every = interval.a;
			var times = interval.b;
			return {aV: 0, av: every, a5: times};
		case 1:
			var every = interval.a;
			var times = interval.b;
			return {aV: 1, av: every, a5: times};
		case 2:
			var every = interval.a;
			var times = interval.b;
			return {aV: 2, av: every, a5: times};
		case 3:
			var every = interval.a;
			var times = interval.b;
			return {aV: 3, av: every, a5: times};
		case 4:
			var every = interval.a;
			var times = interval.b;
			return {aV: 4, av: every, a5: times};
		default:
			var times = interval.a;
			return {aV: 5, av: 1, a5: times};
	}
};
var $author$project$Main$pattern2PendingToDo = F3(
	function (today, pattern, isFavorite) {
		var convertTextPattern = function (t) {
			if (!t.$) {
				var s = t.a;
				return $author$project$Ziege$Editor$EStatic(s);
			} else {
				var s = t.a;
				return A2($author$project$Ziege$Editor$EPlaceholder, s, '');
			}
		};
		var pending = {
			cn: '',
			co: '',
			cp: '',
			U: $author$project$Ziege$ModelEncodeDecode$interval2EditInterval(pattern.l),
			L: A3($author$project$Ziege$Utils$ntimes, pattern.c1, $author$project$Ziege$FastCalendar$incrementDay, today),
			b_: false,
			b0: false,
			b1: isFavorite,
			b2: false,
			I: pattern.I,
			ao: $elm$core$Maybe$Just(pattern),
			K: A2($elm$core$List$map, convertTextPattern, pattern.K),
			j: pattern.j
		};
		return _Utils_update(
			pending,
			{
				L: A2($author$project$Main$findReasonableExpiry, today, pending)
			});
	});
var $author$project$Ziege$Editor$textPart2String = function (textpart) {
	if (!textpart.$) {
		var s = textpart.a;
		return s;
	} else {
		var s = textpart.a;
		var f = textpart.b;
		return $elm$core$String$isEmpty(f) ? s : f;
	}
};
var $author$project$Ziege$Editor$patternTextPartstoString = function (partlist) {
	return A2(
		$elm$core$String$join,
		' ',
		A2($elm$core$List$map, $author$project$Ziege$Editor$textPart2String, partlist));
};
var $author$project$Ziege$MatrixPort$performLogout = _Platform_outgoingPort('performLogout', $elm$core$Basics$identity);
var $author$project$Main$recordLastStatus = F2(
	function (msg, model) {
		var _v0 = $author$project$Ziege$MatrixPort$decodeMessage(msg);
		if (!_v0.$) {
			var message = _v0.a;
			return _Utils_update(
				model,
				{
					b4: A3($elm$core$Dict$insert, message.cI, message.b8, model.b4)
				});
		} else {
			return model;
		}
	});
var $author$project$Ziege$ModelEncodeDecode$decodeStatusVersion = function (payload) {
	return A2(
		$elm$core$Result$withDefault,
		'',
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'v', $elm$json$Json$Decode$string),
			payload));
};
var $author$project$Main$recordStatusVersion = F2(
	function (msg, model) {
		var _v0 = $author$project$Ziege$MatrixPort$decodeMessage(msg);
		if (!_v0.$) {
			var message = _v0.a;
			return ($elm$core$String$isEmpty(message.dN) || _Utils_eq(message.dN, model.n)) ? model : _Utils_update(
				model,
				{
					aR: A3(
						$elm$core$Dict$update,
						message.cI,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault($elm$core$Dict$empty),
							A2(
								$elm$core$Basics$composeR,
								A2(
									$elm$core$Dict$insert,
									message.dN,
									$author$project$Ziege$ModelEncodeDecode$decodeStatusVersion(message.b8)),
								$elm$core$Maybe$Just)),
						model.aR)
				});
		} else {
			return model;
		}
	});
var $author$project$Ziege$MatrixPort$reinviteToRoom = _Platform_outgoingPort('reinviteToRoom', $elm$core$Basics$identity);
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Main$removeFavorite = F2(
	function (name, m) {
		return _Utils_update(
			m,
			{
				ab: A2(
					$elm$core$Set$remove,
					$elm$core$String$trim(name),
					m.ab)
			});
	});
var $author$project$Ziege$PatternServerClient$sendDeleteFavorite = F5(
	function (config, mid, accessToken, patternName, msg) {
		return A2(
			$author$project$Ziege$PatternServerClient$jsonRequest,
			'DELETE',
			{
				aW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pattern_name',
								$elm$json$Json$Encode$string(patternName)),
								_Utils_Tuple2(
								'matrix_id',
								$elm$json$Json$Encode$string(mid)),
								_Utils_Tuple2(
								'access_token',
								$elm$json$Json$Encode$string(accessToken))
							]))),
				a_: A2($elm$http$Http$expectJson, msg, $author$project$Ziege$PatternServerClient$favoritesDecoder),
				aH: config.cy
			});
	});
var $author$project$Main$removeFavoriteFromPatternServer = F2(
	function (model, patternName) {
		var _v0 = model.ap;
		if (!_v0.$) {
			var pcc = _v0.a;
			return A5(
				$author$project$Ziege$PatternServerClient$sendDeleteFavorite,
				pcc,
				model.n,
				$author$project$Main$getAccessToken(model),
				patternName,
				$author$project$Ziege$Model$FavoritesReceived(model.ab));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Ziege$MatrixPort$requestDevices = _Platform_outgoingPort('requestDevices', $elm$json$Json$Encode$string);
var $author$project$Ziege$MatrixPort$requestNotificationPermission = _Platform_outgoingPort('requestNotificationPermission', $elm$core$Basics$identity);
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Ziege$ModelEncodeDecode$encodeClient = function (client) {
	return $elm$json$Json$Encode$object(
		A2($author$project$Ziege$ModelEncodeDecode$clientFields, $author$project$Ziege$ModelEncodeDecode$encodeDate, client));
};
var $author$project$Main$encodeNextUpdate = function (thing) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'begin',
				$elm$json$Json$Encode$int(thing.d1)),
				_Utils_Tuple2(
				'end',
				$elm$json$Json$Encode$int(thing.ec)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(thing.j))
			]));
};
var $author$project$Main$encodeRole = function (appMode) {
	switch (appMode) {
		case 1:
			return $elm$json$Json$Encode$string('berater');
		case 0:
			return $elm$json$Json$Encode$string('klient');
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$Ziege$SaveState$saveData = _Platform_outgoingPort('saveData', $elm$core$Basics$identity);
var $author$project$Main$saveState = F2(
	function (m, nextUpdate) {
		return $author$project$Ziege$SaveState$saveData(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'clients',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$Ziege$ModelEncodeDecode$encodeClient,
							$elm$core$Dict$values(m.c))),
						_Utils_Tuple2(
						'nextUpdate',
						A2($elm$json$Json$Encode$list, $author$project$Main$encodeNextUpdate, nextUpdate)),
						_Utils_Tuple2(
						'role',
						$author$project$Main$encodeRole(m.g)),
						_Utils_Tuple2(
						'logo',
						$elm$json$Json$Encode$string(m.al)),
						_Utils_Tuple2(
						'roomVersions',
						A3(
							$elm$json$Json$Encode$dict,
							$elm$core$Basics$identity,
							A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string),
							m.aR))
					])));
	});
var $author$project$Ziege$Model$SentPatternProposal = function (a) {
	return {$: 46, a: a};
};
var $author$project$Ziege$ModelEncodeDecode$encodePendingTodo = function (ptodo) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(ptodo.I)),
				_Utils_Tuple2(
				'titel',
				$elm$json$Json$Encode$string(ptodo.j)),
				_Utils_Tuple2(
				'interval',
				$author$project$Ziege$ModelEncodeDecode$encodeInterval(
					$author$project$Ziege$ModelEncodeDecode$editInterval2Interval(ptodo.U))),
				_Utils_Tuple2(
				'text',
				$elm$json$Json$Encode$string(
					$author$project$Ziege$Editor$patternTextPartstoString(ptodo.K))),
				_Utils_Tuple2(
				'expires',
				$author$project$Ziege$ModelEncodeDecode$encodeDate(ptodo.L)),
				_Utils_Tuple2(
				'contact_name',
				$elm$json$Json$Encode$string(ptodo.co)),
				_Utils_Tuple2(
				'contact_tel',
				$elm$json$Json$Encode$string(ptodo.cp)),
				_Utils_Tuple2(
				'contact_mail',
				$elm$json$Json$Encode$string(ptodo.cn))
			]));
};
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Ziege$PatternServerClient$sendPatternProposal = F5(
	function (config, mid, accessToken, jsonPayload, msg) {
		return A2(
			$author$project$Ziege$PatternServerClient$jsonRequest,
			'POST',
			{
				aW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'matrix_id',
								$elm$json$Json$Encode$string(mid)),
								_Utils_Tuple2(
								'access_token',
								$elm$json$Json$Encode$string(accessToken)),
								_Utils_Tuple2('payload', jsonPayload)
							]))),
				a_: $elm$http$Http$expectString(msg),
				aH: config.eu
			});
	});
var $author$project$Main$sendPendingTodo2PatternServer = F2(
	function (model, pToDo) {
		if (pToDo.b2) {
			var _v0 = model.ap;
			if (!_v0.$) {
				var pcc = _v0.a;
				return A5(
					$author$project$Ziege$PatternServerClient$sendPatternProposal,
					pcc,
					model.n,
					$author$project$Main$getAccessToken(model),
					$author$project$Ziege$ModelEncodeDecode$encodePendingTodo(pToDo),
					$author$project$Ziege$Model$SentPatternProposal);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Ziege$FastCalendar$localDate = F2(
	function (zone, time) {
		return A2(
			$elm$core$Maybe$withDefault,
			$PanagiotisGeorgiadis$elm_datetime$Calendar$fromPosix(time),
			$PanagiotisGeorgiadis$elm_datetime$Calendar$fromRawParts(
				{
					gu: A2($elm$time$Time$toDay, zone, time),
					hz: A2($elm$time$Time$toMonth, zone, time),
					ji: A2($elm$time$Time$toYear, zone, time)
				}));
	});
var $author$project$Main$setTime = F2(
	function (newTime, model) {
		var newToday = A2($author$project$Ziege$FastCalendar$localDate, model.cR, newTime);
		return _Utils_update(
			model,
			{
				bM: newTime,
				af: (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, newToday, model.af) === 1) ? model.af : newToday
			});
	});
var $author$project$Ziege$Utils$setToggle = F2(
	function (thing, s) {
		return A2(
			A2($elm$core$Set$member, thing, s) ? $elm$core$Set$remove : $elm$core$Set$insert,
			thing,
			s);
	});
var $author$project$Main$statusSizeMessage = F4(
	function (model, roomId, bytes, rejected) {
		var who = A2(
			$elm$core$Maybe$withDefault,
			'einer Klient*in',
			A2(
				$elm$core$Maybe$map,
				$author$project$Ziege$Model$describeClient,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (c) {
							return _Utils_eq(c.i, roomId);
						},
						$elm$core$Dict$values(model.c)))));
		var size = $elm$core$String$fromInt((bytes / 1024) | 0) + ' KB';
		return rejected ? ('Der Stand von ' + (who + (' ist mit ' + (size + ' zu groß zum Senden. Änderungen kommen dort nicht mehr an. Bitte dem Ziege-Team melden.')))) : ('Der Stand von ' + (who + (' ist schon ' + (size + ' groß. Ab etwa 48 KB lässt er sich nicht mehr senden. Bitte dem Ziege-Team melden.'))));
	});
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Main$timeTravel = F2(
	function (days, time) {
		var date = $PanagiotisGeorgiadis$elm_datetime$Calendar$fromPosix(time);
		var changeF = (days >= 0) ? $author$project$Ziege$FastCalendar$incrementDay : $author$project$Ziege$FastCalendar$decrementDay;
		return $elm$time$Time$millisToPosix(
			$author$project$Ziege$FastCalendar$toMillis(
				A3(
					$author$project$Ziege$Utils$ntimes,
					$elm$core$Basics$abs(days),
					changeF,
					date)));
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $author$project$Main$toHex = function (n) {
	var digit = function (d) {
		return A3($elm$core$String$slice, d, d + 1, '0123456789abcdef');
	};
	return (n < 16) ? digit(n) : _Utils_ap(
		$author$project$Main$toHex((n / 16) | 0),
		digit(
			A2($elm$core$Basics$modBy, 16, n)));
};
var $author$project$Main$todoIdGenerator = A2(
	$elm$random$Random$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (n) {
				return A3(
					$elm$core$String$padLeft,
					4,
					'0',
					$author$project$Main$toHex(n));
			}),
		$elm$core$String$concat),
	A2(
		$elm$random$Random$list,
		4,
		A2($elm$random$Random$int, 0, 65535)));
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Main$updateClient = F3(
	function (action, clientId, m) {
		var newClients = A3(
			$elm$core$Dict$update,
			clientId,
			$elm$core$Maybe$map(action),
			m.c);
		return _Utils_update(
			m,
			{c: newClients});
	});
var $author$project$Ziege$ClipboardPort$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Ziege$MatrixPort$encodeInvitation = F2(
	function (roomid, userid) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'roomid',
					$elm$json$Json$Encode$string(roomid)),
					_Utils_Tuple2(
					'userid',
					$elm$json$Json$Encode$string(userid))
				]));
	});
var $author$project$Ziege$UI$ClientEditSettings$invitable = F3(
	function (ownMatrixId, client, mxid) {
		return $author$project$Ziege$Utils$isValidMatrixId(mxid) && ((!_Utils_eq(mxid, ownMatrixId)) && (!_Utils_eq(mxid, client.m)));
	});
var $author$project$Ziege$MatrixPort$inviteToRoom = _Platform_outgoingPort('inviteToRoom', $elm$core$Basics$identity);
var $author$project$Ziege$UI$ClientEditSettings$updateClientEditNames = F4(
	function (ownMatrixId, extras, msg, client) {
		switch (msg.$) {
			case 1:
				var mewFirstName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						client,
						{c8: mewFirstName}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var newLastName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						client,
						{dn: newLastName}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var newNote = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						client,
						{b7: newNote}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var newMatrixId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						client,
						{gL: newMatrixId}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var mxid = $author$project$Ziege$Utils$massageMatrixUsername(client.gL);
				return A3($author$project$Ziege$UI$ClientEditSettings$invitable, ownMatrixId, client, mxid) ? _Utils_Tuple2(
					_Utils_update(
						client,
						{gL: ''}),
					$author$project$Ziege$MatrixPort$inviteToRoom(
						A2($author$project$Ziege$MatrixPort$encodeInvitation, client.i, mxid))) : _Utils_Tuple2(client, $elm$core$Platform$Cmd$none);
			case 5:
				var requested = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						client,
						{ih: requested}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						client,
						{ih: false}),
					$author$project$Ziege$MatrixPort$leaveRoom(
						$author$project$Ziege$MatrixPort$encodeSeverance(client.i)));
			case 7:
				return _Utils_Tuple2(
					client,
					A2($author$project$Ziege$MatrixPort$updateClientRoom, extras, client));
			default:
				return _Utils_Tuple2(
					client,
					$author$project$Ziege$ClipboardPort$copyToClipboard(client.i));
		}
	});
var $author$project$Main$updatePendingTodo = F2(
	function (updater, model) {
		var _v0 = model.f;
		if (_v0.$ === 5) {
			var pendingTodo = _v0.a;
			return _Utils_update(
				model,
				{
					f: $author$project$Ziege$Model$PatternEditorView(
						updater(pendingTodo))
				});
		} else {
			return model;
		}
	});
var $author$project$Ziege$Model$GotPatternServerResponse = function (a) {
	return {$: 28, a: a};
};
var $author$project$Ziege$Model$Loading = {$: 1};
var $author$project$Ziege$Pattern$ClientData = function (features) {
	return {cz: features};
};
var $author$project$Ziege$Pattern$ClientResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ziege$Pattern$CounsellorData = F7(
	function (name, organization, patternlist, logo, logoData, features, favorites) {
		return {gN: favorites, cz: features, al: logo, hp: logoData, I: name, hR: organization, N: patternlist};
	});
var $author$project$Ziege$Pattern$CounsellorResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ziege$Pattern$cleanMaybeMap = $elm$core$List$filterMap($elm$core$Basics$identity);
var $author$project$Ziege$Pattern$Debug = 1;
var $author$project$Ziege$Pattern$Timetravel = 0;
var $author$project$Ziege$Pattern$featureDecoder = A2(
	$elm$json$Json$Decode$map,
	function (x) {
		switch (x) {
			case 'zeitreise':
				return $elm$core$Maybe$Just(0);
			case 'debug':
				return $elm$core$Maybe$Just(1);
			default:
				return $elm$core$Maybe$Nothing;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Ziege$Pattern$Patternlist = F3(
	function (name, title, categories) {
		return {c0: categories, I: name, j: title};
	});
var $author$project$Ziege$Pattern$Category = F4(
	function (name, title, patterns, tags) {
		return {I: name, eT: patterns, fm: tags, j: title};
	});
var $author$project$Ziege$Pattern$LinkedPatterns = F3(
	function (followup, harder, together) {
		return {gR: followup, gV: harder, i_: together};
	});
var $author$project$Ziege$Pattern$Pattern = F7(
	function (name, title, text, linked, interval, commitmentDays, tags) {
		return {c1: commitmentDays, l: interval, hn: linked, I: name, fm: tags, K: text, j: title};
	});
var $author$project$Ziege$Pattern$buildInterval = function (_v0) {
	var base = _v0.a;
	var mevery = _v0.b;
	var times = _v0.c;
	var _v1 = _Utils_Tuple2(base, mevery);
	_v1$0:
	while (true) {
		if (_v1.b.$ === 1) {
			if (_v1.a === 'anytime') {
				break _v1$0;
			} else {
				var _v2 = _v1.b;
				return $elm$json$Json$Decode$fail('base ' + (base + ' ohne every oder unbekannt'));
			}
		} else {
			switch (_v1.a) {
				case 'anytime':
					break _v1$0;
				case 'day':
					var every = _v1.b.a;
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Ziege$Pattern$Day, every, times));
				case 'weekday':
					var every = _v1.b.a;
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Ziege$Pattern$Weekday, every, times));
				case 'weekend':
					var every = _v1.b.a;
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Ziege$Pattern$Weekend, every, times));
				case 'week':
					var every = _v1.b.a;
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Ziege$Pattern$Week, every, times));
				case 'month':
					var every = _v1.b.a;
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Ziege$Pattern$Month, every, times));
				default:
					return $elm$json$Json$Decode$fail('Unbekannte base \u0027' + (base + '\u0027'));
			}
		}
	}
	return $elm$json$Json$Decode$succeed(
		$author$project$Ziege$Pattern$Anytime(times));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Ziege$Pattern$Placeholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ziege$Pattern$placeholderTextDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Ziege$Pattern$Placeholder,
	A2($elm$json$Json$Decode$field, 'placeholder', $elm$json$Json$Decode$string));
var $author$project$Ziege$Pattern$Static = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ziege$Pattern$staticTextDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Ziege$Pattern$Static,
	A2($elm$json$Json$Decode$field, 'static', $elm$json$Json$Decode$string));
var $author$project$Ziege$Pattern$textpartDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Ziege$Pattern$placeholderTextDecoder, $author$project$Ziege$Pattern$staticTextDecoder]));
var $author$project$Ziege$Pattern$triple = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Ziege$Pattern$patternDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Ziege$Pattern$Pattern,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'title',
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'text',
		A2(
			$elm$json$Json$Decode$field,
			'parts',
			$elm$json$Json$Decode$list($author$project$Ziege$Pattern$textpartDecoder))),
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Ziege$Pattern$LinkedPatterns,
		A2(
			$elm$json$Json$Decode$field,
			'followupPatterns',
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'harderPatterns',
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'togetherPatterns',
			$elm$json$Json$Decode$list(
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)))),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Ziege$Pattern$buildInterval,
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Ziege$Pattern$triple,
			A2($elm$json$Json$Decode$field, 'base', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'every', $elm$json$Json$Decode$int)),
			A2($elm$json$Json$Decode$field, 'times', $elm$json$Json$Decode$int))),
	A2($elm$json$Json$Decode$field, 'commitment_days', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(''),
			$elm$core$List$singleton),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string))));
var $author$project$Ziege$Pattern$categoryDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Ziege$Pattern$Category,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'title',
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'patterns',
		$elm$json$Json$Decode$list($author$project$Ziege$Pattern$patternDecoder)),
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$core$Maybe$map($elm$core$List$singleton)),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string))));
var $author$project$Ziege$Pattern$patternlistDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Ziege$Pattern$Patternlist,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'title',
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'categories',
		$elm$json$Json$Decode$list($author$project$Ziege$Pattern$categoryDecoder)));
var $author$project$Ziege$Pattern$patternDataDecoder = function (role) {
	if (role === 'counsellor') {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Ziege$Pattern$CounsellorResponse,
			A8(
				$elm$json$Json$Decode$map7,
				$author$project$Ziege$Pattern$CounsellorData,
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'organisation_name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'katalog', $author$project$Ziege$Pattern$patternlistDecoder),
				A2($elm$json$Json$Decode$field, 'logo', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'logo_data', $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed('')
						])),
				A2(
					$elm$json$Json$Decode$field,
					'features',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Ziege$Pattern$cleanMaybeMap,
						$elm$json$Json$Decode$list($author$project$Ziege$Pattern$featureDecoder))),
				A2(
					$elm$json$Json$Decode$field,
					'favorites',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
	} else {
		return A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$Basics$composeL, $author$project$Ziege$Pattern$ClientResponse, $author$project$Ziege$Pattern$ClientData),
			A2(
				$elm$json$Json$Decode$field,
				'features',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Ziege$Pattern$cleanMaybeMap,
					$elm$json$Json$Decode$list($author$project$Ziege$Pattern$featureDecoder))));
	}
};
var $author$project$Ziege$Pattern$patternServerResponseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Ziege$Pattern$patternDataDecoder,
	A2($elm$json$Json$Decode$field, 'rolle', $elm$json$Json$Decode$string));
var $author$project$Ziege$PatternServerClient$requestPatternlist = F4(
	function (config, mid, accessToken, msg) {
		return $elm$http$Http$request(
			{
				aW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'matrix_id',
								$elm$json$Json$Encode$string(mid)),
								_Utils_Tuple2(
								'access_token',
								$elm$json$Json$Encode$string(accessToken))
							]))),
				a_: A2($elm$http$Http$expectJson, msg, $author$project$Ziege$Pattern$patternServerResponseDecoder),
				eo: _List_Nil,
				eF: 'POST',
				fn: $elm$core$Maybe$Just(20000),
				fq: $elm$core$Maybe$Nothing,
				aH: config.aH
			});
	});
var $author$project$Main$loadingPatternlist = function (_v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	var _v1 = model.N;
	if (!_v1.$) {
		var _v2 = model.ap;
		if (!_v2.$) {
			var pcc = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{N: $author$project$Ziege$Model$Loading}),
				_Utils_ap(
					_List_fromArray(
						[
							A4(
							$author$project$Ziege$PatternServerClient$requestPatternlist,
							pcc,
							model.n,
							$author$project$Main$getAccessToken(model),
							$author$project$Ziege$Model$GotPatternServerResponse)
						]),
					cmds));
		} else {
			return _Utils_Tuple2(model, cmds);
		}
	} else {
		return _Utils_Tuple2(model, cmds);
	}
};
var $author$project$Main$updateTick = F2(
	function (model, newTime) {
		var tickedmodel = A2(
			$author$project$Main$setTime,
			newTime,
			_Utils_update(
				model,
				{cU: false}));
		var _v0 = $author$project$Main$loadingPatternlist(
			_Utils_Tuple2(tickedmodel, _List_Nil));
		var newmodel = _v0.a;
		var cmds = _v0.b;
		var save = model.cU ? A2(
			$author$project$Main$saveState,
			newmodel,
			$author$project$Main$calcNextUpdate(newmodel)) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			newmodel,
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, save, cmds)));
	});
var $author$project$Ziege$Model$ResearchUploaded = function (a) {
	return {$: 56, a: a};
};
var $author$project$Ziege$ModelEncodeDecode$cleanEncodeTodo = function (todo) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(todo.I)),
				_Utils_Tuple2(
				'completionStart',
				$author$project$Ziege$ModelEncodeDecode$encodeDate(todo.q.it)),
				_Utils_Tuple2(
				'completions',
				A2($elm$json$Json$Encode$list, $author$project$Ziege$ModelEncodeDecode$encodeDate, todo.q.cm)),
				_Utils_Tuple2(
				'interval',
				$author$project$Ziege$ModelEncodeDecode$encodeInterval(todo.l)),
				_Utils_Tuple2(
				'expires',
				$author$project$Ziege$ModelEncodeDecode$encodeDate(todo.L))
			]));
};
var $author$project$Ziege$ModelEncodeDecode$cleanEncodeTodos = function (client) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'todos',
				A2($elm$json$Json$Encode$list, $author$project$Ziege$ModelEncodeDecode$cleanEncodeTodo, client.v))
			]));
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Ziege$PatternServerClient$sendResearchData = F5(
	function (config, mid, accessToken, jsonPayload, msg) {
		return A2(
			$author$project$Ziege$PatternServerClient$jsonRequest,
			'POST',
			{
				aW: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'matrix_id',
								$elm$json$Json$Encode$string(mid)),
								_Utils_Tuple2(
								'access_token',
								$elm$json$Json$Encode$string(accessToken)),
								_Utils_Tuple2('payload', jsonPayload)
							]))),
				a_: $elm$http$Http$expectWhatever(msg),
				aH: config.e6
			});
	});
var $author$project$Main$uploadResearchData = F2(
	function (model, client) {
		var _v0 = model.ap;
		if (!_v0.$) {
			var pcc = _v0.a;
			return A5(
				$author$project$Ziege$PatternServerClient$sendResearchData,
				pcc,
				model.n,
				$author$project$Main$getAccessToken(model),
				$author$project$Ziege$ModelEncodeDecode$cleanEncodeTodos(client),
				$author$project$Ziege$Model$ResearchUploaded);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var updateRoom = function (maybeClient) {
			if (maybeClient.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				var client = maybeClient.a;
				return A2(
					$author$project$Ziege$MatrixPort$updateClientRoom,
					$author$project$Main$statusExtras(model),
					client);
			}
		};
		var saveToBrowser = function (m) {
			return A2(
				$author$project$Main$saveState,
				m,
				$author$project$Main$calcNextUpdate(m));
		};
		switch (msg.$) {
			case 35:
				var newmodel = _Utils_update(
					model,
					{f: $author$project$Ziege$Model$StartView});
				return _Utils_Tuple2(
					newmodel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								saveToBrowser(newmodel)
							])));
			case 29:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{N: $author$project$Ziege$Model$Unloaded}),
					$elm$core$Platform$Cmd$none);
			case 28:
				var outerResult = msg.a;
				if (!outerResult.$) {
					var result = outerResult.a;
					if (result.$ === 1) {
						var data = result.a;
						var counselorModel = (model.g === 1) ? model : _Utils_update(
							model,
							{O: $author$project$Ziege$Model$noActiveClient, f: $author$project$Ziege$Model$StartView, g: 1});
						var newmodel = _Utils_update(
							counselorModel,
							{
								ab: $elm$core$Set$fromList(data.gN),
								al: data.hp,
								N: $author$project$Ziege$Model$Loaded(result)
							});
						return _Utils_Tuple2(
							newmodel,
							saveToBrowser(newmodel));
					} else {
						var newmodel = (!model.g) ? _Utils_update(
							model,
							{
								N: $author$project$Ziege$Model$Loaded(result)
							}) : $author$project$Main$updateActiveClientForClientMode(
							_Utils_update(
								model,
								{
									O: model.n,
									f: $author$project$Ziege$Model$ClientTodoList,
									g: 0,
									N: $author$project$Ziege$Model$Loaded(result)
								}));
						return _Utils_Tuple2(
							newmodel,
							saveToBrowser(newmodel));
					}
				} else {
					var failure = outerResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								N: $author$project$Ziege$Model$Loadfail(
									$author$project$Main$httpErrorToString(failure))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				var newTime = msg.a;
				return A2($author$project$Main$updateTick, model, newTime);
			case 12:
				var newZone = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$setTime,
						model.bM,
						_Utils_update(
							model,
							{cR: newZone})),
					$elm$core$Platform$Cmd$none);
			case 0:
				var newClientFirstnameInput = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bE: newClientFirstnameInput}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var newClientLastnameInput = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bF: newClientLastnameInput}),
					$elm$core$Platform$Cmd$none);
			case 49:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bk: input}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var betterUsername = $author$project$Ziege$Utils$massageMatrixUsername(model.bk);
				var newClient = {
					gL: '',
					c8: $elm$core$String$trim(model.bE),
					dn: $elm$core$String$trim(model.bF),
					m: betterUsername,
					eK: '',
					eL: '',
					b7: '',
					i: '',
					ih: false,
					v: _List_Nil
				};
				var newmodel = _Utils_update(
					model,
					{
						f: $author$project$Ziege$Model$StartView,
						c: A3($elm$core$Dict$insert, betterUsername, newClient, model.c),
						bE: '',
						bF: '',
						bk: ''
					});
				return $elm$core$String$isEmpty(
					$author$project$Main$newClientError(model)) ? _Utils_Tuple2(
					newmodel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$Ziege$MatrixPort$updateClientRoom,
								$author$project$Main$statusExtras(model),
								newClient),
								saveToBrowser(newmodel)
							]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cO: !model.cO}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bg: !model.bg}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var requested = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cf: requested}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var todo = msg.a;
				var _v3 = $author$project$Main$getActiveClient(model);
				if (!_v3.$) {
					var client = _v3.a;
					var remaining = A2(
						$elm$core$List$filter,
						function (t) {
							return !_Utils_eq(t.bA, todo.bA);
						},
						client.v);
					if (_Utils_eq(
						$elm$core$List$length(remaining),
						$elm$core$List$length(client.v))) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cf: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					} else {
						var newclient = _Utils_update(
							client,
							{v: remaining});
						var newmodel = _Utils_update(
							model,
							{
								c: A3($elm$core$Dict$insert, model.O, newclient, model.c),
								cf: $elm$core$Maybe$Nothing
							});
						return _Utils_Tuple2(
							newmodel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										saveToBrowser(newmodel),
										updateRoom(
										$elm$core$Maybe$Just(newclient)),
										A2($author$project$Main$uploadResearchData, newmodel, newclient)
									])));
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var clientID = msg.a;
				var todoId = msg.b;
				var checked = msg.c;
				if (checked && (!model.g)) {
					var newmodel = _Utils_update(
						model,
						{
							c: A3(
								$elm$core$Dict$update,
								clientID,
								$elm$core$Maybe$map(
									A2($author$project$Main$addTodoCompletion, model.af, todoId)),
								model.c)
						});
					return _Utils_Tuple2(
						newmodel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									saveToBrowser(newmodel),
									updateRoom(
									A2($elm$core$Dict$get, clientID, newmodel.c))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var depth = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Main$navigateBackTo, depth, model),
					$elm$core$Platform$Cmd$none);
			case 10:
				var depth = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Main$navigateBackTo, depth, model),
					$elm$core$Platform$Cmd$none);
			case 8:
				var clientID = msg.a;
				var newmodel = _Utils_update(
					model,
					{O: clientID});
				return _Utils_eq(newmodel.O, $author$project$Ziege$Model$noActiveClient) ? _Utils_Tuple2(
					_Utils_update(
						newmodel,
						{f: $author$project$Ziege$Model$StartView}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						newmodel,
						{f: $author$project$Ziege$Model$ClientTodoList}),
					$elm$core$Platform$Cmd$none);
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bL: true}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var days = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$setTime,
						A2($author$project$Main$timeTravel, days, model.bM),
						_Utils_update(
							model,
							{bL: false})),
					$elm$core$Platform$Cmd$none);
			case 16:
				var maybePattern = msg.a;
				var pending = function () {
					if (maybePattern.$ === 1) {
						return A2($author$project$Main$createPendingTodo, model.bM, model.af);
					} else {
						var pattern = maybePattern.a;
						return A3(
							$author$project$Main$pattern2PendingToDo,
							model.af,
							pattern,
							A2($elm$core$Set$member, pattern.I, model.ab));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: $author$project$Ziege$Model$PatternEditorView(pending)
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var date = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{L: date});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 17:
				var title = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{j: title});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 18:
				var index = msg.a;
				var textstring = msg.b;
				var updateTextPart = function (oldpart) {
					if (oldpart.$ === 1) {
						var s = oldpart.a;
						return A2($author$project$Ziege$Editor$EPlaceholder, s, textstring);
					} else {
						return oldpart;
					}
				};
				var updateTextParts = A2($elm_community$list_extra$List$Extra$updateAt, index, updateTextPart);
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{
									K: updateTextParts(ptd.K)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 20:
				var text = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{co: text});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 21:
				var text = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{cn: text});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 22:
				var text = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{cp: text});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 23:
				var isfav = msg.a;
				var _v6 = model.f;
				if (_v6.$ === 5) {
					var pendingTodo = _v6.a;
					var withPending = A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{b1: isfav});
						},
						model);
					return isfav ? _Utils_Tuple2(
						A2($author$project$Main$addFavorite, pendingTodo.I, withPending),
						A2($author$project$Main$addFavoriteToPatternServer, model, pendingTodo.I)) : _Utils_Tuple2(
						A2($author$project$Main$removeFavorite, pendingTodo.I, withPending),
						A2($author$project$Main$removeFavoriteFromPatternServer, model, pendingTodo.I));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 26:
				var patname = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Main$addFavorite, patname, model),
					A2($author$project$Main$addFavoriteToPatternServer, model, patname));
			case 27:
				var patname = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Main$removeFavorite, patname, model),
					A2($author$project$Main$removeFavoriteFromPatternServer, model, patname));
			case 24:
				var pToDo = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$random$Random$generate,
						$author$project$Ziege$Model$AddPendingTodoWithId(pToDo),
						$author$project$Main$todoIdGenerator));
			case 25:
				var pToDo = msg.a;
				var newId = msg.b;
				var sentpToDo = A2($author$project$Main$sendPendingTodo2PatternServer, model, pToDo);
				var _v7 = $author$project$Main$getActiveClient(model);
				if (_v7.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var client = _v7.a;
					var _v8 = model.f;
					if (_v8.$ === 5) {
						var ptodo = _v8.a;
						var newclient = _Utils_update(
							client,
							{
								eK: '',
								eL: '',
								v: A2(
									$elm$core$List$cons,
									{
										q: $author$project$Ziege$TodoInterval$newCompletionHistory(model.af),
										L: ptodo.L,
										bA: newId,
										l: $author$project$Ziege$ModelEncodeDecode$editInterval2Interval(ptodo.U),
										I: ptodo.I,
										K: $author$project$Ziege$Editor$patternTextPartstoString(ptodo.K),
										j: ptodo.j
									},
									client.v)
							});
						var newmodel = _Utils_update(
							model,
							{
								f: $author$project$Ziege$Model$ClientTodoList,
								c: A3($elm$core$Dict$insert, model.O, newclient, model.c)
							});
						return _Utils_Tuple2(
							A2(
								pToDo.b1 ? $author$project$Main$addFavorite : $author$project$Main$removeFavorite,
								pToDo.I,
								newmodel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										saveToBrowser(newmodel),
										updateRoom(
										A2($elm$core$Dict$get, newmodel.O, newmodel.c)),
										sentpToDo,
										A2($author$project$Main$uploadResearchData, newmodel, newclient)
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 30:
				var base = msg.a;
				var updateIntervalHelper = function (editinterval) {
					return _Utils_update(
						editinterval,
						{aV: base});
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{
									U: updateIntervalHelper(ptd.U)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 31:
				var updateIntervalHelper = function (editinterval) {
					return _Utils_update(
						editinterval,
						{
							av: A2($elm$core$Basics$min, 9, editinterval.av) + 1
						});
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{
									U: updateIntervalHelper(ptd.U)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 32:
				var updateIntervalHelper = function (editinterval) {
					return _Utils_update(
						editinterval,
						{
							av: A2($elm$core$Basics$max, 1, editinterval.av) - 1
						});
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{
									U: updateIntervalHelper(ptd.U)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 33:
				var updateIntervalHelper = function (editinterval) {
					return _Utils_update(
						editinterval,
						{
							a5: A2($elm$core$Basics$min, 9, editinterval.a5) + 1
						});
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{
									U: updateIntervalHelper(ptd.U)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 34:
				var updateIntervalHelper = function (editinterval) {
					return _Utils_update(
						editinterval,
						{
							a5: A2($elm$core$Basics$max, 1, editinterval.a5) - 1
						});
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{
									U: updateIntervalHelper(ptd.U)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 15:
				var newView = msg.a;
				var favoritesCommand = function () {
					if (newView.$ === 3) {
						return $author$project$Main$fetchFavoritesFromPatternServer(model);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var command = (!_Utils_eq(model.f, newView)) ? saveToBrowser(model) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f: newView}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[command, favoritesCommand])));
			case 36:
				var v = msg.a;
				var _v10 = A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
					v);
				if (!_v10.$) {
					var message = _v10.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bC: $elm$core$Maybe$Just(message)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = _v10.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Fehlermeldung nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 41:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bC: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 38:
				var v = msg.a;
				var _v11 = A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
					v);
				if (!_v11.$) {
					var roomId = _v11.a;
					if (model.g === 1) {
						var who = A2(
							$elm$core$Maybe$withDefault,
							'einer Klient*in',
							A2(
								$elm$core$Maybe$map,
								$author$project$Ziege$Model$describeClient,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (c) {
											return _Utils_eq(c.i, roomId);
										},
										$elm$core$Dict$values(model.c)))));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bC: $elm$core$Maybe$Just('Ziege ist nicht mehr im Raum von ' + (who + '. Änderungen kommen dort nicht mehr an. Unter Klienteneinstellungen lässt sich der Eintrag mit „Verbindung trennen“ entfernen.'))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var err = _v11.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Raummeldung nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 39:
				return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
			case 40:
				var roomId = msg.a;
				var _v12 = A2($elm$core$Dict$get, roomId, model.b4);
				if (!_v12.$) {
					var payload = _v12.a;
					var who = A2(
						$elm$core$Maybe$withDefault,
						'raum',
						A2(
							$elm$core$Maybe$map,
							function (c) {
								return A2(
									$elm$core$String$dropLeft,
									1,
									A2(
										$elm$core$Maybe$withDefault,
										c.m,
										$elm$core$List$head(
											A2($elm$core$String$split, ':', c.m))));
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (c) {
										return _Utils_eq(c.i, roomId);
									},
									$elm$core$Dict$values(model.c)))));
					return _Utils_Tuple2(
						model,
						A3(
							$elm$file$File$Download$string,
							'ziege-status-' + (who + ('-' + ($author$project$Main$isoDate(model.af) + '.json'))),
							'application/json',
							A2($elm$json$Json$Encode$encode, 2, payload)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 37:
				var v = msg.a;
				var _v13 = A2(
					$elm$json$Json$Decode$decodeValue,
					A4(
						$elm$json$Json$Decode$map3,
						F3(
							function (r, b, j) {
								return _Utils_Tuple3(r, b, j);
							}),
						A2($elm$json$Json$Decode$field, 'roomid', $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$field, 'bytes', $elm$json$Json$Decode$int),
						A2($elm$json$Json$Decode$field, 'rejected', $elm$json$Json$Decode$bool)),
					v);
				if (!_v13.$) {
					var _v14 = _v13.a;
					var roomId = _v14.a;
					var bytes = _v14.b;
					var rejected = _v14.c;
					return (model.g === 1) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bC: $elm$core$Maybe$Just(
									A4($author$project$Main$statusSizeMessage, model, roomId, bytes, rejected))
							}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var err = _v13.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Größenmeldung nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 42:
				var v = msg.a;
				var recorded = A2(
					$author$project$Main$recordLastStatus,
					v,
					A2($author$project$Main$recordStatusVersion, v, model));
				var _v15 = function () {
					var _v16 = A2(
						$elm$core$Maybe$map,
						function (m) {
							return _Utils_Tuple2(
								m.cI,
								$author$project$Ziege$ModelEncodeDecode$decodeStatusMinimumVersion(m.b8));
						},
						$author$project$Ziege$MatrixPort$decodeMessage(v));
					if (!_v16.$) {
						var _v17 = _v16.a;
						var roomId = _v17.a;
						var minimum = _v17.b;
						return ($elm$core$String$isEmpty(minimum) || A2($author$project$Ziege$ModelEncodeDecode$versionAtLeast, minimum, model.aI)) ? A2($author$project$Main$handleMatrixStatusUpdate, v, recorded) : _Utils_Tuple2(
							_Utils_update(
								recorded,
								{
									bG: A2($elm$core$Set$insert, roomId, recorded.bG)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return A2($author$project$Main$handleMatrixStatusUpdate, v, recorded);
					}
				}();
				var newmodel = _v15.a;
				var statusCmd = _v15.b;
				return model.bL ? _Utils_Tuple2(
					_Utils_update(
						newmodel,
						{cU: true}),
					statusCmd) : _Utils_Tuple2(
					newmodel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								statusCmd,
								saveToBrowser(newmodel)
							])));
			case 43:
				var v = msg.a;
				return A2($author$project$Main$handleAccessToken, v, model);
			case 57:
				var v = msg.a;
				return A2($author$project$Main$handleCryptoStatus, v, model);
			case 58:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bd: !model.bd, aZ: false}),
					$elm$core$Platform$Cmd$none);
			case 59:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aJ: false, bd: true, aZ: false, bB: false}),
					$elm$core$Platform$Cmd$none);
			case 60:
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aZ: false}),
					A2($author$project$Main$sendCryptoAction, action, _List_Nil));
			case 61:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bH: s}),
					$elm$core$Platform$Cmd$none);
			case 62:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Main$sendCryptoAction,
						'recoveryKey',
						_List_fromArray(
							[
								_Utils_Tuple2(
								'key',
								$elm$json$Json$Encode$string(model.bH))
							])));
			case 63:
				var requested = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aZ: requested}),
					$elm$core$Platform$Cmd$none);
			case 64:
				var v = msg.a;
				var _v18 = A2(
					$elm$json$Json$Decode$decodeValue,
					$elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeRoomInvite),
					v);
				if (!_v18.$) {
					var invites = _v18.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bp: invites}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = _v18.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Einladungen nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 66:
				var v = msg.a;
				var _v19 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ziege$ModelEncodeDecode$decodeRoomMembership, v);
				if (!_v19.$) {
					var _v20 = _v19.a;
					var roomId = _v20.a;
					var members = _v20.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aQ: A3($elm$core$Dict$insert, roomId, members, model.aQ)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = _v19.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Mitgliedschaft nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 70:
				var userId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aN: A3($elm$core$Dict$insert, userId, $author$project$Ziege$Model$DevicesLoading, model.aN)
						}),
					$author$project$Ziege$MatrixPort$requestDevices(userId));
			case 71:
				var userId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aN: A2($elm$core$Dict$remove, userId, model.aN)
						}),
					$elm$core$Platform$Cmd$none);
			case 72:
				var v = msg.a;
				var _v21 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ziege$ModelEncodeDecode$decodeDevices, v);
				if (!_v21.$) {
					var _v22 = _v21.a;
					var userId = _v22.a;
					var state = _v22.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aN: A3($elm$core$Dict$insert, userId, state, model.aN)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = _v21.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Apps nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 69:
				var roomId = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							$author$project$Ziege$MatrixPort$updateClientRoom(
								$author$project$Main$statusExtras(model)),
							A2(
								$elm$core$List$filter,
								function (client) {
									return _Utils_eq(client.i, roomId);
								},
								$elm$core$Dict$values(model.c)))));
			case 68:
				var v = msg.a;
				var _v23 = A2(
					$elm$json$Json$Decode$decodeValue,
					$elm$json$Json$Decode$list($author$project$Ziege$ModelEncodeDecode$decodeDecryptionProblem),
					v);
				if (!_v23.$) {
					var problems = _v23.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c3: problems}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = _v23.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Entschlüsselungsprobleme nicht lesbar: ' + $elm$json$Json$Decode$errorToString(err)));
				}
			case 67:
				var roomId = msg.a;
				var userId = msg.b;
				return _Utils_Tuple2(
					model,
					$author$project$Ziege$MatrixPort$reinviteToRoom(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'roomid',
									$elm$json$Json$Encode$string(roomId)),
									_Utils_Tuple2(
									'userid',
									$elm$json$Json$Encode$string(userId))
								]))));
			case 65:
				var roomId = msg.a;
				var accept = msg.b;
				var switching = accept && ((!model.g) && ((!$elm$core$String$isEmpty(
					$author$project$Main$ownClientRoom(model))) && (!_Utils_eq(
					$author$project$Main$ownClientRoom(model),
					roomId))));
				var answer = F2(
					function (rid, acc) {
						return $author$project$Ziege$MatrixPort$answerRoomInvite(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'roomid',
										$elm$json$Json$Encode$string(rid)),
										_Utils_Tuple2(
										'accept',
										$elm$json$Json$Encode$bool(acc))
									])));
					});
				var othersDeclined = (accept && (!model.g)) ? A2(
					$elm$core$List$map,
					function (invite) {
						return A2(answer, invite.i, false);
					},
					A2(
						$elm$core$List$filter,
						function (invite) {
							return !_Utils_eq(invite.i, roomId);
						},
						model.bp)) : _List_Nil;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b3: switching ? $elm$core$Maybe$Just(
								{
									c$: A2(
										$elm$core$List$any,
										$author$project$Main$invitedByFormerPartner(model),
										A2(
											$elm$core$List$filter,
											function (invite) {
												return _Utils_eq(invite.i, roomId);
											},
											model.bp)),
									i: roomId
								}) : model.b3,
							bp: (accept && (!model.g)) ? _List_Nil : A2(
								$elm$core$List$filter,
								function (invite) {
									return !_Utils_eq(invite.i, roomId);
								},
								model.bp)
						}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2(answer, roomId, accept),
							othersDeclined)));
			case 73:
				return _Utils_Tuple2(
					model,
					$author$project$Ziege$MatrixPort$requestNotificationPermission($elm$json$Json$Encode$null));
			case 74:
				var v = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Main$handleNotificationPermissionUpdate, v, model),
					$elm$core$Platform$Cmd$none);
			case 55:
				var v = msg.a;
				var _v24 = A2($author$project$Main$handleMatrixLeaveRoom, v, model);
				var newmodel = _v24.a;
				var leaveCmd = _v24.b;
				return _Utils_Tuple2(
					newmodel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								leaveCmd,
								saveToBrowser(newmodel)
							])));
			case 44:
				var isActive = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (p) {
							return _Utils_update(
								p,
								{b0: isActive});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 45:
				var proposalState = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (ptd) {
							return _Utils_update(
								ptd,
								{b2: proposalState});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 47:
				var before = msg.a;
				var result = msg.b;
				if (!result.$) {
					var patterns = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ab: $elm$core$Set$fromList(patterns)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ab: before}),
						$author$project$Ziege$MatrixPort$logError(
							'Favoriten nicht abgeglichen: ' + $author$project$Main$httpErrorToString(error)));
				}
			case 56:
				if (!msg.a.$) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ziege$MatrixPort$logError(
							'Forschungsdaten nicht hochgeladen: ' + $author$project$Main$httpErrorToString(error)));
				}
			case 46:
				var result = msg.a;
				if (!result.$) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var errorString = result.a;
					var newmodel = _Utils_update(
						model,
						{
							f: A2(
								$author$project$Ziege$Model$ErrorView,
								'Der Vorschlag wurde nicht gesendet: ' + $author$project$Main$httpErrorToString(errorString),
								false)
						});
					return _Utils_Tuple2(newmodel, $elm$core$Platform$Cmd$none);
				}
			case 48:
				var isActive = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Main$updatePendingTodo,
						function (p) {
							return _Utils_update(
								p,
								{b_: isActive});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 50:
				var client = msg.a;
				var e = msg.b;
				var _v27 = A4(
					$author$project$Ziege$UI$ClientEditSettings$updateClientEditNames,
					model.n,
					$author$project$Main$statusExtras(model),
					e,
					client);
				var changedClient = _v27.a;
				var m = _v27.b;
				var newModel = A3(
					$author$project$Main$updateClient,
					function (_v28) {
						return changedClient;
					},
					changedClient.m,
					model);
				return _Utils_Tuple2(newModel, m);
			case 51:
				var catName = msg.a;
				var _v29 = model.f;
				if (_v29.$ === 3) {
					var openCats = _v29.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: $author$project$Ziege$Model$PatternSelectorView(
									A2($author$project$Ziege$Utils$setToggle, catName, openCats))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 52:
				return model.aJ ? _Utils_Tuple2(
					_Utils_update(
						model,
						{aJ: false, bB: false}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{aJ: true}),
					saveToBrowser(model));
			case 53:
				var requested = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bB: requested}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Ziege$MatrixPort$performLogout($elm$json$Json$Encode$null));
		}
	});
var $author$project$Main$updateWithHistory = F2(
	function (msg, model) {
		var historyDepth = function () {
			if (msg.$ === 9) {
				var depth = msg.a;
				return depth;
			} else {
				return $author$project$Main$navigationDepth(model);
			}
		}();
		var _v0 = A2($author$project$Main$update, msg, model);
		var newModel = _v0.a;
		var cmd = _v0.b;
		var newDepth = $author$project$Main$navigationDepth(newModel);
		return _Utils_eq(newDepth, historyDepth) ? _Utils_Tuple2(newModel, cmd) : _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$Ziege$NavigationPort$navigateTo(newDepth)
					])));
	});
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {aW: body, j: title};
	});
var $author$project$Ziege$UI$Header$BackButton = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ziege$UI$Header$CancelButton = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ziege$Model$ClientEditNamesMsg = F2(
	function (a, b) {
		return {$: 50, a: a, b: b};
	});
var $author$project$Ziege$UI$Header$Empty = {$: 2};
var $author$project$Ziege$UI$Header$GoatButton = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ziege$UI$Header$Icon = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ziege$Model$NavigateBackTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ziege$UI$Colors$Surface = 0;
var $author$project$Ziege$UI$Colors$Text = 3;
var $author$project$Ziege$Model$ToggleGoatMode = {$: 52};
var $author$project$Ziege$UI$Colors$cssVar = function (tone) {
	return 'var(--z-' + (function () {
		switch (tone) {
			case 0:
				return 'surface';
			case 1:
				return 'sunken';
			case 2:
				return 'band-text';
			case 3:
				return 'text';
			case 4:
				return 'text-strong';
			case 5:
				return 'text-muted';
			case 6:
				return 'text-faint';
			case 7:
				return 'line';
			case 8:
				return 'line-light';
			case 9:
				return 'info';
			case 10:
				return 'star';
			case 11:
				return 'accent';
			case 12:
				return 'danger';
			case 13:
				return 'on-danger';
			case 14:
				return 'danger-text';
			case 15:
				return 'favorite-user';
			case 16:
				return 'favorite-server';
			case 17:
				return 'overlay';
			case 18:
				return 'control';
			case 19:
				return 'done';
			case 20:
				return 'partial';
			case 21:
				return 'missed';
			case 22:
				return 'caution';
			case 23:
				return 'on-caution';
			case 24:
				return 'path';
			default:
				return 'on-primary';
		}
	}() + ')');
};
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Ziege$UI$Colors$bg = function (tone) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Attributes$style,
			'background-color',
			$author$project$Ziege$UI$Colors$cssVar(tone)));
};
var $author$project$Ziege$Model$AddClient = {$: 2};
var $author$project$Ziege$UI$Colors$LineLight = 8;
var $author$project$Ziege$Model$NewClientFirstname = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ziege$Model$NewClientLastname = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ziege$Model$NewClientUsername = function (a) {
	return {$: 49, a: a};
};
var $author$project$Ziege$UI$Colors$TextFaint = 6;
var $author$project$Ziege$UI$Colors$TextMuted = 5;
var $author$project$Ziege$UI$Colors$Sunken = 1;
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Internal$Style$classes = {fF: 'a', cW: 'atv', fJ: 'ab', fK: 'cx', fL: 'cy', fM: 'acb', fN: 'accx', fO: 'accy', fP: 'acr', dX: 'al', dY: 'ar', fQ: 'at', cX: 'ah', cY: 'av', fT: 's', f$: 'bh', f0: 'b', f3: 'w7', f5: 'bd', f6: 'bdt', cj: 'bn', f7: 'bs', ck: 'cpe', gj: 'cp', gk: 'cpx', gl: 'cpy', aX: 'c', cq: 'ctr', cr: 'cb', cs: 'ccx', aY: 'ccy', bW: 'cl', ct: 'cr', gn: 'ct', gp: 'cptr', gq: 'ctxt', gQ: 'fcs', eh: 'focus-within', gS: 'fs', gT: 'g', dc: 'hbh', dd: 'hc', eq: 'he', de: 'hf', er: 'hfp', g$: 'hv', g2: 'ic', g4: 'fr', cC: 'lbl', g7: 'iml', g8: 'imlf', g9: 'imlp', ha: 'implw', hb: 'it', hj: 'i', eD: 'lnk', bD: 'nb', eM: 'notxt', hL: 'ol', hM: 'or', bl: 'oq', hT: 'oh', eQ: 'pg', eR: 'p', hV: 'ppe', h3: 'ui', e9: 'r', h7: 'sb', h8: 'sbx', h9: 'sby', ia: 'sbt', ik: 'e', im: 'cap', $9: 'sev', iy: 'sk', K: 't', iC: 'tc', iD: 'w8', iE: 'w2', iF: 'w9', iG: 'tj', cQ: 'tja', iH: 'tl', iI: 'w3', iJ: 'w5', iK: 'w4', iL: 'tr', iM: 'w6', iN: 'w1', iO: 'tun', fs: 'ts', bs: 'clr', i4: 'u', dP: 'wc', fB: 'we', dQ: 'wf', fC: 'wfp', dS: 'wrp'};
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.aX);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gT);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eQ);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eR);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.e9);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ik);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Basics$round = _Basics_round;
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.h6)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.aL)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.io.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.io.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.e9) + ('-' + ($elm$core$String$fromInt(pos.d6) + ('-' + ($elm$core$String$fromInt(pos.fA) + ('-' + $elm$core$String$fromInt(pos.ep)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.ex ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.hK.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.hK.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.f2) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.il) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.gm))
				])));
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eh) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.f4),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.fX),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										f2: shadow.f2,
										gm: shadow.gm,
										ex: false,
										hK: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.hK)),
										il: shadow.il
									}));
						},
						focus.ii),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + ':focus .focusable, ') + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + '.focusable:focus, ') + ('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + ' .focusable-thumb'))),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.f4),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.fX),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										f2: shadow.f2,
										gm: shadow.gm,
										ex: false,
										hK: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.hK)),
										il: shadow.il
									}));
						},
						focus.ii),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gn);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cr);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ct);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bW);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cs);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aY);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fQ);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fJ);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dY);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dX);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fK);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dc),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ia),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.K),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dd),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fC),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dP),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ik),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g2))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h3),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g4),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bD),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ik),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fF),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f0),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hM),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hL),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g4),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dS),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gp),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gq),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hV),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ck),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bs),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bl),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.g$, $mdgriffith$elm_ui$Internal$Style$classes.bs)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.g$, $mdgriffith$elm_ui$Internal$Style$classes.bl)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gQ, $mdgriffith$elm_ui$Internal$Style$classes.bs)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gQ, $mdgriffith$elm_ui$Internal$Style$classes.bl)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.cW, $mdgriffith$elm_ui$Internal$Style$classes.bs)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.cW, $mdgriffith$elm_ui$Internal$Style$classes.bl)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fs),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h8),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e9),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ik),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gk),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gl),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dP),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f5),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f6),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.K),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hb),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ik),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eD),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.er),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cq),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fP,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fN,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fK),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fN,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fK),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fN,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fN + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fP + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.fN)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.$9),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0px'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', 'min-content'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eq),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dP),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fM,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fO,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fO,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fO,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fO + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fM + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.fO)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cq),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.$9),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eQ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.fT + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.fT))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.fT + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.fT))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\u0022\u0022'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\u0022\u0022'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ha),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ik),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g8),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eR),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dc),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.K),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eR),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ik),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.g4),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f$),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fF),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f0),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hM),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hL),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.K),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e9),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gT),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iN),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iE),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iI),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iK),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iJ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iM),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f3),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iD),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iF),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iy),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i4),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i4),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iy)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iO),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iG),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cQ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iC),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iL),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iH),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\u0022' + (_var + '\u0022'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\u0022' + (_var + '\u0022 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\u000A.explain {\u000A    border: 6px solid rgb(174, 121, 15) !important;\u000A}\u000A.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.fT + (' {\u000A    border: 4px dashed rgb(0, 151, 167) !important;\u000A}\u000A\u000A.ctr {\u000A    border: none !important;\u000A}\u000A.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.fT + ' {\u000A    border: 4px dashed rgb(0, 151, 167) !important;\u000A}\u000A\u000A')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\u000Ainput[type=\u0022search\u0022],\u000Ainput[type=\u0022search\u0022]::-webkit-search-decoration,\u000Ainput[type=\u0022search\u0022]::-webkit-search-cancel-button,\u000Ainput[type=\u0022search\u0022]::-webkit-search-results-button,\u000Ainput[type=\u0022search\u0022]::-webkit-search-results-decoration {\u000A  -webkit-appearance:none;\u000A}\u000A';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\u000Ainput[type=range] {\u000A  -webkit-appearance: none; \u000A  background: transparent;\u000A  position:absolute;\u000A  left:0;\u000A  top:0;\u000A  z-index:10;\u000A  width: 100%;\u000A  outline: dashed 1px;\u000A  height: 100%;\u000A  opacity: 0;\u000A}\u000A';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\u000Ainput[type=range]::-webkit-slider-thumb {\u000A    -webkit-appearance: none;\u000A    opacity: 0.5;\u000A    width: 80px;\u000A    height: 80px;\u000A    background-color: black;\u000A    border:none;\u000A    border-radius: 5px;\u000A}\u000Ainput[type=range]::-moz-range-thumb {\u000A    opacity: 0.5;\u000A    width: 80px;\u000A    height: 80px;\u000A    background-color: black;\u000A    border:none;\u000A    border-radius: 5px;\u000A}\u000Ainput[type=range]::-ms-thumb {\u000A    opacity: 0.5;\u000A    width: 80px;\u000A    height: 80px;\u000A    background-color: black;\u000A    border:none;\u000A    border-radius: 5px;\u000A}\u000Ainput[type=range][orient=vertical]{\u000A    writing-mode: bt-lr; /* IE */\u000A    -webkit-appearance: slider-vertical;  /* WebKit */\u000A}\u000A';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\u000Ainput[type=range]::-moz-range-track {\u000A    background: transparent;\u000A    cursor: pointer;\u000A}\u000Ainput[type=range]::-ms-track {\u000A    background: transparent;\u000A    cursor: pointer;\u000A}\u000Ainput[type=range]::-webkit-slider-runnable-track {\u000A    background: transparent;\u000A    cursor: pointer;\u000A}\u000A';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e9) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e9) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cq) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {cl: closing, S: _List_Nil, a3: _List_Nil, aE: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								a3: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.a3)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									{cl: '\u000A}', S: _List_Nil, a3: props, aE: '@supports (' + (prop + (':' + (value + (') {' + parent.aE))))},
									rendered.S)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aE + (' + ' + selector), ''),
										adjRules),
									rendered.S)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aE + (' > ' + child), ''),
										childRules),
									rendered.S)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aE + (' ' + child), ''),
										childRules),
									rendered.S)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.aE, descriptor),
											''),
										descriptorRules),
									rendered.S)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aE, ''),
										batched),
									rendered.S)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.a3;
		if (!_v2.b) {
			return '';
		} else {
			return rule.aE + ('{' + (renderValues(rule.a3) + (rule.cl + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.S)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.hy;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\u0022' + (name + '\u0022');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\u0022' + (name + '\u0022');
		default:
			var name = font.a.I;
			return '\u0022' + (name + '\u0022');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.ft);
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\u000A  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\u000A  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\u000A}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.g$;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\u000A}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\u000A}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[
							selector + ('-fs:focus {' + (renderedProps + '\u000A}')),
							('.' + ($mdgriffith$elm_ui$Internal$Style$classes.fT + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\u000A}'),
							(selector + '-fs:focus-within {') + (renderedProps + '\u000A}'),
							('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fT) + (' .focusable-thumb' + (selector + '-fs {')))) + (renderedProps + '\u000A}')
						]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\u000A}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\u0022' + (name + '\u0022');
		case 1:
			var name = _var.a;
			return '\u0022' + (name + '\u0022 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\u0022' + (name + ('\u0022 ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.ft)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.ik;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.e9;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.dS + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.dY;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.eR;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.eQ;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.dX;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.aX;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.fT;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\u0027\u0027'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\u0027\u0027'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.io.a);
				var ySpacing = toGridLength(template.io.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.h6)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.aL)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.aL)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.io.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.io.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.aL)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.h6)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.aL)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.io.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.io.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.e9) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.ep) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.d6) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.fA) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.e9) + (' / ' + ($elm$core$String$fromInt(position.e9 + position.ep) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.d6) + (' / ' + ($elm$core$String$fromInt(position.d6 + position.fA) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.e9) + ('-' + ($elm$core$String$fromInt(position.d6) + ('-' + ($elm$core$String$fromInt(position.fA) + ('-' + $elm$core$String$fromInt(position.ep)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.K + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.K)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.im, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.gS, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.im + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.im))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.im + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.K + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.im + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.K)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {ep: height / size, il: size, fv: vertical};
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.gf, adjustment.f_, adjustment.gx, adjustment.hq]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.gx,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.f_,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.gf,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		gf: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		ej: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.ep)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.fv) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.il) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.fI;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.ej;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.gf;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\u0027' + (url + '\u0027);'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\u000A',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\u000A',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\u000A',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					cJ: _Utils_ap(
						rendered.cJ,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					cc: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.cc;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.cc);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{cJ: _List_Nil, cc: _List_Nil},
			stylesheet);
		var rules = _v0.cJ;
		var topLevel = _v0.cc;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.hy;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.gQ)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.gQ)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ik))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fT, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.cq, $mdgriffith$elm_ui$Internal$Style$classes.aY, $mdgriffith$elm_ui$Internal$Style$classes.fP])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fT, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.cq, $mdgriffith$elm_ui$Internal$Style$classes.aY, $mdgriffith$elm_ui$Internal$Style$classes.fN])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fT, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.cq, $mdgriffith$elm_ui$Internal$Style$classes.fO])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fT, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.cq, $mdgriffith$elm_ui$Internal$Style$classes.fM])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.K + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.dP + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dd)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.fT + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.K + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.dQ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.de)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.g0, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.fj : _Utils_ap(styled.fj, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.g0, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.fj : _Utils_ap(styled.fj, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.g0, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.fj : _Utils_ap(styled.fj, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.g0, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.fj : _Utils_ap(styled.fj, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.fj : _Utils_ap(rendered.fj, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.bf,
						rendered.eN,
						rendered.ba,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.gh)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						g0: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.bf,
							rendered.eN,
							rendered.ba,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.gh))),
						fj: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.fj : _Utils_ap(rendered.fj, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.bf,
						rendered.eN,
						rendered.ba,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.gh)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						g0: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.bf,
							rendered.eN,
							rendered.ba,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.gh))),
						fj: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bD, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.fF]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bD, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.f0]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bD, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.hM]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bD, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.hL]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bD, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.g4]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.bD, $mdgriffith$elm_ui$Internal$Style$classes.ik, $mdgriffith$elm_ui$Internal$Style$classes.f$]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.g0, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.cX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dX);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.cX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dY);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.cX + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fK);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.cY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fQ);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.cY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fJ);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.cY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fL);
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.eq + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dd,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.de,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.er + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.fT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.aX + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px !important');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.fB + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dP,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dQ,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.fC + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.fT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.e9 + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						ba: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						gh: children,
						bf: has,
						eN: node,
						fj: styles
					};
				} else {
					var _class = _v1.a;
					return {
						ba: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						gh: children,
						bf: has,
						eN: node,
						fj: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.fB + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dP),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dQ),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.fC + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.fT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.e9 + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.eq + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.dd + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.de + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.er + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.fT + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.aX + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.fj);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.gn + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bW)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $mdgriffith$elm_ui$Internal$Model$paddingName = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left)))))));
	});
var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
	var left = _v0.a$;
	var bottom = _v0.X;
	var right = _v0.a4;
	var top = _v0.aS;
	if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
		var topFloat = top;
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				'p-' + $elm$core$String$fromInt(top),
				topFloat,
				topFloat,
				topFloat,
				topFloat));
	} else {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				A4($mdgriffith$elm_ui$Internal$Model$paddingName, top, right, bottom, left),
				top,
				right,
				bottom,
				left));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + $elm$core$String$fromInt(radius),
			'border-radius',
			$elm$core$String$fromInt(radius) + 'px'));
};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $author$project$Ziege$UI$Utils$actionPanel = function (buttons) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$paddingEach(
				{X: 10, a$: 10, a4: 10, aS: 20})
			]),
		A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$padding(14),
					$author$project$Ziege$UI$Colors$bg(1),
					$mdgriffith$elm_ui$Element$Border$rounded(12)
				]),
			buttons));
};
var $mdgriffith$elm_ui$Internal$Model$Class = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
var $mdgriffith$elm_ui$Element$Font$bold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.f3);
var $author$project$Ziege$UI$Colors$borderColor = function (tone) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Attributes$style,
			'border-color',
			$author$project$Ziege$UI$Colors$cssVar(tone)));
};
var $author$project$Ziege$UI$Colors$OnPrimary = 25;
var $author$project$Ziege$UI$Colors$Primary = 24;
var $mdgriffith$elm_ui$Internal$Model$Button = {$: 8};
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $mdgriffith$elm_ui$Element$Input$enter = 'Enter';
var $mdgriffith$elm_ui$Internal$Model$NoAttribute = {$: 0};
var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
	if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
		var _v1 = attr.b;
		var _v2 = _v1.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
	return A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onClick);
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
	var decode = function (code) {
		var _v0 = lookup(code);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('No key matched');
		} else {
			var msg = _v0.a;
			return $elm$json$Json$Decode$succeed(msg);
		}
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		A2(
			$elm$html$Html$Events$preventDefaultOn,
			'keydown',
			A2(
				$elm$json$Json$Decode$map,
				function (fired) {
					return _Utils_Tuple2(fired, true);
				},
				isKey)));
};
var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
var $mdgriffith$elm_ui$Element$pointer = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.gp);
var $mdgriffith$elm_ui$Element$Input$space = ' ';
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $mdgriffith$elm_ui$Element$Input$button = F2(
	function (attrs, _v0) {
		var label = _v0.u;
		var onPress = _v0.aA;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cs + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aY + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.ia + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eM)))))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$pointer,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Input$focusDefault(attrs),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											$elm$html$Html$Attributes$tabindex(0)),
										function () {
											if (onPress.$ === 1) {
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$Attr(
														$elm$html$Html$Attributes$disabled(true)),
													attrs);
											} else {
												var msg = onPress.a;
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$Events$onClick(msg),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$Input$onKeyLookup(
															function (code) {
																return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(msg) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing);
															}),
														attrs));
											}
										}()))))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $author$project$Ziege$UI$Colors$fg = function (tone) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Attributes$style,
			'color',
			$author$project$Ziege$UI$Colors$cssVar(tone)));
};
var $mdgriffith$elm_ui$Element$paddingXY = F2(
	function (x, y) {
		if (_Utils_eq(x, y)) {
			var f = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + $elm$core$String$fromInt(x),
					f,
					f,
					f,
					f));
		} else {
			var yFloat = y;
			var xFloat = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
					yFloat,
					xFloat,
					yFloat,
					xFloat));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $author$project$Ziege$UI$Button$buildPrimaryButton = F2(
	function (label, msg) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 12),
					$mdgriffith$elm_ui$Element$Border$rounded(8),
					$author$project$Ziege$UI$Colors$bg(24),
					$author$project$Ziege$UI$Colors$fg(25),
					$mdgriffith$elm_ui$Element$Font$bold,
					$mdgriffith$elm_ui$Element$Font$size(17)
				]),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$mdgriffith$elm_ui$Element$text(label)),
				aA: $elm$core$Maybe$Just(msg)
			});
	});
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $mdgriffith$elm_ui$Internal$Model$boxShadowClass = function (shadow) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				shadow.ex ? 'box-inset' : 'box-',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.hK.a) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.hK.b) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.f2) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.il) + 'px',
				$mdgriffith$elm_ui$Internal$Model$formatColorClass(shadow.gm)
			]));
};
var $mdgriffith$elm_ui$Internal$Flag$shadows = $mdgriffith$elm_ui$Internal$Flag$flag(19);
var $mdgriffith$elm_ui$Element$Border$shadow = function (almostShade) {
	var shade = {f2: almostShade.f2, gm: almostShade.gm, ex: false, hK: almostShade.hK, il: almostShade.il};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Element$Border$width = function (v) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + $elm$core$String$fromInt(v),
			v,
			v,
			v,
			v));
};
var $author$project$Ziege$UI$Utils$cardStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$author$project$Ziege$UI$Colors$bg(0),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$author$project$Ziege$UI$Colors$borderColor(8),
		$mdgriffith$elm_ui$Element$Border$rounded(10),
		$mdgriffith$elm_ui$Element$Border$shadow(
		{
			f2: 3,
			gm: A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.12),
			hK: _Utils_Tuple2(0, 1),
			il: 0
		})
	]);
var $author$project$Ziege$UI$Utils$card = function (content) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5)
			]),
		A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				$author$project$Ziege$UI$Utils$cardStyle,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(14),
						$mdgriffith$elm_ui$Element$spacing(12),
						$mdgriffith$elm_ui$Element$Font$size(14)
					])),
			content));
};
var $mdgriffith$elm_ui$Internal$Flag$fontAlignment = $mdgriffith$elm_ui$Internal$Flag$flag(12);
var $mdgriffith$elm_ui$Element$Font$center = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.iC);
var $author$project$Ziege$UI$Utils$edges = {X: 0, a$: 0, a4: 0, aS: 0};
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$Ziege$UI$Utils$fieldHint = function (s) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size(12),
				$author$project$Ziege$UI$Colors$fg(5)
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(s)
			]));
};
var $mdgriffith$elm_ui$Element$Input$Above = 2;
var $mdgriffith$elm_ui$Element$Input$Label = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Element$Input$labelAbove = $mdgriffith$elm_ui$Element$Input$Label(2);
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $mdgriffith$elm_ui$Element$Input$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$placeholder = $mdgriffith$elm_ui$Element$Input$Placeholder;
var $author$project$Ziege$UI$Colors$BandText = 2;
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $mdgriffith$elm_ui$Internal$Flag$letterSpacing = $mdgriffith$elm_ui$Internal$Flag$flag(16);
var $mdgriffith$elm_ui$Element$Font$letterSpacing = function (offset) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$letterSpacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'ls-' + $mdgriffith$elm_ui$Internal$Model$floatClass(offset),
			'letter-spacing',
			$elm$core$String$fromFloat(offset) + 'px'));
};
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bW + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.aY)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Ziege$UI$Utils$sectionHeader = F2(
	function (title, detail) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$paddingEach(
					{X: 6, a$: 16, a4: 16, aS: 18})
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(13),
							$mdgriffith$elm_ui$Element$Font$bold,
							$author$project$Ziege$UI$Colors$fg(2),
							$mdgriffith$elm_ui$Element$Font$letterSpacing(0.6)
						]),
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$toUpper(title))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignRight,
							$mdgriffith$elm_ui$Element$Font$size(13),
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					$mdgriffith$elm_ui$Element$text(detail))
				]));
	});
var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Input$TextArea = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$LivePolite = {$: 6};
var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
var $mdgriffith$elm_ui$Element$Input$applyLabel = F3(
	function (attrs, label, input) {
		if (label.$ === 1) {
			var labelText = label.a;
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asColumn,
				$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
				attrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[input])));
		} else {
			var position = label.a;
			var labelAttrs = label.b;
			var labelChild = label.c;
			var labelElement = A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				labelAttrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[labelChild])));
			switch (position) {
				case 2:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cC),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
				case 3:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cC),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				case 0:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cC),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				default:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cC),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
			}
		}
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $mdgriffith$elm_ui$Element$Input$autofill = A2(
	$elm$core$Basics$composeL,
	$mdgriffith$elm_ui$Internal$Model$Attr,
	$elm$html$Html$Attributes$attribute('autocomplete'));
var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
var $mdgriffith$elm_ui$Internal$Model$Nearby = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$createNearby = F2(
	function (loc, element) {
		if (element.$ === 3) {
			return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
		} else {
			return A2($mdgriffith$elm_ui$Internal$Model$Nearby, loc, element);
		}
	});
var $mdgriffith$elm_ui$Element$behindContent = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 5, element);
};
var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
var $mdgriffith$elm_ui$Element$moveUp = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(-y));
};
var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
	var gatherSpacing = F2(
		function (attr, found) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v2 = attr.b;
				var x = _v2.b;
				var y = _v2.c;
				if (found.$ === 1) {
					return $elm$core$Maybe$Just(y);
				} else {
					return found;
				}
			} else {
				return found;
			}
		});
	var _v0 = A3($elm$core$List$foldr, gatherSpacing, $elm$core$Maybe$Nothing, attrs);
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	} else {
		var vSpace = _v0.a;
		return $mdgriffith$elm_ui$Element$moveUp(
			$elm$core$Basics$floor(vSpace / 2));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
var $mdgriffith$elm_ui$Element$clip = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.gj);
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$bgColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'background-color',
			clr));
};
var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'border-color',
			clr));
};
var $mdgriffith$elm_ui$Element$rgb = F3(
	function (r, g, b) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, r, g, b, 1);
	});
var $mdgriffith$elm_ui$Element$Input$darkGrey = A3($mdgriffith$elm_ui$Element$rgb, 186 / 255, 189 / 255, 182 / 255);
var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12);
var $mdgriffith$elm_ui$Element$Input$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Input$defaultTextPadding,
		$mdgriffith$elm_ui$Element$Border$rounded(3),
		$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
		$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$spacing(5),
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
	]);
var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
	if (attr.$ === 8) {
		var h = attr.a;
		return $elm$core$Maybe$Just(h);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
	if (label.$ === 1) {
		var textLabel = label.a;
		return $mdgriffith$elm_ui$Internal$Model$Describe(
			$mdgriffith$elm_ui$Internal$Model$Label(textLabel));
	} else {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	}
};
var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
var $mdgriffith$elm_ui$Element$inFront = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 4, element);
};
var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
	isConstrained:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return true;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isConstrained;
			default:
				var l = len.b;
				return true;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
	if (label.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
	if (!label.$) {
		var loc = label.a;
		switch (loc) {
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return true;
			default:
				return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
	return {X: -box.X, a$: -box.a$, a4: -box.a4, aS: -box.aS};
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
	isFill:
	while (true) {
		switch (len.$) {
			case 2:
				return true;
			case 1:
				return false;
			case 0:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
	isPixel:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
		}
	}
};
var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
	});
var $mdgriffith$elm_ui$Element$Input$redistributeOver = F4(
	function (isMultiline, stacked, attr, els) {
		switch (attr.$) {
			case 9:
				return _Utils_update(
					els,
					{
						d: A2($elm$core$List$cons, attr, els.d)
					});
			case 7:
				var width = attr.a;
				return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(
					els,
					{
						t: A2($elm$core$List$cons, attr, els.t),
						Q: A2($elm$core$List$cons, attr, els.Q),
						d: A2($elm$core$List$cons, attr, els.d)
					}) : (stacked ? _Utils_update(
					els,
					{
						t: A2($elm$core$List$cons, attr, els.t)
					}) : _Utils_update(
					els,
					{
						d: A2($elm$core$List$cons, attr, els.d)
					}));
			case 8:
				var height = attr.a;
				return (!stacked) ? _Utils_update(
					els,
					{
						t: A2($elm$core$List$cons, attr, els.t),
						d: A2($elm$core$List$cons, attr, els.d)
					}) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(
					els,
					{
						t: A2($elm$core$List$cons, attr, els.t),
						d: A2($elm$core$List$cons, attr, els.d)
					}) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(
					els,
					{
						d: A2($elm$core$List$cons, attr, els.d)
					}) : _Utils_update(
					els,
					{
						d: A2($elm$core$List$cons, attr, els.d)
					})));
			case 6:
				return _Utils_update(
					els,
					{
						t: A2($elm$core$List$cons, attr, els.t)
					});
			case 5:
				return _Utils_update(
					els,
					{
						t: A2($elm$core$List$cons, attr, els.t)
					});
			case 4:
				switch (attr.b.$) {
					case 5:
						var _v1 = attr.b;
						return _Utils_update(
							els,
							{
								t: A2($elm$core$List$cons, attr, els.t),
								Q: A2($elm$core$List$cons, attr, els.Q),
								d: A2($elm$core$List$cons, attr, els.d),
								bQ: A2($elm$core$List$cons, attr, els.bQ)
							});
					case 7:
						var cls = attr.a;
						var _v2 = attr.b;
						var pad = _v2.a;
						var t = _v2.b;
						var r = _v2.c;
						var b = _v2.d;
						var l = _v2.e;
						if (isMultiline) {
							return _Utils_update(
								els,
								{
									ai: A2($elm$core$List$cons, attr, els.ai),
									d: A2($elm$core$List$cons, attr, els.d)
								});
						} else {
							var newTop = t - A2($elm$core$Basics$min, t, b);
							var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'line-height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newBottom = b - A2($elm$core$Basics$min, t, b);
							var reducedVerticalPadding = A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, r, newBottom, l),
									newTop,
									r,
									newBottom,
									l));
							return _Utils_update(
								els,
								{
									ai: A2($elm$core$List$cons, attr, els.ai),
									Q: A2(
										$elm$core$List$cons,
										newHeight,
										A2($elm$core$List$cons, newLineHeight, els.Q)),
									d: A2($elm$core$List$cons, reducedVerticalPadding, els.d)
								});
						}
					case 6:
						var _v3 = attr.b;
						return _Utils_update(
							els,
							{
								ai: A2($elm$core$List$cons, attr, els.ai),
								d: A2($elm$core$List$cons, attr, els.d)
							});
					case 10:
						return _Utils_update(
							els,
							{
								ai: A2($elm$core$List$cons, attr, els.ai),
								d: A2($elm$core$List$cons, attr, els.d)
							});
					case 2:
						return _Utils_update(
							els,
							{
								t: A2($elm$core$List$cons, attr, els.t)
							});
					case 1:
						var _v4 = attr.b;
						return _Utils_update(
							els,
							{
								t: A2($elm$core$List$cons, attr, els.t)
							});
					default:
						var flag = attr.a;
						var cls = attr.b;
						return _Utils_update(
							els,
							{
								d: A2($elm$core$List$cons, attr, els.d)
							});
				}
			case 0:
				return els;
			case 1:
				var a = attr.a;
				return _Utils_update(
					els,
					{
						Q: A2($elm$core$List$cons, attr, els.Q)
					});
			case 2:
				return _Utils_update(
					els,
					{
						Q: A2($elm$core$List$cons, attr, els.Q)
					});
			case 3:
				return _Utils_update(
					els,
					{
						d: A2($elm$core$List$cons, attr, els.d)
					});
			default:
				return _Utils_update(
					els,
					{
						Q: A2($elm$core$List$cons, attr, els.Q)
					});
		}
	});
var $mdgriffith$elm_ui$Element$Input$redistribute = F3(
	function (isMultiline, stacked, attrs) {
		return function (redist) {
			return {
				ai: $elm$core$List$reverse(redist.ai),
				t: $elm$core$List$reverse(redist.t),
				Q: $elm$core$List$reverse(redist.Q),
				d: $elm$core$List$reverse(redist.d),
				bQ: $elm$core$List$reverse(redist.bQ)
			};
		}(
			A3(
				$elm$core$List$foldl,
				A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked),
				{ai: _List_Nil, t: _List_Nil, Q: _List_Nil, d: _List_Nil, bQ: _List_Nil},
				attrs));
	});
var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
	var left = _v0.a$;
	var bottom = _v0.X;
	var right = _v0.a4;
	var top = _v0.aS;
	return $elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px'))))));
};
var $mdgriffith$elm_ui$Internal$Model$Transparency = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
var $mdgriffith$elm_ui$Element$alpha = function (o) {
	var transparency = function (x) {
		return 1 - x;
	}(
		A2(
			$elm$core$Basics$min,
			1.0,
			A2($elm$core$Basics$max, 0.0, o)));
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Transparency,
			'transparency-' + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency),
			transparency));
};
var $mdgriffith$elm_ui$Element$Input$charcoal = A3($mdgriffith$elm_ui$Element$rgb, 136 / 255, 138 / 255, 133 / 255);
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor),
			'color',
			fontColor));
};
var $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3(
	function (_v0, forPlaceholder, on) {
		var placeholderAttrs = _v0.a;
		var placeholderEl = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				forPlaceholder,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eM + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hV)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$Border$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$Background$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alpha(
							on ? 1 : 0)
						]),
					placeholderAttrs)),
			placeholderEl);
	});
var $mdgriffith$elm_ui$Element$scrollbarY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.h9);
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$spellcheck);
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$value);
var $mdgriffith$elm_ui$Element$Input$textHelper = F3(
	function (textInput, attrs, textOptions) {
		var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
		var redistributed = A3(
			$mdgriffith$elm_ui$Element$Input$redistribute,
			_Utils_eq(textInput.i3, $mdgriffith$elm_ui$Element$Input$TextArea),
			$mdgriffith$elm_ui$Element$Input$isStacked(textOptions.u),
			withDefaults);
		var onlySpacing = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v9 = attr.b;
				return true;
			} else {
				return false;
			}
		};
		var heightConstrained = function () {
			var _v7 = textInput.i3;
			if (!_v7.$) {
				var inputType = _v7.a;
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$mdgriffith$elm_ui$Element$Input$isConstrained,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
			}
		}();
		var getPadding = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 7)) {
				var cls = attr.a;
				var _v6 = attr.b;
				var pad = _v6.a;
				var t = _v6.b;
				var r = _v6.c;
				var b = _v6.d;
				var l = _v6.e;
				return $elm$core$Maybe$Just(
					{
						X: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(b - 3)),
						a$: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(l - 3)),
						a4: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(r - 3)),
						aS: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(t - 3))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var parentPadding = A2(
			$elm$core$Maybe$withDefault,
			{X: 0, a$: 0, a4: 0, aS: 0},
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$filterMap, getPadding, withDefaults))));
		var inputElement = A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			function () {
				var _v3 = textInput.i3;
				if (!_v3.$) {
					var inputType = _v3.a;
					return $mdgriffith$elm_ui$Internal$Model$NodeName('input');
				} else {
					return $mdgriffith$elm_ui$Internal$Model$NodeName('textarea');
				}
			}(),
			_Utils_ap(
				function () {
					var _v4 = textInput.i3;
					if (!_v4.$) {
						var inputType = _v4.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_(inputType)),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hb)
							]);
					} else {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.g7),
								$mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
								$mdgriffith$elm_ui$Element$paddingEach(parentPadding),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2(
									$elm$html$Html$Attributes$style,
									'margin',
									$mdgriffith$elm_ui$Element$Input$renderBox(
										$mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'))
							]);
					}
				}(),
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Input$value(textOptions.K),
							$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Events$onInput(textOptions.an)),
							$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.u),
							$mdgriffith$elm_ui$Element$Input$spellcheck(textInput.aF),
							A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Internal$Model$NoAttribute,
							A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$Input$autofill, textInput.at))
						]),
					redistributed.Q)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
		var wrappedInput = function () {
			var _v0 = textInput.i3;
			if (_v0.$ === 1) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_Utils_ap(
						(heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eh),
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.ha)
								])),
						redistributed.d),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asParagraph,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Element$inFront(inputElement),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.g9),
												redistributed.bQ)))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(
									function () {
										if (textOptions.K === '') {
											var _v1 = textOptions.b9;
											if (_v1.$ === 1) {
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('\u00A0')
													]);
											} else {
												var place = _v1.a;
												return _List_fromArray(
													[
														A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, _List_Nil, textOptions.K === '')
													]);
											}
										} else {
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Internal$Model$unstyled(
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.g8)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(textOptions.K + '\u00A0')
															])))
												]);
										}
									}()))
							])));
			} else {
				var inputType = _v0.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2(
							$elm$core$List$cons,
							A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eh),
							$elm$core$List$concat(
								_List_fromArray(
									[
										redistributed.d,
										function () {
										var _v2 = textOptions.b9;
										if (_v2.$ === 1) {
											return _List_Nil;
										} else {
											var place = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$behindContent(
													A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, redistributed.ai, textOptions.K === ''))
												]);
										}
									}()
									])))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[inputElement])));
			}
		}();
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.gq),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.u) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5),
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$Region$announce, redistributed.t))),
			textOptions.u,
			wrappedInput);
	});
var $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		at: $elm$core$Maybe$Nothing,
		aF: false,
		i3: $mdgriffith$elm_ui$Element$Input$TextInputNode('text')
	});
var $author$project$Main$buildAddClientView = function (model) {
	var mxid = $author$project$Ziege$Utils$massageMatrixUsername(model.bk);
	var field = F4(
		function (onChange, value, placeholder, label) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$text,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				{
					u: A2(
						$mdgriffith$elm_ui$Element$Input$labelAbove,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$bold]),
						$mdgriffith$elm_ui$Element$text(label)),
					an: onChange,
					b9: $elm$core$Maybe$Just(
						A2(
							$mdgriffith$elm_ui$Element$Input$placeholder,
							_List_Nil,
							$mdgriffith$elm_ui$Element$text(placeholder))),
					K: value
				});
		});
	var buttonError = $author$project$Main$newClientError(model);
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$paddingEach(
				_Utils_update(
					$author$project$Ziege$UI$Utils$edges,
					{X: 10}))
			]),
		_List_fromArray(
			[
				A2($author$project$Ziege$UI$Utils$sectionHeader, 'Neue Klient*in', ''),
				$author$project$Ziege$UI$Utils$card(
				_List_fromArray(
					[
						A4(field, $author$project$Ziege$Model$NewClientFirstname, model.bE, 'Rita', 'Vorname'),
						A4(field, $author$project$Ziege$Model$NewClientLastname, model.bF, 'Musterfrau', 'Nachname'),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(6)
							]),
						_List_fromArray(
							[
								A4(field, $author$project$Ziege$Model$NewClientUsername, model.bk, 'orakel', 'Matrix-Benutzername'),
								$author$project$Ziege$Utils$isValidMatrixId(mxid) ? $author$project$Ziege$UI$Utils$fieldHint('Matrix-ID: ' + mxid) : $mdgriffith$elm_ui$Element$none
							]))
					])),
				$author$project$Ziege$UI$Utils$actionPanel(
				$elm$core$String$isEmpty(buttonError) ? _List_fromArray(
					[
						A2($author$project$Ziege$UI$Button$buildPrimaryButton, 'Mit Klient*in verbinden', $author$project$Ziege$Model$AddClient)
					]) : _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A2($mdgriffith$elm_ui$Element$paddingXY, 10, 12),
								$mdgriffith$elm_ui$Element$Border$width(1),
								$mdgriffith$elm_ui$Element$Border$rounded(8),
								$author$project$Ziege$UI$Colors$borderColor(8),
								$author$project$Ziege$UI$Colors$fg(6),
								$mdgriffith$elm_ui$Element$Font$size(17)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$centerX]),
							$mdgriffith$elm_ui$Element$text('Mit Klient*in verbinden'))),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$author$project$Ziege$UI$Colors$fg(5),
								$mdgriffith$elm_ui$Element$Font$size(13),
								$mdgriffith$elm_ui$Element$Font$center
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(buttonError)
							]))
					]))
			]));
};
var $author$project$Ziege$UI$Colors$Done = 19;
var $author$project$Ziege$UI$Colors$Missed = 21;
var $author$project$Ziege$UI$Colors$Partial = 20;
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Top = 0;
var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
var $author$project$Ziege$TodoInterval$intervalEnd = function (_v0) {
	var e = _v0.b;
	return e;
};
var $author$project$Ziege$TodoInterval$intervalStart = function (_v0) {
	var s = _v0.a;
	return s;
};
var $author$project$Ziege$UI$Utils$listRow = function (attributes) {
	return $mdgriffith$elm_ui$Element$row(
		_Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10),
					A2($mdgriffith$elm_ui$Element$paddingXY, 14, 12)
				]),
			attributes));
};
var $mdgriffith$elm_ui$Element$moveDown = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(y));
};
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $author$project$Ziege$Utils$monthToGerman = function (m) {
	switch (m) {
		case 0:
			return 'Januar';
		case 1:
			return 'Februar';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'Mai';
		case 5:
			return 'Juni';
		case 6:
			return 'Juli';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'Oktober';
		case 10:
			return 'November';
		default:
			return 'Dezember';
	}
};
var $author$project$Ziege$Utils$renderCalendarDate = function (d) {
	return $elm$core$String$fromInt(
		$PanagiotisGeorgiadis$elm_datetime$Calendar$getDay(d)) + ('. ' + ($author$project$Ziege$Utils$monthToGerman(
		$PanagiotisGeorgiadis$elm_datetime$Calendar$getMonth(d)) + (' ' + $elm$core$String$fromInt(
		$PanagiotisGeorgiadis$elm_datetime$Calendar$getYear(d)))));
};
var $author$project$Ziege$TodoInterval$renderIntervalString = function (interval) {
	switch (interval.$) {
		case 0:
			if (interval.a === 1) {
				if (interval.b === 1) {
					return 'jeden Tag';
				} else {
					var times = interval.b;
					return $elm$core$String$fromInt(times) + ' mal am Tag';
				}
			} else {
				if (interval.b === 1) {
					var every = interval.a;
					return 'alle ' + ($elm$core$String$fromInt(every) + ' Tage');
				} else {
					var every = interval.a;
					var times = interval.b;
					return $elm$core$String$fromInt(times) + (' mal alle ' + ($elm$core$String$fromInt(every) + ' Tage'));
				}
			}
		case 1:
			if (interval.a === 1) {
				if (interval.b === 1) {
					return 'jede Woche';
				} else {
					var times = interval.b;
					return $elm$core$String$fromInt(times) + ' pro Woche';
				}
			} else {
				if (interval.b === 1) {
					var every = interval.a;
					return 'alle ' + ($elm$core$String$fromInt(every) + ' Wochen');
				} else {
					var every = interval.a;
					var times = interval.b;
					return $elm$core$String$fromInt(times) + (' mal alle ' + ($elm$core$String$fromInt(every) + ' Wochen'));
				}
			}
		case 2:
			if (interval.a === 1) {
				if (interval.b === 1) {
					return 'an jedem Wochentag';
				} else {
					var times = interval.b;
					return $elm$core$String$fromInt(times) + ' mal an Wochentagen';
				}
			} else {
				if (interval.b === 1) {
					var every = interval.a;
					return 'jeden ' + ($elm$core$String$fromInt(every) + '. Wochentag');
				} else {
					var every = interval.a;
					var times = interval.b;
					return $elm$core$String$fromInt(times) + (' mal an jedem ' + ($elm$core$String$fromInt(every) + '. Wochentag'));
				}
			}
		case 3:
			if (interval.a === 1) {
				if (interval.b === 1) {
					return 'jedes Wochenende';
				} else {
					var times = interval.b;
					return $elm$core$String$fromInt(times) + ' mal an Wochenenden';
				}
			} else {
				if (interval.b === 1) {
					var every = interval.a;
					return 'jedes ' + ($elm$core$String$fromInt(every) + '. Wochenende');
				} else {
					var every = interval.a;
					var times = interval.b;
					return $elm$core$String$fromInt(times) + (' mal an jedem ' + ($elm$core$String$fromInt(every) + '. Wochenende'));
				}
			}
		case 5:
			var times = interval.a;
			return $elm$core$String$fromInt(times) + ' mal';
		default:
			if (interval.a === 1) {
				if (interval.b === 1) {
					return 'ein mal jeden Monat';
				} else {
					var times = interval.b;
					return $elm$core$String$fromInt(times) + ' mal im Monat';
				}
			} else {
				if (interval.b === 1) {
					var every = interval.a;
					return 'alle ' + ($elm$core$String$fromInt(every) + ' Monate');
				} else {
					var every = interval.a;
					var times = interval.b;
					return $elm$core$String$fromInt(times) + (' mal alle ' + ($elm$core$String$fromInt(every) + ' Monate'));
				}
			}
	}
};
var $mdgriffith$elm_ui$Element$spacingXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$spacing,
			A3(
				$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
				A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, y),
				x,
				y));
	});
var $mdgriffith$elm_ui$Internal$Model$Padding = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Model$Spaced = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (attr, _v0) {
				var pad = _v0.a;
				var spacing = _v0.b;
				return _Utils_Tuple2(
					function () {
						if (!pad.$) {
							var x = pad.a;
							return pad;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 7)) {
								var _v3 = attr.b;
								var name = _v3.a;
								var t = _v3.b;
								var r = _v3.c;
								var b = _v3.d;
								var l = _v3.e;
								return $elm$core$Maybe$Just(
									A5($mdgriffith$elm_ui$Internal$Model$Padding, name, t, r, b, l));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
					function () {
						if (!spacing.$) {
							var x = spacing.a;
							return spacing;
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 5)) {
								var _v6 = attr.b;
								var name = _v6.a;
								var x = _v6.b;
								var y = _v6.c;
								return $elm$core$Maybe$Just(
									A3($mdgriffith$elm_ui$Internal$Model$Spaced, name, x, y));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}());
			}),
		_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		attrs);
};
var $mdgriffith$elm_ui$Element$wrappedRow = F2(
	function (attrs, children) {
		var _v0 = $mdgriffith$elm_ui$Internal$Model$extractSpacingAndPadding(attrs);
		var padded = _v0.a;
		var spaced = _v0.b;
		if (spaced.$ === 1) {
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asRow,
				$mdgriffith$elm_ui$Internal$Model$div,
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bW + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dS)))),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							attrs))),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
		} else {
			var _v2 = spaced.a;
			var spaceName = _v2.a;
			var x = _v2.b;
			var y = _v2.c;
			var newPadding = function () {
				if (!padded.$) {
					var _v5 = padded.a;
					var name = _v5.a;
					var t = _v5.b;
					var r = _v5.c;
					var b = _v5.d;
					var l = _v5.e;
					if ((_Utils_cmp(r, x / 2) > -1) && (_Utils_cmp(b, y / 2) > -1)) {
						var newTop = t - (y / 2);
						var newRight = r - (x / 2);
						var newLeft = l - (x / 2);
						var newBottom = b - (y / 2);
						return $elm$core$Maybe$Just(
							A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, newRight, newBottom, newLeft),
									newTop,
									newRight,
									newBottom,
									newLeft)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			if (!newPadding.$) {
				var pad = newPadding.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asRow,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bW + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dS)))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								_Utils_ap(
									attrs,
									_List_fromArray(
										[pad]))))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
			} else {
				var halfY = -(y / 2);
				var halfX = -(x / 2);
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					attrs,
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asRow,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.bW + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dS)))),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											A2(
												$elm$html$Html$Attributes$style,
												'margin',
												$elm$core$String$fromFloat(halfY) + ('px' + (' ' + ($elm$core$String$fromFloat(halfX) + 'px'))))),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Internal$Model$Attr(
												A2(
													$elm$html$Html$Attributes$style,
													'width',
													'calc(100% + ' + ($elm$core$String$fromInt(x) + 'px)'))),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$Attr(
													A2(
														$elm$html$Html$Attributes$style,
														'height',
														'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))),
												A2(
													$elm$core$List$cons,
													A2(
														$mdgriffith$elm_ui$Internal$Model$StyleClass,
														$mdgriffith$elm_ui$Internal$Flag$spacing,
														A3($mdgriffith$elm_ui$Internal$Model$SpacingStyle, spaceName, x, y)),
													_List_Nil))))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(children))
							])));
			}
		}
	});
var $author$project$Ziege$UI$ClientCompletionLog$buildClientCompletionLogItem = function (event) {
	var ttbd = $author$project$Ziege$TodoInterval$timesToBeDone(event.cT.l);
	var statusTone = _Utils_eq(event.cm, ttbd) ? 19 : ((!event.cm) ? 21 : 20);
	var intervalString = function (_v2) {
		var s = _v2.a;
		var e = _v2.b;
		var _v1 = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, s, e);
		if (_v1 === 1) {
			return 'am ' + $author$project$Ziege$Utils$renderCalendarDate(s);
		} else {
			return $author$project$Ziege$Utils$renderCalendarDate(
				$author$project$Ziege$TodoInterval$intervalStart(event.l)) + (' bis ' + $author$project$Ziege$Utils$renderCalendarDate(
				$author$project$Ziege$TodoInterval$intervalEnd(event.l)));
		}
	};
	var completionString = F2(
		function (completions, tobedone) {
			var _v0 = _Utils_Tuple2(completions, tobedone);
			_v0$2:
			while (true) {
				if (_v0.b === 1) {
					switch (_v0.a) {
						case 0:
							return 'nicht erledigt';
						case 1:
							return 'erledigt';
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return $elm$core$String$fromInt(completions) + (' mal von ' + ($elm$core$String$fromInt(tobedone) + ' erledigt'));
		});
	return A2(
		$author$project$Ziege$UI$Utils$listRow,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(12)),
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(12)),
						$mdgriffith$elm_ui$Element$Border$rounded(3),
						$author$project$Ziege$UI$Colors$bg(statusTone),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$moveDown(3)
					]),
				$mdgriffith$elm_ui$Element$none),
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(4)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$wrappedRow,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A2($mdgriffith$elm_ui$Element$spacingXY, 10, 2)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$bold,
										$mdgriffith$elm_ui$Element$Font$size(15)
									]),
								$mdgriffith$elm_ui$Element$text(event.cT.j)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignRight,
										$mdgriffith$elm_ui$Element$Font$size(12),
										$author$project$Ziege$UI$Colors$fg(5)
									]),
								$mdgriffith$elm_ui$Element$text(
									$author$project$Ziege$TodoInterval$renderIntervalString(event.cT.l)))
							])),
						A2(
						$mdgriffith$elm_ui$Element$wrappedRow,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								A2($mdgriffith$elm_ui$Element$spacingXY, 10, 2),
								$mdgriffith$elm_ui$Element$Font$size(13)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								A2(completionString, event.cm, ttbd)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignRight,
										$author$project$Ziege$UI$Colors$fg(5)
									]),
								$mdgriffith$elm_ui$Element$text(
									intervalString(event.l)))
							]))
					]))
			]));
};
var $author$project$Ziege$UI$ClientCompletionLog$ClientCompletionEvent = F4(
	function (client, completions, interval, todo) {
		return {gi: client, cm: completions, l: interval, cT: todo};
	});
var $author$project$Ziege$TodoInterval$agreementPeriods = F3(
	function (expires, interval, history) {
		var go = F2(
			function (d, acc) {
				go:
				while (true) {
					if (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, d, expires) === 2) {
						return $elm$core$List$reverse(acc);
					} else {
						var _v0 = A3($author$project$Ziege$TodoInterval$periodAt, interval, history.it, d);
						if (!_v0.$) {
							var period = _v0.a;
							var last = period.b;
							var $temp$d = $author$project$Ziege$FastCalendar$incrementDay(last),
								$temp$acc = A2($elm$core$List$cons, period, acc);
							d = $temp$d;
							acc = $temp$acc;
							continue go;
						} else {
							var $temp$d = $author$project$Ziege$FastCalendar$incrementDay(d),
								$temp$acc = acc;
							d = $temp$d;
							acc = $temp$acc;
							continue go;
						}
					}
				}
			});
		if (interval.$ === 5) {
			return _List_fromArray(
				[
					A2($author$project$Ziege$TodoInterval$DateInterval, history.it, expires)
				]);
		} else {
			return A2(go, history.it, _List_Nil);
		}
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Ziege$TodoInterval$countBelow = F2(
	function (sorted, n) {
		var search = F2(
			function (low, high) {
				search:
				while (true) {
					if (_Utils_cmp(low, high) > -1) {
						return low;
					} else {
						var mid = ((low + high) / 2) | 0;
						if (_Utils_cmp(
							A2(
								$elm$core$Maybe$withDefault,
								n,
								A2($elm$core$Array$get, mid, sorted)),
							n) < 0) {
							var $temp$low = mid + 1,
								$temp$high = high;
							low = $temp$low;
							high = $temp$high;
							continue search;
						} else {
							var $temp$low = low,
								$temp$high = mid;
							low = $temp$low;
							high = $temp$high;
							continue search;
						}
					}
				}
			});
		return A2(
			search,
			0,
			$elm$core$Array$length(sorted));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{M: nodeList, D: nodeListSize, J: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Ziege$TodoInterval$countDatesInInterval = F2(
	function (intervals, dates) {
		var sorted = $elm$core$Array$fromList(
			$elm$core$List$sort(
				A2($elm$core$List$map, $author$project$Ziege$FastCalendar$toDayNumber, dates)));
		var count = function (_v0) {
			var start = _v0.a;
			var end = _v0.b;
			return A2(
				$author$project$Ziege$TodoInterval$countBelow,
				sorted,
				$author$project$Ziege$FastCalendar$toDayNumber(end) + 1) - A2(
				$author$project$Ziege$TodoInterval$countBelow,
				sorted,
				$author$project$Ziege$FastCalendar$toDayNumber(start));
		};
		return A2(
			$elm$core$List$map,
			function (itvl) {
				return _Utils_Tuple2(
					itvl,
					count(itvl));
			},
			intervals);
	});
var $author$project$Ziege$UI$ClientCompletionLog$clientTodoCompletionLog = F3(
	function (today, client, todo) {
		var settled = function (_v1) {
			var _v2 = _v1.a;
			var first = _v2.a;
			var last = _v2.b;
			var count = _v1.b;
			return (!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, last, today)) || ((A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, first, today) !== 2) && (_Utils_cmp(
				count,
				$author$project$Ziege$TodoInterval$timesToBeDone(todo.l)) > -1));
		};
		var counts = A2(
			$author$project$Ziege$TodoInterval$countDatesInInterval,
			A3($author$project$Ziege$TodoInterval$agreementPeriods, todo.L, todo.l, todo.q),
			todo.q.cm);
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var i = _v0.a;
				var count = _v0.b;
				return A4($author$project$Ziege$UI$ClientCompletionLog$ClientCompletionEvent, client, count, i, todo);
			},
			A2($elm$core$List$filter, settled, counts));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Ziege$UI$ClientCompletionLog$clientCompletionLog = F2(
	function (today, client) {
		var compareCompletionEvent = F2(
			function (lhs, rhs) {
				var _v0 = A2(
					$PanagiotisGeorgiadis$elm_datetime$Calendar$compare,
					$author$project$Ziege$TodoInterval$intervalEnd(rhs.l),
					$author$project$Ziege$TodoInterval$intervalEnd(lhs.l));
				if (_v0 === 1) {
					return A2(
						$PanagiotisGeorgiadis$elm_datetime$Calendar$compare,
						$author$project$Ziege$TodoInterval$intervalStart(rhs.l),
						$author$project$Ziege$TodoInterval$intervalStart(lhs.l));
				} else {
					var result = _v0;
					return result;
				}
			});
		return A2(
			$elm$core$List$sortWith,
			compareCompletionEvent,
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					A2($author$project$Ziege$UI$ClientCompletionLog$clientTodoCompletionLog, today, client),
					client.v)));
	});
var $mdgriffith$elm_ui$Element$Border$widthXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$borderWidth,
			A5(
				$mdgriffith$elm_ui$Internal$Model$BorderWidth,
				'b-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
				y,
				x,
				y,
				x));
	});
var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
	var right = _v0.a4;
	var left = _v0.a$;
	var top = _v0.aS;
	var bottom = _v0.X;
	return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : A2($mdgriffith$elm_ui$Element$Border$widthXY, left, top)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left))))))),
			top,
			right,
			bottom,
			left));
};
var $author$project$Ziege$UI$Utils$divided = F2(
	function (index, content) {
		return (!index) ? content : A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Border$widthEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{aS: 1})),
					$author$project$Ziege$UI$Colors$borderColor(8)
				]),
			content);
	});
var $author$project$Ziege$UI$Utils$listCard = function (rows) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5)
			]),
		A2(
			$mdgriffith$elm_ui$Element$column,
			_Utils_ap(
				$author$project$Ziege$UI$Utils$cardStyle,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$clip,
						$mdgriffith$elm_ui$Element$Font$size(14)
					])),
			A2($elm$core$List$indexedMap, $author$project$Ziege$UI$Utils$divided, rows)));
};
var $author$project$Ziege$UI$Utils$quietNote = function (s) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Element$paddingXY, 16, 8),
				$mdgriffith$elm_ui$Element$Font$size(14),
				$author$project$Ziege$UI$Colors$fg(5)
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(s)
			]));
};
var $author$project$Ziege$UI$ClientCompletionLog$buildClientCompletionLog = F2(
	function (model, client) {
		var today = model.af;
		var events = A2($author$project$Ziege$UI$ClientCompletionLog$clientCompletionLog, today, client);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$paddingEach(
					{X: 10, a$: 0, a4: 0, aS: 0})
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ziege$UI$Utils$sectionHeader,
					'Zeiträume',
					$elm$core$String$fromInt(
						$elm$core$List$length(events))),
					$elm$core$List$isEmpty(events) ? $author$project$Ziege$UI$Utils$quietNote('Noch keine abgeschlossenen Zeiträume.') : $author$project$Ziege$UI$Utils$listCard(
					A2($elm$core$List$map, $author$project$Ziege$UI$ClientCompletionLog$buildClientCompletionLogItem, events))
				]));
	});
var $author$project$Ziege$Model$ClientUpdateExtraCounsellorMatrixId = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ziege$Model$ClientUpdateFirstname = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ziege$Model$ClientUpdateLastname = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ziege$Model$ClientUpdateNote = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ziege$Model$ClientUpdateRoom = {$: 7};
var $author$project$Ziege$Model$InviteExtraCounsellor = {$: 4};
var $author$project$Ziege$Model$RequestSeverance = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ziege$UI$Colors$Danger = 12;
var $author$project$Ziege$UI$Colors$OnDanger = 13;
var $author$project$Ziege$UI$Button$buildDangerButton = F2(
	function (label, msg) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 12),
					$mdgriffith$elm_ui$Element$Border$rounded(8),
					$author$project$Ziege$UI$Colors$bg(12),
					$author$project$Ziege$UI$Colors$fg(13),
					$mdgriffith$elm_ui$Element$Font$bold,
					$mdgriffith$elm_ui$Element$Font$size(17)
				]),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$mdgriffith$elm_ui$Element$text(label)),
				aA: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Ziege$UI$Colors$Line = 7;
var $author$project$Ziege$UI$Button$buildWideButton = F2(
	function (label, msg) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 12),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$Border$rounded(8),
					$author$project$Ziege$UI$Colors$borderColor(7),
					$author$project$Ziege$UI$Colors$bg(0),
					$mdgriffith$elm_ui$Element$Font$size(17)
				]),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$mdgriffith$elm_ui$Element$text(label)),
				aA: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Ziege$UI$ClientEditSettings$field = F3(
	function (value, onChange, label) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$text,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$Input$labelAbove,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$Font$bold]),
					$mdgriffith$elm_ui$Element$text(label)),
				an: onChange,
				b9: $elm$core$Maybe$Just(
					A2(
						$mdgriffith$elm_ui$Element$Input$placeholder,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text(label))),
				K: value
			});
	});
var $author$project$Ziege$UI$Colors$DangerText = 14;
var $author$project$Ziege$Model$SeverConnection = {$: 6};
var $author$project$Ziege$UI$ClientEditSettings$severanceConfirmation = A2(
	$mdgriffith$elm_ui$Element$column,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$spacing(10)
		]),
	_List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$bold,
					$mdgriffith$elm_ui$Element$Font$size(16),
					$author$project$Ziege$UI$Colors$fg(14)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Verbindung wirklich trennen?')
				])),
			A2(
			$mdgriffith$elm_ui$Element$paragraph,
			_List_Nil,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text('Ziege verlässt dann den gemeinsamen Raum mit dieser Klient*in. Sie verschwindet samt Zielen und Verlauf aus der Klientenliste, auf allen Geräten dieses Kontos. Für eine neue Zusammenarbeit braucht es eine neue Einladung.')
				])),
			A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Abbrechen',
					$author$project$Ziege$Model$RequestSeverance(false)),
					A2($author$project$Ziege$UI$Button$buildDangerButton, 'Ja, trennen', $author$project$Ziege$Model$SeverConnection)
				]))
		]));
var $author$project$Ziege$UI$ClientEditSettings$buildClientEditNames = F2(
	function (ownMatrixId, client) {
		var betterMatrixId = $author$project$Ziege$Utils$massageMatrixUsername(client.gL);
		var inviteInfo = $elm$core$String$isEmpty(betterMatrixId) ? '' : ((!$author$project$Ziege$Utils$isValidMatrixId(betterMatrixId)) ? 'In der Matrix-ID sind nur a–z, 0–9 und ._=-/+ erlaubt, keine Leerzeichen oder Umlaute' : (_Utils_eq(betterMatrixId, ownMatrixId) ? 'Das ist Ihr eigenes Konto.' : (_Utils_eq(betterMatrixId, client.m) ? 'Das ist das Konto der Klient*in.' : ('Eingeladen wird ' + betterMatrixId))));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Ziege$UI$Utils$sectionHeader, 'Name', ''),
						$author$project$Ziege$UI$Utils$card(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$spacing(4)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$Font$bold]),
										$mdgriffith$elm_ui$Element$text('Matrix-ID')),
										A2(
										$mdgriffith$elm_ui$Element$paragraph,
										_List_fromArray(
											[
												$author$project$Ziege$UI$Colors$fg(5),
												$mdgriffith$elm_ui$Element$htmlAttribute(
												A2($elm$html$Html$Attributes$style, 'overflow-wrap', 'anywhere'))
											]),
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$text(client.m)
											]))
									])),
								A3($author$project$Ziege$UI$ClientEditSettings$field, client.c8, $author$project$Ziege$Model$ClientUpdateFirstname, 'Vorname'),
								A3($author$project$Ziege$UI$ClientEditSettings$field, client.dn, $author$project$Ziege$Model$ClientUpdateLastname, 'Nachname'),
								A3($author$project$Ziege$UI$ClientEditSettings$field, client.b7, $author$project$Ziege$Model$ClientUpdateNote, 'Spitzname')
							]))
					]),
				$elm$core$String$isEmpty(client.i) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Ziege$UI$Utils$sectionHeader, 'Weitere Berater*in einladen', ''),
						$author$project$Ziege$UI$Utils$card(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$spacing(6)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$Input$text,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										{
											u: A2(
												$mdgriffith$elm_ui$Element$Input$labelAbove,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$Font$bold]),
												$mdgriffith$elm_ui$Element$text('Berater*in-Matrix-ID')),
											an: $author$project$Ziege$Model$ClientUpdateExtraCounsellorMatrixId,
											b9: $elm$core$Maybe$Just(
												A2(
													$mdgriffith$elm_ui$Element$Input$placeholder,
													_List_Nil,
													$mdgriffith$elm_ui$Element$text('MatrixID'))),
											K: client.gL
										}),
										$author$project$Ziege$UI$Utils$fieldHint(inviteInfo)
									])),
								A3($author$project$Ziege$UI$ClientEditSettings$invitable, ownMatrixId, client, betterMatrixId) ? A2($author$project$Ziege$UI$Button$buildWideButton, 'Einladen', $author$project$Ziege$Model$InviteExtraCounsellor) : $mdgriffith$elm_ui$Element$none
							])),
						A2($author$project$Ziege$UI$Utils$sectionHeader, 'Status erneut senden', ''),
						$author$project$Ziege$UI$Utils$card(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$author$project$Ziege$UI$Colors$fg(5)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Schickt Ziele und Stand dieser Klient*in noch einmal in den gemeinsamen Raum.')
									])),
								A2($author$project$Ziege$UI$Button$buildWideButton, 'Status senden', $author$project$Ziege$Model$ClientUpdateRoom)
							])),
						A2($author$project$Ziege$UI$Utils$sectionHeader, 'Verbindung trennen', ''),
						$author$project$Ziege$UI$Utils$card(
						_List_fromArray(
							[
								client.ih ? $author$project$Ziege$UI$ClientEditSettings$severanceConfirmation : A2(
								$author$project$Ziege$UI$Button$buildDangerButton,
								'Verbindung trennen',
								$author$project$Ziege$Model$RequestSeverance(true))
							]))
					])));
	});
var $author$project$Ziege$UI$Colors$Accent = 11;
var $author$project$Ziege$UI$Colors$Caution = 22;
var $author$project$Ziege$UI$Colors$OnCaution = 23;
var $author$project$Ziege$Model$ToggleCryptoPanel = {$: 58};
var $mdgriffith$elm_ui$Element$Font$underline = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.i4);
var $author$project$Ziege$UI$CryptoPanel$buildCryptoBanner = function (status) {
	var banner = F3(
		function (title, body, buttonLabel) {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$padding(10),
						$author$project$Ziege$UI$Colors$bg(22),
						$author$project$Ziege$UI$Colors$fg(23),
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$bold]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(title)
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(body)
							])),
						A2(
						$mdgriffith$elm_ui$Element$Input$button,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Element$paddingXY, 12, 8),
								$mdgriffith$elm_ui$Element$Border$width(1),
								$mdgriffith$elm_ui$Element$Border$rounded(4),
								$author$project$Ziege$UI$Colors$borderColor(23),
								$mdgriffith$elm_ui$Element$Font$bold
							]),
						{
							u: $mdgriffith$elm_ui$Element$text(buttonLabel),
							aA: $elm$core$Maybe$Just($author$project$Ziege$Model$ToggleCryptoPanel)
						})
					]));
		});
	var _v0 = status.bn;
	switch (_v0) {
		case 3:
			return _List_fromArray(
				[
					A3(banner, 'Diese App ist noch nicht verifiziert.', 'Sie kann Ziele und Fortschritte weder empfangen noch senden, bis sie mit dem Recovery-Key oder einer anderen, schon verifizierten App bestätigt ist.', 'Jetzt verifizieren')
				]);
		case 2:
			return status.gd ? _List_Nil : _List_fromArray(
				[
					A3(banner, 'Die Verschlüsselung ist noch nicht eingerichtet.', 'Bis dahin kann Ziege keine Ziele und Fortschritte austauschen.', 'Jetzt einrichten')
				]);
		case 1:
			return _List_fromArray(
				[
					A3(banner, 'Die Verschlüsselung steht nicht zur Verfügung.', 'In dieser App kann Ziege keine Ziele und Fortschritte austauschen.', 'Details')
				]);
		case 4:
			return status.d0 ? _List_Nil : _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(10),
							A2($mdgriffith$elm_ui$Element$paddingXY, 16, 10),
							$author$project$Ziege$UI$Colors$bg(1),
							$mdgriffith$elm_ui$Element$Font$size(13)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Für die Schlüssel ist kein Backup aktiv.')
								])),
							A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$underline,
									$author$project$Ziege$UI$Colors$fg(11)
								]),
							{
								u: $mdgriffith$elm_ui$Element$text('Details'),
								aA: $elm$core$Maybe$Just($author$project$Ziege$Model$ToggleCryptoPanel)
							})
						]))
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Ziege$UI$Colors$Info = 9;
var $author$project$Ziege$UI$Button$buildButton = F2(
	function (s, m) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Element$paddingXY, 16, 10),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$Border$rounded(8),
					$author$project$Ziege$UI$Colors$borderColor(7),
					$author$project$Ziege$UI$Colors$bg(0),
					$mdgriffith$elm_ui$Element$Font$size(16)
				]),
			{
				u: $mdgriffith$elm_ui$Element$text(s),
				aA: $elm$core$Maybe$Just(m)
			});
	});
var $author$project$Ziege$UI$CryptoPanel$effectiveKind = F2(
	function (phase, problem) {
		return ((problem.hk === 2) && ((phase !== 4) && (!(!phase)))) ? 1 : problem.hk;
	});
var $author$project$Ziege$UI$CryptoPanel$para = function (s) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_Nil,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(s)
			]));
};
var $author$project$Ziege$UI$CryptoPanel$decryptionProblemHint = F3(
	function (ownUserId, phase, problem) {
		var name = _Utils_eq(problem.ie, problem.id) ? problem.id : (problem.ie + (' (' + (problem.id + ')')));
		var kind = A2($author$project$Ziege$UI$CryptoPanel$effectiveKind, phase, problem);
		switch (kind) {
			case 0:
				return _Utils_eq(problem.id, ownUserId) ? $author$project$Ziege$UI$CryptoPanel$para('Eine Nachricht aus einer anderen App dieses Kontos ist nicht lesbar, weil jene App nicht verifiziert ist. Bitte die andere App verifizieren und die Nachricht dort erneut senden.') : $author$project$Ziege$UI$CryptoPanel$para('Eine Nachricht von ' + (name + (' ist nicht lesbar: Die App, mit der sie gesendet wurde, ist nicht verifiziert. ' + (name + ' muss diese App verifizieren – mit dem Recovery-Key oder einer anderen, schon verifizierten App – und die Nachricht danach erneut senden.'))));
			case 1:
				return (phase === 4) ? (_Utils_eq(problem.id, ownUserId) ? $author$project$Ziege$UI$CryptoPanel$para('Eine Nachricht aus einer anderen App dieses Kontos kam an, bevor diese App verifiziert war. Ihr Schlüssel kommt aus dem Backup, sobald jene App ihn gesichert hat.') : $author$project$Ziege$UI$CryptoPanel$para('Eine Nachricht von ' + (name + (' kam an, bevor diese App verifiziert war, und ist hier nicht lesbar. Die App von ' + (name + ' schickt den aktuellen Stand noch einmal, sobald sie die Verifikation bemerkt; sie muss dafür geöffnet sein.'))))) : A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(10),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$author$project$Ziege$UI$CryptoPanel$para(
							_Utils_eq(problem.id, ownUserId) ? 'Nachrichten aus einer anderen App dieses Kontos sind hier nicht lesbar, weil diese App noch nicht verifiziert ist. Nach dem Verifizieren kommen die Schlüssel aus dem Backup.' : ('Nachrichten von ' + (name + (' sind nicht lesbar, weil diese App noch nicht verifiziert ist. Nach dem Verifizieren sind neue Nachrichten lesbar; ältere muss ' + (name + ' erneut senden.'))))),
							A2($author$project$Ziege$UI$Button$buildButton, 'Jetzt verifizieren', $author$project$Ziege$Model$ToggleCryptoPanel)
						]));
			default:
				return $author$project$Ziege$UI$CryptoPanel$para('Für eine Nachricht von ' + (name + (' fehlt der Schlüssel. Meist ist die App, mit der sie gesendet wurde, nicht verifiziert. Bleibt dieser Hinweis, ' + (name + ' bitten, die App zu verifizieren und die Nachricht erneut zu senden.'))));
		}
	});
var $author$project$Ziege$UI$CryptoPanel$buildDecryptionProblems = F3(
	function (ownUserId, phase, problems) {
		var shown = (phase === 3) ? A2(
			$elm$core$List$filter,
			function (problem) {
				return A2($author$project$Ziege$UI$CryptoPanel$effectiveKind, phase, problem) !== 1;
			},
			problems) : problems;
		return $elm$core$List$isEmpty(shown) ? _List_Nil : _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$padding(10),
						$author$project$Ziege$UI$Colors$bg(9),
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				A2(
					$elm$core$List$map,
					A2($author$project$Ziege$UI$CryptoPanel$decryptionProblemHint, ownUserId, phase),
					shown))
			]);
	});
var $author$project$Ziege$Model$HideDevices = function (a) {
	return {$: 71, a: a};
};
var $author$project$Ziege$Model$ShowDevices = function (a) {
	return {$: 70, a: a};
};
var $author$project$Ziege$UI$DeviceList$deviceRow = F2(
	function (currentDeviceId, device) {
		var name = _Utils_ap(
			$elm$core$String$isEmpty(device.I) ? device.bY : (device.I + (' (' + (device.bY + ')'))),
			_Utils_eq(device.bY, currentDeviceId) ? ', diese App' : '');
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(8)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							device.ja ? $author$project$Ziege$UI$Colors$fg(19) : $author$project$Ziege$UI$Colors$fg(14)
						]),
					$mdgriffith$elm_ui$Element$text(
						device.ja ? '✓' : '⚠')),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$text(name),
						device.ja ? _List_Nil : _List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$author$project$Ziege$UI$Colors$fg(14)
									]),
								$mdgriffith$elm_ui$Element$text(' – nicht verifiziert'))
							])))
				]));
	});
var $author$project$Ziege$UI$DeviceList$link = F2(
	function (label, msg) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(14),
					$mdgriffith$elm_ui$Element$Font$underline,
					$author$project$Ziege$UI$Colors$fg(11)
				]),
			{
				u: $mdgriffith$elm_ui$Element$text(label),
				aA: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Ziege$UI$DeviceList$buildDeviceList = F4(
	function (label, userId, currentDeviceId, state) {
		if (state.$ === 1) {
			return A2(
				$author$project$Ziege$UI$DeviceList$link,
				label + ' anzeigen',
				$author$project$Ziege$Model$ShowDevices(userId));
		} else {
			switch (state.a.$) {
				case 0:
					var _v1 = state.a;
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(14),
								$author$project$Ziege$UI$Colors$fg(5)
							]),
						$mdgriffith$elm_ui$Element$text('Apps werden abgefragt …'));
				case 2:
					var error = state.a.a;
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(6),
								$mdgriffith$elm_ui$Element$Font$size(14)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$author$project$Ziege$UI$Colors$fg(14)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Die Apps ließen sich nicht abfragen: ' + error)
									])),
								A2(
								$author$project$Ziege$UI$DeviceList$link,
								'Erneut versuchen',
								$author$project$Ziege$Model$ShowDevices(userId))
							]));
				default:
					var devices = state.a.a;
					var unverified = $elm$core$List$length(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.ja;
								}),
							devices));
					var sorted = A2(
						$elm$core$List$sortBy,
						function (d) {
							return _Utils_Tuple2(
								d.ja ? 1 : 0,
								d.I);
						},
						devices);
					return A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(6),
								$mdgriffith$elm_ui$Element$Font$size(14)
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$Font$bold]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(
											label + (': ' + ($elm$core$String$fromInt(
												$elm$core$List$length(devices)) + ((!unverified) ? ', alle verifiziert' : (', davon ' + ($elm$core$String$fromInt(unverified) + ' nicht verifiziert'))))))
										]))
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Ziege$UI$DeviceList$deviceRow(currentDeviceId),
									sorted),
								_List_fromArray(
									[
										A2(
										$author$project$Ziege$UI$DeviceList$link,
										'Ausblenden',
										$author$project$Ziege$Model$HideDevices(userId))
									]))));
			}
		}
	});
var $author$project$Ziege$Model$AddPendingTodo2ActiveClient = function (a) {
	return {$: 24, a: a};
};
var $author$project$Ziege$Model$UpdatePendingToDoIsFavorite = function (a) {
	return {$: 23, a: a};
};
var $author$project$Ziege$Model$UpdatePendingToDoTextPart = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Ziege$Model$UpdatePendingToDoTitle = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ziege$Model$DecrementEditIntervalEvery = {$: 32};
var $author$project$Ziege$Model$DecrementEditIntervalTimes = {$: 34};
var $author$project$Ziege$Model$IncrementEditIntervalEvery = {$: 31};
var $author$project$Ziege$Model$IncrementEditIntervalTimes = {$: 33};
var $mdgriffith$elm_ui$Element$Input$Selected = 2;
var $author$project$Ziege$UI$Colors$TextStrong = 4;
var $author$project$Ziege$Model$UpdateEditIntervalBase = function (a) {
	return {$: 30, a: a};
};
var $author$project$Ziege$Model$UpdateExpiresDatePickerActive = function (a) {
	return {$: 48, a: a};
};
var $author$project$Ziege$Model$UpdateIntervalEditorActive = function (a) {
	return {$: 44, a: a};
};
var $author$project$Ziege$Model$UpdatePendingExpires = function (a) {
	return {$: 19, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $author$project$Ziege$FastCalendar$getDateRange = F2(
	function (start, end) {
		var _v0 = _Utils_Tuple2(
			$author$project$Ziege$FastCalendar$dayNumber(start),
			$author$project$Ziege$FastCalendar$dayNumber(end));
		var from = _v0.a;
		var to = _v0.b;
		return A2(
			$elm$core$List$map,
			$author$project$Ziege$FastCalendar$fromDayNumber,
			A2(
				$elm$core$List$range,
				A2($elm$core$Basics$min, from, to),
				A2($elm$core$Basics$max, from, to)));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getDatesInMonth = function (_v0) {
	var month = _v0.hz;
	var year = _v0.ji;
	var lastDayOfTheMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt(
		A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, year, month));
	return A2(
		$elm$core$List$map,
		function (day) {
			return {gu: day, hz: month, ji: year};
		},
		A2($elm$core$List$range, 1, lastDayOfTheMonth));
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$getDatesInMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getDatesInMonth;
var $author$project$Ziege$UI$DatePicker$groupsOf = F2(
	function (groupSize, lst) {
		var helper = F3(
			function (n, l, acc) {
				helper:
				while (true) {
					var _v0 = A2($elm$core$List$take, n, l);
					if (!_v0.b) {
						return A2($elm$core$List$cons, _List_Nil, acc);
					} else {
						var group = _v0;
						var $temp$n = n,
							$temp$l = A2($elm$core$List$drop, n, l),
							$temp$acc = A2($elm$core$List$cons, group, acc);
						n = $temp$n;
						l = $temp$l;
						acc = $temp$acc;
						continue helper;
					}
				}
			});
		return $elm$core$List$reverse(
			A3(helper, groupSize, lst, _List_Nil));
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Ziege$UI$DatePicker$buildDaySelector = F5(
	function (updateMsg, isValidDay, start, end, selected) {
		var isValid = function (d) {
			return isValidDay(d) && ((A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, d) !== 2) && (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, d, end) !== 2));
		};
		var daysOfMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$getDatesInMonth(selected);
		var firstDayOfMonth = A2(
			$elm$core$Maybe$withDefault,
			selected,
			$elm$core$List$head(daysOfMonth));
		var mondayBeforeTheFirst = A2(
			$elm$core$Maybe$withDefault,
			selected,
			A2(
				$elm$core$Maybe$map,
				$author$project$Ziege$Utils$lastMonday,
				$elm$core$List$head(daysOfMonth)));
		var frontPaddedDatesOfMonth = A2($elm$core$List$member, mondayBeforeTheFirst, daysOfMonth) ? _List_Nil : A2(
			$author$project$Ziege$FastCalendar$getDateRange,
			mondayBeforeTheFirst,
			$author$project$Ziege$FastCalendar$decrementDay(firstDayOfMonth));
		var reversedDaysOfMonth = $elm$core$List$reverse(daysOfMonth);
		var lastDayofMonth = A2(
			$elm$core$Maybe$withDefault,
			selected,
			$elm$core$List$head(reversedDaysOfMonth));
		var sundayAfterTheLast = A2(
			$elm$core$Maybe$withDefault,
			selected,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Ziege$Utils$nextWeekday, 6, false),
				$elm$core$List$head(reversedDaysOfMonth)));
		var buildWeekDayElement = function (wd) {
			var wdtext = function () {
				switch (wd) {
					case 0:
						return 'Mo';
					case 1:
						return 'Di';
					case 2:
						return 'Mi';
					case 3:
						return 'Do';
					case 4:
						return 'Fr';
					case 5:
						return 'Sa';
					default:
						return 'So';
				}
			}();
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2($mdgriffith$elm_ui$Element$paddingXY, 0, 6),
						$mdgriffith$elm_ui$Element$Font$size(12),
						$mdgriffith$elm_ui$Element$Font$bold,
						$author$project$Ziege$UI$Colors$fg(5)
					]),
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]),
					$mdgriffith$elm_ui$Element$text(wdtext)));
		};
		var buildWeekDaysRow = A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(2)
				]),
			A2(
				$elm$core$List$map,
				buildWeekDayElement,
				_List_fromArray(
					[0, 1, 2, 3, 4, 5, 6])));
		var backPaddedDatesOfMonth = A2($elm$core$List$member, sundayAfterTheLast, reversedDaysOfMonth) ? _List_Nil : A2(
			$author$project$Ziege$FastCalendar$getDateRange,
			$author$project$Ziege$FastCalendar$incrementDay(lastDayofMonth),
			sundayAfterTheLast);
		var buildDayButton = function (date) {
			var isSelectedDate = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, date, selected) === 1;
			var isPaddedDate = A2($elm$core$List$member, date, frontPaddedDatesOfMonth) || A2($elm$core$List$member, date, backPaddedDatesOfMonth);
			var isOk = isValid(date);
			var dayAttrs = function () {
				var _v0 = _Utils_Tuple3(isOk, isPaddedDate, isSelectedDate);
				if (_v0.c) {
					return _List_fromArray(
						[
							$author$project$Ziege$UI$Colors$fg(25),
							$author$project$Ziege$UI$Colors$bg(24),
							$mdgriffith$elm_ui$Element$Font$bold
						]);
				} else {
					if (_v0.a) {
						if (!_v0.b) {
							return _List_fromArray(
								[
									$author$project$Ziege$UI$Colors$fg(4),
									$mdgriffith$elm_ui$Element$Font$bold
								]);
						} else {
							return _List_fromArray(
								[
									$author$project$Ziege$UI$Colors$fg(5)
								]);
						}
					} else {
						return _List_fromArray(
							[
								$author$project$Ziege$UI$Colors$fg(6)
							]);
					}
				}
			}();
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							A2($mdgriffith$elm_ui$Element$paddingXY, 0, 9),
							$mdgriffith$elm_ui$Element$Border$rounded(8),
							$mdgriffith$elm_ui$Element$Font$size(15)
						]),
					dayAttrs),
				{
					u: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]),
						$mdgriffith$elm_ui$Element$text(
							$elm$core$String$fromInt(
								$PanagiotisGeorgiadis$elm_datetime$Calendar$getDay(date)))),
					aA: $elm$core$Maybe$Just(
						updateMsg(date))
				});
		};
		var buildDaysRow = function (dayslist) {
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(2)
					]),
				A2($elm$core$List$map, buildDayButton, dayslist));
		};
		var paddedDays = _Utils_ap(
			frontPaddedDatesOfMonth,
			_Utils_ap(daysOfMonth, backPaddedDatesOfMonth));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(2)
				]),
			A2(
				$elm$core$List$cons,
				buildWeekDaysRow,
				A2(
					$elm$core$List$map,
					buildDaysRow,
					A2($author$project$Ziege$UI$DatePicker$groupsOf, 7, paddedDays))));
	});
var $author$project$Ziege$UI$Icons$RegularIcon = 0;
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Ziege$UI$Icons$iconStyleString = function (s) {
	if (!s) {
		return 'regular';
	} else {
		return 'solid';
	}
};
var $author$project$Ziege$UI$Icons$buildFaIcon = F2(
	function (style, iconname) {
		return $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding-bottom', '0.15em'),
						$elm$html$Html$Attributes$class(
						'fa-' + $author$project$Ziege$UI$Icons$iconStyleString(style)),
						$elm$html$Html$Attributes$class('fa-' + iconname)
					]),
				_List_Nil));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$rollMonthBackwards = function (month) {
	switch (month) {
		case 0:
			return 11;
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		default:
			return 10;
	}
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$decrementMonth = function (_v0) {
	var date = _v0;
	var updatedMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$rollMonthBackwards(date.hz);
	var updatedYear = function () {
		if (updatedMonth === 11) {
			return $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(date.ji) - 1;
		} else {
			return date.ji;
		}
	}();
	var lastDayOfUpdatedMonth = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, updatedYear, updatedMonth);
	var updatedDay = function () {
		var _v1 = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays, date.gu, lastDayOfUpdatedMonth);
		if (_v1 === 2) {
			return lastDayOfUpdatedMonth;
		} else {
			return date.gu;
		}
	}();
	return {gu: updatedDay, hz: updatedMonth, ji: updatedYear};
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$decrementMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$decrementMonth;
var $PanagiotisGeorgiadis$elm_datetime$Calendar$lastDayOf = function (date) {
	return $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$dayToInt(
		A2(
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf,
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getYear(date),
			$PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$getMonth(date)));
};
var $author$project$Ziege$UI$DatePicker$buildMonthSelector = F5(
	function (updateMsg, isValidDate, start, stop, selected) {
		var selectetMonthString = $author$project$Ziege$Utils$monthToGerman(
			$PanagiotisGeorgiadis$elm_datetime$Calendar$getMonth(selected)) + (' ' + $elm$core$String$fromInt(
			$PanagiotisGeorgiadis$elm_datetime$Calendar$getYear(selected)));
		var previousMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$decrementMonth(selected);
		var nextMonth = $PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth(selected);
		var lastOfPreviousMonth = A2(
			$elm$core$Maybe$withDefault,
			previousMonth,
			A2(
				$PanagiotisGeorgiadis$elm_datetime$Calendar$setDay,
				$PanagiotisGeorgiadis$elm_datetime$Calendar$lastDayOf(previousMonth),
				previousMonth));
		var firstOfNextMonth = A2(
			$elm$core$Maybe$withDefault,
			nextMonth,
			A2($PanagiotisGeorgiadis$elm_datetime$Calendar$setDay, 1, nextMonth));
		var dateBeforeStart = function (d) {
			return !A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, d, start);
		};
		var dateAfterStop = function (d) {
			return A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, d, stop) === 2;
		};
		var clampDateStartStop = function (d) {
			return dateBeforeStart(d) ? start : (dateAfterStop(d) ? stop : d);
		};
		var clampDatePast = function (d) {
			clampDatePast:
			while (true) {
				if (isValidDate(d)) {
					return $elm$core$Maybe$Just(d);
				} else {
					if (dateBeforeStart(d)) {
						return $elm$core$Maybe$Nothing;
					} else {
						var $temp$d = $author$project$Ziege$FastCalendar$decrementDay(d);
						d = $temp$d;
						continue clampDatePast;
					}
				}
			}
		};
		var clampDateFuture = function (d) {
			clampDateFuture:
			while (true) {
				if (isValidDate(d)) {
					return $elm$core$Maybe$Just(d);
				} else {
					if (dateAfterStop(d)) {
						return $elm$core$Maybe$Nothing;
					} else {
						var $temp$d = $author$project$Ziege$FastCalendar$incrementDay(d);
						d = $temp$d;
						continue clampDateFuture;
					}
				}
			}
		};
		var clampDate = function (d) {
			var startStopClamped = clampDateStartStop(d);
			var _v0 = clampDatePast(startStopClamped);
			if (!_v0.$) {
				var aDate = _v0.a;
				return aDate;
			} else {
				var _v1 = clampDateFuture(startStopClamped);
				if (_v1.$ === 1) {
					return startStopClamped;
				} else {
					var aDate = _v1.a;
					return aDate;
				}
			}
		};
		var canIncrementMonth = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, firstOfNextMonth, stop) !== 2;
		var canDecrementMonth = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, lastOfPreviousMonth) !== 2;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Font$bold,
					$mdgriffith$elm_ui$Element$Font$size(16)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							canDecrementMonth ? $author$project$Ziege$UI$Colors$fg(4) : $author$project$Ziege$UI$Colors$fg(6),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(40)),
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$padding(10),
							$mdgriffith$elm_ui$Element$Border$rounded(8)
						]),
					{
						u: A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$centerX]),
							A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, 'chevron-left')),
						aA: canDecrementMonth ? $elm$core$Maybe$Just(
							updateMsg(
								clampDate(previousMonth))) : $elm$core$Maybe$Nothing
					}),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(10)
						]),
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]),
						$mdgriffith$elm_ui$Element$text(selectetMonthString))),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							canIncrementMonth ? $author$project$Ziege$UI$Colors$fg(4) : $author$project$Ziege$UI$Colors$fg(6),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(40)),
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$padding(10),
							$mdgriffith$elm_ui$Element$Border$rounded(8)
						]),
					{
						u: A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$centerX]),
							A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, 'chevron-right')),
						aA: canIncrementMonth ? $elm$core$Maybe$Just(
							updateMsg(
								clampDate(nextMonth))) : $elm$core$Maybe$Nothing
					})
				]));
	});
var $author$project$Ziege$UI$DatePicker$buildDatePicker = F5(
	function (updateMsg, isValidDay, start, end, selected) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(6)
				]),
			_List_fromArray(
				[
					A5($author$project$Ziege$UI$DatePicker$buildMonthSelector, updateMsg, isValidDay, start, end, selected),
					A5($author$project$Ziege$UI$DatePicker$buildDaySelector, updateMsg, isValidDay, start, end, selected)
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$Left = 0;
var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
var $mdgriffith$elm_ui$Element$Input$tabindex = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$tabindex);
var $mdgriffith$elm_ui$Element$Input$checkbox = F2(
	function (attrs, _v0) {
		var onChange = _v0.an;
		var checked = _v0.bV;
		var icon = _v0.b$;
		var label = _v0.u;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(label) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(6),
					$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Events$onClick(
						onChange(!checked))),
					$mdgriffith$elm_ui$Element$Region$announce,
					$mdgriffith$elm_ui$Element$Input$onKeyLookup(
					function (code) {
						return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(
							onChange(!checked)) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(
							onChange(!checked)) : $elm$core$Maybe$Nothing);
					}),
					$mdgriffith$elm_ui$Element$Input$tabindex(0),
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			attrs);
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$html$Html$Attributes$attribute, 'role', 'checkbox')),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						A2(
							$elm$html$Html$Attributes$attribute,
							'aria-checked',
							checked ? 'true' : 'false')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(label),
						attributes))),
			label,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
					]),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[
							icon(checked)
						]))));
	});
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$decrementYear = function (_v0) {
	var date = _v0;
	var updatedYear = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(date.ji) - 1;
	var lastDayOfUpdatedMonth = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, updatedYear, date.hz);
	var updatedDay = function () {
		var _v1 = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays, date.gu, lastDayOfUpdatedMonth);
		if (_v1 === 2) {
			return lastDayOfUpdatedMonth;
		} else {
			return date.gu;
		}
	}();
	return {gu: updatedDay, hz: date.hz, ji: updatedYear};
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$decrementYear = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$decrementYear;
var $author$project$Ziege$UI$Icons$SolidIcon = 1;
var $author$project$Main$checkboxIcon = F2(
	function (iconName, checked) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(15),
					$mdgriffith$elm_ui$Element$padding(5),
					$author$project$Ziege$UI$Colors$fg(4),
					checked ? $author$project$Ziege$UI$Colors$bg(9) : $author$project$Ziege$UI$Colors$bg(0)
				]),
			A2(
				$author$project$Ziege$UI$Icons$buildFaIcon,
				checked ? 1 : 0,
				iconName));
	});
var $author$project$Main$editIconCheckbox = $author$project$Main$checkboxIcon('pen-to-square');
var $mdgriffith$elm_ui$Element$fillPortion = $mdgriffith$elm_ui$Internal$Model$Fill;
var $author$project$Main$getBaseStringFromInterval = function (interval) {
	switch (interval) {
		case 0:
			return 'Tag';
		case 1:
			return 'Woche';
		case 2:
			return 'Wochentag';
		case 3:
			return 'Wochenende';
		case 4:
			return 'Monat';
		default:
			return 'Jederzeit';
	}
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$incrementYear = function (_v0) {
	var date = _v0;
	var updatedYear = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$yearToInt(date.ji) + 1;
	var lastDayOfUpdatedMonth = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$lastDayOf, updatedYear, date.hz);
	var updatedDay = function () {
		var _v1 = A2($PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$compareDays, date.gu, lastDayOfUpdatedMonth);
		if (_v1 === 2) {
			return lastDayOfUpdatedMonth;
		} else {
			return date.gu;
		}
	}();
	return {gu: updatedDay, hz: date.hz, ji: updatedYear};
};
var $PanagiotisGeorgiadis$elm_datetime$Calendar$incrementYear = $PanagiotisGeorgiadis$elm_datetime$Calendar$Internal$incrementYear;
var $author$project$Main$isValidExpiry = function (_v0) {
	return true;
};
var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
var $mdgriffith$elm_ui$Element$Input$Option = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$optionWith = F2(
	function (val, view) {
		return A2($mdgriffith$elm_ui$Element$Input$Option, val, view);
	});
var $mdgriffith$elm_ui$Element$Input$Column = 1;
var $mdgriffith$elm_ui$Element$Input$AfterFound = 2;
var $mdgriffith$elm_ui$Element$Input$BeforeFound = 1;
var $mdgriffith$elm_ui$Element$Input$Idle = 0;
var $mdgriffith$elm_ui$Element$Input$NotFound = 0;
var $mdgriffith$elm_ui$Element$Input$column = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					attributes)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$downArrow = 'ArrowDown';
var $mdgriffith$elm_ui$Internal$Model$filter = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (x, _v0) {
				var found = _v0.a;
				var has = _v0.b;
				switch (x.$) {
					case 0:
						return _Utils_Tuple2(found, has);
					case 3:
						var key = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 1:
						var attr = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 4:
						var style = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 7:
						var width = x.a;
						return A2($elm$core$Set$member, 'width', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'width', has));
					case 8:
						var height = x.a;
						return A2($elm$core$Set$member, 'height', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'height', has));
					case 2:
						var description = x.a;
						return A2($elm$core$Set$member, 'described', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'described', has));
					case 9:
						var location = x.a;
						var elem = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 6:
						return A2($elm$core$Set$member, 'align-x', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-x', has));
					case 5:
						return A2($elm$core$Set$member, 'align-y', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-y', has));
					default:
						return A2($elm$core$Set$member, 'transform', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'transform', has));
				}
			}),
		_Utils_Tuple2(_List_Nil, $elm$core$Set$empty),
		attrs).a;
};
var $mdgriffith$elm_ui$Internal$Model$get = F2(
	function (attrs, isAttr) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, found) {
					return isAttr(x) ? A2($elm$core$List$cons, x, found) : found;
				}),
			_List_Nil,
			$mdgriffith$elm_ui$Internal$Model$filter(attrs));
	});
var $mdgriffith$elm_ui$Element$Input$leftArrow = 'ArrowLeft';
var $mdgriffith$elm_ui$Element$Input$rightArrow = 'ArrowRight';
var $mdgriffith$elm_ui$Element$Input$row = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				attributes),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$upArrow = 'ArrowUp';
var $mdgriffith$elm_ui$Element$Input$radioHelper = F3(
	function (orientation, attrs, input) {
		var track = F2(
			function (opt, _v14) {
				var found = _v14.a;
				var prev = _v14.b;
				var nxt = _v14.c;
				var val = opt.a;
				switch (found) {
					case 0:
						return _Utils_eq(
							$elm$core$Maybe$Just(val),
							input.ic) ? _Utils_Tuple3(1, prev, nxt) : _Utils_Tuple3(found, val, nxt);
					case 1:
						return _Utils_Tuple3(2, prev, val);
					default:
						return _Utils_Tuple3(found, prev, nxt);
				}
			});
		var renderOption = function (_v11) {
			var val = _v11.a;
			var view = _v11.b;
			var status = _Utils_eq(
				$elm$core$Maybe$Just(val),
				input.ic) ? 2 : 0;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						function () {
						if (!orientation) {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink);
						} else {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill);
						}
					}(),
						$mdgriffith$elm_ui$Element$Events$onClick(
						input.an(val)),
						function () {
						if (status === 2) {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'true'));
						} else {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'false'));
						}
					}(),
						$mdgriffith$elm_ui$Internal$Model$Attr(
						A2($elm$html$Html$Attributes$attribute, 'role', 'radio'))
					]),
				view(status));
		};
		var prevNext = function () {
			var _v5 = input.hQ;
			if (!_v5.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v6 = _v5.a;
				var val = _v6.a;
				return function (_v7) {
					var found = _v7.a;
					var b = _v7.b;
					var a = _v7.c;
					switch (found) {
						case 0:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						case 1:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						default:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, a));
					}
				}(
					A3(
						$elm$core$List$foldl,
						track,
						_Utils_Tuple3(0, val, val),
						input.hQ));
			}
		}();
		var optionArea = function () {
			if (!orientation) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$row,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.u),
						attrs),
					A2($elm$core$List$map, renderOption, input.hQ));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$Input$column,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.u),
						attrs),
					A2($elm$core$List$map, renderOption, input.hQ));
			}
		}();
		var events = A2(
			$mdgriffith$elm_ui$Internal$Model$get,
			attrs,
			function (attr) {
				_v3$3:
				while (true) {
					switch (attr.$) {
						case 7:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 8:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 1:
							return true;
						default:
							break _v3$3;
					}
				}
				return false;
			});
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$alignLeft),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Element$Input$tabindex(0)),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$htmlClass('focus')),
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Region$announce),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'role', 'radiogroup'))),
							function () {
							if (prevNext.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var _v1 = prevNext.a;
								var prev = _v1.a;
								var next = _v1.b;
								return $elm$core$Maybe$Just(
									$mdgriffith$elm_ui$Element$Input$onKeyLookup(
										function (code) {
											if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$leftArrow)) {
												return $elm$core$Maybe$Just(
													input.an(prev));
											} else {
												if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$upArrow)) {
													return $elm$core$Maybe$Just(
														input.an(prev));
												} else {
													if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$rightArrow)) {
														return $elm$core$Maybe$Just(
															input.an(next));
													} else {
														if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$downArrow)) {
															return $elm$core$Maybe$Just(
																input.an(next));
														} else {
															if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space)) {
																var _v2 = input.ic;
																if (_v2.$ === 1) {
																	return $elm$core$Maybe$Just(
																		input.an(prev));
																} else {
																	return $elm$core$Maybe$Nothing;
																}
															} else {
																return $elm$core$Maybe$Nothing;
															}
														}
													}
												}
											}
										}));
							}
						}()
						])),
				events),
			input.u,
			optionArea);
	});
var $mdgriffith$elm_ui$Element$Input$radio = $mdgriffith$elm_ui$Element$Input$radioHelper(1);
var $author$project$Ziege$Utils$weekdayToGerman = function (w) {
	switch (w) {
		case 0:
			return 'Montag';
		case 1:
			return 'Dienstag';
		case 2:
			return 'Mittwoch';
		case 3:
			return 'Donnerstag';
		case 4:
			return 'Freitag';
		case 5:
			return 'Samstag';
		default:
			return 'Sonntag';
	}
};
var $author$project$Ziege$Utils$renderWeekday = A2($elm$core$Basics$composeR, $author$project$Ziege$FastCalendar$getWeekday, $author$project$Ziege$Utils$weekdayToGerman);
var $author$project$Ziege$UI$Utils$sectionHint = function (s) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$paddingEach(
				{X: 6, a$: 16, a4: 16, aS: 0}),
				$mdgriffith$elm_ui$Element$Font$size(13),
				$author$project$Ziege$UI$Colors$fg(5)
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(s)
			]));
};
var $author$project$Main$buildIntervalUI = F2(
	function (today, todo) {
		var stringifyMasculine = function (n) {
			switch (n) {
				case 1:
					return 'jeden';
				case 2:
					return 'jeden zweiten';
				case 3:
					return 'jeden dritten';
				default:
					return 'jeden ' + ($elm$core$String$fromInt(n) + '.');
			}
		};
		var makeMaybe = F2(
			function (b, thing) {
				return b ? $elm$core$Maybe$Just(thing) : $elm$core$Maybe$Nothing;
			});
		var ifmaybe = F3(
			function (mb, ok, nope) {
				if (mb.$ === 1) {
					return nope;
				} else {
					return ok;
				}
			});
		var stepButton = F2(
			function (msg, label) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							A3(
							ifmaybe,
							msg,
							$author$project$Ziege$UI$Colors$fg(4),
							$author$project$Ziege$UI$Colors$fg(6)),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(40)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$Font$size(18)
						]),
					{
						u: A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]),
							$mdgriffith$elm_ui$Element$text(label)),
						aA: msg
					});
			});
		var expires = todo.L;
		var editinterval = todo.U;
		var everyString = function () {
			var _v4 = _Utils_Tuple2(editinterval.aV, editinterval.av);
			switch (_v4.a) {
				case 0:
					var _v5 = _v4.a;
					var n = _v4.b;
					return stringifyMasculine(n);
				case 1:
					switch (_v4.b) {
						case 1:
							var _v6 = _v4.a;
							return 'jede';
						case 2:
							var _v7 = _v4.a;
							return 'jede zweite';
						case 3:
							var _v8 = _v4.a;
							return 'jede dritte';
						default:
							var _v9 = _v4.a;
							return 'jede ' + ($elm$core$String$fromInt(editinterval.av) + '.');
					}
				case 2:
					var _v10 = _v4.a;
					var n = _v4.b;
					return stringifyMasculine(n);
				case 3:
					switch (_v4.b) {
						case 1:
							var _v11 = _v4.a;
							return 'jedes';
						case 2:
							var _v12 = _v4.a;
							return 'jedes zweite';
						case 3:
							var _v13 = _v4.a;
							return 'jedes dritte';
						default:
							var _v14 = _v4.a;
							return 'jedes ' + ($elm$core$String$fromInt(editinterval.av) + '.');
					}
				case 4:
					var _v15 = _v4.a;
					var n = _v4.b;
					return stringifyMasculine(n);
				default:
					var _v16 = _v4.a;
					return '';
			}
		}();
		var isAnytime = function () {
			var _v3 = editinterval.aV;
			if (_v3 === 5) {
				return true;
			} else {
				return false;
			}
		}();
		var maxEvery = function () {
			var _v2 = editinterval.aV;
			switch (_v2) {
				case 0:
					return 7;
				case 1:
					return 4;
				case 4:
					return 11;
				case 2:
					return 5;
				case 3:
					return 4;
				default:
					return 0;
			}
		}();
		var timesString = function () {
			var _v1 = editinterval.a5;
			switch (_v1) {
				case 1:
					return 'ein Mal';
				case 2:
					return 'zwei Mal';
				case 3:
					return 'drei Mal';
				default:
					var n = _v1;
					return $elm$core$String$fromInt(n) + ' Mal';
			}
		}();
		var canIncrementTimes = function () {
			var _v0 = editinterval.aV;
			return editinterval.a5 < 25;
		}();
		var canIncrementEvery = _Utils_cmp(editinterval.av, maxEvery) < 0;
		var canDecrementTimes = editinterval.a5 > 1;
		var canDecerementEvery = editinterval.av > 1;
		var buildIncDec = F3(
			function (v, decmsg, incmsg) {
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(44)),
							$mdgriffith$elm_ui$Element$Border$width(1),
							$author$project$Ziege$UI$Colors$borderColor(7),
							$mdgriffith$elm_ui$Element$Border$rounded(8)
						]),
					_List_fromArray(
						[
							A2(stepButton, decmsg, '−'),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
									$author$project$Ziege$UI$Colors$bg(1)
								]),
							A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$Font$bold]),
								$mdgriffith$elm_ui$Element$text(v))),
							A2(stepButton, incmsg, '+')
						]));
			});
		return _List_fromArray(
			[
				A2($author$project$Ziege$UI$Utils$sectionHeader, 'Zielvereinbarung bis', ''),
				$author$project$Ziege$UI$Utils$sectionHint('Wie lange soll diese Zielvereinbarung insgesamt laufen?'),
				$author$project$Ziege$UI$Utils$card(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$centerY,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(
											$author$project$Ziege$Utils$renderWeekday(expires) + (', ' + $author$project$Ziege$Utils$renderCalendarDate(todo.L)))
										]))),
								(!_Utils_eq(todo.ao, $elm$core$Maybe$Nothing)) ? A2(
								$mdgriffith$elm_ui$Element$Input$checkbox,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignRight,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
										$mdgriffith$elm_ui$Element$alignTop
									]),
								{
									bV: todo.b_,
									b$: $author$project$Main$editIconCheckbox,
									u: $mdgriffith$elm_ui$Element$Input$labelHidden('Zieldatum bearbeiten'),
									an: $author$project$Ziege$Model$UpdateExpiresDatePickerActive
								}) : $mdgriffith$elm_ui$Element$none
							])),
						(_Utils_eq(todo.ao, $elm$core$Maybe$Nothing) || todo.b_) ? A5(
						$author$project$Ziege$UI$DatePicker$buildDatePicker,
						$author$project$Ziege$Model$UpdatePendingExpires,
						$author$project$Main$isValidExpiry,
						$PanagiotisGeorgiadis$elm_datetime$Calendar$decrementYear(today),
						$PanagiotisGeorgiadis$elm_datetime$Calendar$incrementYear(today),
						todo.L) : $mdgriffith$elm_ui$Element$none
					])),
				A2($author$project$Ziege$UI$Utils$sectionHeader, 'Rhythmus', ''),
				$author$project$Ziege$UI$Utils$sectionHint('Wie häufig soll das Ziel erreicht werden?'),
				$author$project$Ziege$UI$Utils$card(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$centerY,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(
											$author$project$Ziege$TodoInterval$renderIntervalString(
												$author$project$Ziege$ModelEncodeDecode$editInterval2Interval(editinterval)))
										]))),
								(!_Utils_eq(todo.ao, $elm$core$Maybe$Nothing)) ? A2(
								$mdgriffith$elm_ui$Element$Input$checkbox,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignRight,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
										$mdgriffith$elm_ui$Element$alignTop
									]),
								{
									bV: todo.b0,
									b$: $author$project$Main$editIconCheckbox,
									u: $mdgriffith$elm_ui$Element$Input$labelHidden('Rhythmus bearbeiten'),
									an: $author$project$Ziege$Model$UpdateIntervalEditorActive
								}) : $mdgriffith$elm_ui$Element$none
							])),
						(todo.b0 || _Utils_eq(todo.ao, $elm$core$Maybe$Nothing)) ? A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$fillPortion(1)),
										$mdgriffith$elm_ui$Element$alignTop,
										$mdgriffith$elm_ui$Element$spacing(8)
									]),
								_List_fromArray(
									[
										A3(
										buildIncDec,
										timesString,
										A2(makeMaybe, canDecrementTimes, $author$project$Ziege$Model$DecrementEditIntervalTimes),
										A2(makeMaybe, canIncrementTimes, $author$project$Ziege$Model$IncrementEditIntervalTimes)),
										(!isAnytime) ? A3(
										buildIncDec,
										everyString,
										A2(makeMaybe, canDecerementEvery, $author$project$Ziege$Model$DecrementEditIntervalEvery),
										A2(makeMaybe, canIncrementEvery, $author$project$Ziege$Model$IncrementEditIntervalEvery)) : $mdgriffith$elm_ui$Element$none
									])),
								A2(
								$mdgriffith$elm_ui$Element$Input$radio,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$fillPortion(1)),
										$mdgriffith$elm_ui$Element$spacing(6)
									]),
								{
									u: $mdgriffith$elm_ui$Element$Input$labelHidden('Rhythmus-Basis'),
									an: $author$project$Ziege$Model$UpdateEditIntervalBase,
									hQ: A2(
										$elm$core$List$map,
										function (b) {
											return A2(
												$mdgriffith$elm_ui$Element$Input$optionWith,
												b,
												function (state) {
													return A2(
														$mdgriffith$elm_ui$Element$el,
														_Utils_ap(
															_List_fromArray(
																[
																	$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
																	A2($mdgriffith$elm_ui$Element$paddingXY, 10, 9),
																	$mdgriffith$elm_ui$Element$Border$rounded(8)
																]),
															(state === 2) ? _List_fromArray(
																[
																	$author$project$Ziege$UI$Colors$bg(24),
																	$author$project$Ziege$UI$Colors$fg(25),
																	$mdgriffith$elm_ui$Element$Font$bold
																]) : _List_fromArray(
																[
																	$mdgriffith$elm_ui$Element$Border$width(1),
																	$author$project$Ziege$UI$Colors$borderColor(8)
																])),
														A2(
															$mdgriffith$elm_ui$Element$el,
															_List_fromArray(
																[$mdgriffith$elm_ui$Element$centerX]),
															$mdgriffith$elm_ui$Element$text(
																$author$project$Main$getBaseStringFromInterval(b))));
												});
										},
										_List_fromArray(
											[0, 1, 2, 3, 4, 5])),
									ic: $elm$core$Maybe$Just(editinterval.aV)
								})
							])) : $mdgriffith$elm_ui$Element$none
					]))
			]);
	});
var $author$project$Ziege$Model$MakePendingTodo2PatternProposal = function (a) {
	return {$: 45, a: a};
};
var $author$project$Ziege$Model$UpdatePendingToDoContactMail = function (a) {
	return {$: 21, a: a};
};
var $author$project$Ziege$Model$UpdatePendingToDoContactName = function (a) {
	return {$: 20, a: a};
};
var $author$project$Ziege$Model$UpdatePendingToDoContactTel = function (a) {
	return {$: 22, a: a};
};
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $mdgriffith$elm_ui$Internal$Model$Rotate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$rotate = $mdgriffith$elm_ui$Internal$Flag$flag(24);
var $mdgriffith$elm_ui$Element$rotate = function (angle) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$rotate,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Rotate,
			_Utils_Tuple3(0, 0, 1),
			angle));
};
var $mdgriffith$elm_ui$Element$transparent = function (on) {
	return on ? A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'transparent', 1.0)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'visible', 0.0));
};
var $mdgriffith$elm_ui$Element$Input$defaultCheckbox = function (checked) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Internal$Model$htmlClass('focusable'),
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(14)),
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px(14)),
				$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$white),
				$mdgriffith$elm_ui$Element$centerY,
				$mdgriffith$elm_ui$Element$Font$size(9),
				$mdgriffith$elm_ui$Element$Font$center,
				$mdgriffith$elm_ui$Element$Border$rounded(3),
				$mdgriffith$elm_ui$Element$Border$color(
				checked ? A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255) : A3($mdgriffith$elm_ui$Element$rgb, 211 / 255, 211 / 255, 211 / 255)),
				$mdgriffith$elm_ui$Element$Border$shadow(
				{
					f2: 1,
					gm: checked ? A4($mdgriffith$elm_ui$Element$rgba, 238 / 255, 238 / 255, 238 / 255, 0) : A3($mdgriffith$elm_ui$Element$rgb, 238 / 255, 238 / 255, 238 / 255),
					hK: _Utils_Tuple2(0, 0),
					il: 1
				}),
				$mdgriffith$elm_ui$Element$Background$color(
				checked ? A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255) : $mdgriffith$elm_ui$Element$Input$white),
				$mdgriffith$elm_ui$Element$Border$width(
				checked ? 0 : 1),
				$mdgriffith$elm_ui$Element$inFront(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$white),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(6)),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(9)),
							$mdgriffith$elm_ui$Element$rotate(
							$elm$core$Basics$degrees(-45)),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$centerY,
							$mdgriffith$elm_ui$Element$moveUp(1),
							$mdgriffith$elm_ui$Element$transparent(!checked),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{X: 2, a$: 2, a4: 0, aS: 0})
						]),
					$mdgriffith$elm_ui$Element$none))
			]),
		$mdgriffith$elm_ui$Element$none);
};
var $mdgriffith$elm_ui$Element$Input$OnRight = 0;
var $mdgriffith$elm_ui$Element$Input$labelRight = $mdgriffith$elm_ui$Element$Input$Label(0);
var $author$project$Main$buildPatternPoposalUI = function (pendingToDo) {
	var contactField = F3(
		function (value, onChange, label) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$text,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				{
					u: A2(
						$mdgriffith$elm_ui$Element$Input$labelAbove,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$bold]),
						$mdgriffith$elm_ui$Element$text(label)),
					an: onChange,
					b9: $elm$core$Maybe$Just(
						A2(
							$mdgriffith$elm_ui$Element$Input$placeholder,
							_List_Nil,
							$mdgriffith$elm_ui$Element$text(label))),
					K: value
				});
		});
	return _List_fromArray(
		[
			A2($author$project$Ziege$UI$Utils$sectionHeader, 'Ziel in Katalog aufnehmen', ''),
			$author$project$Ziege$UI$Utils$card(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(15),
							$mdgriffith$elm_ui$Element$Font$bold
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Helfen Sie mit, die Zielvorschläge in ZieGE zu verbessern:')
						])),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Ein zentraler Teil von ZieGE sind die Zielvorschläge. Sie können helfen, ZieGE zu verbessern, indem Sie ein Ziel, das Ihnen fehlt, hier als Vorschlag zur Ergänzung des Katalogs einreichen. Wir werden Ihren Vorschlag anschauen und ihn möglichst in das System für alle Nutzer aufnehmen. Wenn Sie die folgende Checkbox anklicken, stimmen Sie der Übertragung der Daten aus dieser Zielvereinbarung an uns zu.')
						])),
					A2(
					$mdgriffith$elm_ui$Element$Input$checkbox,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(12)
						]),
					{
						bV: pendingToDo.b2,
						b$: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
						u: A2(
							$mdgriffith$elm_ui$Element$Input$labelRight,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(15),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							$mdgriffith$elm_ui$Element$text('Dieses Ziel für Katalog vorschlagen')),
						an: $author$project$Ziege$Model$MakePendingTodo2PatternProposal
					}),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Wenn wir Sie bei Fragen kontaktieren dürfen, füllen Sie bitte folgende Felder aus:')
						])),
					A3(contactField, pendingToDo.co, $author$project$Ziege$Model$UpdatePendingToDoContactName, 'Name'),
					A3(contactField, pendingToDo.cn, $author$project$Ziege$Model$UpdatePendingToDoContactMail, 'Email'),
					A3(contactField, pendingToDo.cp, $author$project$Ziege$Model$UpdatePendingToDoContactTel, 'Telefon')
				]))
		]);
};
var $mdgriffith$elm_ui$Element$Border$glow = F2(
	function (clr, size) {
		return $mdgriffith$elm_ui$Element$Border$shadow(
			{
				f2: size * 2,
				gm: clr,
				hK: _Utils_Tuple2(0, 0),
				il: size
			});
	});
var $mdgriffith$elm_ui$Element$rgb255 = F3(
	function (red, green, blue) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, 1);
	});
var $author$project$Main$elementFromTextpart = F2(
	function (i, part) {
		if (part.$ === 1) {
			var s = part.a;
			var f = part.b;
			return A2(
				$mdgriffith$elm_ui$Element$Input$text,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(3),
						A2(
						$mdgriffith$elm_ui$Element$Border$glow,
						A3($mdgriffith$elm_ui$Element$rgb255, 1, 207, 216),
						0.4)
					]),
				{
					u: $mdgriffith$elm_ui$Element$Input$labelHidden(''),
					an: $author$project$Ziege$Model$UpdatePendingToDoTextPart(i),
					b9: $elm$core$Maybe$Just(
						A2(
							$mdgriffith$elm_ui$Element$Input$placeholder,
							_List_fromArray(
								[
									$author$project$Ziege$UI$Colors$fg(6)
								]),
							$mdgriffith$elm_ui$Element$text(s))),
					K: f
				});
		} else {
			var s = part.a;
			return $mdgriffith$elm_ui$Element$text(s);
		}
	});
var $author$project$Main$elementsFromTextparts = function (partlist) {
	return A2($elm$core$List$indexedMap, $author$project$Main$elementFromTextpart, partlist);
};
var $mdgriffith$elm_ui$Element$Input$multiline = F2(
	function (attrs, multi) {
		return A3(
			$mdgriffith$elm_ui$Element$Input$textHelper,
			{at: $elm$core$Maybe$Nothing, aF: multi.ip, i3: $mdgriffith$elm_ui$Element$Input$TextArea},
			attrs,
			{u: multi.u, an: multi.an, b9: multi.b9, K: multi.K});
	});
var $author$project$Main$buildPatternEditor = F2(
	function (today, pendingtodo) {
		var newTextEditor = function () {
			var pendingTodoText = function () {
				var _v1 = $elm$core$List$head(pendingtodo.K);
				if ((!_v1.$) && (_v1.a.$ === 1)) {
					var _v2 = _v1.a;
					var t = _v2.b;
					return t;
				} else {
					return '';
				}
			}();
			return _List_fromArray(
				[
					A2($author$project$Ziege$UI$Utils$sectionHeader, 'Ziel beschreiben', ''),
					$author$project$Ziege$UI$Utils$card(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$Font$size(16),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							{
								u: A2(
									$mdgriffith$elm_ui$Element$Input$labelAbove,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(14),
											$mdgriffith$elm_ui$Element$Font$bold
										]),
									$mdgriffith$elm_ui$Element$text('Titel')),
								an: $author$project$Ziege$Model$UpdatePendingToDoTitle,
								b9: $elm$core$Maybe$Just(
									A2(
										$mdgriffith$elm_ui$Element$Input$placeholder,
										_List_Nil,
										$mdgriffith$elm_ui$Element$text('Titel'))),
								K: pendingtodo.j
							}),
							A2(
							$mdgriffith$elm_ui$Element$Input$multiline,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$Font$size(14),
									$mdgriffith$elm_ui$Element$spacing(8)
								]),
							{
								u: A2(
									$mdgriffith$elm_ui$Element$Input$labelAbove,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(14),
											$mdgriffith$elm_ui$Element$Font$bold
										]),
									$mdgriffith$elm_ui$Element$text('Beschreibung')),
								an: $author$project$Ziege$Model$UpdatePendingToDoTextPart(0),
								b9: $elm$core$Maybe$Just(
									A2(
										$mdgriffith$elm_ui$Element$Input$placeholder,
										_List_Nil,
										$mdgriffith$elm_ui$Element$text('Beschreibung des Ziels'))),
								ip: true,
								K: pendingTodoText
							})
						]))
				]);
		}();
		var isPlaceholder = function (p) {
			if (p.$ === 1) {
				return true;
			} else {
				return false;
			}
		};
		var patternTextEditor = _List_fromArray(
			[
				A2($author$project$Ziege$UI$Utils$sectionHeader, 'Ziel beschreiben', ''),
				A2($elm$core$List$any, isPlaceholder, pendingtodo.K) ? $author$project$Ziege$UI$Utils$sectionHint('Füllen Sie die Lücken im Text:') : $mdgriffith$elm_ui$Element$none,
				$author$project$Ziege$UI$Utils$card(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$bold
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(pendingtodo.j)
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(15),
								$mdgriffith$elm_ui$Element$spacing(8)
							]),
						$author$project$Main$elementsFromTextparts(pendingtodo.K))
					]))
			]);
		var descriptionEditor = _Utils_eq(pendingtodo.ao, $elm$core$Maybe$Nothing) ? newTextEditor : patternTextEditor;
		return _Utils_ap(
			descriptionEditor,
			_Utils_ap(
				A2($author$project$Main$buildIntervalUI, today, pendingtodo),
				_Utils_eq(pendingtodo.ao, $elm$core$Maybe$Nothing) ? $author$project$Main$buildPatternPoposalUI(pendingtodo) : _List_Nil));
	});
var $author$project$Main$starIconCheckox = $author$project$Main$checkboxIcon('star');
var $author$project$Main$buildEditorView = F2(
	function (today, pendingToDo) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{X: 10}))
				]),
			_Utils_ap(
				A2($author$project$Main$buildPatternEditor, today, pendingToDo),
				_Utils_ap(
					(!_Utils_eq(pendingToDo.ao, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A2($author$project$Ziege$UI$Utils$sectionHeader, 'Favorit', ''),
							$author$project$Ziege$UI$Utils$sectionHint('Soll diese Vorlage ein Favorit sein, damit man sie schneller wiederfindet?'),
							$author$project$Ziege$UI$Utils$card(
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$Input$checkbox,
									_List_Nil,
									{
										bV: pendingToDo.b1,
										b$: $author$project$Main$starIconCheckox,
										u: A2(
											$mdgriffith$elm_ui$Element$Input$labelRight,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$Font$size(15),
													$mdgriffith$elm_ui$Element$Font$bold,
													$mdgriffith$elm_ui$Element$centerY
												]),
											$mdgriffith$elm_ui$Element$text('Als Favorit markieren')),
										an: $author$project$Ziege$Model$UpdatePendingToDoIsFavorite
									})
								]))
						]) : _List_Nil,
					_List_fromArray(
						[
							$author$project$Ziege$UI$Utils$actionPanel(
							_List_fromArray(
								[
									A2(
									$author$project$Ziege$UI$Button$buildPrimaryButton,
									'Ziel zuweisen',
									$author$project$Ziege$Model$AddPendingTodo2ActiveClient(pendingToDo))
								]))
						]))));
	});
var $author$project$Ziege$Model$ResetData = {$: 35};
var $author$project$Ziege$UI$ErrorView$buildErrorView = F2(
	function (err, canReset) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$Ziege$UI$Colors$fg(13),
					$author$project$Ziege$UI$Colors$bg(12),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(50),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{X: 10}))
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(err)
						])),
					canReset ? A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					A2($author$project$Ziege$UI$Button$buildButton, 'Daten zurücksetzen', $author$project$Ziege$Model$ResetData)) : $mdgriffith$elm_ui$Element$none
				]));
	});
var $author$project$Ziege$Model$StopTimeTravel = {$: 14};
var $author$project$Ziege$Model$TimeTravelDay = function (a) {
	return {$: 13, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
var $author$project$Ziege$Config$footerHeight = 40;
var $author$project$Ziege$Config$maxWidth = 1366;
var $mdgriffith$elm_ui$Internal$Model$Max = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$maximum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Max, i, l);
	});
var $author$project$Ziege$UI$Footer$plusBottomInset = function (pixels) {
	return 'calc(' + ($elm$core$String$fromInt(pixels) + 'px + env(safe-area-inset-bottom, 0px))');
};
var $author$project$Ziege$UI$Footer$buildFooterColumn = $mdgriffith$elm_ui$Element$column(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$height(
			$mdgriffith$elm_ui$Element$px($author$project$Ziege$Config$footerHeight)),
			$mdgriffith$elm_ui$Element$htmlAttribute(
			A2(
				$elm$html$Html$Attributes$style,
				'height',
				$author$project$Ziege$UI$Footer$plusBottomInset($author$project$Ziege$Config$footerHeight))),
			$mdgriffith$elm_ui$Element$htmlAttribute(
			A2(
				$elm$html$Html$Attributes$style,
				'padding-bottom',
				$author$project$Ziege$UI$Footer$plusBottomInset(5))),
			$author$project$Ziege$UI$Colors$bg(0),
			$mdgriffith$elm_ui$Element$Border$widthEach(
			{X: 0, a$: 0, a4: 0, aS: 1}),
			$author$project$Ziege$UI$Colors$borderColor(8),
			$mdgriffith$elm_ui$Element$alignBottom,
			$mdgriffith$elm_ui$Element$centerX,
			$mdgriffith$elm_ui$Element$width(
			A2($mdgriffith$elm_ui$Element$maximum, $author$project$Ziege$Config$maxWidth, $mdgriffith$elm_ui$Element$fill)),
			A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5)
		]));
var $elm$core$String$pad = F3(
	function (n, _char, string) {
		var half = (n - $elm$core$String$length(string)) / 2;
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				$elm$core$Basics$ceiling(half),
				$elm$core$String$fromChar(_char)),
			_Utils_ap(
				string,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$floor(half),
					$elm$core$String$fromChar(_char))));
	});
var $author$project$Ziege$Utils$renderDate = F2(
	function (z, t) {
		var year = A3(
			$elm$core$String$pad,
			2,
			'4',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toYear, z, t)));
		var month = $author$project$Ziege$Utils$monthToGerman(
			A2($elm$time$Time$toMonth, z, t));
		var day = $elm$core$String$fromInt(
			A2($elm$time$Time$toDay, z, t));
		return day + ('. ' + (month + (' ' + year)));
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $author$project$Ziege$Utils$renderTime = F2(
	function (z, t) {
		var second = A3(
			$elm$core$String$pad,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toSecond, z, t)));
		var minute = A3(
			$elm$core$String$pad,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toMinute, z, t)));
		var hour = A3(
			$elm$core$String$pad,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toHour, z, t)));
		return hour + (':' + (minute + (':' + second)));
	});
var $author$project$Ziege$UI$Footer$buildFooter = F3(
	function (zone, now, timeTravelActive) {
		var stepButton = F2(
			function (label, msg) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(10),
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$Border$rounded(2)
						]),
					{
						u: $mdgriffith$elm_ui$Element$text(label),
						aA: $elm$core$Maybe$Just(msg)
					});
			});
		var rocket = timeTravelActive ? '🚀' : '';
		return $author$project$Ziege$UI$Footer$buildFooterColumn(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Font$size(12)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignLeft]),
							A2(
								stepButton,
								'-',
								$author$project$Ziege$Model$TimeTravelDay(-1))),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0),
									$mdgriffith$elm_ui$Element$centerX
								]),
							$mdgriffith$elm_ui$Element$text(
								rocket + (A2($author$project$Ziege$Utils$renderDate, zone, now) + (' ' + (A2($author$project$Ziege$Utils$renderTime, zone, now) + rocket))))),
							timeTravelActive ? A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							A2(stepButton, '🗓', $author$project$Ziege$Model$StopTimeTravel)) : $mdgriffith$elm_ui$Element$none,
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignRight]),
							A2(
								stepButton,
								'+',
								$author$project$Ziege$Model$TimeTravelDay(1)))
						]))
				]));
	});
var $author$project$Ziege$UI$Colors$Control = 18;
var $mdgriffith$elm_ui$Element$Region$description = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Describe, $mdgriffith$elm_ui$Internal$Model$Label);
var $author$project$Ziege$Config$headerHeight = 56;
var $author$project$Ziege$UI$Header$iconSize = 40;
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $mdgriffith$elm_ui$Element$image = F2(
	function (attrs, _v0) {
		var description = _v0.gy;
		var src = _v0.iq;
		var imageAttributes = A2(
			$elm$core$List$filter,
			function (a) {
				switch (a.$) {
					case 7:
						return true;
					case 8:
						return true;
					default:
						return false;
				}
			},
			attrs);
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.g2),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('img'),
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$src(src)),
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$alt(description))
								]),
							imageAttributes),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
					])));
	});
var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
var $mdgriffith$elm_ui$Element$moveLeft = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(-x));
};
var $author$project$Ziege$UI$Header$oneLine = F2(
	function (attrs, s) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'min-width', '0')),
					attrs)),
			$mdgriffith$elm_ui$Element$html(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
							A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
							A2($elm$html$Html$Attributes$style, 'line-height', '1.3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(s)
						]))));
	});
var $mdgriffith$elm_ui$Element$Font$semiBold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.iM);
var $author$project$Ziege$UI$Header$buildHeader = function (cfg) {
	var cornerButton = F4(
		function (symbol, description, msg, attr) {
			return A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						attr,
						$mdgriffith$elm_ui$Element$Region$description(description),
						$mdgriffith$elm_ui$Element$alignTop,
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(44)),
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(44)),
						$mdgriffith$elm_ui$Element$Font$size(20),
						$author$project$Ziege$UI$Colors$fg(18)
					]),
				{
					u: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]),
						A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, symbol)),
					aA: $elm$core$Maybe$Just(msg)
				});
		});
	var makeElement = F2(
		function (element, attr) {
			switch (element.$) {
				case 0:
					var msg = element.a;
					return A4(cornerButton, 'chevron-left', 'Zurück', msg, attr);
				case 1:
					var description = element.a;
					var msg = element.b;
					return A4(cornerButton, 'xmark-large', description, msg, attr);
				case 2:
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[attr, $mdgriffith$elm_ui$Element$centerY]),
						$mdgriffith$elm_ui$Element$none);
				case 4:
					var uri = element.a;
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								attr,
								$mdgriffith$elm_ui$Element$centerY,
								A2($mdgriffith$elm_ui$Element$paddingXY, 8, 0)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px($author$project$Ziege$UI$Header$iconSize)),
									A2($mdgriffith$elm_ui$Element$paddingXY, 4, 3),
									$mdgriffith$elm_ui$Element$Border$rounded(6),
									$mdgriffith$elm_ui$Element$htmlAttribute(
									A2($elm$html$Html$Attributes$style, 'background-color', '#ffffff'))
								]),
							A2(
								$mdgriffith$elm_ui$Element$image,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$height(
										$mdgriffith$elm_ui$Element$px($author$project$Ziege$UI$Header$iconSize - 6))
									]),
								{gy: 'Logo der Organisation', iq: uri})));
				default:
					var msg = element.a;
					return A2(
						$mdgriffith$elm_ui$Element$Input$button,
						_List_fromArray(
							[
								attr,
								$mdgriffith$elm_ui$Element$centerY,
								A2($mdgriffith$elm_ui$Element$paddingXY, 8, 0)
							]),
						{
							u: A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px($author$project$Ziege$UI$Header$iconSize)),
										$mdgriffith$elm_ui$Element$height(
										$mdgriffith$elm_ui$Element$px($author$project$Ziege$UI$Header$iconSize)),
										$mdgriffith$elm_ui$Element$Border$rounded(8),
										$mdgriffith$elm_ui$Element$clip
									]),
								A2(
									$mdgriffith$elm_ui$Element$image,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px($author$project$Ziege$UI$Header$iconSize + 8)),
											$mdgriffith$elm_ui$Element$height(
											$mdgriffith$elm_ui$Element$px($author$project$Ziege$UI$Header$iconSize + 8)),
											$mdgriffith$elm_ui$Element$moveLeft(4),
											$mdgriffith$elm_ui$Element$moveUp(4)
										]),
									{gy: 'Ziege-Icon', iq: '/static/appicon.png'})),
							aA: $elm$core$Maybe$Just(msg)
						});
			}
		});
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px($author$project$Ziege$Config$headerHeight)),
				$author$project$Ziege$UI$Colors$bg(0),
				$mdgriffith$elm_ui$Element$Border$widthEach(
				{X: 1, a$: 0, a4: 0, aS: 0}),
				$author$project$Ziege$UI$Colors$borderColor(8),
				$mdgriffith$elm_ui$Element$inFront(
				A2(makeElement, cfg.a0, $mdgriffith$elm_ui$Element$alignLeft)),
				$mdgriffith$elm_ui$Element$inFront(
				A2(makeElement, cfg.h1, $mdgriffith$elm_ui$Element$alignRight)),
				$mdgriffith$elm_ui$Element$centerX,
				$mdgriffith$elm_ui$Element$width(
				A2($mdgriffith$elm_ui$Element$maximum, $author$project$Ziege$Config$maxWidth, $mdgriffith$elm_ui$Element$fill)),
				$mdgriffith$elm_ui$Element$Font$size(16),
				A2($mdgriffith$elm_ui$Element$paddingXY, 70, 0)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(2)
					]),
				$elm$core$String$isEmpty(cfg.j) ? _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$Font$size(20),
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$Font$letterSpacing(0.5),
								$author$project$Ziege$UI$Colors$fg(4)
							]),
						$mdgriffith$elm_ui$Element$text('ZieGE')),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$Font$size(10),
								$author$project$Ziege$UI$Colors$fg(5)
							]),
						$mdgriffith$elm_ui$Element$text('Ziele Gemeinsam Erreichen'))
					]) : ($elm$core$String$isEmpty(cfg.bq) ? _List_fromArray(
					[
						A2(
						$author$project$Ziege$UI$Header$oneLine,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$semiBold,
								$author$project$Ziege$UI$Colors$fg(4)
							]),
						cfg.j)
					]) : _List_fromArray(
					[
						A2(
						$author$project$Ziege$UI$Header$oneLine,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(12),
								$author$project$Ziege$UI$Colors$fg(5)
							]),
						cfg.bq),
						A2(
						$author$project$Ziege$UI$Header$oneLine,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$semiBold,
								$author$project$Ziege$UI$Colors$fg(4)
							]),
						cfg.j)
					])))
			]));
};
var $author$project$Ziege$Model$DismissMatrixError = {$: 41};
var $author$project$Main$buildMatrixError = function (matrixError) {
	if (!matrixError.$) {
		var message = matrixError.a;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$padding(10),
						$author$project$Ziege$UI$Colors$bg(9),
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(message)
							])),
						A2($author$project$Ziege$UI$Button$buildButton, 'OK', $author$project$Ziege$Model$DismissMatrixError)
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ziege$Model$CopyRoomId = {$: 8};
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Ziege$UI$ClientEditSettings$shortRoomId = function (roomId) {
	return ($elm$core$String$length(roomId) <= 20) ? roomId : (A2($elm$core$String$left, 12, roomId) + ('…' + A2($elm$core$String$right, 6, roomId)));
};
var $author$project$Ziege$UI$ClientEditSettings$buildRoomIdLink = function (client) {
	return $elm$core$String$isEmpty(client.i) ? $mdgriffith$elm_ui$Element$none : A2(
		$mdgriffith$elm_ui$Element$Input$button,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Region$description('Raum-ID kopieren')
			]),
		{
			u: A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(6),
						$author$project$Ziege$UI$Colors$fg(5),
						$mdgriffith$elm_ui$Element$Font$size(13)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(
						'Raum-ID: ' + $author$project$Ziege$UI$ClientEditSettings$shortRoomId(client.i)),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$underline]),
						$mdgriffith$elm_ui$Element$text('kopieren'))
					])),
			aA: $elm$core$Maybe$Just($author$project$Ziege$Model$CopyRoomId)
		});
};
var $author$project$Ziege$Model$ResetPatternlist = {$: 29};
var $author$project$Ziege$Model$SwitchView = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ziege$Model$PatternSelected = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ziege$Model$ToggleCategory = function (a) {
	return {$: 51, a: a};
};
var $author$project$Ziege$Model$AddUserFavorite = function (a) {
	return {$: 26, a: a};
};
var $author$project$Ziege$UI$Colors$FavoriteServer = 16;
var $author$project$Ziege$UI$Colors$FavoriteUser = 15;
var $author$project$Ziege$Model$RemoveUserFavorite = function (a) {
	return {$: 27, a: a};
};
var $author$project$Ziege$UI$Colors$Star = 10;
var $author$project$Main$onClickAndStropPropagation = function (message) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Events$stopPropagationOn,
			'click',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(message, true))));
};
var $author$project$Main$patternIsFavorite = function (pat) {
	return A2($elm$core$List$member, 'favorite', pat.fm);
};
var $author$project$Main$textPart2Element = function (textpart) {
	if (!textpart.$) {
		var s = textpart.a;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_Nil,
			$mdgriffith$elm_ui$Element$text(s));
	} else {
		var s = textpart.a;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$author$project$Ziege$UI$Colors$fg(6)
				]),
			$mdgriffith$elm_ui$Element$text(s));
	}
};
var $author$project$Main$patternTextPartstoElementList = function (partlist) {
	return A2($elm$core$List$map, $author$project$Main$textPart2Element, partlist);
};
var $author$project$Main$buildPatternUI = F2(
	function (pattern, isFavorite) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$paddingEach(
						{X: 12, a$: 44, a4: 14, aS: 10}),
						$mdgriffith$elm_ui$Element$Border$widthEach(
						_Utils_update(
							$author$project$Ziege$UI$Utils$edges,
							{aS: 1})),
						$author$project$Ziege$UI$Colors$borderColor(8),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				($author$project$Main$patternIsFavorite(pattern) && isFavorite) ? _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'background-image', 'linear-gradient(to right, var(--z-favorite-server), var(--z-favorite-user))'))
					]) : ($author$project$Main$patternIsFavorite(pattern) ? _List_fromArray(
					[
						$author$project$Ziege$UI$Colors$bg(16)
					]) : (isFavorite ? _List_fromArray(
					[
						$author$project$Ziege$UI$Colors$bg(15)
					]) : _List_Nil))),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(5)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$bold,
									$mdgriffith$elm_ui$Element$Font$size(14)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(pattern.j),
									isFavorite ? A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$author$project$Main$onClickAndStropPropagation(
											$author$project$Ziege$Model$RemoveUserFavorite(pattern.I)),
											$author$project$Ziege$UI$Colors$fg(10),
											A2($mdgriffith$elm_ui$Element$paddingXY, 6, 0)
										]),
									A2($author$project$Ziege$UI$Icons$buildFaIcon, 1, 'star')) : A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$author$project$Main$onClickAndStropPropagation(
											$author$project$Ziege$Model$AddUserFavorite(pattern.I)),
											$author$project$Ziege$UI$Colors$fg(6),
											A2($mdgriffith$elm_ui$Element$paddingXY, 6, 0)
										]),
									A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, 'star'))
								])),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(13),
									$author$project$Ziege$UI$Colors$fg(5)
								]),
							$author$project$Main$patternTextPartstoElementList(pattern.K)),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(12),
									$author$project$Ziege$UI$Colors$fg(5)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(
									$author$project$Ziege$TodoInterval$renderIntervalString(pattern.l) + (' · ' + ($elm$core$String$fromInt(pattern.c1) + ' Tage')))
								]))
						])),
				aA: $elm$core$Maybe$Just(
					$author$project$Ziege$Model$PatternSelected(
						$elm$core$Maybe$Just(pattern)))
			});
	});
var $author$project$Main$categoryIsFavorite = function (cat) {
	return A2($elm$core$List$member, 'favorite', cat.fm);
};
var $author$project$Main$patternIsUserFavorite = F2(
	function (m, pat) {
		return A2(
			$elm$core$Set$member,
			$elm$core$String$trim(pat.I),
			m.ab);
	});
var $author$project$Main$findUserFavoritePatterns = function (model) {
	var _v0 = model.N;
	if ((_v0.$ === 2) && (_v0.a.$ === 1)) {
		var cr = _v0.a.a;
		var findInCategory = function (c) {
			return A2(
				$elm$core$List$filter,
				$author$project$Main$patternIsUserFavorite(model),
				c.eT);
		};
		return $elm$core$List$concat(
			A2($elm$core$List$map, findInCategory, cr.N.c0));
	} else {
		return _List_Nil;
	}
};
var $author$project$Main$buildPatternCategoriesUI = F3(
	function (m, openCategories, category) {
		var isOpen = A2($elm$core$Set$member, category.I, openCategories);
		var children = isOpen ? A2(
			$elm$core$List$map,
			function (p) {
				return A2(
					$author$project$Main$buildPatternUI,
					p,
					A2($author$project$Main$patternIsUserFavorite, m, p));
			},
			_Utils_ap(
				category.eT,
				$author$project$Main$categoryIsFavorite(category) ? $author$project$Main$findUserFavoritePatterns(m) : _List_Nil)) : _List_Nil;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					{
						u: A2(
							$author$project$Ziege$UI$Utils$listRow,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(15)
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$author$project$Ziege$UI$Colors$fg(2),
												$mdgriffith$elm_ui$Element$width(
												$mdgriffith$elm_ui$Element$px(20))
											]),
										A2(
											$author$project$Ziege$UI$Icons$buildFaIcon,
											0,
											isOpen ? 'folder-open' : 'folder-closed')),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[$mdgriffith$elm_ui$Element$Font$bold]),
										$mdgriffith$elm_ui$Element$text(category.j))
									]),
								_Utils_ap(
									$author$project$Main$categoryIsFavorite(category) ? _List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[
													$author$project$Ziege$UI$Colors$fg(2)
												]),
											A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, 'stars'))
										]) : _List_Nil,
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$alignRight,
													$author$project$Ziege$UI$Colors$fg(6)
												]),
											A2(
												$author$project$Ziege$UI$Icons$buildFaIcon,
												1,
												isOpen ? 'chevron-down' : 'chevron-right'))
										])))),
						aA: $elm$core$Maybe$Just(
							$author$project$Ziege$Model$ToggleCategory(category.I))
					}),
				children));
	});
var $author$project$Main$buildPatternlistUI = F3(
	function (m, patternlist, openCategories) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$paddingEach(
						{X: 5, a$: 10, a4: 10, aS: 12})
					]),
				A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_Utils_ap(
						$author$project$Ziege$UI$Utils$cardStyle,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$padding(14)
							])),
					{
						u: A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$spacing(12)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$author$project$Ziege$UI$Colors$fg(2),
											$mdgriffith$elm_ui$Element$Font$size(18)
										]),
									A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, 'pen-to-square')),
									A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$spacing(4)
										]),
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$paragraph,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$Font$bold,
													$mdgriffith$elm_ui$Element$Font$size(15)
												]),
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$text('Keine passende Vorlage?')
												])),
											A2(
											$mdgriffith$elm_ui$Element$paragraph,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$Font$size(14),
													$author$project$Ziege$UI$Colors$fg(2)
												]),
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$text('Ein eigenes Ziel erstellen')
												]))
										])),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$alignRight,
											$author$project$Ziege$UI$Colors$fg(6)
										]),
									A2($author$project$Ziege$UI$Icons$buildFaIcon, 1, 'chevron-right'))
								])),
						aA: $elm$core$Maybe$Just(
							$author$project$Ziege$Model$PatternSelected($elm$core$Maybe$Nothing))
					})),
				A2(
				$author$project$Ziege$UI$Utils$sectionHeader,
				'Vorlagen',
				$elm$core$String$fromInt(
					$elm$core$List$length(patternlist.c0)) + ' Bereiche'),
				$author$project$Ziege$UI$Utils$listCard(
				A2(
					$elm$core$List$map,
					A2($author$project$Main$buildPatternCategoriesUI, m, openCategories),
					patternlist.c0))
			]);
	});
var $author$project$Main$buildSelectorView = F2(
	function (model, openCategories) {
		var retry = F2(
			function (label, msg) {
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$centerX,
							A2($mdgriffith$elm_ui$Element$paddingXY, 0, 10)
						]),
					A2($author$project$Ziege$UI$Button$buildButton, label, msg));
			});
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{X: 10}))
				]),
			function () {
				var _v0 = model.N;
				switch (_v0.$) {
					case 3:
						var s = _v0.a;
						return _List_fromArray(
							[
								$author$project$Ziege$UI$Utils$quietNote('Die Zielvorlagen ließen sich nicht laden: ' + s),
								A2(retry, 'Nochmal probieren', $author$project$Ziege$Model$ResetPatternlist)
							]);
					case 0:
						return _List_fromArray(
							[
								$author$project$Ziege$UI$Utils$quietNote('Die Zielvorlagen sind noch nicht geladen.')
							]);
					case 2:
						if (_v0.a.$ === 1) {
							var data = _v0.a.a;
							return A3($author$project$Main$buildPatternlistUI, model, data.N, openCategories);
						} else {
							return _List_fromArray(
								[
									$author$project$Ziege$UI$Utils$quietNote('Zielvorlagen gibt es nur für Berater*innen.'),
									A2(
									retry,
									'Zurück',
									$author$project$Ziege$Model$SwitchView($author$project$Ziege$Model$ClientTodoList))
								]);
						}
					default:
						return _List_fromArray(
							[
								$author$project$Ziege$UI$Utils$quietNote('Die Zielvorlagen werden geladen …')
							]);
				}
			}());
	});
var $author$project$Ziege$Model$AddClientView = {$: 2};
var $author$project$Ziege$Model$SwitchActiveClient = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ziege$TodoInterval$getDateRangeInterval = F3(
	function (stepper, start, stop) {
		return A2(
			$elm$core$List$cons,
			start,
			(!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, stop)) ? A3(
				$author$project$Ziege$TodoInterval$getDateRangeInterval,
				stepper,
				stepper(start),
				stop) : _List_Nil);
	});
var $author$project$Ziege$TodoInterval$getMonthRangeInterval = $author$project$Ziege$TodoInterval$getDateRangeInterval($PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth);
var $author$project$Ziege$UI$ClientPerformance$isDateBetween = F3(
	function (start, stop, d) {
		return (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, d) !== 2) && (!(!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, stop, d)));
	});
var $author$project$Ziege$UI$ClientPerformance$allIntervalsInRollingYear = F3(
	function (stepper, client, today) {
		var completionLog = A2($author$project$Ziege$UI$ClientCompletionLog$clientCompletionLog, today, client);
		var calcDueDatesinInterval = function (monthstart) {
			var monthend = stepper(monthstart);
			var isCompletionEventInInterval = F3(
				function (start, stop, event) {
					return A3(
						$author$project$Ziege$UI$ClientPerformance$isDateBetween,
						start,
						stop,
						$author$project$Ziege$TodoInterval$intervalEnd(event.l));
				});
			var filteredCompletionLog = A2(
				$elm$core$List$filter,
				A2(isCompletionEventInInterval, monthstart, monthend),
				completionLog);
			return _Utils_Tuple2(monthstart, filteredCompletionLog);
		};
		return A2(
			$elm$core$List$map,
			calcDueDatesinInterval,
			A2(
				$author$project$Ziege$TodoInterval$getMonthRangeInterval,
				$PanagiotisGeorgiadis$elm_datetime$Calendar$decrementYear(today),
				today));
	});
var $author$project$Ziege$UI$ClientPerformance$allIntervalsInRollingYearMonths = $author$project$Ziege$UI$ClientPerformance$allIntervalsInRollingYear(
	A2($elm$core$Basics$composeL, $author$project$Ziege$FastCalendar$decrementDay, $PanagiotisGeorgiadis$elm_datetime$Calendar$incrementMonth));
var $terezka$elm_charts$Internal$Helpers$Attribute = $elm$core$Basics$identity;
var $terezka$elm_charts$Chart$Attributes$amount = function (value) {
	return function (config) {
		return _Utils_update(
			config,
			{as: value});
	};
};
var $terezka$elm_charts$Internal$Property$NotStacked = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Internal$Property$notStacked = F3(
	function (toY, interpolation, presentation) {
		return $terezka$elm_charts$Internal$Property$NotStacked(
			{
				hc: interpolation,
				hW: presentation,
				cS: toY,
				cb: toY,
				fp: $elm$core$Maybe$Nothing,
				i0: function (datum) {
					return A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$fromFloat,
							toY(datum)));
				},
				fu: F2(
					function (_v0, _v1) {
						return _List_Nil;
					})
			});
	});
var $terezka$elm_charts$Chart$bar = function (y) {
	return A2(
		$terezka$elm_charts$Internal$Property$notStacked,
		A2($elm$core$Basics$composeR, y, $elm$core$Maybe$Just),
		_List_Nil);
};
var $terezka$elm_charts$Chart$BarsElement = F5(
	function (a, b, c, d, e) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e};
	});
var $terezka$elm_charts$Chart$Indexed = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Internal$Many$apply = F2(
	function (_v0, items) {
		var func = _v0.b;
		return func(items);
	});
var $terezka$elm_charts$Chart$Item$apply = $terezka$elm_charts$Internal$Many$apply;
var $terezka$elm_charts$Internal$Helpers$apply = F2(
	function (attrs, _default) {
		var apply_ = F2(
			function (_v0, a) {
				var f = _v0;
				return f(a);
			});
		return A3($elm$core$List$foldl, apply_, _default, attrs);
	});
var $terezka$elm_charts$Internal$Many$Remodel = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Item$Rendered = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Many$editLimits = F2(
	function (edit, _v0) {
		var _v1 = _v0.a;
		var x = _v1.a;
		var xs = _v1.b;
		var rendering = _v0.b;
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			_Utils_Tuple2(x, xs),
			_Utils_update(
				rendering,
				{
					R: A2(edit, x, rendering.R)
				}));
	});
var $terezka$elm_charts$Internal$Item$getPosition = F2(
	function (plane, _v0) {
		var item = _v0.b;
		return item.iX(plane);
	});
var $terezka$elm_charts$Internal$Item$getX1 = function (_v0) {
	var meta = _v0.a;
	return meta.bR;
};
var $terezka$elm_charts$Internal$Item$getX2 = function (_v0) {
	var meta = _v0.a;
	return meta.cg;
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $terezka$elm_charts$Internal$Helpers$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = A2(
						$elm$core$List$partition,
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					return A2(
						helper,
						remaining,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered));
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $terezka$elm_charts$Internal$Coordinates$Position = F4(
	function (x1, x2, y1, y2) {
		return {bR: x1, cg: x2, jg: y1, dT: y2};
	});
var $terezka$elm_charts$Internal$Coordinates$foldPosition = F2(
	function (func, data) {
		var fold = F2(
			function (datum, posM) {
				if (!posM.$) {
					var pos = posM.a;
					return $elm$core$Maybe$Just(
						{
							bR: A2(
								$elm$core$Basics$min,
								func(datum).bR,
								pos.bR),
							cg: A2(
								$elm$core$Basics$max,
								func(datum).cg,
								pos.cg),
							jg: A2(
								$elm$core$Basics$min,
								func(datum).jg,
								pos.jg),
							dT: A2(
								$elm$core$Basics$max,
								func(datum).dT,
								pos.dT)
						});
				} else {
					return $elm$core$Maybe$Just(
						func(datum));
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			A4($terezka$elm_charts$Internal$Coordinates$Position, 0, 0, 0, 0),
			A3($elm$core$List$foldl, fold, $elm$core$Maybe$Nothing, data));
	});
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $terezka$elm_charts$Internal$Item$getLimits = function (_v0) {
	var item = _v0.b;
	return item.R;
};
var $terezka$elm_charts$Internal$Item$render = F2(
	function (plane, _v0) {
		var item = _v0.b;
		return A2(
			item.e3,
			plane,
			item.iX(plane));
	});
var $elm$html$Html$table = _VirtualDom_node('table');
var $terezka$elm_charts$Internal$Item$tooltip = function (_v0) {
	var item = _v0.b;
	return item.i$(0);
};
var $terezka$elm_charts$Internal$Many$toGroup = F2(
	function (first, rest) {
		var all = A2($elm$core$List$cons, first, rest);
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			_Utils_Tuple2(first, rest),
			{
				R: A2($terezka$elm_charts$Internal$Coordinates$foldPosition, $terezka$elm_charts$Internal$Item$getLimits, all),
				e3: F2(
					function (plane, _v0) {
						return A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__group')
								]),
							A2(
								$elm$core$List$map,
								$terezka$elm_charts$Internal$Item$render(plane),
								all));
					}),
				iX: function (plane) {
					return A2(
						$terezka$elm_charts$Internal$Coordinates$foldPosition,
						$terezka$elm_charts$Internal$Item$getPosition(plane),
						all);
				},
				i$: function (c) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_Nil,
							A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Item$tooltip, all))
						]);
				}
			});
	});
var $terezka$elm_charts$Internal$Many$groupingHelp = F2(
	function (_v0, items) {
		var edits = _v0.cv;
		var equality = _v0.cw;
		var shared = _v0.cN;
		var toShared = function (_v2) {
			var meta = _v2.a;
			var item = _v2.b;
			return shared(meta);
		};
		var toNewGroup = function (_v1) {
			var i = _v1.a;
			var is = _v1.b;
			return edits(
				A2($terezka$elm_charts$Internal$Many$toGroup, i, is));
		};
		var toEquality = F2(
			function (aO, bO) {
				return A2(
					equality,
					toShared(aO),
					toShared(bO));
			});
		return A2(
			$elm$core$List$map,
			toNewGroup,
			A2($terezka$elm_charts$Internal$Helpers$gatherWith, toEquality, items));
	});
var $terezka$elm_charts$Internal$Many$bins = A2(
	$terezka$elm_charts$Internal$Many$Remodel,
	$terezka$elm_charts$Internal$Item$getPosition,
	$terezka$elm_charts$Internal$Many$groupingHelp(
		{
			cv: $terezka$elm_charts$Internal$Many$editLimits(
				F2(
					function (item, pos) {
						return _Utils_update(
							pos,
							{
								bR: $terezka$elm_charts$Internal$Item$getX1(item),
								cg: $terezka$elm_charts$Internal$Item$getX2(item)
							});
					})),
			cw: F2(
				function (a, b) {
					return _Utils_eq(a.bR, b.bR) && (_Utils_eq(a.cg, b.cg) && (_Utils_eq(a.c7, b.c7) && _Utils_eq(a.d8, b.d8)));
				}),
			cN: function (config) {
				return {d8: config.g1.d8, c7: config.g1.gD, bR: config.bR, cg: config.cg};
			}
		}));
var $terezka$elm_charts$Chart$Item$bins = $terezka$elm_charts$Internal$Many$bins;
var $terezka$elm_charts$Internal$Produce$defaultBars = {gT: false, gU: true, bi: 0.1, h4: 0, h5: 0, io: 0.05, bR: $elm$core$Maybe$Nothing, cg: $elm$core$Maybe$Nothing};
var $terezka$elm_charts$Internal$Item$generalize = function (_v0) {
	var meta = _v0.a;
	var item = _v0.b;
	return A2(
		$terezka$elm_charts$Internal$Item$Rendered,
		{
			gm: meta.gm,
			gt: meta.gt,
			g1: meta.g1,
			hi: meta.hi,
			I: meta.I,
			hW: meta.iU(meta.hW),
			iU: $elm$core$Basics$identity,
			i0: meta.i0,
			bR: meta.bR,
			cg: meta.cg,
			jf: meta.jf
		},
		item);
};
var $terezka$elm_charts$Internal$Many$getMembers = function (_v0) {
	var _v1 = _v0.a;
	var x = _v1.a;
	var xs = _v1.b;
	return A2($elm$core$List$cons, x, xs);
};
var $terezka$elm_charts$Internal$Many$generalize = function (many) {
	return A2(
		$elm$core$List$map,
		$terezka$elm_charts$Internal$Item$generalize,
		$terezka$elm_charts$Internal$Many$getMembers(many));
};
var $terezka$elm_charts$Chart$Item$getLimits = $terezka$elm_charts$Internal$Item$getLimits;
var $terezka$elm_charts$Internal$Item$map = F2(
	function (func, _v0) {
		var meta = _v0.a;
		var item = _v0.b;
		return A2(
			$terezka$elm_charts$Internal$Item$Rendered,
			{
				gm: meta.gm,
				gt: func(meta.gt),
				g1: meta.g1,
				hi: meta.hi,
				I: meta.I,
				hW: meta.hW,
				iU: meta.iU,
				i0: meta.i0,
				bR: meta.bR,
				cg: meta.cg,
				jf: meta.jf
			},
			item);
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $terezka$elm_charts$Internal$Legend$BarLegend = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Chart$Attributes$border = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{_: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$color = function (v) {
	return function (config) {
		return (v === '') ? config : _Utils_update(
			config,
			{gm: v});
	};
};
var $terezka$elm_charts$Internal$Helpers$pink = '#ea60df';
var $terezka$elm_charts$Internal$Svg$defaultBar = {p: _List_Nil, _: 'white', ah: 0, gm: $terezka$elm_charts$Internal$Helpers$pink, c5: $elm$core$Maybe$Nothing, gX: 0, gY: '', gZ: 10, aB: 1, h4: 0, h5: 0};
var $terezka$elm_charts$Chart$Attributes$roundBottom = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{h4: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$roundTop = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{h5: v});
	};
};
var $terezka$elm_charts$Internal$Property$toConfigs = function (property) {
	if (!property.$) {
		var config = property.a;
		return _List_fromArray(
			[config]);
	} else {
		var configs = property.a;
		return configs;
	}
};
var $terezka$elm_charts$Internal$Helpers$blue = '#12A5ED';
var $terezka$elm_charts$Internal$Helpers$brown = '#871c1c';
var $terezka$elm_charts$Internal$Helpers$green = '#71c614';
var $terezka$elm_charts$Internal$Helpers$moss = '#92b42c';
var $terezka$elm_charts$Internal$Helpers$orange = '#FF8400';
var $terezka$elm_charts$Internal$Helpers$purple = '#7b4dff';
var $terezka$elm_charts$Internal$Helpers$red = '#F5325B';
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $terezka$elm_charts$Internal$Helpers$toDefault = F3(
	function (_default, items, index) {
		var dict = $elm$core$Dict$fromList(
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, items));
		var numOfItems = $elm$core$Dict$size(dict);
		var itemIndex = index % numOfItems;
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2($elm$core$Dict$get, itemIndex, dict));
	});
var $terezka$elm_charts$Internal$Helpers$turquoise = '#22d2ba';
var $terezka$elm_charts$Internal$Helpers$yellow = '#FFCA00';
var $terezka$elm_charts$Internal$Helpers$toDefaultColor = A2(
	$terezka$elm_charts$Internal$Helpers$toDefault,
	$terezka$elm_charts$Internal$Helpers$pink,
	_List_fromArray(
		[$terezka$elm_charts$Internal$Helpers$purple, $terezka$elm_charts$Internal$Helpers$pink, $terezka$elm_charts$Internal$Helpers$blue, $terezka$elm_charts$Internal$Helpers$green, $terezka$elm_charts$Internal$Helpers$red, $terezka$elm_charts$Internal$Helpers$yellow, $terezka$elm_charts$Internal$Helpers$turquoise, $terezka$elm_charts$Internal$Helpers$orange, $terezka$elm_charts$Internal$Helpers$moss, $terezka$elm_charts$Internal$Helpers$brown]));
var $terezka$elm_charts$Internal$Legend$toBarLegends = F3(
	function (elIndex, barsAttrs, properties) {
		var toBarConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultBar);
		};
		var barsConfig = A2($terezka$elm_charts$Internal$Helpers$apply, barsAttrs, $terezka$elm_charts$Internal$Produce$defaultBars);
		var toBarLegend = F2(
			function (colorIndex, prop) {
				var rounding = A2($elm$core$Basics$max, barsConfig.h5, barsConfig.h4);
				var defaultName = 'Property #' + $elm$core$String$fromInt(colorIndex + 1);
				var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefaultColor(colorIndex);
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$roundTop(rounding),
						$terezka$elm_charts$Chart$Attributes$roundBottom(rounding),
						$terezka$elm_charts$Chart$Attributes$color(defaultColor),
						$terezka$elm_charts$Chart$Attributes$border(defaultColor)
					]);
				var attrsOrg = _Utils_ap(defaultAttrs, prop.hW);
				var productOrg = toBarConfig(attrsOrg);
				var attrs = _Utils_eq(productOrg._, defaultColor) ? _Utils_ap(
					attrsOrg,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$border(productOrg.gm)
						])) : attrsOrg;
				return A2(
					$terezka$elm_charts$Internal$Legend$BarLegend,
					A2($elm$core$Maybe$withDefault, defaultName, prop.fp),
					attrs);
			});
		return A2(
			$elm$core$List$indexedMap,
			function (propIndex) {
				return toBarLegend(elIndex + propIndex);
			},
			A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Property$toConfigs, properties));
	});
var $terezka$elm_charts$Internal$Item$Bar = function (a) {
	return {$: 1, a: a};
};
var $terezka$elm_charts$Internal$Commands$Arc = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $terezka$elm_charts$Internal$Commands$Line = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $terezka$elm_charts$Internal$Commands$joinCommands = function (commands) {
	return A2($elm$core$String$join, ' ', commands);
};
var $terezka$elm_charts$Internal$Commands$stringBoolInt = function (bool) {
	return bool ? '1' : '0';
};
var $terezka$elm_charts$Internal$Commands$stringPoint = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return $elm$core$String$fromFloat(x) + (' ' + $elm$core$String$fromFloat(y));
};
var $terezka$elm_charts$Internal$Commands$stringPoints = function (points) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $terezka$elm_charts$Internal$Commands$stringPoint, points));
};
var $terezka$elm_charts$Internal$Commands$stringCommand = function (command) {
	switch (command.$) {
		case 0:
			var x = command.a;
			var y = command.b;
			return 'M' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 1:
			var x = command.a;
			var y = command.b;
			return 'L' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 2:
			var cx1 = command.a;
			var cy1 = command.b;
			var cx2 = command.c;
			var cy2 = command.d;
			var x = command.e;
			var y = command.f;
			return 'C' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(cx2, cy2),
						_Utils_Tuple2(x, y)
					]));
		case 3:
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 4:
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 5:
			var x = command.a;
			var y = command.b;
			return 'T' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 6:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var x = command.f;
			var y = command.g;
			return 'A ' + $terezka$elm_charts$Internal$Commands$joinCommands(
				_List_fromArray(
					[
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(rx, ry)),
						$elm$core$String$fromInt(xAxisRotation),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(largeArcFlag),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(sweepFlag),
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(x, y))
					]));
		default:
			return 'Z';
	}
};
var $terezka$elm_charts$Internal$Commands$Close = {$: 7};
var $terezka$elm_charts$Internal$Commands$CubicBeziers = F6(
	function (a, b, c, d, e, f) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $terezka$elm_charts$Internal$Commands$CubicBeziersShort = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziers = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Coordinates$innerLength = function (axis) {
	return A2($elm$core$Basics$max, 1, (axis.H - axis.hs) - axis.hr);
};
var $terezka$elm_charts$Internal$Coordinates$innerWidth = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.fD);
};
var $terezka$elm_charts$Internal$Coordinates$range = function (axis) {
	var diff = axis.eE - axis.dq;
	return (diff > 0) ? diff : 1;
};
var $terezka$elm_charts$Internal$Coordinates$scaleSVGX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerWidth(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.fD);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, value - plane.fD.dq) + plane.fD.hs;
	});
var $terezka$elm_charts$Internal$Coordinates$innerHeight = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.jf);
};
var $terezka$elm_charts$Internal$Coordinates$scaleSVGY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerHeight(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.jf);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGY = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGY, plane, plane.jf.eE - value) + plane.jf.hs;
	});
var $terezka$elm_charts$Internal$Commands$translate = F2(
	function (plane, command) {
		switch (command.$) {
			case 0:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Move,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 1:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Line,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 2:
				var cx1 = command.a;
				var cy1 = command.b;
				var cx2 = command.c;
				var cy2 = command.d;
				var x = command.e;
				var y = command.f;
				return A6(
					$terezka$elm_charts$Internal$Commands$CubicBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 3:
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$CubicBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 4:
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 5:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 6:
				var rx = command.a;
				var ry = command.b;
				var xAxisRotation = command.c;
				var largeArcFlag = command.d;
				var sweepFlag = command.e;
				var x = command.f;
				var y = command.g;
				return A7(
					$terezka$elm_charts$Internal$Commands$Arc,
					rx,
					ry,
					xAxisRotation,
					largeArcFlag,
					sweepFlag,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			default:
				return $terezka$elm_charts$Internal$Commands$Close;
		}
	});
var $terezka$elm_charts$Internal$Commands$description = F2(
	function (plane, commands) {
		return $terezka$elm_charts$Internal$Commands$joinCommands(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$terezka$elm_charts$Internal$Commands$translate(plane),
					$terezka$elm_charts$Internal$Commands$stringCommand),
				commands));
	});
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.fD)) / $terezka$elm_charts$Internal$Coordinates$innerWidth(plane);
	});
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.jf)) / $terezka$elm_charts$Internal$Coordinates$innerHeight(plane);
	});
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$pattern = $elm$svg$Svg$trustedNode('pattern');
var $elm$svg$Svg$Attributes$patternTransform = _VirtualDom_attribute('patternTransform');
var $elm$svg$Svg$Attributes$patternUnits = _VirtualDom_attribute('patternUnits');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $terezka$elm_charts$Internal$Svg$toPattern = F2(
	function (defaultColor, design) {
		var toPatternId = function (props) {
			return A3(
				$elm$core$String$replace,
				'(',
				'-',
				A3(
					$elm$core$String$replace,
					')',
					'-',
					A3(
						$elm$core$String$replace,
						'.',
						'-',
						A3(
							$elm$core$String$replace,
							',',
							'-',
							A3(
								$elm$core$String$replace,
								' ',
								'-',
								A2(
									$elm$core$String$join,
									'-',
									_Utils_ap(
										_List_fromArray(
											[
												'elm-charts__pattern',
												function () {
												switch (design.$) {
													case 0:
														return 'striped';
													case 1:
														return 'dotted';
													default:
														return 'gradient';
												}
											}()
											]),
										props)))))));
		};
		var toPatternDefs = F4(
			function (id, spacing, rotate, inside) {
				return A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$pattern,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(id),
									$elm$svg$Svg$Attributes$patternUnits('userSpaceOnUse'),
									$elm$svg$Svg$Attributes$width(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$height(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$patternTransform(
									'rotate(' + ($elm$core$String$fromFloat(rotate) + ')'))
								]),
							_List_fromArray(
								[inside]))
						]));
			});
		var _v0 = function () {
			switch (design.$) {
				case 0:
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Helpers$apply,
						edits,
						{gm: defaultColor, F: 45, io: 4, fA: 3});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.gm,
								$elm$core$String$fromFloat(config.fA),
								$elm$core$String$fromFloat(config.io),
								$elm$core$String$fromFloat(config.F)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.io,
							config.F,
							A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x1('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$x2('0'),
										$elm$svg$Svg$Attributes$y2(
										$elm$core$String$fromFloat(config.io)),
										$elm$svg$Svg$Attributes$stroke(config.gm),
										$elm$svg$Svg$Attributes$strokeWidth(
										$elm$core$String$fromFloat(config.fA))
									]),
								_List_Nil)),
						theId);
				case 1:
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Helpers$apply,
						edits,
						{gm: defaultColor, F: 45, io: 4, fA: 3});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.gm,
								$elm$core$String$fromFloat(config.fA),
								$elm$core$String$fromFloat(config.io),
								$elm$core$String$fromFloat(config.F)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.io,
							config.F,
							A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill(config.gm),
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(config.fA / 3)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(config.fA / 3)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(config.fA / 3))
									]),
								_List_Nil)),
						theId);
				default:
					var edits = design.a;
					var colors = _Utils_eq(edits, _List_Nil) ? _List_fromArray(
						[defaultColor, 'white']) : edits;
					var theId = toPatternId(colors);
					var totalColors = $elm$core$List$length(colors);
					var toPercentage = function (i) {
						return (i * 100) / (totalColors - 1);
					};
					var toStop = F2(
						function (i, c) {
							return A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$offset(
										$elm$core$String$fromFloat(
											toPercentage(i)) + '%'),
										$elm$svg$Svg$Attributes$stopColor(c)
									]),
								_List_Nil);
						});
					return _Utils_Tuple2(
						A2(
							$elm$svg$Svg$defs,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$linearGradient,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id(theId),
											$elm$svg$Svg$Attributes$x1('0'),
											$elm$svg$Svg$Attributes$x2('0'),
											$elm$svg$Svg$Attributes$y1('0'),
											$elm$svg$Svg$Attributes$y2('1')
										]),
									A2($elm$core$List$indexedMap, toStop, colors))
								])),
						theId);
			}
		}();
		var patternDefs = _v0.a;
		var patternId = _v0.b;
		return _Utils_Tuple2(patternDefs, 'url(#' + (patternId + ')'));
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $terezka$elm_charts$Internal$Svg$withAttrs = F3(
	function (attrs, toEl, defaultAttrs) {
		return toEl(
			_Utils_ap(
				defaultAttrs,
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					attrs)));
	});
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $terezka$elm_charts$Internal$Coordinates$toId = function (plane) {
	var numToStr = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromFloat,
		A2($elm$core$String$replace, '.', '-'));
	return A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			[
				'elm-charts__id',
				numToStr(plane.fD.H),
				numToStr(plane.fD.dq),
				numToStr(plane.fD.eE),
				numToStr(plane.fD.hs),
				numToStr(plane.fD.hr),
				numToStr(plane.jf.H),
				numToStr(plane.jf.dq),
				numToStr(plane.jf.eE),
				numToStr(plane.jf.hs),
				numToStr(plane.jf.hr)
			]));
};
var $terezka$elm_charts$Internal$Svg$withinChartArea = function (plane) {
	return $elm$svg$Svg$Attributes$clipPath(
		'url(#' + ($terezka$elm_charts$Internal$Coordinates$toId(plane) + ')'));
};
var $terezka$elm_charts$Internal$Svg$bar = F3(
	function (plane, config, point) {
		var viewBar = F6(
			function (fill, fillOpacity, border, borderWidth, strokeOpacity, cmds) {
				return A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.p,
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__bar'),
							$elm$svg$Svg$Attributes$fill(fill),
							$elm$svg$Svg$Attributes$fillOpacity(
							$elm$core$String$fromFloat(fillOpacity)),
							$elm$svg$Svg$Attributes$stroke(border),
							$elm$svg$Svg$Attributes$strokeWidth(
							$elm$core$String$fromFloat(borderWidth)),
							$elm$svg$Svg$Attributes$strokeOpacity(
							$elm$core$String$fromFloat(strokeOpacity)),
							$elm$svg$Svg$Attributes$d(
							A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_Nil);
			});
		var highlightColor = (config.gY === '') ? config.gm : config.gY;
		var borderWidthCarY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, config.ah / 2);
		var highlightWidthCarY = borderWidthCarY + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, config.gZ / 2);
		var borderWidthCarX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, config.ah / 2);
		var highlightWidthCarX = borderWidthCarX + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, config.gZ / 2);
		var pos = {
			bR: A2($elm$core$Basics$min, point.bR, point.cg) + borderWidthCarX,
			cg: A2($elm$core$Basics$max, point.bR, point.cg) - borderWidthCarX,
			jg: A2($elm$core$Basics$min, point.jg, point.dT) + borderWidthCarY,
			dT: A2($elm$core$Basics$max, point.jg, point.dT) - borderWidthCarY
		};
		var height = $elm$core$Basics$abs(pos.dT - pos.jg);
		var highlightPos = {bR: pos.bR - highlightWidthCarX, cg: pos.cg + highlightWidthCarX, jg: pos.jg - highlightWidthCarY, dT: pos.dT + highlightWidthCarY};
		var width = $elm$core$Basics$abs(pos.cg - pos.bR);
		var roundingBottom = (A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, width) * 0.5) * A3($elm$core$Basics$clamp, 0, 1, config.h4);
		var radiusBottomX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, roundingBottom);
		var radiusBottomY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, roundingBottom);
		var roundingTop = (A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, width) * 0.5) * A3($elm$core$Basics$clamp, 0, 1, config.h5);
		var radiusTopX = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, roundingTop);
		var radiusTopY = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, roundingTop);
		var _v0 = ((((height - (radiusTopY * 0.8)) - (radiusBottomY * 0.8)) <= 0) || (((width - (radiusTopX * 0.8)) - (radiusBottomX * 0.8)) <= 0)) ? _Utils_Tuple2(0, 0) : _Utils_Tuple2(config.h5, config.h4);
		var roundTop = _v0.a;
		var roundBottom = _v0.b;
		var _v1 = function () {
			if (_Utils_eq(pos.jg, pos.dT)) {
				return _Utils_Tuple2(_List_Nil, _List_Nil);
			} else {
				var _v2 = _Utils_Tuple2(roundTop > 0, roundBottom > 0);
				if (!_v2.a) {
					if (!_v2.b) {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.bR, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.jg)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.bR, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.bR, highlightPos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg, highlightPos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.jg)
								]));
					} else {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.bR + radiusBottomX, pos.jg),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.bR, pos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.cg - radiusBottomX, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR + radiusBottomX, pos.jg)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.bR + radiusBottomX, highlightPos.jg),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.bR, highlightPos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.bR, highlightPos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg, highlightPos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg, highlightPos.jg + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.cg - radiusBottomX, highlightPos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.bR + radiusBottomX, highlightPos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg - radiusBottomX, pos.jg),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, false, pos.cg, pos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg)
								]));
					}
				} else {
					if (!_v2.b) {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.bR, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.dT - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.bR + radiusTopX, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg - radiusTopX, pos.dT),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.cg, pos.dT - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.jg)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.bR, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.bR, highlightPos.dT - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.bR + radiusTopX, highlightPos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg - radiusTopX, highlightPos.dT),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.cg, highlightPos.dT - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.dT - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.cg - radiusTopX, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR + radiusTopX, pos.dT),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.bR, pos.dT - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.jg)
								]));
					} else {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, pos.bR + radiusBottomX, pos.jg),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.bR, pos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.dT - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.bR + radiusTopX, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg - radiusTopX, pos.dT),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, pos.cg, pos.dT - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, pos.cg - radiusBottomX, pos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR + radiusBottomX, pos.jg)
								]),
							_List_fromArray(
								[
									A2($terezka$elm_charts$Internal$Commands$Move, highlightPos.bR + radiusBottomX, highlightPos.jg),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.bR, highlightPos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.bR, highlightPos.dT - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.bR + radiusTopX, highlightPos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg - radiusTopX, highlightPos.dT),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, true, highlightPos.cg, highlightPos.dT - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.cg, highlightPos.jg + radiusBottomY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, true, highlightPos.cg - radiusBottomX, highlightPos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, highlightPos.bR + radiusBottomX, highlightPos.jg),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg - radiusBottomX, pos.jg),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingBottom, roundingBottom, -45, false, false, pos.cg, pos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.dT - radiusTopY),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.cg - radiusTopX, pos.dT),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR + radiusTopX, pos.dT),
									A7($terezka$elm_charts$Internal$Commands$Arc, roundingTop, roundingTop, -45, false, false, pos.bR, pos.dT - radiusTopY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.bR, pos.jg + radiusBottomY),
									A2($terezka$elm_charts$Internal$Commands$Line, pos.cg, pos.jg)
								]));
					}
				}
			}
		}();
		var commands = _v1.a;
		var highlightCommands = _v1.b;
		var viewAuraBar = function (fill) {
			return (!config.gX) ? A6(viewBar, fill, config.aB, config._, config.ah, 1, commands) : A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__bar-with-highlight')
					]),
				_List_fromArray(
					[
						A6(viewBar, highlightColor, config.gX, 'transparent', 0, 0, highlightCommands),
						A6(viewBar, fill, config.aB, config._, config.ah, 1, commands)
					]));
		};
		var _v3 = config.c5;
		if (_v3.$ === 1) {
			return viewAuraBar(config.gm);
		} else {
			var design = _v3.a;
			var _v4 = A2($terezka$elm_charts$Internal$Svg$toPattern, config.gm, design);
			var patternDefs = _v4.a;
			var fill = _v4.b;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__bar-with-pattern')
					]),
				_List_fromArray(
					[
						patternDefs,
						viewAuraBar(fill)
					]));
		}
	});
var $terezka$elm_charts$Internal$Produce$toBin = F5(
	function (barsConfig, index, prevM, curr, nextM) {
		var _v0 = _Utils_Tuple2(barsConfig.bR, barsConfig.cg);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return {gt: curr, ec: (index + 1) + 0.5, it: (index + 1) - 0.5};
			} else {
				var _v8 = _v0.a;
				var toX2 = _v0.b.a;
				var _v9 = _Utils_Tuple2(prevM, nextM);
				if (!_v9.a.$) {
					var prev = _v9.a.a;
					return {
						gt: curr,
						ec: toX2(curr),
						it: toX2(prev)
					};
				} else {
					if (!_v9.b.$) {
						var _v10 = _v9.a;
						var next = _v9.b.a;
						return {
							gt: curr,
							ec: toX2(curr),
							it: toX2(curr) - (toX2(next) - toX2(curr))
						};
					} else {
						var _v11 = _v9.a;
						var _v12 = _v9.b;
						return {
							gt: curr,
							ec: toX2(curr),
							it: toX2(curr) - 1
						};
					}
				}
			}
		} else {
			if (_v0.b.$ === 1) {
				var toX1 = _v0.a.a;
				var _v3 = _v0.b;
				var _v4 = _Utils_Tuple2(prevM, nextM);
				if (!_v4.b.$) {
					var next = _v4.b.a;
					return {
						gt: curr,
						ec: toX1(next),
						it: toX1(curr)
					};
				} else {
					if (!_v4.a.$) {
						var prev = _v4.a.a;
						var _v5 = _v4.b;
						return {
							gt: curr,
							ec: toX1(curr) + (toX1(curr) - toX1(prev)),
							it: toX1(curr)
						};
					} else {
						var _v6 = _v4.a;
						var _v7 = _v4.b;
						return {
							gt: curr,
							ec: toX1(curr) + 1,
							it: toX1(curr)
						};
					}
				}
			} else {
				var toX1 = _v0.a.a;
				var toX2 = _v0.b.a;
				return {
					gt: curr,
					ec: toX2(curr),
					it: toX1(curr)
				};
			}
		}
	});
var $terezka$elm_charts$Internal$Produce$toDefaultName = F2(
	function (ids, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Property #' + $elm$core$String$fromInt(ids.fG + 1),
			name);
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $terezka$elm_charts$Internal$Produce$tooltipRow = F3(
	function (color, title, text) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', color),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'padding-right', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title + ':')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
							A2($elm$html$Html$Attributes$style, 'padding', '0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]))
				]));
	});
var $terezka$elm_charts$Internal$Produce$updateBorder = F2(
	function (defaultColor, product) {
		return _Utils_eq(product._, defaultColor) ? _Utils_update(
			product,
			{_: product.gm}) : product;
	});
var $terezka$elm_charts$Internal$Produce$updateColorIfGradientIsSet = F2(
	function (defaultColor, product) {
		var _v0 = product.c5;
		if (((!_v0.$) && (_v0.a.$ === 2)) && _v0.a.a.b) {
			var _v1 = _v0.a.a;
			var first = _v1.a;
			return _Utils_eq(product.gm, defaultColor) ? _Utils_update(
				product,
				{gm: first}) : product;
		} else {
			return product;
		}
	});
var $terezka$elm_charts$Internal$Helpers$withFirst = F2(
	function (xs, func) {
		if (xs.b) {
			var x = xs.a;
			var rest = xs.b;
			return $elm$core$Maybe$Just(
				A2(func, x, rest));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $terezka$elm_charts$Internal$Helpers$withSurround = F2(
	function (all, func) {
		var fold = F4(
			function (index, prev, acc, list) {
				fold:
				while (true) {
					if (list.b) {
						if (list.b.b) {
							var a = list.a;
							var _v1 = list.b;
							var b = _v1.a;
							var rest = _v1.b;
							var $temp$index = index + 1,
								$temp$prev = $elm$core$Maybe$Just(a),
								$temp$acc = _Utils_ap(
								acc,
								_List_fromArray(
									[
										A4(
										func,
										index,
										prev,
										a,
										$elm$core$Maybe$Just(b))
									])),
								$temp$list = A2($elm$core$List$cons, b, rest);
							index = $temp$index;
							prev = $temp$prev;
							acc = $temp$acc;
							list = $temp$list;
							continue fold;
						} else {
							var a = list.a;
							return _Utils_ap(
								acc,
								_List_fromArray(
									[
										A4(func, index, prev, a, $elm$core$Maybe$Nothing)
									]));
						}
					} else {
						return acc;
					}
				}
			});
		return A4(fold, 0, $elm$core$Maybe$Nothing, _List_Nil, all);
	});
var $terezka$elm_charts$Internal$Produce$toBarSeries = F4(
	function (elementIndex, barsAttrs, properties, data) {
		var barsConfig = A2($terezka$elm_charts$Internal$Helpers$apply, barsAttrs, $terezka$elm_charts$Internal$Produce$defaultBars);
		var numOfStacks = barsConfig.gU ? $elm$core$List$length(properties) : 1;
		var forEachDataPoint = F7(
			function (absoluteIndex, stackSeriesConfigIndex, barSeriesConfigIndex, numOfBarsInStack, barSeriesConfig, dataIndex, bin) {
				var ySum = barSeriesConfig.cb(bin.gt);
				var y = barSeriesConfig.cS(bin.gt);
				var start = bin.it;
				var minY = (numOfBarsInStack > 1) ? $elm$core$Basics$max(0) : $elm$core$Basics$identity;
				var y1 = minY(
					A2($elm$core$Maybe$withDefault, 0, ySum) - A2($elm$core$Maybe$withDefault, 0, y));
				var y2 = minY(
					A2($elm$core$Maybe$withDefault, 0, ySum));
				var isSingle = numOfBarsInStack === 1;
				var identification = {fG: absoluteIndex, d8: dataIndex, gD: elementIndex, ig: barSeriesConfigIndex, ir: stackSeriesConfigIndex};
				var isBottom = _Utils_eq(identification.ig, numOfBarsInStack - 1);
				var roundBottom = (isSingle || isBottom) ? barsConfig.h4 : 0;
				var isTop = !identification.ig;
				var roundTop = (isSingle || isTop) ? barsConfig.h5 : 0;
				var end = bin.ec;
				var length = end - start;
				var margin = length * barsConfig.bi;
				var spacing = length * barsConfig.io;
				var width = ((length - (margin * 2)) - ((numOfStacks - 1) * spacing)) / numOfStacks;
				var offset = barsConfig.gU ? ((identification.ir * width) + (identification.ir * spacing)) : 0;
				var x1 = (start + margin) + offset;
				var x2 = ((start + margin) + offset) + width;
				var defaultColor = $terezka$elm_charts$Internal$Helpers$toDefaultColor(identification.fG);
				var basicAttributes = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$roundTop(roundTop),
						$terezka$elm_charts$Chart$Attributes$roundBottom(roundBottom),
						$terezka$elm_charts$Chart$Attributes$color(defaultColor),
						$terezka$elm_charts$Chart$Attributes$border(defaultColor)
					]);
				var barPresentationConfig = A2(
					$terezka$elm_charts$Internal$Produce$updateBorder,
					defaultColor,
					A2(
						$terezka$elm_charts$Internal$Produce$updateColorIfGradientIsSet,
						defaultColor,
						A2(
							$terezka$elm_charts$Internal$Helpers$apply,
							_Utils_ap(
								basicAttributes,
								_Utils_ap(
									barSeriesConfig.hW,
									A2(barSeriesConfig.fu, identification, bin.gt))),
							$terezka$elm_charts$Internal$Svg$defaultBar)));
				return A2(
					$terezka$elm_charts$Internal$Item$Rendered,
					{
						gm: barPresentationConfig.gm,
						gt: bin.gt,
						g1: identification,
						hi: !_Utils_eq(y, $elm$core$Maybe$Nothing),
						I: barSeriesConfig.fp,
						hW: barPresentationConfig,
						iU: $terezka$elm_charts$Internal$Item$Bar,
						i0: barSeriesConfig.i0(bin.gt),
						bR: start,
						cg: end,
						jf: A2($elm$core$Maybe$withDefault, 0, y)
					},
					{
						R: {
							bR: x1,
							cg: x2,
							jg: A2($elm$core$Basics$min, y1, y2),
							dT: A2($elm$core$Basics$max, y1, y2)
						},
						e3: F2(
							function (plane, position) {
								return A3($terezka$elm_charts$Internal$Svg$bar, plane, barPresentationConfig, position);
							}),
						iX: function (_v5) {
							return {bR: x1, cg: x2, jg: y1, dT: y2};
						},
						i$: function (_v6) {
							return _List_fromArray(
								[
									A3(
									$terezka$elm_charts$Internal$Produce$tooltipRow,
									barPresentationConfig.gm,
									A2($terezka$elm_charts$Internal$Produce$toDefaultName, identification, barSeriesConfig.fp),
									barSeriesConfig.i0(bin.gt))
								]);
						}
					});
			});
		var forEachBarSeriesConfig = F6(
			function (bins, absoluteIndex, stackSeriesConfigIndex, numOfBarsInStack, barSeriesConfigIndex, barSeriesConfig) {
				var absoluteIndexNew = absoluteIndex + barSeriesConfigIndex;
				var items = A2(
					$elm$core$List$indexedMap,
					A5(forEachDataPoint, absoluteIndexNew, stackSeriesConfigIndex, barSeriesConfigIndex, numOfBarsInStack, barSeriesConfig),
					bins);
				return A2(
					$terezka$elm_charts$Internal$Helpers$withFirst,
					items,
					F2(
						function (first, rest) {
							return A2(
								$terezka$elm_charts$Internal$Item$Rendered,
								_Utils_Tuple2(first, rest),
								{
									R: A2($terezka$elm_charts$Internal$Coordinates$foldPosition, $terezka$elm_charts$Internal$Item$getLimits, items),
									e3: F2(
										function (plane, _v3) {
											return A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('elm-charts__series')
													]),
												A2(
													$elm$core$List$map,
													$terezka$elm_charts$Internal$Item$render(plane),
													items));
										}),
									iX: function (plane) {
										return A2(
											$terezka$elm_charts$Internal$Coordinates$foldPosition,
											$terezka$elm_charts$Internal$Item$getPosition(plane),
											items);
									},
									i$: function (_v4) {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$table,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'margin', '0')
													]),
												A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Item$tooltip, items))
											]);
									}
								});
						}));
			});
		var forEachStackSeriesConfig = F3(
			function (bins, stackSeriesConfig, _v2) {
				var absoluteIndex = _v2.a;
				var stackSeriesConfigIndex = _v2.b;
				var items = _v2.c;
				var seriesItems = function () {
					if (!stackSeriesConfig.$) {
						var barSeriesConfig = stackSeriesConfig.a;
						return _List_fromArray(
							[
								A6(forEachBarSeriesConfig, bins, absoluteIndex, stackSeriesConfigIndex, 1, 0, barSeriesConfig)
							]);
					} else {
						var barSeriesConfigs = stackSeriesConfig.a;
						var numOfBarsInStack = $elm$core$List$length(barSeriesConfigs);
						return A2(
							$elm$core$List$indexedMap,
							A4(forEachBarSeriesConfig, bins, absoluteIndex, stackSeriesConfigIndex, numOfBarsInStack),
							barSeriesConfigs);
					}
				}();
				return _Utils_Tuple3(
					absoluteIndex + $elm$core$List$length(seriesItems),
					stackSeriesConfigIndex + 1,
					_Utils_ap(
						items,
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, seriesItems)));
			});
		return function (bins) {
			return function (_v0) {
				var items = _v0.c;
				return items;
			}(
				A3(
					$elm$core$List$foldl,
					forEachStackSeriesConfig(bins),
					_Utils_Tuple3(elementIndex, 0, _List_Nil),
					properties));
		}(
			A2(
				$terezka$elm_charts$Internal$Helpers$withSurround,
				data,
				$terezka$elm_charts$Internal$Produce$toBin(barsConfig)));
	});
var $terezka$elm_charts$Chart$barsMap = F4(
	function (mapData, edits, properties, data) {
		return $terezka$elm_charts$Chart$Indexed(
			function (index) {
				var legends_ = A3($terezka$elm_charts$Internal$Legend$toBarLegends, index, edits, properties);
				var items = A4($terezka$elm_charts$Internal$Produce$toBarSeries, index, edits, properties, data);
				var generalized = A2(
					$elm$core$List$map,
					$terezka$elm_charts$Internal$Item$map(mapData),
					A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Many$generalize, items));
				var bins = A2($terezka$elm_charts$Chart$Item$apply, $terezka$elm_charts$Chart$Item$bins, generalized);
				var toLimits = A2($elm$core$List$map, $terezka$elm_charts$Internal$Item$getLimits, bins);
				var barsConfig = A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Produce$defaultBars);
				var toTicks = F2(
					function (plane, acc) {
						return _Utils_update(
							acc,
							{
								ag: _Utils_ap(
									acc.ag,
									barsConfig.gT ? A2(
										$elm$core$List$concatMap,
										A2(
											$elm$core$Basics$composeR,
											$terezka$elm_charts$Chart$Item$getLimits,
											function (pos) {
												return _List_fromArray(
													[pos.bR, pos.cg]);
											}),
										bins) : _List_Nil)
							});
					});
				return _Utils_Tuple2(
					A5(
						$terezka$elm_charts$Chart$BarsElement,
						toLimits,
						generalized,
						legends_,
						toTicks,
						function (plane) {
							return A2(
								$elm$svg$Svg$map,
								$elm$core$Basics$never,
								A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('elm-charts__bar-series')
										]),
									A2(
										$elm$core$List$map,
										$terezka$elm_charts$Internal$Item$render(plane),
										items)));
						}),
					index + $elm$core$List$length(items));
			});
	});
var $terezka$elm_charts$Chart$bars = F3(
	function (edits, properties, data) {
		return A4($terezka$elm_charts$Chart$barsMap, $elm$core$Basics$identity, edits, properties, data);
	});
var $terezka$elm_charts$Internal$Svg$Event = F2(
	function (name, handler) {
		return {en: handler, I: name};
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $K_Adam$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $K_Adam$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $K_Adam$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$K_Adam$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($K_Adam$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$K_Adam$elm_dom$DOM$scrollLeft,
				$K_Adam$elm_dom$DOM$scrollTop,
				$K_Adam$elm_dom$DOM$offsetLeft,
				$K_Adam$elm_dom$DOM$offsetTop));
	});
var $K_Adam$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {ep: height, a$: x, aS: y, fA: width};
		}),
	A2($K_Adam$elm_dom$DOM$position, 0, 0),
	$K_Adam$elm_dom$DOM$offsetWidth,
	$K_Adam$elm_dom$DOM$offsetHeight);
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $K_Adam$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
function $terezka$elm_charts$Internal$Svg$cyclic$decodePosition() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$K_Adam$elm_dom$DOM$boundingClientRect,
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $K_Adam$elm_dom$DOM$parentElement(
						$terezka$elm_charts$Internal$Svg$cyclic$decodePosition());
				})
			]));
}
var $terezka$elm_charts$Internal$Svg$decodePosition = $terezka$elm_charts$Internal$Svg$cyclic$decodePosition();
$terezka$elm_charts$Internal$Svg$cyclic$decodePosition = function () {
	return $terezka$elm_charts$Internal$Svg$decodePosition;
};
var $terezka$elm_charts$Internal$Coordinates$toCartesianX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, value - plane.fD.hs) + plane.fD.dq;
	});
var $terezka$elm_charts$Internal$Coordinates$toCartesianY = F2(
	function (plane, value) {
		return ($terezka$elm_charts$Internal$Coordinates$range(plane.jf) - A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, value - plane.jf.hs)) + plane.jf.dq;
	});
var $terezka$elm_charts$Internal$Svg$fromSvg = F2(
	function (plane, point) {
		return {
			fD: A2($terezka$elm_charts$Internal$Coordinates$toCartesianX, plane, point.fD),
			jf: A2($terezka$elm_charts$Internal$Coordinates$toCartesianY, plane, point.jf)
		};
	});
var $K_Adam$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $terezka$elm_charts$Internal$Svg$decoder = F2(
	function (plane, toMsg) {
		var handle = F3(
			function (mouseX, mouseY, box) {
				var yPrev = plane.jf;
				var xPrev = plane.fD;
				var widthPercent = box.fA / plane.fD.H;
				var heightPercent = box.ep / plane.jf.H;
				var newPlane = _Utils_update(
					plane,
					{
						fD: _Utils_update(
							xPrev,
							{H: box.fA, hr: plane.fD.hr * widthPercent, hs: plane.fD.hs * widthPercent}),
						jf: _Utils_update(
							yPrev,
							{H: box.ep, hr: plane.jf.hr * heightPercent, hs: plane.jf.hs * heightPercent})
					});
				var searched = A2(
					$terezka$elm_charts$Internal$Svg$fromSvg,
					newPlane,
					{fD: mouseX - box.a$, jf: mouseY - box.aS});
				return A2(toMsg, newPlane, searched);
			});
		return A4(
			$elm$json$Json$Decode$map3,
			handle,
			A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float),
			$K_Adam$elm_dom$DOM$target($terezka$elm_charts$Internal$Svg$decodePosition));
	});
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $terezka$elm_charts$Internal$Svg$container = F5(
	function (plane, config, below, chartEls, above) {
		var toEvent = function (event) {
			return A2(
				$elm$svg$Svg$Events$on,
				event.I,
				A2($terezka$elm_charts$Internal$Svg$decoder, plane, event.en));
		};
		var svgAttrsSize = config.cH ? _List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox(
				'0 0 ' + ($elm$core$String$fromFloat(plane.fD.H) + (' ' + $elm$core$String$fromFloat(plane.jf.H)))),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]) : _List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(plane.fD.H)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(plane.jf.H)),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]);
		var htmlAttrsSize = config.cH ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(plane.fD.H) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromFloat(plane.jf.H) + 'px')
			]);
		var htmlAttrsDef = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('elm-charts__container-inner')
			]);
		var htmlAttrs = _Utils_ap(
			config.cB,
			_Utils_ap(htmlAttrsDef, htmlAttrsSize));
		var chartPosition = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(plane.fD.hs)),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(plane.jf.hs)),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerWidth(plane))),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerHeight(plane))),
				$elm$svg$Svg$Attributes$fill('transparent')
			]);
		var clipPathDefs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(
							$terezka$elm_charts$Internal$Coordinates$toId(plane))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$rect, chartPosition, _List_Nil)
						]))
				]));
		var catcher = A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				chartPosition,
				A2($elm$core$List$map, toEvent, config.gH)),
			_List_Nil);
		var chart = A2(
			$elm$svg$Svg$svg,
			_Utils_ap(svgAttrsSize, config.p),
			_Utils_ap(
				_List_fromArray(
					[clipPathDefs]),
				_Utils_ap(
					chartEls,
					_List_fromArray(
						[catcher]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-charts__container'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					htmlAttrs,
					_Utils_ap(
						below,
						_Utils_ap(
							_List_fromArray(
								[chart]),
							above)))
				]));
	});
var $terezka$elm_charts$Chart$Attributes$lowest = F2(
	function (v, edit) {
		return function (b) {
			return _Utils_update(
				b,
				{
					dq: A3(edit, v, b.dq, b.gs)
				});
		};
	});
var $terezka$elm_charts$Chart$Attributes$orLower = F3(
	function (least, real, _v0) {
		return (_Utils_cmp(real, least) > 0) ? least : real;
	});
var $terezka$elm_charts$Chart$definePlane = F2(
	function (config, elements) {
		var width = A2($elm$core$Basics$max, 1, (config.fA - config.aD.a$) - config.aD.a4);
		var toLimit = F5(
			function (length, marginMin, marginMax, min, max) {
				return {gr: max, gs: min, H: length, hr: marginMax, hs: marginMin, eE: max, dq: min};
			});
		var height = A2($elm$core$Basics$max, 1, (config.ep - config.aD.X) - config.aD.aS);
		var fixSingles = function (bs) {
			return _Utils_eq(bs.dq, bs.eE) ? _Utils_update(
				bs,
				{eE: bs.dq + 10}) : bs;
		};
		var collectLimits = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 2:
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 3:
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[
									$terezka$elm_charts$Internal$Item$getLimits(item)
								]));
					case 4:
						return acc;
					case 5:
						return acc;
					case 6:
						return acc;
					case 7:
						return acc;
					case 8:
						return acc;
					case 9:
						return acc;
					case 10:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, collectLimits, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		var limits_ = function (pos) {
			return function (_v3) {
				var y = _v3.jf;
				var x = _v3.fD;
				return {
					fD: fixSingles(x),
					jf: fixSingles(y)
				};
			}(
				{
					fD: A5(toLimit, width, config.bi.a$, config.bi.a4, pos.bR, pos.cg),
					jf: A5(toLimit, height, config.bi.aS, config.bi.X, pos.jg, pos.dT)
				});
		}(
			A2(
				$terezka$elm_charts$Internal$Coordinates$foldPosition,
				$elm$core$Basics$identity,
				A3($elm$core$List$foldl, collectLimits, _List_Nil, elements)));
		var calcRange = function () {
			var _v2 = config.dy;
			if (!_v2.b) {
				return limits_.fD;
			} else {
				var some = _v2;
				return A2($terezka$elm_charts$Internal$Helpers$apply, some, limits_.fD);
			}
		}();
		var calcDomain = function () {
			var _v1 = config.c6;
			if (!_v1.b) {
				return A2(
					$terezka$elm_charts$Internal$Helpers$apply,
					_List_fromArray(
						[
							A2($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$orLower)
						]),
					limits_.jf);
			} else {
				var some = _v1;
				return A2($terezka$elm_charts$Internal$Helpers$apply, some, limits_.jf);
			}
		}();
		var unpadded = {fD: calcRange, jf: calcDomain};
		var scalePadX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX(unpadded);
		var xMax = calcRange.eE + scalePadX(config.aD.a4);
		var xMin = calcRange.dq - scalePadX(config.aD.a$);
		var scalePadY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY(unpadded);
		var yMax = calcDomain.eE + scalePadY(config.aD.aS);
		var yMin = calcDomain.dq - scalePadY(config.aD.X);
		return {
			fD: _Utils_update(
				calcRange,
				{
					H: config.fA,
					eE: A2($elm$core$Basics$max, xMin, xMax),
					dq: A2($elm$core$Basics$min, xMin, xMax)
				}),
			jf: _Utils_update(
				calcDomain,
				{
					H: config.ep,
					eE: A2($elm$core$Basics$max, yMin, yMax),
					dq: A2($elm$core$Basics$min, yMin, yMax)
				})
		};
	});
var $terezka$elm_charts$Chart$getItems = F2(
	function (plane, elements) {
		var toItems = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						var items = el.b;
						return _Utils_ap(acc, items);
					case 2:
						var items = el.b;
						return _Utils_ap(acc, items);
					case 3:
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[item]));
					case 4:
						var func = el.a;
						return acc;
					case 5:
						return acc;
					case 6:
						return acc;
					case 7:
						return acc;
					case 8:
						return acc;
					case 9:
						return acc;
					case 10:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, toItems, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		return A3($elm$core$List$foldl, toItems, _List_Nil, elements);
	});
var $terezka$elm_charts$Chart$getLegends = function (elements) {
	var toLegends = F2(
		function (el, acc) {
			switch (el.$) {
				case 0:
					return acc;
				case 1:
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 2:
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 3:
					return acc;
				case 4:
					return acc;
				case 5:
					return acc;
				case 6:
					return acc;
				case 7:
					return acc;
				case 8:
					return acc;
				case 9:
					return acc;
				case 10:
					return acc;
				case 11:
					var subs = el.a;
					return A3($elm$core$List$foldl, toLegends, acc, subs);
				case 12:
					return acc;
				default:
					return acc;
			}
		});
	return A3($elm$core$List$foldl, toLegends, _List_Nil, elements);
};
var $terezka$elm_charts$Chart$TickValues = F4(
	function (xAxis, yAxis, xs, ys) {
		return {ch: xAxis, ag: xs, ci: yAxis, ar: ys};
	});
var $terezka$elm_charts$Chart$getTickValues = F3(
	function (plane, items, elements) {
		var toValues = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						return acc;
					case 2:
						var func = el.d;
						return A2(func, plane, acc);
					case 3:
						return acc;
					case 4:
						var func = el.a;
						return A2(func, plane, acc);
					case 5:
						var func = el.a;
						return A2(func, plane, acc);
					case 6:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 7:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 8:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 10:
						var func = el.a;
						return A3(
							$elm$core$List$foldl,
							toValues,
							acc,
							A2(func, plane, items));
					case 9:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, toValues, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		return A3(
			$elm$core$List$foldl,
			toValues,
			A4($terezka$elm_charts$Chart$TickValues, _List_Nil, _List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$GridElement = function (a) {
	return {$: 9, a: a};
};
var $terezka$elm_charts$Internal$Svg$Circle = 0;
var $terezka$elm_charts$Chart$Attributes$circle = function (config) {
	return _Utils_update(
		config,
		{
			bI: $elm$core$Maybe$Just(0)
		});
};
var $terezka$elm_charts$Internal$Helpers$darkGray = 'rgb(200 200 200)';
var $terezka$elm_charts$Chart$Attributes$dashed = function (value) {
	return function (config) {
		return _Utils_update(
			config,
			{cu: value});
	};
};
var $terezka$elm_charts$Internal$Svg$defaultDot = {_: '', ah: 0, gm: $terezka$elm_charts$Internal$Helpers$pink, C: false, gX: 0, gY: '', gZ: 5, aB: 1, bI: $elm$core$Maybe$Nothing, il: 6};
var $terezka$elm_charts$Internal$Svg$isWithinPlane = F3(
	function (plane, x, y) {
		return _Utils_eq(
			A3($elm$core$Basics$clamp, plane.fD.dq, plane.fD.eE, x),
			x) && _Utils_eq(
			A3($elm$core$Basics$clamp, plane.jf.dq, plane.jf.eE, y),
			y);
	});
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $terezka$elm_charts$Internal$Svg$plusPath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(area_ / 4) + off;
		var r6 = side / 2;
		var r3 = side;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_ - r6) + (' ' + $elm$core$String$fromFloat(((y_ - r3) - r6) + off))),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat(r3),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat(r3),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(-r3),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(-r3),
					'v' + $elm$core$String$fromFloat(r3 - off)
				]));
	});
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$core$Basics$tan = _Basics_tan;
var $terezka$elm_charts$Internal$Svg$trianglePath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(
			(area_ * 4) / $elm$core$Basics$sqrt(3)) + (off * $elm$core$Basics$sqrt(3));
		var height = ($elm$core$Basics$sqrt(3) * side) / 2;
		var fromMiddle = height - (($elm$core$Basics$tan(
			$elm$core$Basics$degrees(30)) * side) / 2);
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_) + (' ' + $elm$core$String$fromFloat(y_ - fromMiddle))),
					'l' + ($elm$core$String$fromFloat((-side) / 2) + (' ' + $elm$core$String$fromFloat(height))),
					'h' + $elm$core$String$fromFloat(side),
					'z'
				]));
	});
var $terezka$elm_charts$Internal$Svg$dot = F5(
	function (plane, toX, toY, config, datum_) {
		var yOrg = toY(datum_);
		var y_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, yOrg);
		var xOrg = toX(datum_);
		var x_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, xOrg);
		var styleAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(
				(config._ === '') ? config.gm : config._),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.ah)),
				$elm$svg$Svg$Attributes$fillOpacity(
				$elm$core$String$fromFloat(config.aB)),
				$elm$svg$Svg$Attributes$fill(config.gm),
				$elm$svg$Svg$Attributes$class('elm-charts__dot'),
				config.C ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
			]);
		var showDot = A3($terezka$elm_charts$Internal$Svg$isWithinPlane, plane, xOrg, yOrg) || config.C;
		var highlightColor = (config.gY === '') ? config.gm : config.gY;
		var highlightAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(highlightColor),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.gZ)),
				$elm$svg$Svg$Attributes$strokeOpacity(
				$elm$core$String$fromFloat(config.gX)),
				$elm$svg$Svg$Attributes$fill('transparent'),
				$elm$svg$Svg$Attributes$class('elm-charts__dot-highlight')
			]);
		var view = F3(
			function (toEl, highlightOff, toAttrs) {
				return (config.gX > 0) ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__dot-container')
						]),
					_List_fromArray(
						[
							A2(
							toEl,
							_Utils_ap(
								toAttrs(highlightOff),
								highlightAttrs),
							_List_Nil),
							A2(
							toEl,
							_Utils_ap(
								toAttrs(0),
								styleAttrs),
							_List_Nil)
						])) : A2(
					toEl,
					_Utils_ap(
						toAttrs(0),
						styleAttrs),
					_List_Nil);
			});
		var area_ = (2 * $elm$core$Basics$pi) * config.il;
		if (!showDot) {
			return $elm$svg$Svg$text('');
		} else {
			var _v0 = config.bI;
			if (_v0.$ === 1) {
				return $elm$svg$Svg$text('');
			} else {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$circle,
							config.gZ / 2,
							function (off) {
								var radius = $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(x_)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(y_)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(radius + off))
									]);
							});
					case 1:
						var _v2 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.gZ,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$trianglePath, area_, off, x_, y_))
									]);
							});
					case 2:
						var _v3 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.gZ,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff))
									]);
							});
					case 3:
						var _v4 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.gZ,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					case 4:
						var _v5 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.gZ,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					default:
						var _v6 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.gZ,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_))
									]);
							});
				}
			}
		}
	});
var $terezka$elm_charts$Chart$Svg$dot = F4(
	function (plane, toX, toY, edits) {
		return A4(
			$terezka$elm_charts$Internal$Svg$dot,
			plane,
			toX,
			toY,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultDot));
	});
var $terezka$elm_charts$Internal$Helpers$gray = '#EFF2FA';
var $terezka$elm_charts$Internal$Svg$defaultLine = {p: _List_Nil, ga: false, gm: 'rgb(210, 210, 210)', cu: _List_Nil, s: false, C: false, aB: 1, iQ: -90, iR: 0, fA: 1, bR: $elm$core$Maybe$Nothing, cg: $elm$core$Maybe$Nothing, je: $elm$core$Maybe$Nothing, w: 0, jg: $elm$core$Maybe$Nothing, dT: $elm$core$Maybe$Nothing, jh: $elm$core$Maybe$Nothing, x: 0};
var $elm$core$Basics$cos = _Basics_cos;
var $terezka$elm_charts$Internal$Svg$lengthInCartesianX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX;
var $terezka$elm_charts$Internal$Svg$lengthInCartesianY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $terezka$elm_charts$Internal$Svg$line = F2(
	function (plane, config) {
		var angle = $elm$core$Basics$degrees(config.iQ);
		var _v0 = function () {
			var _v3 = _Utils_Tuple3(
				_Utils_Tuple2(config.bR, config.cg),
				_Utils_Tuple2(config.jg, config.dT),
				_Utils_Tuple2(config.je, config.jh));
			if (!_v3.a.a.$) {
				if (!_v3.a.b.$) {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v4 = _v3.a;
							var a = _v4.a.a;
							var b = _v4.b.a;
							var _v5 = _v3.b;
							var _v6 = _v5.a;
							var _v7 = _v5.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(plane.jf.dq, plane.jf.dq));
						} else {
							var _v38 = _v3.a;
							var a = _v38.a.a;
							var b = _v38.b.a;
							var _v39 = _v3.b;
							var _v40 = _v39.a;
							var c = _v39.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						}
					} else {
						if (_v3.b.b.$ === 1) {
							var _v41 = _v3.a;
							var a = _v41.a.a;
							var b = _v41.b.a;
							var _v42 = _v3.b;
							var c = _v42.a.a;
							var _v43 = _v42.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.fD.dq, config.bR),
									A2($elm$core$Maybe$withDefault, plane.fD.eE, config.cg)),
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.jf.dq, config.jg),
									A2($elm$core$Maybe$withDefault, plane.jf.eE, config.dT)));
						}
					}
				} else {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v8 = _v3.a;
							var a = _v8.a.a;
							var _v9 = _v8.b;
							var _v10 = _v3.b;
							var _v11 = _v10.a;
							var _v12 = _v10.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, a),
								_Utils_Tuple2(plane.jf.dq, plane.jf.eE));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v51 = _v3.a;
									var a = _v51.a.a;
									var _v52 = _v51.b;
									var _v53 = _v3.b;
									var _v54 = _v53.a;
									var b = _v53.b.a;
									var _v55 = _v3.c;
									var xOff = _v55.a.a;
									var yOff = _v55.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v56 = _v3.a;
									var a = _v56.a.a;
									var _v57 = _v56.b;
									var _v58 = _v3.b;
									var _v59 = _v58.a;
									var b = _v58.b.a;
									var _v60 = _v3.c;
									var xOff = _v60.a.a;
									var _v61 = _v60.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v44 = _v3.a;
									var a = _v44.a.a;
									var _v45 = _v44.b;
									var _v46 = _v3.b;
									var _v47 = _v46.a;
									var b = _v46.b.a;
									var _v48 = _v3.c;
									var _v49 = _v48.a;
									var _v50 = _v48.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.fD.eE),
										_Utils_Tuple2(b, b));
								} else {
									var _v62 = _v3.a;
									var a = _v62.a.a;
									var _v63 = _v62.b;
									var _v64 = _v3.b;
									var _v65 = _v64.a;
									var b = _v64.b.a;
									var _v66 = _v3.c;
									var _v67 = _v66.a;
									var yOff = _v66.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (!_v3.b.b.$) {
							var _v35 = _v3.a;
							var c = _v35.a.a;
							var _v36 = _v35.b;
							var _v37 = _v3.b;
							var a = _v37.a.a;
							var b = _v37.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v75 = _v3.a;
									var a = _v75.a.a;
									var _v76 = _v75.b;
									var _v77 = _v3.b;
									var b = _v77.a.a;
									var _v78 = _v77.b;
									var _v79 = _v3.c;
									var xOff = _v79.a.a;
									var yOff = _v79.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v80 = _v3.a;
									var a = _v80.a.a;
									var _v81 = _v80.b;
									var _v82 = _v3.b;
									var b = _v82.a.a;
									var _v83 = _v82.b;
									var _v84 = _v3.c;
									var xOff = _v84.a.a;
									var _v85 = _v84.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v68 = _v3.a;
									var a = _v68.a.a;
									var _v69 = _v68.b;
									var _v70 = _v3.b;
									var b = _v70.a.a;
									var _v71 = _v70.b;
									var _v72 = _v3.c;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.fD.eE),
										_Utils_Tuple2(b, b));
								} else {
									var _v86 = _v3.a;
									var a = _v86.a.a;
									var _v87 = _v86.b;
									var _v88 = _v3.b;
									var b = _v88.a.a;
									var _v89 = _v88.b;
									var _v90 = _v3.c;
									var _v91 = _v90.a;
									var yOff = _v90.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				}
			} else {
				if (!_v3.a.b.$) {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v13 = _v3.a;
							var _v14 = _v13.a;
							var b = _v13.b.a;
							var _v15 = _v3.b;
							var _v16 = _v15.a;
							var _v17 = _v15.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(b, b),
								_Utils_Tuple2(plane.jf.dq, plane.jf.eE));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v99 = _v3.a;
									var _v100 = _v99.a;
									var a = _v99.b.a;
									var _v101 = _v3.b;
									var _v102 = _v101.a;
									var b = _v101.b.a;
									var _v103 = _v3.c;
									var xOff = _v103.a.a;
									var yOff = _v103.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v104 = _v3.a;
									var _v105 = _v104.a;
									var a = _v104.b.a;
									var _v106 = _v3.b;
									var _v107 = _v106.a;
									var b = _v106.b.a;
									var _v108 = _v3.c;
									var xOff = _v108.a.a;
									var _v109 = _v108.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v92 = _v3.a;
									var _v93 = _v92.a;
									var a = _v92.b.a;
									var _v94 = _v3.b;
									var _v95 = _v94.a;
									var b = _v94.b.a;
									var _v96 = _v3.c;
									var _v97 = _v96.a;
									var _v98 = _v96.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.fD.eE),
										_Utils_Tuple2(b, b));
								} else {
									var _v110 = _v3.a;
									var _v111 = _v110.a;
									var a = _v110.b.a;
									var _v112 = _v3.b;
									var _v113 = _v112.a;
									var b = _v112.b.a;
									var _v114 = _v3.c;
									var _v115 = _v114.a;
									var yOff = _v114.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (!_v3.b.b.$) {
							var _v32 = _v3.a;
							var _v33 = _v32.a;
							var c = _v32.b.a;
							var _v34 = _v3.b;
							var a = _v34.a.a;
							var b = _v34.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v123 = _v3.a;
									var _v124 = _v123.a;
									var a = _v123.b.a;
									var _v125 = _v3.b;
									var b = _v125.a.a;
									var _v126 = _v125.b;
									var _v127 = _v3.c;
									var xOff = _v127.a.a;
									var yOff = _v127.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v128 = _v3.a;
									var _v129 = _v128.a;
									var a = _v128.b.a;
									var _v130 = _v3.b;
									var b = _v130.a.a;
									var _v131 = _v130.b;
									var _v132 = _v3.c;
									var xOff = _v132.a.a;
									var _v133 = _v132.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v116 = _v3.a;
									var _v117 = _v116.a;
									var a = _v116.b.a;
									var _v118 = _v3.b;
									var b = _v118.a.a;
									var _v119 = _v118.b;
									var _v120 = _v3.c;
									var _v121 = _v120.a;
									var _v122 = _v120.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.fD.eE),
										_Utils_Tuple2(b, b));
								} else {
									var _v134 = _v3.a;
									var _v135 = _v134.a;
									var a = _v134.b.a;
									var _v136 = _v3.b;
									var b = _v136.a.a;
									var _v137 = _v136.b;
									var _v138 = _v3.c;
									var _v139 = _v138.a;
									var yOff = _v138.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				} else {
					if (!_v3.b.a.$) {
						if (!_v3.b.b.$) {
							var _v18 = _v3.a;
							var _v19 = _v18.a;
							var _v20 = _v18.b;
							var _v21 = _v3.b;
							var a = _v21.a.a;
							var b = _v21.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.fD.dq, plane.fD.dq),
								_Utils_Tuple2(a, b));
						} else {
							var _v22 = _v3.a;
							var _v23 = _v22.a;
							var _v24 = _v22.b;
							var _v25 = _v3.b;
							var a = _v25.a.a;
							var _v26 = _v25.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.fD.dq, plane.fD.eE),
								_Utils_Tuple2(a, a));
						}
					} else {
						if (!_v3.b.b.$) {
							var _v27 = _v3.a;
							var _v28 = _v27.a;
							var _v29 = _v27.b;
							var _v30 = _v3.b;
							var _v31 = _v30.a;
							var b = _v30.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.fD.dq, plane.fD.eE),
								_Utils_Tuple2(b, b));
						} else {
							var _v140 = _v3.a;
							var _v141 = _v140.a;
							var _v142 = _v140.b;
							var _v143 = _v3.b;
							var _v144 = _v143.a;
							var _v145 = _v143.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.fD.dq, plane.fD.eE),
								_Utils_Tuple2(plane.jf.dq, plane.jf.eE));
						}
					}
				}
			}
		}();
		var _v1 = _v0.a;
		var x1 = _v1.a;
		var x2 = _v1.b;
		var _v2 = _v0.b;
		var y1 = _v2.a;
		var y2 = _v2.b;
		var x1_ = x1 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.w);
		var x2_ = x2 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.w);
		var y1_ = y1 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.x);
		var y2_ = y2 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.x);
		var _v146 = (config.iR > 0) ? _Utils_Tuple2(
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianX,
				plane,
				$elm$core$Basics$cos(angle) * config.iR),
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianY,
				plane,
				$elm$core$Basics$sin(angle) * config.iR)) : _Utils_Tuple2(0, 0);
		var tickOffsetX = _v146.a;
		var tickOffsetY = _v146.b;
		var cmds = config.s ? _Utils_ap(
			(config.iR > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_ + tickOffsetX, y2_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_, y2_)
				]),
			_Utils_ap(
				config.ga ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y1_),
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]),
				(config.iR > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_ + tickOffsetX, y1_ + tickOffsetY)
					]) : _List_Nil)) : _Utils_ap(
			(config.iR > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_ + tickOffsetX, y1_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_, y1_)
				]),
			_Utils_ap(
				config.ga ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y2_),
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]),
				(config.iR > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_ + tickOffsetX, y2_ + tickOffsetY)
					]) : _List_Nil));
		return A4(
			$terezka$elm_charts$Internal$Svg$withAttrs,
			config.p,
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__line'),
					$elm$svg$Svg$Attributes$fill('transparent'),
					$elm$svg$Svg$Attributes$stroke(config.gm),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(config.fA)),
					$elm$svg$Svg$Attributes$strokeOpacity(
					$elm$core$String$fromFloat(config.aB)),
					$elm$svg$Svg$Attributes$strokeDasharray(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, config.cu))),
					$elm$svg$Svg$Attributes$d(
					A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
					config.C ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
				]),
			_List_Nil);
	});
var $terezka$elm_charts$Chart$Svg$line = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$line,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultLine));
	});
var $terezka$elm_charts$Chart$Attributes$size = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{il: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$width = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{fA: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$x1 = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				bR: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$Attributes$y1 = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				jg: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$grid = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{gm: '', cu: _List_Nil, bZ: false, fA: 0});
	var width = (!config.fA) ? (config.bZ ? 0.5 : 1) : config.fA;
	var color = $elm$core$String$isEmpty(config.gm) ? (config.bZ ? $terezka$elm_charts$Internal$Helpers$darkGray : $terezka$elm_charts$Internal$Helpers$gray) : config.gm;
	var toDot = F4(
		function (vs, p, x, y) {
			return (A2($elm$core$List$member, x, vs.ch) || A2($elm$core$List$member, y, vs.ci)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A5(
					$terezka$elm_charts$Chart$Svg$dot,
					p,
					function ($) {
						return $.fD;
					},
					function ($) {
						return $.jf;
					},
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$size(width),
							$terezka$elm_charts$Chart$Attributes$circle
						]),
					{fD: x, jf: y}));
		});
	var toXGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.ch) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$x1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.cu)
						])));
		});
	var toYGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.ci) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$y1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.cu)
						])));
		});
	return $terezka$elm_charts$Chart$GridElement(
		F2(
			function (p, vs) {
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__grid')
						]),
					config.bZ ? A2(
						$elm$core$List$concatMap,
						function (x) {
							return A2(
								$elm$core$List$filterMap,
								A3(toDot, vs, p, x),
								vs.ar);
						},
						vs.ag) : _List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__x-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toXGrid, vs, p),
								vs.ag)),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__y-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toYGrid, vs, p),
								vs.ar))
						]));
			}));
};
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $terezka$elm_charts$Chart$viewElements = F6(
	function (config, plane, tickValues, allItems, allLegends, elements) {
		var viewOne = F2(
			function (el, _v0) {
				var before = _v0.a;
				var chart_ = _v0.b;
				var after = _v0.c;
				switch (el.$) {
					case 0:
						return _Utils_Tuple3(before, chart_, after);
					case 1:
						var view = el.d;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 2:
						var view = el.e;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 3:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 4:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 5:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 6:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 7:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 8:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 9:
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(view, plane, tickValues),
								chart_),
							after);
					case 10:
						var func = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							A2(func, plane, allItems));
					case 11:
						var els = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							els);
					case 12:
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					default:
						var view = el.a;
						return _Utils_Tuple3(
							($elm$core$List$length(chart_) > 0) ? A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								before) : before,
							chart_,
							($elm$core$List$length(chart_) > 0) ? after : A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								after));
				}
			});
		return A3(
			$elm$core$List$foldr,
			viewOne,
			_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$chart = F2(
	function (edits, unindexedElements) {
		var indexedElements = function () {
			var toIndexedEl = F2(
				function (el, _v4) {
					var acc = _v4.a;
					var index = _v4.b;
					switch (el.$) {
						case 0:
							var toElAndIndex = el.a;
							var _v6 = toElAndIndex(index);
							var newEl = _v6.a;
							var newIndex = _v6.b;
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[newEl])),
								newIndex);
						case 11:
							var els = el.a;
							return A3(
								$elm$core$List$foldl,
								toIndexedEl,
								_Utils_Tuple2(acc, index),
								els);
						default:
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[el])),
								index);
					}
				});
			return A3(
				$elm$core$List$foldl,
				toIndexedEl,
				_Utils_Tuple2(_List_Nil, 0),
				unindexedElements).a;
		}();
		var elements = function () {
			var isGrid = function (el) {
				if (el.$ === 9) {
					return true;
				} else {
					return false;
				}
			};
			return A2($elm$core$List$any, isGrid, indexedElements) ? indexedElements : A2(
				$elm$core$List$cons,
				$terezka$elm_charts$Chart$grid(_List_Nil),
				indexedElements);
		}();
		var legends_ = $terezka$elm_charts$Chart$getLegends(elements);
		var config = A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{
				p: _List_fromArray(
					[
						$elm$svg$Svg$Attributes$style('overflow: visible;')
					]),
				c6: _List_Nil,
				gH: _List_Nil,
				ep: 300,
				cB: _List_Nil,
				bi: {X: 0, a$: 0, a4: 0, aS: 0},
				aD: {X: 0, a$: 0, a4: 0, aS: 0},
				dy: _List_Nil,
				cH: true,
				fA: 300
			});
		var plane = A2($terezka$elm_charts$Chart$definePlane, config, elements);
		var items = A2($terezka$elm_charts$Chart$getItems, plane, elements);
		var toEvent = function (_v2) {
			var event_ = _v2;
			var _v1 = event_.gv;
			var decoder = _v1;
			return A2(
				$terezka$elm_charts$Internal$Svg$Event,
				event_.I,
				decoder(items));
		};
		var tickValues = A3($terezka$elm_charts$Chart$getTickValues, plane, items, elements);
		var _v0 = A6($terezka$elm_charts$Chart$viewElements, config, plane, tickValues, items, legends_, elements);
		var beforeEls = _v0.a;
		var chartEls = _v0.b;
		var afterEls = _v0.c;
		return A5(
			$terezka$elm_charts$Internal$Svg$container,
			plane,
			{
				p: config.p,
				gH: A2($elm$core$List$map, toEvent, config.gH),
				cB: config.cB,
				cH: config.cH
			},
			beforeEls,
			chartEls,
			afterEls);
	});
var $terezka$elm_charts$Chart$Attributes$domain = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{c6: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$exactly = F3(
	function (exact, _v0, _v1) {
		return exact;
	});
var $terezka$elm_charts$Chart$Attributes$height = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{ep: v});
	};
};
var $terezka$elm_charts$Chart$Attributes$highest = F2(
	function (v, edit) {
		return function (b) {
			return _Utils_update(
				b,
				{
					eE: A3(edit, v, b.eE, b.gr)
				});
		};
	});
var $terezka$elm_charts$Chart$AxisElement = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $terezka$elm_charts$Internal$Svg$position = F6(
	function (plane, rotation, x_, y_, xOff_, yOff_) {
		return $elm$svg$Svg$Attributes$transform(
			'translate(' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x_) + xOff_) + (',' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y_) + yOff_) + (') rotate(' + ($elm$core$String$fromFloat(rotation) + ')'))))));
	});
var $terezka$elm_charts$Internal$Svg$arrow = F3(
	function (plane, config, point) {
		var points_ = '0,0 ' + ($elm$core$String$fromFloat(config.H) + (',' + ($elm$core$String$fromFloat(config.fA) + (' 0, ' + $elm$core$String$fromFloat(config.fA * 2)))));
		var commands = 'rotate(' + ($elm$core$String$fromFloat(config.F) + (') translate(0 ' + ($elm$core$String$fromFloat(-config.fA) + ') ')));
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__arrow'),
					A6($terezka$elm_charts$Internal$Svg$position, plane, 0, point.fD, point.jf, config.w, config.x)
				]),
			_List_fromArray(
				[
					A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.p,
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(config.gm),
							$elm$svg$Svg$Attributes$points(points_),
							$elm$svg$Svg$Attributes$transform(commands)
						]),
					_List_Nil)
				]));
	});
var $terezka$elm_charts$Internal$Svg$defaultArrow = {p: _List_Nil, gm: 'rgb(210, 210, 210)', H: 7, F: 0, fA: 4, w: 0, x: 0};
var $terezka$elm_charts$Chart$Svg$arrow = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$arrow,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultArrow));
	});
var $terezka$elm_charts$Chart$Attributes$x2 = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				cg: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$Attributes$zero = function (b) {
	return A3($elm$core$Basics$clamp, b.dq, b.eE, 0);
};
var $terezka$elm_charts$Chart$xAxis = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{bx: true, gm: '', R: _List_Nil, E: $terezka$elm_charts$Chart$Attributes$zero, fA: 1});
	var addTickValues = F2(
		function (p, ts) {
			return _Utils_update(
				ts,
				{
					ci: A2(
						$elm$core$List$cons,
						config.E(p.jf),
						ts.ci)
				});
		});
	return A2(
		$terezka$elm_charts$Chart$AxisElement,
		addTickValues,
		function (p) {
			var xLimit = A2($terezka$elm_charts$Internal$Helpers$apply, config.R, p.fD);
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__x-axis')
					]),
				_List_fromArray(
					[
						A2(
						$terezka$elm_charts$Chart$Svg$line,
						p,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(config.gm),
								$terezka$elm_charts$Chart$Attributes$width(config.fA),
								$terezka$elm_charts$Chart$Attributes$y1(
								config.E(p.jf)),
								$terezka$elm_charts$Chart$Attributes$x1(
								A2($elm$core$Basics$max, p.fD.dq, xLimit.dq)),
								$terezka$elm_charts$Chart$Attributes$x2(
								A2($elm$core$Basics$min, p.fD.eE, xLimit.eE))
							])),
						config.bx ? A3(
						$terezka$elm_charts$Chart$Svg$arrow,
						p,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(config.gm)
							]),
						{
							fD: xLimit.eE,
							jf: config.E(p.jf)
						}) : $elm$svg$Svg$text('')
					]));
		});
};
var $terezka$elm_charts$Internal$Svg$Floats = {$: 0};
var $terezka$elm_charts$Chart$LabelsElement = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $terezka$elm_charts$Internal$Svg$defaultLabel = {y: $elm$core$Maybe$Nothing, p: _List_Nil, _: 'white', ah: 0, gm: '#808BAB', A: $elm$core$Maybe$Nothing, B: $elm$core$Maybe$Nothing, C: false, F: 0, G: false, w: 0, x: 0};
var $terezka$elm_charts$Internal$Svg$Generator = $elm$core$Basics$identity;
var $terezka$intervals$Intervals$Around = function (a) {
	return {$: 1, a: a};
};
var $terezka$intervals$Intervals$around = $terezka$intervals$Intervals$Around;
var $terezka$intervals$Intervals$ceilingTo = F2(
	function (prec, number) {
		return prec * $elm$core$Basics$ceiling(number / prec);
	});
var $terezka$intervals$Intervals$getBeginning = F2(
	function (min, interval) {
		var multiple = min / interval;
		return _Utils_eq(
			multiple,
			$elm$core$Basics$round(multiple)) ? min : A2($terezka$intervals$Intervals$ceilingTo, interval, min);
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$String$toFloat = _String_toFloat;
var $terezka$intervals$Intervals$correctFloat = function (prec) {
	return A2(
		$elm$core$Basics$composeR,
		$myrho$elm_round$Round$round(prec),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toFloat,
			$elm$core$Maybe$withDefault(0)));
};
var $terezka$intervals$Intervals$getMultiples = F3(
	function (magnitude, allowDecimals, hasTickAmount) {
		var defaults = hasTickAmount ? _List_fromArray(
			[1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) : _List_fromArray(
			[1, 2, 2.5, 5, 10]);
		return allowDecimals ? defaults : ((magnitude === 1) ? A2(
			$elm$core$List$filter,
			function (n) {
				return _Utils_eq(
					$elm$core$Basics$round(n),
					n);
			},
			defaults) : ((magnitude <= 0.1) ? _List_fromArray(
			[1 / magnitude]) : defaults));
	});
var $terezka$intervals$Intervals$getPrecision = function (number) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(number));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var before = _v0.a;
		var _v1 = _v0.b;
		var after = _v1.a;
		return $elm$core$Basics$abs(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(after)));
	} else {
		var _v2 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$fromFloat(number));
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var before = _v2.a;
			var _v3 = _v2.b;
			var after = _v3.a;
			return $elm$core$String$length(after);
		} else {
			return 0;
		}
	}
};
var $elm$core$Basics$e = _Basics_e;
var $elm$core$Basics$pow = _Basics_pow;
var $terezka$intervals$Intervals$toMagnitude = function (num) {
	return A2(
		$elm$core$Basics$pow,
		10,
		$elm$core$Basics$floor(
			A2($elm$core$Basics$logBase, $elm$core$Basics$e, num) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
};
var $terezka$intervals$Intervals$getInterval = F3(
	function (intervalRaw, allowDecimals, hasTickAmount) {
		var magnitude = $terezka$intervals$Intervals$toMagnitude(intervalRaw);
		var multiples = A3($terezka$intervals$Intervals$getMultiples, magnitude, allowDecimals, hasTickAmount);
		var normalized = intervalRaw / magnitude;
		var findMultipleExact = function (multiples_) {
			findMultipleExact:
			while (true) {
				if (multiples_.b) {
					var m1 = multiples_.a;
					var rest = multiples_.b;
					if (_Utils_cmp(m1 * magnitude, intervalRaw) > -1) {
						return m1;
					} else {
						var $temp$multiples_ = rest;
						multiples_ = $temp$multiples_;
						continue findMultipleExact;
					}
				} else {
					return 1;
				}
			}
		};
		var findMultiple = function (multiples_) {
			findMultiple:
			while (true) {
				if (multiples_.b) {
					if (multiples_.b.b) {
						var m1 = multiples_.a;
						var _v2 = multiples_.b;
						var m2 = _v2.a;
						var rest = _v2.b;
						if (_Utils_cmp(normalized, (m1 + m2) / 2) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = A2($elm$core$List$cons, m2, rest);
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					} else {
						var m1 = multiples_.a;
						var rest = multiples_.b;
						if (_Utils_cmp(normalized, m1) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = rest;
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					}
				} else {
					return 1;
				}
			}
		};
		var multiple = hasTickAmount ? findMultipleExact(multiples) : findMultiple(multiples);
		var precision = $terezka$intervals$Intervals$getPrecision(magnitude) + $terezka$intervals$Intervals$getPrecision(multiple);
		return A2($terezka$intervals$Intervals$correctFloat, precision, multiple * magnitude);
	});
var $terezka$intervals$Intervals$positions = F5(
	function (range, beginning, interval, m, acc) {
		positions:
		while (true) {
			var nextPosition = A2(
				$terezka$intervals$Intervals$correctFloat,
				$terezka$intervals$Intervals$getPrecision(interval),
				beginning + (m * interval));
			if (_Utils_cmp(nextPosition, range.eE) > 0) {
				return acc;
			} else {
				var $temp$range = range,
					$temp$beginning = beginning,
					$temp$interval = interval,
					$temp$m = m + 1,
					$temp$acc = _Utils_ap(
					acc,
					_List_fromArray(
						[nextPosition]));
				range = $temp$range;
				beginning = $temp$beginning;
				interval = $temp$interval;
				m = $temp$m;
				acc = $temp$acc;
				continue positions;
			}
		}
	});
var $terezka$intervals$Intervals$values = F4(
	function (allowDecimals, exact, amountRough, range) {
		var intervalRough = (range.eE - range.dq) / amountRough;
		var interval = A3($terezka$intervals$Intervals$getInterval, intervalRough, allowDecimals, exact);
		var intervalSafe = (!interval) ? 1 : interval;
		var beginning = A2($terezka$intervals$Intervals$getBeginning, range.dq, intervalSafe);
		var amountRoughSafe = (!amountRough) ? 1 : amountRough;
		return A5($terezka$intervals$Intervals$positions, range, beginning, intervalSafe, 0, _List_Nil);
	});
var $terezka$intervals$Intervals$floats = function (amount) {
	if (!amount.$) {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, true, number);
	} else {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, false, number);
	}
};
var $terezka$elm_charts$Internal$Svg$floats = F2(
	function (i, b) {
		return A2(
			$terezka$intervals$Intervals$floats,
			$terezka$intervals$Intervals$around(i),
			{eE: b.eE, dq: b.dq});
	});
var $terezka$elm_charts$Chart$Svg$floats = $terezka$elm_charts$Internal$Svg$floats;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {iT: toAmPm, iV: toMonthAbbreviation, iW: toMonthName, bN: toOrdinalSuffix, iY: toWeekdayAbbreviation, iZ: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.iT(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bN(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.iV(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.iW(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bN(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bN(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bN(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bN(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.iY(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.iZ(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bN(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $terezka$elm_charts$Internal$Svg$formatClock = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $ryan_haskell$date_format$DateFormat$MillisecondFixed = {$: 35};
var $ryan_haskell$date_format$DateFormat$millisecondFixed = $ryan_haskell$date_format$DateFormat$MillisecondFixed;
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 33};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $terezka$elm_charts$Internal$Svg$formatClockMillis = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$secondFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$millisecondFixed
		]));
var $terezka$elm_charts$Internal$Svg$formatClockSecond = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$secondFixed
		]));
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$MonthNumber = {$: 0};
var $ryan_haskell$date_format$DateFormat$monthNumber = $ryan_haskell$date_format$DateFormat$MonthNumber;
var $terezka$elm_charts$Internal$Svg$formatDate = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNumber,
			$ryan_haskell$date_format$DateFormat$text('/'),
			$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
		]));
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $terezka$elm_charts$Internal$Svg$formatMonth = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$monthNameAbbreviated]));
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull = {$: 14};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameFull = $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull;
var $terezka$elm_charts$Internal$Svg$formatWeekday = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull]));
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $terezka$elm_charts$Internal$Svg$formatYear = $ryan_haskell$date_format$DateFormat$format(
	_List_fromArray(
		[$ryan_haskell$date_format$DateFormat$yearNumber]));
var $terezka$elm_charts$Internal$Svg$formatTime = F2(
	function (zone, time) {
		var _v0 = A2($elm$core$Maybe$withDefault, time.i5, time.gg);
		switch (_v0) {
			case 0:
				return A2($terezka$elm_charts$Internal$Svg$formatClockMillis, zone, time.iS);
			case 1:
				return A2($terezka$elm_charts$Internal$Svg$formatClockSecond, zone, time.iS);
			case 2:
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.iS);
			case 3:
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.iS);
			case 4:
				return (time.hA === 7) ? A2($terezka$elm_charts$Internal$Svg$formatWeekday, zone, time.iS) : A2($terezka$elm_charts$Internal$Svg$formatDate, zone, time.iS);
			case 5:
				return A2($terezka$elm_charts$Internal$Svg$formatMonth, zone, time.iS);
			default:
				return A2($terezka$elm_charts$Internal$Svg$formatYear, zone, time.iS);
		}
	});
var $terezka$elm_charts$Chart$Svg$formatTime = $terezka$elm_charts$Internal$Svg$formatTime;
var $terezka$elm_charts$Internal$Svg$generate = F3(
	function (amount, _v0, limits) {
		var func = _v0;
		return A2(func, amount, limits);
	});
var $terezka$elm_charts$Chart$Svg$generate = $terezka$elm_charts$Internal$Svg$generate;
var $terezka$intervals$Intervals$ints = F2(
	function (amount, range) {
		return A2(
			$elm$core$List$map,
			$elm$core$Basics$round,
			function () {
				if (!amount.$) {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, true, number, range);
				} else {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, false, number, range);
				}
			}());
	});
var $terezka$elm_charts$Internal$Svg$ints = F2(
	function (i, b) {
		return A2(
			$terezka$intervals$Intervals$ints,
			$terezka$intervals$Intervals$around(i),
			{eE: b.eE, dq: b.dq});
	});
var $terezka$elm_charts$Chart$Svg$ints = $terezka$elm_charts$Internal$Svg$ints;
var $terezka$intervals$Intervals$Day = 4;
var $terezka$intervals$Intervals$Hour = 3;
var $terezka$intervals$Intervals$Millisecond = 0;
var $terezka$intervals$Intervals$Minute = 2;
var $terezka$intervals$Intervals$Month = 5;
var $terezka$intervals$Intervals$Second = 1;
var $terezka$intervals$Intervals$Year = 6;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {gu: d, hz: m, ji: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		dv: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		ji: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ji, 0, date.dv);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.ji - 1)) + ($justinmimbs$date$Date$monthToNumber(date.hz) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.gu,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.hz;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $terezka$intervals$Intervals$Time$ceilingDay = F3(
	function (zone, mult, stamp) {
		return (mult === 7) ? A3($justinmimbs$time_extra$Time$Extra$ceiling, 3, zone, stamp) : A3($justinmimbs$time_extra$Time$Extra$ceiling, 11, zone, stamp);
	});
var $justinmimbs$time_extra$Time$Extra$Hour = 12;
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var millisecond = _v0.dp;
		var second = _v0.dC;
		var minute = _v0.dr;
		var hour = _v0.df;
		var day = _v0.gu;
		var month = _v0.hz;
		var year = _v0.ji;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			gu: A2($elm$time$Time$toDay, zone, posix),
			df: A2($elm$time$Time$toHour, zone, posix),
			dp: A2($elm$time$Time$toMillis, zone, posix),
			dr: A2($elm$time$Time$toMinute, zone, posix),
			hz: A2($elm$time$Time$toMonth, zone, posix),
			dC: A2($elm$time$Time$toSecond, zone, posix),
			ji: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $terezka$intervals$Intervals$Time$ceilingHour = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 12, zone, stamp));
		var rem = parts.df % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 12, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $terezka$intervals$Intervals$Time$ceilingMinute = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 13, zone, stamp));
		var rem = parts.dr % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 13, mult - rem, zone, _new);
	});
var $terezka$intervals$Intervals$Time$intAsMonth = function (_int) {
	switch (_int) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		case 12:
			return 11;
		default:
			return 11;
	}
};
var $terezka$intervals$Intervals$Time$monthAsInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $terezka$intervals$Intervals$Time$ceilingMonth = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 2, zone, stamp));
		var monthInt = $terezka$intervals$Intervals$Time$monthAsInt(parts.hz);
		var rem = (monthInt - 1) % mult;
		var newMonth = (!rem) ? monthInt : ((monthInt - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			(newMonth > 12) ? _Utils_update(
				parts,
				{
					hz: $terezka$intervals$Intervals$Time$intAsMonth(newMonth - 12),
					ji: parts.ji + 1
				}) : _Utils_update(
				parts,
				{
					hz: $terezka$intervals$Intervals$Time$intAsMonth(newMonth)
				}));
	});
var $terezka$intervals$Intervals$Time$ceilingMs = F3(
	function (zone, mult, stamp) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, stamp);
		var rem = parts.dp % mult;
		return (!rem) ? A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts) : A4($justinmimbs$time_extra$Time$Extra$add, 15, mult - rem, zone, stamp);
	});
var $justinmimbs$time_extra$Time$Extra$Second = 14;
var $terezka$intervals$Intervals$Time$ceilingSecond = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 14, zone, stamp));
		var rem = parts.dC % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 14, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Year = 0;
var $terezka$intervals$Intervals$Time$ceilingYear = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 0, zone, stamp));
		var rem = parts.ji % mult;
		var newYear = (!rem) ? parts.ji : ((parts.ji - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			_Utils_update(
				parts,
				{ji: newYear}));
	});
var $terezka$intervals$Intervals$Time$ceilingUnit = F3(
	function (zone, unit, mult) {
		switch (unit) {
			case 0:
				return A2($terezka$intervals$Intervals$Time$ceilingMs, zone, mult);
			case 1:
				return A2($terezka$intervals$Intervals$Time$ceilingSecond, zone, mult);
			case 2:
				return A2($terezka$intervals$Intervals$Time$ceilingMinute, zone, mult);
			case 3:
				return A2($terezka$intervals$Intervals$Time$ceilingHour, zone, mult);
			case 4:
				return A2($terezka$intervals$Intervals$Time$ceilingDay, zone, mult);
			case 5:
				return A2($terezka$intervals$Intervals$Time$ceilingMonth, zone, mult);
			default:
				return A2($terezka$intervals$Intervals$Time$ceilingYear, zone, mult);
		}
	});
var $terezka$intervals$Intervals$Time$Day = 4;
var $terezka$intervals$Intervals$Time$Hour = 3;
var $terezka$intervals$Intervals$Time$Millisecond = 0;
var $terezka$intervals$Intervals$Time$Minute = 2;
var $terezka$intervals$Intervals$Time$Month = 5;
var $terezka$intervals$Intervals$Time$Second = 1;
var $terezka$intervals$Intervals$Time$Year = 6;
var $terezka$intervals$Intervals$Time$getChange = F3(
	function (zone, a, b) {
		var bP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b);
		var aP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a);
		return (!_Utils_eq(aP.ji, bP.ji)) ? 6 : ((!_Utils_eq(aP.hz, bP.hz)) ? 5 : ((!_Utils_eq(aP.gu, bP.gu)) ? 4 : ((!_Utils_eq(aP.df, bP.df)) ? 3 : ((!_Utils_eq(aP.dr, bP.dr)) ? 2 : ((!_Utils_eq(aP.dC, bP.dC)) ? 1 : 0)))));
	});
var $danhandrea$elm_time_extra$Util$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 400, year)) || ((!(!A2($elm$core$Basics$modBy, 100, year))) && (!A2($elm$core$Basics$modBy, 4, year)));
};
var $danhandrea$elm_time_extra$Month$days = F2(
	function (year, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $danhandrea$elm_time_extra$Util$isLeapYear(year) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $danhandrea$elm_time_extra$TimeExtra$daysInMonth = $danhandrea$elm_time_extra$Month$days;
var $terezka$intervals$Intervals$Time$toMs = $elm$time$Time$posixToMillis;
var $terezka$intervals$Intervals$Time$getDiff = F3(
	function (zone, a, b) {
		var _v0 = (_Utils_cmp(
			$terezka$intervals$Intervals$Time$toMs(a),
			$terezka$intervals$Intervals$Time$toMs(b)) < 0) ? _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b)) : _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a));
		var aP = _v0.a;
		var bP = _v0.b;
		var dMsX = bP.dp - aP.dp;
		var dMs = (dMsX < 0) ? (1000 + dMsX) : dMsX;
		var dSecondX = (bP.dC - aP.dC) + ((dMsX < 0) ? (-1) : 0);
		var dMinuteX = (bP.dr - aP.dr) + ((dSecondX < 0) ? (-1) : 0);
		var dHourX = (bP.df - aP.df) + ((dMinuteX < 0) ? (-1) : 0);
		var dDayX = (bP.gu - aP.gu) + ((dHourX < 0) ? (-1) : 0);
		var dDay = (dDayX < 0) ? (A2($danhandrea$elm_time_extra$TimeExtra$daysInMonth, bP.ji, bP.hz) + dDayX) : dDayX;
		var dMonthX = ($terezka$intervals$Intervals$Time$monthAsInt(bP.hz) - $terezka$intervals$Intervals$Time$monthAsInt(aP.hz)) + ((dDayX < 0) ? (-1) : 0);
		var dMonth = (dMonthX < 0) ? (12 + dMonthX) : dMonthX;
		var dHour = (dHourX < 0) ? (24 + dHourX) : dHourX;
		var dMinute = (dMinuteX < 0) ? (60 + dMinuteX) : dMinuteX;
		var dSecond = (dSecondX < 0) ? (60 + dSecondX) : dSecondX;
		var dYearX = (bP.ji - aP.ji) + ((dMonthX < 0) ? (-1) : 0);
		var dYear = (dYearX < 0) ? ($terezka$intervals$Intervals$Time$monthAsInt(bP.hz) + dYearX) : dYearX;
		return {gu: dDay, df: dHour, dp: dMs, dr: dMinute, hz: dMonth, dC: dSecond, ji: dYear};
	});
var $terezka$intervals$Intervals$Time$oneSecond = 1000;
var $terezka$intervals$Intervals$Time$oneMinute = $terezka$intervals$Intervals$Time$oneSecond * 60;
var $terezka$intervals$Intervals$Time$oneHour = $terezka$intervals$Intervals$Time$oneMinute * 60;
var $terezka$intervals$Intervals$Time$oneDay = $terezka$intervals$Intervals$Time$oneHour * 24;
var $terezka$intervals$Intervals$Time$oneMs = 1;
var $terezka$intervals$Intervals$Time$getNumOfTicks = F5(
	function (zone, unit, mult, a, b) {
		var div = F2(
			function (n1, n2) {
				return $elm$core$Basics$floor(n1 / n2);
			});
		var timeDiff = function (ms) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				A2(
					div,
					$terezka$intervals$Intervals$Time$toMs(b) - $terezka$intervals$Intervals$Time$toMs(ceiled),
					ms),
				mult);
		};
		var diff = function (property) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				property(
					A3($terezka$intervals$Intervals$Time$getDiff, zone, ceiled, b)),
				mult);
		};
		switch (unit) {
			case 0:
				return timeDiff($terezka$intervals$Intervals$Time$oneMs) + 1;
			case 1:
				return timeDiff($terezka$intervals$Intervals$Time$oneSecond) + 1;
			case 2:
				return timeDiff($terezka$intervals$Intervals$Time$oneMinute) + 1;
			case 3:
				return timeDiff($terezka$intervals$Intervals$Time$oneHour) + 1;
			case 4:
				return timeDiff($terezka$intervals$Intervals$Time$oneDay) + 1;
			case 5:
				return diff(
					function (d) {
						return d.hz + (d.ji * 12);
					}) + 1;
			default:
				return diff(
					function ($) {
						return $.ji;
					}) + 1;
		}
	});
var $terezka$intervals$Intervals$Time$largerUnit = function (unit) {
	switch (unit) {
		case 0:
			return $elm$core$Maybe$Just(1);
		case 1:
			return $elm$core$Maybe$Just(2);
		case 2:
			return $elm$core$Maybe$Just(3);
		case 3:
			return $elm$core$Maybe$Just(4);
		case 4:
			return $elm$core$Maybe$Just(5);
		case 5:
			return $elm$core$Maybe$Just(6);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $terezka$intervals$Intervals$Time$niceMultiples = function (unit) {
	switch (unit) {
		case 0:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500]);
		case 1:
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 2:
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 3:
			return _List_fromArray(
				[1, 2, 3, 4, 6, 8, 12]);
		case 4:
			return _List_fromArray(
				[1, 2, 3, 7, 14]);
		case 5:
			return _List_fromArray(
				[1, 2, 3, 4, 6]);
		default:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 10000, 1000000, 10000000]);
	}
};
var $terezka$intervals$Intervals$Time$toBestUnit = F4(
	function (zone, amount, min, max) {
		var toNice = function (unit) {
			toNice:
			while (true) {
				var niceNums = $terezka$intervals$Intervals$Time$niceMultiples(unit);
				var maybeNiceNum = A2(
					$elm$core$List$filter,
					function (n) {
						return _Utils_cmp(
							A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, n, min, max),
							amount) < 1;
					},
					niceNums);
				var div = F2(
					function (n1, n2) {
						return $elm$core$Basics$ceiling(n1 / n2);
					});
				var _v0 = $elm$core$List$head(maybeNiceNum);
				if (!_v0.$) {
					var niceNum = _v0.a;
					return _Utils_Tuple2(unit, niceNum);
				} else {
					var _v1 = $terezka$intervals$Intervals$Time$largerUnit(unit);
					if (!_v1.$) {
						var larger = _v1.a;
						var $temp$unit = larger;
						unit = $temp$unit;
						continue toNice;
					} else {
						return _Utils_Tuple2(6, 100000000);
					}
				}
			}
		};
		return toNice(0);
	});
var $terezka$intervals$Intervals$Time$toExtraUnit = function (unit) {
	switch (unit) {
		case 0:
			return 15;
		case 1:
			return 14;
		case 2:
			return 13;
		case 3:
			return 12;
		case 4:
			return 11;
		case 5:
			return 2;
		default:
			return 0;
	}
};
var $terezka$intervals$Intervals$Time$unitToInt = function (unit) {
	switch (unit) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $terezka$intervals$Intervals$Time$values = F4(
	function (zone, maxMmount, min, max) {
		var _v0 = A4($terezka$intervals$Intervals$Time$toBestUnit, zone, maxMmount, min, max);
		var unit = _v0.a;
		var mult = _v0.b;
		var amount = A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, mult, min, max);
		var initial = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, min);
		var tUnit = $terezka$intervals$Intervals$Time$toExtraUnit(unit);
		var toTick = F3(
			function (x, timestamp, change) {
				return {
					gg: (_Utils_cmp(
						$terezka$intervals$Intervals$Time$unitToInt(change),
						$terezka$intervals$Intervals$Time$unitToInt(unit)) > 0) ? $elm$core$Maybe$Just(change) : $elm$core$Maybe$Nothing,
					dm: !x,
					hA: mult,
					iS: timestamp,
					i5: unit,
					dU: zone
				};
			});
		var toTicks = F2(
			function (xs, acc) {
				toTicks:
				while (true) {
					if (xs.b) {
						var x = xs.a;
						var rest = xs.b;
						var prev = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, (x - 1) * mult, zone, initial);
						var curr = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, x * mult, zone, initial);
						var change = A3($terezka$intervals$Intervals$Time$getChange, zone, prev, curr);
						var $temp$xs = rest,
							$temp$acc = A2(
							$elm$core$List$cons,
							A3(toTick, x, curr, change),
							acc);
						xs = $temp$xs;
						acc = $temp$acc;
						continue toTicks;
					} else {
						return acc;
					}
				}
			});
		return $elm$core$List$reverse(
			A2(
				toTicks,
				A2($elm$core$List$range, 0, amount - 1),
				_List_Nil));
	});
var $terezka$intervals$Intervals$times = F3(
	function (zone, amount, range) {
		var toUnit = function (unit) {
			switch (unit) {
				case 0:
					return 0;
				case 1:
					return 1;
				case 2:
					return 2;
				case 3:
					return 3;
				case 4:
					return 4;
				case 5:
					return 5;
				default:
					return 6;
			}
		};
		var translateUnit = function (time) {
			return {
				gg: A2($elm$core$Maybe$map, toUnit, time.gg),
				dm: time.dm,
				hA: time.hA,
				iS: time.iS,
				i5: toUnit(time.i5),
				dU: time.dU
			};
		};
		var fromMs = function (ts) {
			return $elm$time$Time$millisToPosix(
				$elm$core$Basics$round(ts));
		};
		return A2(
			$elm$core$List$map,
			translateUnit,
			A4(
				$terezka$intervals$Intervals$Time$values,
				zone,
				amount,
				fromMs(range.dq),
				fromMs(range.eE)));
	});
var $terezka$elm_charts$Internal$Svg$times = function (zone) {
	return F2(
		function (i, b) {
			return A3(
				$terezka$intervals$Intervals$times,
				zone,
				i,
				{eE: b.eE, dq: b.dq});
		});
};
var $terezka$elm_charts$Chart$Svg$times = $terezka$elm_charts$Internal$Svg$times;
var $terezka$elm_charts$Chart$generateValues = F4(
	function (amount, tick, maybeFormat, axis) {
		var toTickValues = F2(
			function (toValue, toString) {
				return $elm$core$List$map(
					function (i) {
						return {
							u: function () {
								if (!maybeFormat.$) {
									var formatter = maybeFormat.a;
									return formatter(
										toValue(i));
								} else {
									return toString(i);
								}
							}(),
							aT: toValue(i)
						};
					});
			});
		switch (tick.$) {
			case 0:
				return A3(
					toTickValues,
					$elm$core$Basics$identity,
					$elm$core$String$fromFloat,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$floats, axis));
			case 1:
				return A3(
					toTickValues,
					$elm$core$Basics$toFloat,
					$elm$core$String$fromInt,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$ints, axis));
			default:
				var zone = tick.a;
				return A3(
					toTickValues,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$toFloat, $elm$time$Time$posixToMillis),
						function ($) {
							return $.iS;
						}),
					$terezka$elm_charts$Chart$Svg$formatTime(zone),
					A3(
						$terezka$elm_charts$Chart$Svg$generate,
						amount,
						$terezka$elm_charts$Chart$Svg$times(zone),
						axis));
		}
	});
var $elm$svg$Svg$foreignObject = $elm$svg$Svg$trustedNode('foreignObject');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $terezka$elm_charts$Internal$Svg$label = F4(
	function (plane, config, inner, point) {
		var _v0 = config.A;
		if (_v0.$ === 1) {
			var withOverflowWrap = function (el) {
				return config.C ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.G ? 'text-transform: uppercase;' : '';
			var fontStyle = function () {
				var _v5 = config.B;
				if (!_v5.$) {
					var size_ = _v5.a;
					return 'font-size: ' + ($elm$core$String$fromInt(size_) + 'px;');
				} else {
					return '';
				}
			}();
			var anchorStyle = function () {
				var _v1 = config.y;
				if (_v1.$ === 1) {
					return 'text-anchor: middle;';
				} else {
					switch (_v1.a) {
						case 0:
							var _v2 = _v1.a;
							return 'text-anchor: end;';
						case 1:
							var _v3 = _v1.a;
							return 'text-anchor: start;';
						default:
							var _v4 = _v1.a;
							return 'text-anchor: middle;';
					}
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.p,
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$stroke(config._),
							$elm$svg$Svg$Attributes$strokeWidth(
							$elm$core$String$fromFloat(config.ah)),
							$elm$svg$Svg$Attributes$fill(config.gm),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.F, point.fD, point.jf, config.w, config.x),
							$elm$svg$Svg$Attributes$style(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									['pointer-events: none;', fontStyle, anchorStyle, uppercaseStyle])))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$tspan, _List_Nil, inner)
						])));
		} else {
			var ellipsis = _v0.a;
			var xOffWithAnchor = function () {
				var _v11 = config.y;
				if (_v11.$ === 1) {
					return config.w - (ellipsis.fA / 2);
				} else {
					switch (_v11.a) {
						case 0:
							var _v12 = _v11.a;
							return config.w - ellipsis.fA;
						case 1:
							var _v13 = _v11.a;
							return config.w;
						default:
							var _v14 = _v11.a;
							return config.w - (ellipsis.fA / 2);
					}
				}
			}();
			var withOverflowWrap = function (el) {
				return config.C ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.G ? A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase') : A2($elm$html$Html$Attributes$style, '', '');
			var fontStyle = function () {
				var _v10 = config.B;
				if (!_v10.$) {
					var size_ = _v10.a;
					return A2(
						$elm$html$Html$Attributes$style,
						'font-size',
						$elm$core$String$fromInt(size_) + 'px');
				} else {
					return A2($elm$html$Html$Attributes$style, '', '');
				}
			}();
			var anchorStyle = function () {
				var _v6 = config.y;
				if (_v6.$ === 1) {
					return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
				} else {
					switch (_v6.a) {
						case 0:
							var _v7 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'right');
						case 1:
							var _v8 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'left');
						default:
							var _v9 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
					}
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.p,
					$elm$svg$Svg$foreignObject,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$class('elm-charts__html-label'),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromFloat(ellipsis.fA)),
							$elm$svg$Svg$Attributes$height(
							$elm$core$String$fromFloat(ellipsis.ep)),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.F, point.fD, point.jf, xOffWithAnchor, config.x - 10)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/1999/xhtml'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
									A2($elm$html$Html$Attributes$style, 'color', config.gm),
									fontStyle,
									uppercaseStyle,
									anchorStyle
								]),
							inner)
						])));
		}
	});
var $terezka$elm_charts$Chart$xLabels = function (edits) {
	var toTicks = F2(
		function (p, config) {
			return A4(
				$terezka$elm_charts$Chart$generateValues,
				config.as,
				config.aw,
				config.ac,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.R, p.fD));
		});
	var toTickValues = F3(
		function (p, config, ts) {
			return (!config.gT) ? ts : _Utils_update(
				ts,
				{
					ag: _Utils_ap(
						ts.ag,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aT;
							},
							A2(toTicks, p, config)))
				});
		});
	var toConfig = function (p) {
		return A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{as: 5, y: $elm$core$Maybe$Nothing, p: _List_Nil, gm: '#808BAB', A: $elm$core$Maybe$Nothing, s: false, B: $elm$core$Maybe$Nothing, ac: $elm$core$Maybe$Nothing, aw: $terezka$elm_charts$Internal$Svg$Floats, gT: false, C: false, R: _List_Nil, E: $terezka$elm_charts$Chart$Attributes$zero, F: 0, G: false, w: 0, x: 18});
	};
	return A3(
		$terezka$elm_charts$Chart$LabelsElement,
		toConfig,
		toTickValues,
		F2(
			function (p, config) {
				var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
				var toLabel = function (item) {
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						_Utils_update(
							_default,
							{
								y: config.y,
								p: config.p,
								gm: config.gm,
								A: config.A,
								B: config.B,
								C: config.C,
								F: config.F,
								G: config.G,
								w: config.w,
								x: config.s ? ((-config.x) + 10) : config.x
							}),
						_List_fromArray(
							[
								$elm$svg$Svg$text(item.u)
							]),
						{
							fD: item.aT,
							jf: config.E(p.jf)
						});
				};
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__x-labels')
						]),
					A2(
						$elm$core$List$map,
						toLabel,
						A2(toTicks, p, config)));
			}));
};
var $terezka$elm_charts$Chart$TicksElement = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $terezka$elm_charts$Chart$Attributes$length = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{H: v});
	};
};
var $terezka$elm_charts$Internal$Svg$defaultTick = {p: _List_Nil, gm: 'rgb(210, 210, 210)', H: 5, fA: 1};
var $terezka$elm_charts$Internal$Svg$tick = F4(
	function (plane, config, isX, point) {
		return A4(
			$terezka$elm_charts$Internal$Svg$withAttrs,
			config.p,
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__tick'),
					$elm$svg$Svg$Attributes$stroke(config.gm),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(config.fA)),
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(
						A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, point.fD))),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(
						A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, point.fD) + (isX ? 0 : (-config.H)))),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromFloat(
						A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, point.jf))),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(
						A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, point.jf) + (isX ? config.H : 0)))
				]),
			_List_Nil);
	});
var $terezka$elm_charts$Internal$Svg$xTick = F3(
	function (plane, config, point) {
		return A4($terezka$elm_charts$Internal$Svg$tick, plane, config, true, point);
	});
var $terezka$elm_charts$Chart$Svg$xTick = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$xTick,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultTick));
	});
var $terezka$elm_charts$Chart$xTicks = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{as: 5, gm: '', s: false, aw: $terezka$elm_charts$Internal$Svg$Floats, gT: true, ep: 5, R: _List_Nil, E: $terezka$elm_charts$Chart$Attributes$zero, fA: 1});
	var toTicks = function (p) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.aT;
			},
			A4(
				$terezka$elm_charts$Chart$generateValues,
				config.as,
				config.aw,
				$elm$core$Maybe$Nothing,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.R, p.fD)));
	};
	var addTickValues = F2(
		function (p, ts) {
			return (!config.gT) ? ts : _Utils_update(
				ts,
				{
					ag: _Utils_ap(
						ts.ag,
						toTicks(p))
				});
		});
	return A2(
		$terezka$elm_charts$Chart$TicksElement,
		addTickValues,
		function (p) {
			var toTick = function (x) {
				return A3(
					$terezka$elm_charts$Chart$Svg$xTick,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(config.gm),
							$terezka$elm_charts$Chart$Attributes$length(
							config.s ? (-config.ep) : config.ep),
							$terezka$elm_charts$Chart$Attributes$width(config.fA)
						]),
					{
						fD: x,
						jf: config.E(p.jf)
					});
			};
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__x-ticks')
					]),
				A2(
					$elm$core$List$map,
					toTick,
					toTicks(p)));
		});
};
var $terezka$elm_charts$Chart$Attributes$rotate = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{F: config.F + v});
	};
};
var $terezka$elm_charts$Chart$Attributes$y2 = function (v) {
	return function (config) {
		return _Utils_update(
			config,
			{
				dT: $elm$core$Maybe$Just(v)
			});
	};
};
var $terezka$elm_charts$Chart$yAxis = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{bx: true, gm: '', R: _List_Nil, E: $terezka$elm_charts$Chart$Attributes$zero, fA: 1});
	var addTickValues = F2(
		function (p, ts) {
			return _Utils_update(
				ts,
				{
					ch: A2(
						$elm$core$List$cons,
						config.E(p.fD),
						ts.ch)
				});
		});
	return A2(
		$terezka$elm_charts$Chart$AxisElement,
		addTickValues,
		function (p) {
			var yLimit = A2($terezka$elm_charts$Internal$Helpers$apply, config.R, p.jf);
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__y-axis')
					]),
				_List_fromArray(
					[
						A2(
						$terezka$elm_charts$Chart$Svg$line,
						p,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(config.gm),
								$terezka$elm_charts$Chart$Attributes$width(config.fA),
								$terezka$elm_charts$Chart$Attributes$x1(
								config.E(p.fD)),
								$terezka$elm_charts$Chart$Attributes$y1(
								A2($elm$core$Basics$max, p.jf.dq, yLimit.dq)),
								$terezka$elm_charts$Chart$Attributes$y2(
								A2($elm$core$Basics$min, p.jf.eE, yLimit.eE))
							])),
						config.bx ? A3(
						$terezka$elm_charts$Chart$Svg$arrow,
						p,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color(config.gm),
								$terezka$elm_charts$Chart$Attributes$rotate(-90)
							]),
						{
							fD: config.E(p.fD),
							jf: yLimit.eE
						}) : $elm$svg$Svg$text('')
					]));
		});
};
var $terezka$elm_charts$Internal$Svg$End = 0;
var $terezka$elm_charts$Internal$Svg$Start = 1;
var $terezka$elm_charts$Chart$yLabels = function (edits) {
	var toTicks = F2(
		function (p, config) {
			return A4(
				$terezka$elm_charts$Chart$generateValues,
				config.as,
				config.aw,
				config.ac,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.R, p.jf));
		});
	var toTickValues = F3(
		function (p, config, ts) {
			return (!config.gT) ? ts : _Utils_update(
				ts,
				{
					ar: _Utils_ap(
						ts.ar,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aT;
							},
							A2(toTicks, p, config)))
				});
		});
	var toConfig = function (p) {
		return A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{as: 5, y: $elm$core$Maybe$Nothing, p: _List_Nil, gm: '#808BAB', A: $elm$core$Maybe$Nothing, s: false, B: $elm$core$Maybe$Nothing, ac: $elm$core$Maybe$Nothing, aw: $terezka$elm_charts$Internal$Svg$Floats, gT: false, C: false, R: _List_Nil, E: $terezka$elm_charts$Chart$Attributes$zero, F: 0, G: false, w: -10, x: 3});
	};
	return A3(
		$terezka$elm_charts$Chart$LabelsElement,
		toConfig,
		toTickValues,
		F2(
			function (p, config) {
				var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
				var toLabel = function (item) {
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						_Utils_update(
							_default,
							{
								y: function () {
									var _v0 = config.y;
									if (_v0.$ === 1) {
										return $elm$core$Maybe$Just(
											config.s ? 1 : 0);
									} else {
										var anchor = _v0.a;
										return $elm$core$Maybe$Just(anchor);
									}
								}(),
								p: config.p,
								gm: config.gm,
								A: config.A,
								B: config.B,
								C: config.C,
								F: config.F,
								G: config.G,
								w: config.s ? (-config.w) : config.w,
								x: config.x
							}),
						_List_fromArray(
							[
								$elm$svg$Svg$text(item.u)
							]),
						{
							fD: config.E(p.fD),
							jf: item.aT
						});
				};
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__y-labels')
						]),
					A2(
						$elm$core$List$map,
						toLabel,
						A2(toTicks, p, config)));
			}));
};
var $terezka$elm_charts$Internal$Svg$yTick = F3(
	function (plane, config, point) {
		return A4($terezka$elm_charts$Internal$Svg$tick, plane, config, false, point);
	});
var $terezka$elm_charts$Chart$Svg$yTick = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$yTick,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultTick));
	});
var $terezka$elm_charts$Chart$yTicks = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{as: 5, gm: '', s: false, aw: $terezka$elm_charts$Internal$Svg$Floats, gT: true, ep: 5, R: _List_Nil, E: $terezka$elm_charts$Chart$Attributes$zero, fA: 1});
	var toTicks = function (p) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.aT;
			},
			A4(
				$terezka$elm_charts$Chart$generateValues,
				config.as,
				config.aw,
				$elm$core$Maybe$Nothing,
				A2($terezka$elm_charts$Internal$Helpers$apply, config.R, p.jf)));
	};
	var addTickValues = F2(
		function (p, ts) {
			return _Utils_update(
				ts,
				{
					ar: _Utils_ap(
						ts.ar,
						toTicks(p))
				});
		});
	return A2(
		$terezka$elm_charts$Chart$TicksElement,
		addTickValues,
		function (p) {
			var toTick = function (y) {
				return A3(
					$terezka$elm_charts$Chart$Svg$yTick,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(config.gm),
							$terezka$elm_charts$Chart$Attributes$length(
							config.s ? (-config.ep) : config.ep),
							$terezka$elm_charts$Chart$Attributes$width(config.fA)
						]),
					{
						fD: config.E(p.fD),
						jf: y
					});
			};
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__y-ticks')
					]),
				A2(
					$elm$core$List$map,
					toTick,
					toTicks(p)));
		});
};
var $author$project$Ziege$UI$Charts$diagram = function (data) {
	return A2(
		$terezka$elm_charts$Chart$chart,
		_List_fromArray(
			[
				$terezka$elm_charts$Chart$Attributes$height(300),
				$terezka$elm_charts$Chart$Attributes$width(720),
				$terezka$elm_charts$Chart$Attributes$domain(
				_List_fromArray(
					[
						A2($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$exactly),
						A2($terezka$elm_charts$Chart$Attributes$highest, 1, $terezka$elm_charts$Chart$Attributes$exactly)
					]))
			]),
		_List_fromArray(
			[
				$terezka$elm_charts$Chart$xLabels(
				_List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$amount(0)
					])),
				$terezka$elm_charts$Chart$yLabels(
				_List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$amount(0)
					])),
				$terezka$elm_charts$Chart$xTicks(
				_List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$amount(0)
					])),
				$terezka$elm_charts$Chart$yTicks(
				_List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$amount(0)
					])),
				$terezka$elm_charts$Chart$xAxis(_List_Nil),
				$terezka$elm_charts$Chart$yAxis(_List_Nil),
				A3(
				$terezka$elm_charts$Chart$bars,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$terezka$elm_charts$Chart$bar,
						function ($) {
							return $.jf;
						},
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$color('#FF7600')
							]))
					]),
				data)
			]));
};
var $author$project$Ziege$UI$Charts$buildChart = function (data) {
	return $mdgriffith$elm_ui$Element$html(
		A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ziege$UI$Charts$diagram(data)
				])));
};
var $author$project$Ziege$UI$ClientPerformance$buildChartData = function (succesMonthList) {
	var tupleToRecord = function (tuple) {
		return {jf: tuple.b};
	};
	return A2($elm$core$List$map, tupleToRecord, succesMonthList);
};
var $author$project$Ziege$UI$ClientPerformance$calcSuccessateforCompletionLogsinMonth = function (list) {
	var calcSuccessrate = function (log) {
		var times2do = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.cT;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.l;
						},
						$author$project$Ziege$TodoInterval$timesToBeDone)),
				log));
		return (!(!times2do)) ? ($elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.cm;
				},
				log)) / times2do) : 0;
	};
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapSecond(calcSuccessrate),
		list);
};
var $author$project$Ziege$UI$ClientPerformance$buildMonthPerformanceChart = F2(
	function (today, client) {
		return $author$project$Ziege$UI$Charts$buildChart(
			$author$project$Ziege$UI$ClientPerformance$buildChartData(
				$author$project$Ziege$UI$ClientPerformance$calcSuccessateforCompletionLogsinMonth(
					A2($author$project$Ziege$UI$ClientPerformance$allIntervalsInRollingYearMonths, client, today))));
	});
var $mdgriffith$elm_ui$Element$Font$italic = $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hj);
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Lazy$embed = function (x) {
	switch (x.$) {
		case 0:
			var html = x.a;
			return html;
		case 1:
			var styled = x.a;
			return styled.g0(
				A2(
					$mdgriffith$elm_ui$Internal$Model$OnlyDynamic,
					{
						gQ: {fX: $elm$core$Maybe$Nothing, f4: $elm$core$Maybe$Nothing, ii: $elm$core$Maybe$Nothing},
						g$: 1,
						hy: 0
					},
					styled.fj));
		case 2:
			var text = x.a;
			return $elm$core$Basics$always(
				$elm$virtual_dom$VirtualDom$text(text));
		default:
			return $elm$core$Basics$always(
				$elm$virtual_dom$VirtualDom$text(''));
	}
};
var $mdgriffith$elm_ui$Element$Lazy$apply2 = F3(
	function (fn, a, b) {
		return $mdgriffith$elm_ui$Element$Lazy$embed(
			A2(fn, a, b));
	});
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $mdgriffith$elm_ui$Element$Lazy$lazy2 = F3(
	function (fn, a, b) {
		return $mdgriffith$elm_ui$Internal$Model$Unstyled(
			A4($elm$virtual_dom$VirtualDom$lazy4, $mdgriffith$elm_ui$Element$Lazy$apply2, fn, a, b));
	});
var $author$project$Main$membershipHint = F2(
	function (client, membership) {
		_v0$4:
		while (true) {
			if (!membership.$) {
				switch (membership.a) {
					case 'invite':
						return $elm$core$Maybe$Just(
							_Utils_Tuple2('Die Einladung an ' + (client.m + ' ist noch nicht angenommen.'), 'Einladung erneut senden'));
					case 'leave':
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(client.m + ' hat die Einladung abgelehnt oder den Raum verlassen.', 'Erneut einladen'));
					case 'none':
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(client.m + ' ist nicht in den Raum eingeladen.', 'Einladen'));
					case 'ban':
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(client.m + ' ist aus dem Raum ausgeschlossen.', ''));
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Main$numberOfDoneTodayTodos = F2(
	function (today, client) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$author$project$Main$isDoneTodayToDo(today),
				client.v));
	});
var $author$project$Main$isDueToDo = F2(
	function (today, todo) {
		return A3($author$project$Ziege$TodoInterval$isDue, today, todo.l, todo.q);
	});
var $author$project$Main$todayTodo = F2(
	function (today, todo) {
		return A2($author$project$Main$isDoneTodayToDo, today, todo) || A2($author$project$Main$isDueToDo, today, todo);
	});
var $author$project$Main$todayTodos = F2(
	function (today, client) {
		return A2(
			$elm$core$List$filter,
			$author$project$Main$todayTodo(today),
			client.v);
	});
var $author$project$Main$buildClientListItem = F3(
	function (today, membership, _v0) {
		var id = _v0.a;
		var client = _v0.b;
		return $elm$core$String$isEmpty(client.i) ? A2(
			$author$project$Ziege$UI$Utils$listRow,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(13),
					$author$project$Ziege$UI$Colors$fg(5)
				]),
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$text(
					'Warten auf: ' + $author$project$Ziege$Model$describeClient(client))
				])) : A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			{
				u: A2(
					$author$project$Ziege$UI$Utils$listRow,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(5),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$alignTop
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$bold,
											$mdgriffith$elm_ui$Element$Font$size(15)
										]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(
											$author$project$Ziege$Model$describeClient(client))
										])),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(12),
											$author$project$Ziege$UI$Colors$fg(5)
										]),
									$mdgriffith$elm_ui$Element$text(
										'Heute: ' + ($elm$core$String$fromInt(
											A2($author$project$Main$numberOfDoneTodayTodos, today, client)) + (' von ' + ($elm$core$String$fromInt(
											$elm$core$List$length(
												A2($author$project$Main$todayTodos, today, client))) + ' erledigt'))))),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(12),
											$author$project$Ziege$UI$Colors$fg(5),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											A2($elm$html$Html$Attributes$style, 'overflow-wrap', 'anywhere'))
										]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(client.m)
										])),
									function () {
									var _v1 = A2($author$project$Main$membershipHint, client, membership);
									if (!_v1.$) {
										var _v2 = _v1.a;
										var hint = _v2.a;
										return A2(
											$mdgriffith$elm_ui$Element$paragraph,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$Font$size(12),
													$mdgriffith$elm_ui$Element$Font$italic
												]),
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$text(hint)
												]));
									} else {
										return $mdgriffith$elm_ui$Element$none;
									}
								}()
								])),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$alignRight,
									$mdgriffith$elm_ui$Element$alignTop,
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(110)),
									$author$project$Ziege$UI$Colors$bg(1),
									$mdgriffith$elm_ui$Element$Border$rounded(6),
									$mdgriffith$elm_ui$Element$clip
								]),
							A3($mdgriffith$elm_ui$Element$Lazy$lazy2, $author$project$Ziege$UI$ClientPerformance$buildMonthPerformanceChart, today, client)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$alignRight,
									$mdgriffith$elm_ui$Element$centerY,
									$author$project$Ziege$UI$Colors$fg(6)
								]),
							A2($author$project$Ziege$UI$Icons$buildFaIcon, 1, 'chevron-right'))
						])),
				aA: $elm$core$Maybe$Just(
					$author$project$Ziege$Model$SwitchActiveClient(id))
			});
	});
var $author$project$Main$clientMembership = F2(
	function (memberships, client) {
		return A2(
			$elm$core$Maybe$map,
			function (members) {
				return A2(
					$elm$core$Maybe$withDefault,
					'none',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.bj;
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (m) {
									return _Utils_eq(m.bu, client.m);
								},
								members))));
			},
			A2($elm$core$Dict$get, client.i, memberships));
	});
var $author$project$Main$buildClientList = F3(
	function (today, memberships, clients) {
		return $elm$core$Dict$isEmpty(clients) ? $mdgriffith$elm_ui$Element$none : $author$project$Ziege$UI$Utils$listCard(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var id = _v0.a;
					var client = _v0.b;
					return A3(
						$author$project$Main$buildClientListItem,
						today,
						A2($author$project$Main$clientMembership, memberships, client),
						_Utils_Tuple2(id, client));
				},
				$elm$core$Dict$toList(clients)));
	});
var $author$project$Ziege$Model$ToggleHelp = {$: 6};
var $author$project$Main$buildHelp = F2(
	function (mode, expanded) {
		var steps = (mode === 1) ? _List_fromArray(
			['Unter „Klient*in hinzufügen“ lädst du eine Klient*in ein; sie nimmt die Einladung in ihrer Ziege-App an.', 'Auf ihrer Seite legst du mit „Neues Ziel anlegen“ Ziele aus dem Katalog an, etwa „jeden Tag“ oder „2 mal pro Woche“.', 'Die Klient*in hakt ab, was sie geschafft hat. Hier, im Verlauf und im Performance-Bericht siehst du ihren Fortschritt.']) : _List_fromArray(
			['Deine Beratung legt Ziele gemeinsam mit dir an, etwa „jeden Tag“ oder „2 mal pro Woche“.', 'Unter „Heute“ steht, was gerade ansteht. Hast du ein Ziel geschafft, hake es ab.', 'Die rote Linie mit den Kreisen zeigt, wie oft du es im aktuellen Zeitraum schon geschafft hast; der dünne Balken, wie lange die Vereinbarung noch läuft.', 'Deine Beratung sieht deinen Fortschritt und kann Ziele anpassen.']);
		return expanded ? A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 8)
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(8),
						$mdgriffith$elm_ui$Element$padding(12),
						$author$project$Ziege$UI$Colors$bg(1),
						$mdgriffith$elm_ui$Element$Border$rounded(10),
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$Font$size(15)
							]),
						$mdgriffith$elm_ui$Element$text('So funktioniert Ziege')),
					_Utils_ap(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, step) {
									return A2(
										$mdgriffith$elm_ui$Element$row,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$spacing(8)
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$alignTop,
														$mdgriffith$elm_ui$Element$Font$bold,
														$author$project$Ziege$UI$Colors$fg(2)
													]),
												$mdgriffith$elm_ui$Element$text(
													$elm$core$String$fromInt(i + 1) + '.')),
												A2(
												$mdgriffith$elm_ui$Element$paragraph,
												_List_Nil,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text(step)
													]))
											]));
								}),
							steps),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$button,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$underline,
										$author$project$Ziege$UI$Colors$fg(11)
									]),
								{
									u: $mdgriffith$elm_ui$Element$text('Ausblenden'),
									aA: $elm$core$Maybe$Just($author$project$Ziege$Model$ToggleHelp)
								})
							]))))) : A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$paddingEach(
					{X: 2, a$: 16, a4: 16, aS: 10}),
					$mdgriffith$elm_ui$Element$Font$size(14),
					$author$project$Ziege$UI$Colors$fg(11)
				]),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(8)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$paddingEach(
									_Utils_update(
										$author$project$Ziege$UI$Utils$edges,
										{a4: 2}))
								]),
							A2($author$project$Ziege$UI$Icons$buildFaIcon, 0, 'circle-question')),
							$mdgriffith$elm_ui$Element$text('So funktioniert Ziege')
						])),
				aA: $elm$core$Maybe$Just($author$project$Ziege$Model$ToggleHelp)
			});
	});
var $mdgriffith$elm_ui$Element$Lazy$apply3 = F4(
	function (fn, a, b, c) {
		return $mdgriffith$elm_ui$Element$Lazy$embed(
			A3(fn, a, b, c));
	});
var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var $mdgriffith$elm_ui$Element$Lazy$lazy3 = F4(
	function (fn, a, b, c) {
		return $mdgriffith$elm_ui$Internal$Model$Unstyled(
			A5($elm$virtual_dom$VirtualDom$lazy5, $mdgriffith$elm_ui$Element$Lazy$apply3, fn, a, b, c));
	});
var $author$project$Main$buildStartView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(12),
				$mdgriffith$elm_ui$Element$paddingEach(
				_Utils_update(
					$author$project$Ziege$UI$Utils$edges,
					{X: 10}))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Main$buildHelp,
				1,
				!_Utils_eq(
					model.bg,
					$elm$core$Dict$isEmpty(model.c))),
				A3(
				$mdgriffith$elm_ui$Element$Lazy$lazy2,
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ziege$UI$Utils$sectionHeader,
						'Klient*innen',
						$elm$core$String$fromInt(
							$elm$core$Dict$size(model.c))),
						A4($mdgriffith$elm_ui$Element$Lazy$lazy3, $author$project$Main$buildClientList, model.af, model.aQ, model.c)
					])),
				$author$project$Ziege$UI$Utils$actionPanel(
				_List_fromArray(
					[
						A2(
						$author$project$Ziege$UI$Button$buildWideButton,
						'Klient*in hinzufügen',
						$author$project$Ziege$Model$SwitchView($author$project$Ziege$Model$AddClientView))
					]))
			]));
};
var $author$project$Main$counsellorsGone = function (model) {
	var room = $author$project$Main$ownClientRoom(model);
	return ((!(!model.g)) || $elm$core$String$isEmpty(room)) ? $elm$core$Maybe$Nothing : A2(
		$elm$core$Maybe$andThen,
		function (members) {
			return A2(
				$elm$core$List$any,
				function (m) {
					return m.bj === 'join';
				},
				members) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.I;
					},
					A2(
						$elm$core$List$filter,
						function (m) {
							return (m.bj === 'leave') || (m.bj === 'ban');
						},
						members)));
		},
		A2($elm$core$Dict$get, room, model.aQ));
};
var $author$project$Ziege$UI$Colors$Overlay = 17;
var $author$project$Ziege$UI$CryptoPanel$busyPart = function (status) {
	return status.gd ? _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[$mdgriffith$elm_ui$Element$Font$italic]),
			$mdgriffith$elm_ui$Element$text('Bitte warten …'))
		]) : _List_Nil;
};
var $author$project$Ziege$UI$CryptoPanel$cryptoNeedsAttention = function (status) {
	return (!_Utils_eq(status.i9, $elm$core$Maybe$Nothing)) || ((status.e$ !== '') || ((status.d_ !== '') || ((status.ed !== '') || ((status.bn === 2) && status.gd))));
};
var $author$project$Ziege$UI$CryptoPanel$closePart = function (status) {
	return $author$project$Ziege$UI$CryptoPanel$cryptoNeedsAttention(status) ? _List_Nil : _List_fromArray(
		[
			A2($author$project$Ziege$UI$Button$buildWideButton, 'Schließen', $author$project$Ziege$Model$ToggleCryptoPanel)
		]);
};
var $author$project$Ziege$UI$CryptoPanel$devicesPart = F4(
	function (status, ownUserId, ownDeviceId, ownDevices) {
		return ((status.bn === 4) || (status.bn === 3)) ? _List_fromArray(
			[
				A4($author$project$Ziege$UI$DeviceList$buildDeviceList, 'Meine Apps', ownUserId, ownDeviceId, ownDevices)
			]) : _List_Nil;
	});
var $author$project$Ziege$Model$CryptoAction = function (a) {
	return {$: 60, a: a};
};
var $author$project$Ziege$UI$CryptoPanel$errorPart = function (status) {
	return (status.ed === '') ? _List_Nil : _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$author$project$Ziege$UI$Colors$borderColor(14),
					$author$project$Ziege$UI$Colors$fg(14)
				]),
			_List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para(status.ed),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'OK',
					$author$project$Ziege$Model$CryptoAction('dismissError'))
				]))
		]);
};
var $author$project$Ziege$UI$CryptoPanel$buttonRow = $mdgriffith$elm_ui$Element$row(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$spacing(10)
		]));
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $mdgriffith$elm_ui$Element$newTabLink = F2(
	function (attrs, _v0) {
		var label = _v0.u;
		var url = _v0.aH;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Attributes$target('_blank')),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.cs + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.aY + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eD)))),
									attrs)))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $author$project$Ziege$UI$CryptoPanel$approvalPart = function (url) {
	return _List_fromArray(
		[
			$author$project$Ziege$UI$CryptoPanel$para('Zum Zurücksetzen der Verschlüsselung ist eine Bestätigung in der Kontoverwaltung nötig. Sie gilt 10 Minuten.'),
			A2(
			$mdgriffith$elm_ui$Element$newTabLink,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$underline,
					$author$project$Ziege$UI$Colors$fg(11)
				]),
			{
				u: $mdgriffith$elm_ui$Element$text('Kontoverwaltung öffnen'),
				aH: url
			}),
			$author$project$Ziege$UI$CryptoPanel$para('Nach der Bestätigung dort hier weitermachen:'),
			$author$project$Ziege$UI$CryptoPanel$buttonRow(
			_List_fromArray(
				[
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Bestätigt, weiter',
					$author$project$Ziege$Model$CryptoAction('approvalDone')),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Abbrechen',
					$author$project$Ziege$Model$CryptoAction('approvalCancelled'))
				]))
		]);
};
var $author$project$Ziege$Model$RecoveryKeyInputChanged = function (a) {
	return {$: 61, a: a};
};
var $author$project$Ziege$Model$SubmitRecoveryKey = {$: 62};
var $author$project$Ziege$Model$RequestCryptoReset = function (a) {
	return {$: 63, a: a};
};
var $author$project$Ziege$UI$CryptoPanel$resetPart = function (resetRequested) {
	return resetRequested ? _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$author$project$Ziege$UI$Colors$borderColor(14)
				]),
			_List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Beim Zurücksetzen entstehen neue Schlüssel und ein neuer Recovery-Key. Ältere Nachrichten sind danach nur noch in Apps lesbar, die ihre Schlüssel schon haben; alle anderen eigenen Apps müssen neu verifiziert werden.'),
					$author$project$Ziege$UI$CryptoPanel$buttonRow(
					_List_fromArray(
						[
							A2(
							$author$project$Ziege$UI$Button$buildDangerButton,
							'Ja, zurücksetzen',
							$author$project$Ziege$Model$CryptoAction('resetIdentity')),
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Abbrechen',
							$author$project$Ziege$Model$RequestCryptoReset(false))
						]))
				]))
		]) : _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Font$size(14),
					$mdgriffith$elm_ui$Element$Font$underline
				]),
			{
				u: A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Keine andere App und kein Recovery-Key mehr? Verschlüsselung zurücksetzen')
						])),
				aA: $elm$core$Maybe$Just(
					$author$project$Ziege$Model$RequestCryptoReset(true))
			})
		]);
};
var $author$project$Ziege$UI$CryptoPanel$unverifiedPart = F2(
	function (recoveryKeyInput, resetRequested) {
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Diese App ist noch nicht verifiziert und kann Nachrichten deshalb weder lesen noch senden.'),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$paddingEach(
							{X: 0, a$: 0, a4: 0, aS: 6})
						]),
					$mdgriffith$elm_ui$Element$text('Mit einer anderen App')),
					$author$project$Ziege$UI$CryptoPanel$para('Symbole mit einer schon verifizierten App vergleichen, z. B. Ziege auf einem anderen Gerät oder Element.'),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Mit anderer App verifizieren',
					$author$project$Ziege$Model$CryptoAction('verify')),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$paddingEach(
							{X: 0, a$: 0, a4: 0, aS: 6})
						]),
					$mdgriffith$elm_ui$Element$text('Mit dem Recovery-Key')),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(8)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$Input$text,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$padding(10)
								]),
							{
								u: $mdgriffith$elm_ui$Element$Input$labelHidden('Recovery-Key'),
								an: $author$project$Ziege$Model$RecoveryKeyInputChanged,
								b9: $elm$core$Maybe$Just(
									A2(
										$mdgriffith$elm_ui$Element$Input$placeholder,
										_List_Nil,
										$mdgriffith$elm_ui$Element$text('EsTc 1234 …'))),
								K: recoveryKeyInput
							}),
							A2($author$project$Ziege$UI$Button$buildButton, 'Freischalten', $author$project$Ziege$Model$SubmitRecoveryKey)
						]))
				]),
			$author$project$Ziege$UI$CryptoPanel$resetPart(resetRequested));
	});
var $author$project$Ziege$UI$CryptoPanel$phasePart = F3(
	function (status, recoveryKeyInput, resetRequested) {
		var _v0 = status.bn;
		switch (_v0) {
			case 0:
				return _List_fromArray(
					[
						$author$project$Ziege$UI$CryptoPanel$para('Die Verschlüsselung wird vorbereitet …')
					]);
			case 1:
				return _List_fromArray(
					[
						$author$project$Ziege$UI$CryptoPanel$para('In dieser App steht die Verschlüsselung nicht zur Verfügung. Nachrichten können nicht gelesen oder gesendet werden.')
					]);
			case 2:
				return status.gd ? _List_fromArray(
					[
						$author$project$Ziege$UI$CryptoPanel$para('Die Verschlüsselung wird für dieses Konto eingerichtet …')
					]) : _List_fromArray(
					[
						$author$project$Ziege$UI$CryptoPanel$para('Für dieses Konto ist die Verschlüsselung noch nicht eingerichtet.'),
						A2(
						$author$project$Ziege$UI$Button$buildWideButton,
						'Jetzt einrichten',
						$author$project$Ziege$Model$CryptoAction('setup'))
					]);
			case 3:
				return A2($author$project$Ziege$UI$CryptoPanel$unverifiedPart, recoveryKeyInput, resetRequested);
			default:
				return _List_fromArray(
					[
						$author$project$Ziege$UI$CryptoPanel$para('Diese App ist verifiziert.'),
						$author$project$Ziege$UI$CryptoPanel$para(
						status.d0 ? 'Schlüssel werden im Backup gesichert.' : 'Achtung: Es ist kein Schlüssel-Backup aktiv.'),
						A2(
						$author$project$Ziege$UI$Button$buildWideButton,
						'Andere App verifizieren',
						$author$project$Ziege$Model$CryptoAction('verify'))
					]);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $elm$core$String$words = _String_words;
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.I;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Element$Font$family = function (families) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontFamily,
		A2(
			$mdgriffith$elm_ui$Internal$Model$FontFamily,
			A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'ff-', families),
			families));
};
var $mdgriffith$elm_ui$Internal$Model$Monospace = {$: 2};
var $mdgriffith$elm_ui$Element$Font$monospace = $mdgriffith$elm_ui$Internal$Model$Monospace;
var $author$project$Ziege$UI$CryptoPanel$recoveryKeyPart = F2(
	function (key, replaced) {
		return _Utils_ap(
			replaced ? _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$bold,
							$author$project$Ziege$UI$Colors$fg(14)
						]),
					$author$project$Ziege$UI$CryptoPanel$para('Die Einrichtung musste wiederholt werden. Ein zuvor notierter Recovery-Key gilt nicht mehr, bitte durch diesen ersetzen.'))
				]) : _List_Nil,
			_List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Das ist der Recovery-Key für dieses Konto. Mit ihm lässt sich Ziege in einer neuen App freischalten, wenn keine andere App zur Hand ist.'),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(10),
							$author$project$Ziege$UI$Colors$bg(1),
							$mdgriffith$elm_ui$Element$Font$family(
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$Font$monospace])),
							$mdgriffith$elm_ui$Element$Font$size(15)
						]),
					A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(key)
							]))),
					$author$project$Ziege$UI$CryptoPanel$para('Bitte notieren und sicher aufbewahren. Er wird nicht noch einmal angezeigt.'),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Ist sicher notiert',
					$author$project$Ziege$Model$CryptoAction('recoveryKeySaved'))
				]));
	});
var $author$project$Ziege$UI$CryptoPanel$emojiCell = function (sasEmoji) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(80)),
				$mdgriffith$elm_ui$Element$spacing(4)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Font$size(36)
					]),
				$mdgriffith$elm_ui$Element$text(sasEmoji.gE)),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Font$size(12)
					]),
				$mdgriffith$elm_ui$Element$text(sasEmoji.I))
			]));
};
var $author$project$Ziege$UI$CryptoPanel$verificationPart = function (verification) {
	var otherApp = (verification.hS === '') ? 'einer anderen App' : ('der App ' + verification.hS);
	var _v0 = verification.bn;
	switch (_v0) {
		case 0:
			return _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Anfrage von ' + (otherApp + ': Die beiden Apps sollen sich gegenseitig verifizieren.')),
					$author$project$Ziege$UI$CryptoPanel$buttonRow(
					_List_fromArray(
						[
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Annehmen',
							$author$project$Ziege$Model$CryptoAction('acceptVerification')),
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Ablehnen',
							$author$project$Ziege$Model$CryptoAction('cancelVerification'))
						]))
				]);
		case 1:
			return verification.hU ? _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Bitte in der anderen App die Verifikation annehmen und dort den Vergleich mit Emojis wählen. Die andere App sollte dabei geöffnet sein.'),
					$author$project$Ziege$UI$CryptoPanel$para('Erscheint dort keine Anfrage, hilft meist ein neuer Versuch.'),
					$author$project$Ziege$UI$CryptoPanel$buttonRow(
					_List_fromArray(
						[
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Nochmal probieren',
							$author$project$Ziege$Model$CryptoAction('verify')),
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Abbrechen',
							$author$project$Ziege$Model$CryptoAction('cancelVerification'))
						]))
				]) : _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Bitte in der anderen App die Verifikation annehmen und dort den Vergleich mit Emojis wählen.'),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Abbrechen',
					$author$project$Ziege$Model$CryptoAction('cancelVerification'))
				]);
		case 2:
			return _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Erscheinen in ' + (otherApp + ' dieselben Symbole in derselben Reihenfolge?')),
					A2(
					$mdgriffith$elm_ui$Element$wrappedRow,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(12),
							$mdgriffith$elm_ui$Element$centerX
						]),
					A2($elm$core$List$map, $author$project$Ziege$UI$CryptoPanel$emojiCell, verification.gF)),
					$author$project$Ziege$UI$CryptoPanel$buttonRow(
					_List_fromArray(
						[
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Stimmen überein',
							$author$project$Ziege$Model$CryptoAction('confirmEmojis')),
							A2(
							$author$project$Ziege$UI$Button$buildWideButton,
							'Stimmen nicht überein',
							$author$project$Ziege$Model$CryptoAction('rejectEmojis'))
						]))
				]);
		case 3:
			return _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Bestätigt. Warte auf die andere App …')
				]);
		case 4:
			return _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para('Die Apps sind verifiziert. Schlüssel werden jetzt ausgetauscht.'),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Schließen',
					$author$project$Ziege$Model$CryptoAction('closeVerification'))
				]);
		default:
			return _List_fromArray(
				[
					$author$project$Ziege$UI$CryptoPanel$para(verification.ht),
					A2(
					$author$project$Ziege$UI$Button$buildWideButton,
					'Schließen',
					$author$project$Ziege$Model$CryptoAction('closeVerification'))
				]);
	}
};
var $author$project$Ziege$UI$CryptoPanel$mainPart = F3(
	function (status, recoveryKeyInput, resetRequested) {
		if (status.d_ !== '') {
			return $author$project$Ziege$UI$CryptoPanel$approvalPart(status.d_);
		} else {
			if (status.e$ !== '') {
				return A2($author$project$Ziege$UI$CryptoPanel$recoveryKeyPart, status.e$, status.e0);
			} else {
				var _v0 = status.i9;
				if (!_v0.$) {
					var verification = _v0.a;
					return $author$project$Ziege$UI$CryptoPanel$verificationPart(verification);
				} else {
					return A3($author$project$Ziege$UI$CryptoPanel$phasePart, status, recoveryKeyInput, resetRequested);
				}
			}
		}
	});
var $author$project$Ziege$UI$CryptoPanel$buildCryptoPanel = F6(
	function (status, ownUserId, ownDeviceId, recoveryKeyInput, resetRequested, ownDevices) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$Ziege$UI$Colors$bg(17),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0)
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$width(
						A2($mdgriffith$elm_ui$Element$maximum, 380, $mdgriffith$elm_ui$Element$fill)),
						$mdgriffith$elm_ui$Element$height(
						A2($mdgriffith$elm_ui$Element$maximum, 600, $mdgriffith$elm_ui$Element$shrink)),
						$mdgriffith$elm_ui$Element$scrollbarY,
						$author$project$Ziege$UI$Colors$bg(0),
						$mdgriffith$elm_ui$Element$padding(15),
						$mdgriffith$elm_ui$Element$spacing(12),
						$mdgriffith$elm_ui$Element$Font$size(16),
						$mdgriffith$elm_ui$Element$Border$rounded(10),
						$author$project$Ziege$UI$Colors$borderColor(11),
						$mdgriffith$elm_ui$Element$Border$shadow(
						{
							f2: 5.0,
							gm: A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.25),
							hK: _Utils_Tuple2(0, 1),
							il: 2.0
						})
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$spacing(4)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(20),
											$mdgriffith$elm_ui$Element$Font$bold
										]),
									$mdgriffith$elm_ui$Element$text('Verschlüsselung')),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(13),
											$author$project$Ziege$UI$Colors$fg(5)
										]),
									$mdgriffith$elm_ui$Element$text('Konto: ' + ownUserId)),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$size(13),
											$author$project$Ziege$UI$Colors$fg(5)
										]),
									$mdgriffith$elm_ui$Element$text('Geräte-ID: ' + ownDeviceId))
								]))
						]),
					_Utils_ap(
						$author$project$Ziege$UI$CryptoPanel$errorPart(status),
						_Utils_ap(
							A3($author$project$Ziege$UI$CryptoPanel$mainPart, status, recoveryKeyInput, resetRequested),
							_Utils_ap(
								$author$project$Ziege$UI$CryptoPanel$busyPart(status),
								_Utils_ap(
									$author$project$Ziege$UI$CryptoPanel$closePart(status),
									A4($author$project$Ziege$UI$CryptoPanel$devicesPart, status, ownUserId, ownDeviceId, ownDevices))))))));
	});
var $author$project$Main$cryptoPanelAttribs = function (model) {
	return (model.bd || $author$project$Ziege$UI$CryptoPanel$cryptoNeedsAttention(model.aM)) ? _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$inFront(
			A6(
				$author$project$Ziege$UI$CryptoPanel$buildCryptoPanel,
				model.aM,
				model.n,
				model.cG,
				model.bH,
				model.aZ,
				A2($elm$core$Dict$get, model.n, model.aN)))
		]) : _List_Nil;
};
var $author$project$Ziege$Model$DownloadLastStatus = function (a) {
	return {$: 40, a: a};
};
var $author$project$Ziege$Pattern$hasFeature = F2(
	function (f, resp) {
		if (!resp.$) {
			var data = resp.a;
			return A2($elm$core$List$member, f, data.cz);
		} else {
			var data = resp.a;
			return A2($elm$core$List$member, f, data.cz);
		}
	});
var $author$project$Main$debugTools = F2(
	function (model, client) {
		var enabled = function () {
			var _v0 = model.N;
			if (_v0.$ === 2) {
				var p = _v0.a;
				return A2($author$project$Ziege$Pattern$hasFeature, 1, p);
			} else {
				return false;
			}
		}();
		return (!enabled) ? _List_Nil : (A2($elm$core$Dict$member, client.i, model.b4) ? _List_fromArray(
			[
				A2(
				$author$project$Ziege$UI$Button$buildWideButton,
				'Letzten Stand als .json herunterladen',
				$author$project$Ziege$Model$DownloadLastStatus(client.i))
			]) : _List_fromArray(
			[
				$author$project$Ziege$UI$Utils$fieldHint('Aus diesem Raum ist noch kein Stand angekommen.')
			]));
	});
var $author$project$Ziege$UI$CryptoPanel$cryptoDescription = function (status) {
	var _v0 = status.bn;
	switch (_v0) {
		case 4:
			return status.d0 ? 'diese App ist verifiziert, Schlüssel-Backup aktiv' : 'diese App ist verifiziert, kein Schlüssel-Backup';
		case 3:
			return 'diese App ist nicht verifiziert';
		case 2:
			return 'wird eingerichtet';
		case 0:
			return 'startet';
		default:
			return 'nicht verfügbar';
	}
};
var $author$project$BuildInfo$gitHash = 'v2.12.4';
var $author$project$Main$aboutInfo = function (model) {
	return {
		a9: model.a9,
		gc: model.aI + (' (Build ' + ($author$project$BuildInfo$gitHash + ')')),
		bY: model.cG,
		gG: $author$project$Ziege$UI$CryptoPanel$cryptoDescription(model.aM),
		ho: function () {
			var _v0 = model.N;
			if (_v0.$ === 3) {
				var s = _v0.a;
				return $elm$core$Maybe$Just(s);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		m: model.n,
		dB: (model.g === 1) ? 'Berater*in' : 'Klient*in'
	};
};
var $author$project$Ziege$Model$ShowCryptoPanel = {$: 59};
var $author$project$Ziege$UI$About$accountPart = function (url) {
	return $elm$core$String$isEmpty(url) ? _List_Nil : _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(4)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$newTabLink,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$underline,
							$mdgriffith$elm_ui$Element$Font$size(16),
							$author$project$Ziege$UI$Colors$fg(11)
						]),
					{
						u: $mdgriffith$elm_ui$Element$text('Kontoverwaltung öffnen'),
						aH: url
					}),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(12),
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Passwort, E-Mail-Adresse und angemeldete Geräte, in einem neuen Tab')
						]))
				]))
		]);
};
var $author$project$Ziege$Model$RequestLogout = function (a) {
	return {$: 53, a: a};
};
var $author$project$Ziege$UI$About$buttons = A2(
	$mdgriffith$elm_ui$Element$row,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$spacing(10),
			$mdgriffith$elm_ui$Element$paddingEach(
			{X: 0, a$: 0, a4: 0, aS: 10})
		]),
	_List_fromArray(
		[
			A2($author$project$Ziege$UI$Button$buildWideButton, 'Schließen', $author$project$Ziege$Model$ToggleGoatMode),
			A2(
			$author$project$Ziege$UI$Button$buildDangerButton,
			'Abmelden',
			$author$project$Ziege$Model$RequestLogout(true))
		]));
var $author$project$Ziege$UI$About$field = F2(
	function (label, value) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(2),
					A2($mdgriffith$elm_ui$Element$paddingXY, 0, 8),
					$mdgriffith$elm_ui$Element$Border$widthEach(
					{X: 1, a$: 0, a4: 0, aS: 0}),
					$author$project$Ziege$UI$Colors$borderColor(8)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(12),
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					$mdgriffith$elm_ui$Element$text(label)),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(16)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(value)
						]))
				]));
	});
var $author$project$Ziege$Model$Logout = {$: 54};
var $author$project$Ziege$UI$About$logoutConfirmation = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$padding(10),
				$mdgriffith$elm_ui$Element$Border$width(2),
				$mdgriffith$elm_ui$Element$Border$rounded(4),
				$author$project$Ziege$UI$Colors$borderColor(12)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$Font$bold]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Wirklich abmelden?')
					])),
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_Nil,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Beim Abmelden löscht Ziege alles, was auf diesem Gerät gespeichert ist, auch die Schlüssel. Um die Nachrichten nach einer neuen Anmeldung wieder lesen zu können, braucht es dann eine andere, schon verifizierte App oder den Recovery-Key.')
					])),
				A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ziege$UI$Button$buildWideButton,
						'Abbrechen',
						$author$project$Ziege$Model$RequestLogout(false)),
						A2($author$project$Ziege$UI$Button$buildDangerButton, 'Ja, abmelden', $author$project$Ziege$Model$Logout)
					]))
			]))
	]);
var $author$project$Ziege$UI$About$buildAboutPanel = F2(
	function (info, logoutRequested) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$Ziege$UI$Colors$bg(17),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0)
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$width(
						A2($mdgriffith$elm_ui$Element$maximum, 380, $mdgriffith$elm_ui$Element$fill)),
						$mdgriffith$elm_ui$Element$height(
						A2($mdgriffith$elm_ui$Element$maximum, 640, $mdgriffith$elm_ui$Element$shrink)),
						$mdgriffith$elm_ui$Element$scrollbarY,
						$author$project$Ziege$UI$Colors$bg(0),
						$mdgriffith$elm_ui$Element$padding(15),
						$mdgriffith$elm_ui$Element$spacing(15),
						$mdgriffith$elm_ui$Element$Border$rounded(10),
						$author$project$Ziege$UI$Colors$borderColor(11),
						$mdgriffith$elm_ui$Element$Border$shadow(
						{
							f2: 5.0,
							gm: A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.25),
							hK: _Utils_Tuple2(0, 1),
							il: 2.0
						})
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(20),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							$mdgriffith$elm_ui$Element$text('ZieGE')),
							A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2($author$project$Ziege$UI$About$field, 'Rolle', info.dB),
										A2($author$project$Ziege$UI$About$field, 'Matrix-ID', info.m),
										A2($author$project$Ziege$UI$About$field, 'Geräte-ID', info.bY),
										A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$spacing(10),
												$mdgriffith$elm_ui$Element$paddingEach(
												{X: 4, a$: 0, a4: 0, aS: 0})
											]),
										_List_fromArray(
											[
												A2($author$project$Ziege$UI$About$field, 'Verschlüsselung', info.gG),
												A2($author$project$Ziege$UI$Button$buildWideButton, 'Verschlüsselung und Geräte', $author$project$Ziege$Model$ShowCryptoPanel)
											])),
										A2($author$project$Ziege$UI$About$field, 'Version', info.gc)
									]),
								function () {
									var _v0 = info.ho;
									if (!_v0.$) {
										var loadError = _v0.a;
										return _List_fromArray(
											[
												A2($author$project$Ziege$UI$About$field, 'Fehler beim Laden der Ziele', loadError)
											]);
									} else {
										return _List_Nil;
									}
								}()))
						]),
					_Utils_ap(
						$author$project$Ziege$UI$About$accountPart(info.a9),
						logoutRequested ? $author$project$Ziege$UI$About$logoutConfirmation : _List_fromArray(
							[$author$project$Ziege$UI$About$buttons])))));
	});
var $author$project$Main$extraLayoutAttribs = function (model) {
	return model.aJ ? _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$inFront(
			A2(
				$author$project$Ziege$UI$About$buildAboutPanel,
				$author$project$Main$aboutInfo(model),
				model.bB))
		]) : _List_Nil;
};
var $author$project$Ziege$Pattern$getLogo = function (p) {
	if (!p.$) {
		return '';
	} else {
		var data = p.a;
		return data.al;
	}
};
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	fX: $elm$core$Maybe$Nothing,
	f4: $elm$core$Maybe$Nothing,
	ii: $elm$core$Maybe$Just(
		{
			f2: 0,
			gm: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			hK: _Utils_Tuple2(0, 0),
			il: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.g$;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								g$: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.gQ;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								gQ: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.hy;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								hy: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			gQ: function () {
				var _v0 = record.gQ;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			g$: function () {
				var _v1 = record.g$;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			hy: function () {
				var _v2 = record.hy;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{gQ: $elm$core$Maybe$Nothing, g$: $elm$core$Maybe$Nothing, hy: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var html = el.a.g0;
				var styles = el.a.fj;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.hy;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.hQ;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.h3, $mdgriffith$elm_ui$Internal$Style$classes.fT, $mdgriffith$elm_ui$Internal$Style$classes.ik]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $mdgriffith$elm_ui$Element$layout = $mdgriffith$elm_ui$Element$layoutWith(
	{hQ: _List_Nil});
var $mdgriffith$elm_ui$Internal$Model$map = F2(
	function (fn, el) {
		switch (el.$) {
			case 1:
				var styled = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						g0: F2(
							function (add, context) {
								return A2(
									$elm$virtual_dom$VirtualDom$map,
									fn,
									A2(styled.g0, add, context));
							}),
						fj: styled.fj
					});
			case 0:
				var html = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A2(
						$elm$core$Basics$composeL,
						$elm$virtual_dom$VirtualDom$map(fn),
						html));
			case 2:
				var str = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Text(str);
			default:
				return $mdgriffith$elm_ui$Internal$Model$Empty;
		}
	});
var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
var $author$project$Ziege$Model$RequestNotificationPermission = {$: 73};
var $author$project$Ziege$UI$NotificationRequestor$buildNotificationBanner = function (permission) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$padding(10),
				$author$project$Ziege$UI$Colors$bg(12),
				$author$project$Ziege$UI$Colors$fg(13),
				$mdgriffith$elm_ui$Element$Font$size(14)
			]),
		function () {
			switch (permission) {
				case 'prompt':
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$Font$bold]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Die Ziege muss meckern können.')
								])),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Für Erinnerungen und Nachrichten braucht Ziege Benachrichtigungen.')
								])),
							A2(
							$mdgriffith$elm_ui$Element$Input$button,
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Element$paddingXY, 12, 8),
									$mdgriffith$elm_ui$Element$Border$width(1),
									$mdgriffith$elm_ui$Element$Border$rounded(4),
									$author$project$Ziege$UI$Colors$borderColor(13),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							{
								u: $mdgriffith$elm_ui$Element$text('Benachrichtigungen einschalten'),
								aA: $elm$core$Maybe$Just($author$project$Ziege$Model$RequestNotificationPermission)
							})
						]);
				case 'denied':
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$Font$bold]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Benachrichtigungen sind für Ziege blockiert.')
								])),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Ohne sie kommen keine Erinnerungen. Erlauben lassen sie sich in den Einstellungen der Website bzw. der App.')
								]))
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$Font$bold]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('In diesem Browser gibt es keine Benachrichtigungen.')
								])),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Auf dem iPhone gehen sie, wenn Ziege über „Zum Home-Bildschirm“ als App installiert ist.')
								]))
						]);
			}
		}());
};
var $author$project$Main$notificationBanner = function (model) {
	var topLevel = function () {
		var _v0 = _Utils_Tuple2(model.g, model.f);
		_v0$2:
		while (true) {
			switch (_v0.a) {
				case 1:
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				case 0:
					if (!_v0.b.$) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	}();
	return (topLevel && ((model.ay !== 'granted') && (model.ay !== 'waiting'))) ? _List_fromArray(
		[
			$author$project$Ziege$UI$NotificationRequestor$buildNotificationBanner(model.ay)
		]) : _List_Nil;
};
var $author$project$Ziege$Model$ReloadApp = {$: 39};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Main$outdatedBanner = function (model) {
	return $elm$core$Set$isEmpty(model.bG) ? _List_Nil : _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$padding(10),
					$author$project$Ziege$UI$Colors$bg(22),
					$author$project$Ziege$UI$Colors$fg(23),
					$mdgriffith$elm_ui$Element$Font$size(14)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$Font$bold]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Diese Ziege ist nicht mehr aktuell.')
						])),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_Nil,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Ein neuerer Stand ist da, den diese Version nicht lesen kann. Bis Ziege neu geladen ist, werden keine Änderungen gesendet.')
						])),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Element$paddingXY, 12, 8),
							$mdgriffith$elm_ui$Element$Border$width(1),
							$mdgriffith$elm_ui$Element$Border$rounded(4),
							$author$project$Ziege$UI$Colors$borderColor(23),
							$mdgriffith$elm_ui$Element$Font$bold
						]),
					{
						u: $mdgriffith$elm_ui$Element$text('Jetzt neu laden'),
						aA: $elm$core$Maybe$Just($author$project$Ziege$Model$ReloadApp)
					})
				]))
		]);
};
var $author$project$Ziege$Model$ClientCompletionLog = {$: 7};
var $author$project$Ziege$Model$ClientEditSettings = {$: 8};
var $author$project$Ziege$Model$ClientPerformanceView = {$: 6};
var $author$project$Main$allDoneToday = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5)
		]),
	A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(12),
				$mdgriffith$elm_ui$Element$padding(14),
				$author$project$Ziege$UI$Colors$bg(1),
				$mdgriffith$elm_ui$Element$Border$rounded(10)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$author$project$Ziege$UI$Colors$fg(10),
						$mdgriffith$elm_ui$Element$Font$size(24)
					]),
				A2($author$project$Ziege$UI$Icons$buildFaIcon, 1, 'star')),
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(2)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$Font$size(16)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Für heute ist alles erledigt.')
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(14),
								$author$project$Ziege$UI$Colors$fg(5)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Gut gemacht! Morgen geht es weiter.')
							]))
					]))
			])));
var $author$project$Main$buildCounsellorsGoneHint = function (gone) {
	if (!gone.$) {
		var names = gone.a;
		var who = function () {
			if (!names.b) {
				return 'Deine Beratung hat';
			} else {
				if (!names.b.b) {
					var one = names.a;
					return one + ' hat';
				} else {
					return A2($elm$core$String$join, ', ', names) + ' haben';
				}
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(8),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(10),
					$author$project$Ziege$UI$Colors$bg(9)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(15),
							$mdgriffith$elm_ui$Element$Font$bold
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(who + ' die Zusammenarbeit beendet.')
						])),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(14)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Deine Ziele bleiben, und du kannst sie weiter abhaken. Deine Fortschritte sieht aber niemand mehr, bis dich jemand neu einlädt.')
						]))
				]));
	} else {
		return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$Ziege$Model$ReinviteToRoom = F2(
	function (a, b) {
		return {$: 67, a: a, b: b};
	});
var $author$project$Main$buildMembershipHint = F2(
	function (client, membership) {
		var _v0 = A2($author$project$Main$membershipHint, client, membership);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var hint = _v1.a;
			var buttonLabel = _v1.b;
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding(10),
						$author$project$Ziege$UI$Colors$bg(9)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(14)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(hint)
							])),
						(buttonLabel === '') ? $mdgriffith$elm_ui$Element$none : A2(
						$author$project$Ziege$UI$Button$buildButton,
						buttonLabel,
						A2($author$project$Ziege$Model$ReinviteToRoom, client.i, client.m))
					]));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Main$compactGoal = F3(
	function (today, old, todo) {
		var done = (!old) && A3($author$project$Ziege$TodoInterval$isDone, today, todo.l, todo.q);
		var info = old ? ($author$project$Ziege$TodoInterval$renderIntervalString(todo.l) + (' · endete am ' + ($author$project$Ziege$Utils$renderCalendarDate(todo.L) + (' · ' + ($elm$core$String$fromInt(
			$elm$core$List$length(todo.q.cm)) + ' mal erledigt'))))) : ((done ? 'für diesen Zeitraum erledigt · ' : '') + ($author$project$Ziege$TodoInterval$renderIntervalString(todo.l) + (' · läuft bis ' + $author$project$Ziege$Utils$renderCalendarDate(todo.L))));
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 16, 8),
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$Font$size(14)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							done ? $author$project$Ziege$UI$Colors$fg(19) : $author$project$Ziege$UI$Colors$fg(6)
						]),
					$mdgriffith$elm_ui$Element$text(
						done ? '✓' : '○')),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(2)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$Font$bold]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(todo.j)
								])),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(12),
									$author$project$Ziege$UI$Colors$fg(5)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(info)
								]))
						]))
				]));
	});
var $author$project$Main$isOld = F2(
	function (today, todo) {
		return !A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, todo.L, today);
	});
var $author$project$Ziege$Model$ToggleOldGoals = {$: 5};
var $author$project$Main$oldGoalsToggle = F2(
	function (open, count) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$paddingEach(
					{X: 6, a$: 16, a4: 16, aS: 16}),
					$mdgriffith$elm_ui$Element$Font$size(14),
					$mdgriffith$elm_ui$Element$Font$underline,
					$author$project$Ziege$UI$Colors$fg(11)
				]),
			{
				u: $mdgriffith$elm_ui$Element$text(
					open ? 'Abgelaufene Ziele ausblenden' : ((count === 1) ? '1 abgelaufenes Ziel anzeigen' : ($elm$core$String$fromInt(count) + ' abgelaufene Ziele anzeigen'))),
				aA: $elm$core$Maybe$Just($author$project$Ziege$Model$ToggleOldGoals)
			});
	});
var $mdgriffith$elm_ui$Element$Keyed$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.gn + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bW)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Keyed(children));
	});
var $author$project$Ziege$Model$TodoDone = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Ziege$UI$Colors$insetOutline = F2(
	function (w, t) {
		return $mdgriffith$elm_ui$Element$htmlAttribute(
			A2(
				$elm$html$Html$Attributes$style,
				'box-shadow',
				'inset 0 0 0 ' + ($elm$core$String$fromInt(w) + ('px ' + $author$project$Ziege$UI$Colors$cssVar(t)))));
	});
var $author$project$Main$agreementStrip = F2(
	function (today, todo) {
		var unit = function () {
			var _v3 = todo.l;
			switch (_v3.$) {
				case 0:
					return 'Tag';
				case 1:
					return 'Woche';
				case 2:
					return 'Wochentag';
				case 3:
					return 'Wochenende';
				case 4:
					return 'Monat';
				default:
					return 'Zeitraum';
			}
		}();
		var needed = $author$project$Ziege$TodoInterval$timesToBeDone(todo.l);
		var segment = function (_v1) {
			var _v2 = _v1.a;
			var start = _v2.a;
			var end = _v2.b;
			var count = _v1.b;
			var fill_ = (_Utils_cmp(count, needed) > -1) ? 19 : ((count > 0) ? 20 : ((!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, end, today)) ? 6 : 8));
			var current = (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, today) !== 2) && (!(!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, end, today)));
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$author$project$Ziege$UI$Colors$bg(fill_)
						]),
					current ? _List_fromArray(
						[
							A2($author$project$Ziege$UI$Colors$insetOutline, 2, 19)
						]) : _List_Nil),
				$mdgriffith$elm_ui$Element$none);
		};
		var intervals = A3($author$project$Ziege$TodoInterval$agreementPeriods, todo.L, todo.l, todo.q);
		var total = $elm$core$List$length(intervals);
		var position = A2(
			$elm$core$Basics$min,
			total,
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var start = _v0.a;
						return A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, today) !== 2;
					},
					intervals)));
		var gap = (total > 150) ? 0 : ((total > 40) ? 1 : 2);
		return (total <= 1) ? $mdgriffith$elm_ui$Element$none : A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(5)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(10)),
							$mdgriffith$elm_ui$Element$spacing(gap),
							$mdgriffith$elm_ui$Element$Border$rounded(5),
							$mdgriffith$elm_ui$Element$clip
						]),
					A2(
						$elm$core$List$map,
						segment,
						A2($author$project$Ziege$TodoInterval$countDatesInInterval, intervals, todo.q.cm))),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(12),
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$author$project$Ziege$TodoInterval$renderIntervalString(todo.l) + (' · ' + (unit + (' ' + ($elm$core$String$fromInt(position) + (' von ' + ($elm$core$String$fromInt(total) + (' · bis ' + $author$project$Ziege$Utils$renderCalendarDate(todo.L)))))))))
						]))
				]));
	});
var $author$project$Ziege$Model$RequestWithdrawTodo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ziege$Model$WithdrawTodo = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$buildWithdrawPart = F2(
	function (withdrawal, todo) {
		if (!withdrawal.$) {
			var requested = withdrawal.a;
			return (!$elm$core$List$isEmpty(todo.q.cm)) ? $mdgriffith$elm_ui$Element$none : (_Utils_eq(
				requested,
				$elm$core$Maybe$Just(todo)) ? A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$padding(10),
						$mdgriffith$elm_ui$Element$Border$width(2),
						$mdgriffith$elm_ui$Element$Border$rounded(4),
						$author$project$Ziege$UI$Colors$borderColor(12),
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$bold]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Ziel „' + (todo.j + '“ zurücknehmen?'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_Nil,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Es verschwindet bei dir und bei der Klient*in. Das richtige Ziel legst du danach neu an.')
							])),
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ziege$UI$Button$buildWideButton,
								'Abbrechen',
								$author$project$Ziege$Model$RequestWithdrawTodo($elm$core$Maybe$Nothing)),
								A2(
								$author$project$Ziege$UI$Button$buildDangerButton,
								'Ja, zurücknehmen',
								$author$project$Ziege$Model$WithdrawTodo(todo))
							]))
					])) : A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$alignRight,
						$mdgriffith$elm_ui$Element$Font$size(13),
						$mdgriffith$elm_ui$Element$Font$underline,
						$author$project$Ziege$UI$Colors$fg(11)
					]),
				{
					u: $mdgriffith$elm_ui$Element$text('Zurücknehmen'),
					aA: $elm$core$Maybe$Just(
						$author$project$Ziege$Model$RequestWithdrawTodo(
							$elm$core$Maybe$Just(todo)))
				}));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$Ziege$TodoInterval$currentCompletionStatus = F3(
	function (today, interval, history) {
		return _Utils_Tuple2(
			$elm$core$List$length(
				A3($author$project$Ziege$TodoInterval$currentCompletions, today, interval, history)),
			$author$project$Ziege$TodoInterval$timesToBeDone(interval));
	});
var $author$project$Main$iconCheckbox = function (checked) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size(24),
				checked ? $author$project$Ziege$UI$Colors$fg(19) : $author$project$Ziege$UI$Colors$fg(5)
			]),
		A2(
			$author$project$Ziege$UI$Icons$buildFaIcon,
			0,
			checked ? 'square-check' : 'square'));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Main$renderCups = F3(
	function (today, interval, completionHistory) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{a$: 5}))
				]),
			function () {
				var _v0 = A3($author$project$Ziege$TodoInterval$currentCompletionStatus, today, interval, completionHistory);
				if (_v0.b === 1) {
					return _List_Nil;
				} else {
					var doneCount = _v0.a;
					var neededCount = _v0.b;
					return _Utils_ap(
						A2(
							$elm$core$List$repeat,
							doneCount,
							A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$color(
										A3($mdgriffith$elm_ui$Element$rgb, 1.0, 0.84, 0))
									]),
								A2($author$project$Ziege$UI$Icons$buildFaIcon, 1, 'trophy-star'))),
						A2(
							$elm$core$List$repeat,
							neededCount - doneCount,
							A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$author$project$Ziege$UI$Colors$fg(8)
									]),
								A2($author$project$Ziege$UI$Icons$buildFaIcon, 1, 'trophy-star'))));
				}
			}());
	});
var $author$project$Ziege$TodoInterval$renderDueString = F3(
	function (today, interval, history) {
		var left = $author$project$Ziege$TodoInterval$timesToBeDone(interval) - $elm$core$List$length(
			A3($author$project$Ziege$TodoInterval$currentCompletions, today, interval, history));
		var times = function (until) {
			return ($author$project$Ziege$TodoInterval$timesToBeDone(interval) <= 1) ? until : ('noch ' + ($elm$core$String$fromInt(left) + (' mal ' + until)));
		};
		var _v0 = _Utils_Tuple2(
			interval,
			A3($author$project$Ziege$TodoInterval$currentDueInterval, interval, history, today));
		_v0$0:
		while (true) {
			if (!_v0.b.$) {
				if (_v0.a.$ === 5) {
					break _v0$0;
				} else {
					var _v1 = _v0.b.a;
					var last = _v1.b;
					return (A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, last, today) === 1) ? times('heute') : times(
						'bis ' + $author$project$Ziege$Utils$renderCalendarDate(last));
				}
			} else {
				switch (_v0.a.$) {
					case 5:
						break _v0$0;
					case 3:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 'am Wochenende';
					case 2:
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return 'am nächsten Wochentag';
					default:
						var _v6 = _v0.b;
						return '';
				}
			}
		}
		return ($author$project$Ziege$TodoInterval$timesToBeDone(interval) <= 1) ? 'irgendwann' : ('noch ' + ($elm$core$String$fromInt(left) + ' mal'));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Main$renderTodo = F4(
	function (today, withdrawal, id, todo) {
		var due = A3($author$project$Ziege$TodoInterval$isDue, today, todo.l, todo.q);
		var done = A3($author$project$Ziege$TodoInterval$isDone, today, todo.l, todo.q);
		var status = done ? A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$author$project$Ziege$UI$Colors$fg(19),
					$mdgriffith$elm_ui$Element$Font$bold
				]),
			$mdgriffith$elm_ui$Element$text('✓ erledigt')) : A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$author$project$Ziege$UI$Colors$fg(5)
				]),
			$mdgriffith$elm_ui$Element$text(
				A3($author$project$Ziege$TodoInterval$renderDueString, today, todo.l, todo.q)));
		var counsellorView = !_Utils_eq(withdrawal, $elm$core$Maybe$Nothing);
		var progressMuting = counsellorView ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'muted', '')
			]) : _List_Nil;
		var _v0 = A3($author$project$Ziege$TodoInterval$currentCompletionStatus, today, todo.l, todo.q);
		var doneCount = _v0.a;
		var neededCount = _v0.b;
		return (done || due) ? A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5)
				]),
			A2(
				$mdgriffith$elm_ui$Element$row,
				_Utils_ap(
					$author$project$Ziege$UI$Utils$cardStyle,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(12),
							$mdgriffith$elm_ui$Element$paddingEach(
							{X: 12, a$: 12, a4: 22, aS: 12})
						])),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignTop]),
						counsellorView ? A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(24),
									$author$project$Ziege$UI$Colors$fg(6),
									$mdgriffith$elm_ui$Element$htmlAttribute(
									$elm$html$Html$Attributes$title('Abhaken kann nur die Klient*in'))
								]),
							A2(
								$author$project$Ziege$UI$Icons$buildFaIcon,
								0,
								done ? 'square-check' : 'square')) : A2(
							$mdgriffith$elm_ui$Element$Input$checkbox,
							_List_Nil,
							{
								bV: done,
								b$: $author$project$Main$iconCheckbox,
								u: $mdgriffith$elm_ui$Element$Input$labelHidden('Erledigt?'),
								an: A2($author$project$Ziege$Model$TodoDone, id, todo.bA)
							})),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(6)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$bold,
										$mdgriffith$elm_ui$Element$Font$size(16)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(todo.j),
										A3($author$project$Main$renderCups, today, todo.l, todo.q)
									])),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$size(12)
									]),
								status),
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$size(14),
										$author$project$Ziege$UI$Colors$fg(5)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(todo.K)
									])),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										A2($mdgriffith$elm_ui$Element$paddingXY, 0, 2)
									]),
								$mdgriffith$elm_ui$Element$html(
									A3(
										$elm$html$Html$node,
										'ziege-progress',
										_Utils_ap(
											progressMuting,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$Attributes$attribute,
													'max',
													$elm$core$String$fromInt(neededCount)),
													A2(
													$elm$html$Html$Attributes$attribute,
													'value',
													$elm$core$String$fromInt(doneCount))
												])),
										_List_Nil))),
								A2($author$project$Main$agreementStrip, today, todo),
								A2($author$project$Main$buildWithdrawPart, withdrawal, todo)
							]))
					]))) : $mdgriffith$elm_ui$Element$none;
	});
var $author$project$Main$renderTodos = F4(
	function (today, withdrawal, id, todos) {
		return A2(
			$mdgriffith$elm_ui$Element$Keyed$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			A2(
				$elm$core$List$map,
				function (todo) {
					return _Utils_Tuple2(
						todo.bA,
						A4($author$project$Main$renderTodo, today, withdrawal, id, todo));
				},
				todos));
	});
var $author$project$Main$renderClient = F7(
	function (today, mode, membership, gone, withdrawal, options, _v0) {
		var name = _v0.a;
		var client = _v0.b;
		var todayItems = A2(
			$elm$core$List$filter,
			$author$project$Main$todayTodo(today),
			client.v);
		var oldItems = A2(
			$elm$core$List$filter,
			$author$project$Main$isOld(today),
			client.v);
		var noGoals = $elm$core$List$isEmpty(client.v);
		var laterItems = A2(
			$elm$core$List$filter,
			function (t) {
				return (!A2($author$project$Main$isOld, today, t)) && (!A2($author$project$Main$todayTodo, today, t));
			},
			client.v);
		var doneToday = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$author$project$Main$isDoneTodayToDo(today),
				todayItems));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(2),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{X: 20}))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						(mode === 1) ? A2($author$project$Main$buildMembershipHint, client, membership) : $author$project$Main$buildCounsellorsGoneHint(gone),
						A2(
						$author$project$Main$buildHelp,
						mode,
						!_Utils_eq(options.bg, noGoals))
					]),
				_Utils_ap(
					noGoals ? _List_fromArray(
						[
							$author$project$Ziege$UI$Utils$quietNote(
							(mode === 1) ? 'Noch keine Ziele. Das erste legst du unten mit „Neues Ziel anlegen“ an.' : 'Noch keine Ziele. Deine Beratung legt sie gemeinsam mit dir an, dann erscheinen sie hier.')
						]) : A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ziege$UI$Utils$sectionHeader,
							'Heute',
							$elm$core$List$isEmpty(todayItems) ? '' : ($elm$core$String$fromInt(doneToday) + (' von ' + ($elm$core$String$fromInt(
								$elm$core$List$length(todayItems)) + ' erledigt')))),
						_Utils_ap(
							$elm$core$List$isEmpty(todayItems) ? _List_fromArray(
								[
									$author$project$Ziege$UI$Utils$quietNote('Heute steht nichts an.')
								]) : _List_fromArray(
								[
									((!mode) && _Utils_eq(
									doneToday,
									$elm$core$List$length(todayItems))) ? $author$project$Main$allDoneToday : $mdgriffith$elm_ui$Element$none,
									A4($author$project$Main$renderTodos, today, withdrawal, name, todayItems)
								]),
							_Utils_ap(
								$elm$core$List$isEmpty(laterItems) ? _List_Nil : A2(
									$elm$core$List$cons,
									A2($author$project$Ziege$UI$Utils$sectionHeader, 'Später', ''),
									A2(
										$elm$core$List$map,
										A2($author$project$Main$compactGoal, today, false),
										laterItems)),
								$elm$core$List$isEmpty(oldItems) ? _List_Nil : A2(
									$elm$core$List$cons,
									A2(
										$author$project$Main$oldGoalsToggle,
										options.dE,
										$elm$core$List$length(oldItems)),
									options.dE ? A2(
										$elm$core$List$map,
										A2($author$project$Main$compactGoal, today, true),
										oldItems) : _List_Nil)))),
					_List_fromArray(
						[
							(mode === 1) ? $author$project$Ziege$UI$Utils$actionPanel(
							_List_fromArray(
								[
									A2(
									$author$project$Ziege$UI$Button$buildWideButton,
									'Neues Ziel anlegen',
									$author$project$Ziege$Model$SwitchView(
										$author$project$Ziege$Model$PatternSelectorView($elm$core$Set$empty))),
									A2(
									$author$project$Ziege$UI$Button$buildWideButton,
									'Performance-Bericht',
									$author$project$Ziege$Model$SwitchView($author$project$Ziege$Model$ClientPerformanceView)),
									A2(
									$author$project$Ziege$UI$Button$buildWideButton,
									'Verlauf',
									$author$project$Ziege$Model$SwitchView($author$project$Ziege$Model$ClientCompletionLog)),
									A2(
									$author$project$Ziege$UI$Button$buildWideButton,
									'Klienteneinstellungen',
									$author$project$Ziege$Model$SwitchView($author$project$Ziege$Model$ClientEditSettings))
								])) : $mdgriffith$elm_ui$Element$none
						]))));
	});
var $author$project$Main$activeTodos = F2(
	function (today, todos) {
		return A2(
			$elm$core$List$filter,
			function (t) {
				return !(!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, t.L, today));
			},
			todos);
	});
var $author$project$Main$renderIntervalPerformances = F3(
	function (today, todo, periods) {
		var renderPerformanceItem = function (_v1) {
			var _v2 = _v1.a;
			var start = _v2.a;
			var ende = _v2.b;
			var count = _v1.b;
			var needed = $author$project$Ziege$TodoInterval$timesToBeDone(todo.l);
			var marker = (_Utils_cmp(count, needed) > -1) ? _List_fromArray(
				[
					$author$project$Ziege$UI$Colors$bg(19)
				]) : ((count > 0) ? _List_fromArray(
				[
					$author$project$Ziege$UI$Colors$bg(20)
				]) : ((!A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, ende, today)) ? _List_fromArray(
				[
					$author$project$Ziege$UI$Colors$bg(6)
				]) : _List_fromArray(
				[
					A2($author$project$Ziege$UI$Colors$insetOutline, 2, 19)
				])));
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(8),
						$mdgriffith$elm_ui$Element$Font$size(13)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(12)),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(12)),
									$mdgriffith$elm_ui$Element$Border$rounded(3),
									$mdgriffith$elm_ui$Element$centerY
								]),
							marker),
						$mdgriffith$elm_ui$Element$none),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								(A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, ende) === 1) ? $author$project$Ziege$Utils$renderCalendarDate(start) : ($author$project$Ziege$Utils$renderCalendarDate(start) + (' – ' + $author$project$Ziege$Utils$renderCalendarDate(ende))))
							])),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$alignRight]),
						A3($author$project$Main$renderCups, ende, todo.l, todo.q))
					]));
		};
		var begun = A2(
			$elm$core$List$filter,
			function (_v0) {
				var start = _v0.a;
				return A2($PanagiotisGeorgiadis$elm_datetime$Calendar$compare, start, today) !== 2;
			},
			periods);
		return A2(
			$elm$core$List$map,
			renderPerformanceItem,
			$elm$core$List$reverse(
				A2($author$project$Ziege$TodoInterval$countDatesInInterval, begun, todo.q.cm)));
	});
var $author$project$Main$renderTodoPerformance = F2(
	function (today, todo) {
		var periods = A3($author$project$Ziege$TodoInterval$agreementPeriods, todo.L, todo.l, todo.q);
		var done = A3($author$project$Ziege$TodoInterval$isDone, today, todo.l, todo.q);
		return $author$project$Ziege$UI$Utils$card(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(4)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$bold,
									$mdgriffith$elm_ui$Element$Font$size(16)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(todo.j)
								])),
							done ? A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(12),
									$author$project$Ziege$UI$Colors$fg(19),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							$mdgriffith$elm_ui$Element$text('✓ erledigt')) : A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(12),
									$author$project$Ziege$UI$Colors$fg(5)
								]),
							$mdgriffith$elm_ui$Element$text(
								'zu erledigen: ' + A3($author$project$Ziege$TodoInterval$renderDueString, today, todo.l, todo.q)))
						])),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(todo.K)
						])),
					($elm$core$List$length(periods) > 1) ? A2($author$project$Main$agreementStrip, today, todo) : A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(12),
							$author$project$Ziege$UI$Colors$fg(5)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							$author$project$Ziege$TodoInterval$renderIntervalString(todo.l) + (' · bis ' + $author$project$Ziege$Utils$renderCalendarDate(todo.L)))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$spacing(2)
						]),
					A3($author$project$Main$renderIntervalPerformances, today, todo, periods))
				]));
	});
var $author$project$Main$renderClientPerformanceView = function (model) {
	var today = model.af;
	var _v0 = $author$project$Main$getActiveClient(model);
	if (_v0.$ === 1) {
		return $author$project$Ziege$UI$Utils$quietNote('Keine Klient*in ausgewählt.');
	} else {
		var client = _v0.a;
		var todos = A2($author$project$Main$activeTodos, today, client.v);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{X: 10}))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ziege$UI$Utils$sectionHeader,
					'Laufende Ziele',
					$elm$core$String$fromInt(
						$elm$core$List$length(todos))),
				$elm$core$List$isEmpty(todos) ? _List_fromArray(
					[
						$author$project$Ziege$UI$Utils$quietNote('Zurzeit läuft keine Zielvereinbarung.')
					]) : A2(
					$elm$core$List$map,
					$author$project$Main$renderTodoPerformance(today),
					todos)));
	}
};
var $author$project$Ziege$UI$Footer$reserveBottomSpace = function (withFooter) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Attributes$style,
			'padding-bottom',
			$author$project$Ziege$UI$Footer$plusBottomInset(
				withFooter ? $author$project$Ziege$Config$footerHeight : 8)));
};
var $author$project$Ziege$Model$AnswerRoomInvite = F2(
	function (a, b) {
		return {$: 65, a: a, b: b};
	});
var $author$project$Ziege$UI$RoomInvites$buildRoomInvitePanel = F4(
	function (currentPartners, carryOver, otherInvites, invite) {
		var who = _Utils_eq(invite.hh, invite.hg) ? invite.hg : (invite.hh + (' (' + (invite.hg + ')')));
		var otherInvitesNote = (otherInvites === 1) ? _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Es liegt noch eine weitere Einladung vor. Nimmst du diese hier an, wird die andere abgelehnt.')
					]))
			]) : ((otherInvites > 1) ? _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$size(14)
					]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text(
						'Es liegen noch ' + ($elm$core$String$fromInt(otherInvites) + ' weitere Einladungen vor. Nimmst du diese hier an, werden die anderen abgelehnt.'))
					]))
			]) : _List_Nil);
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$author$project$Ziege$UI$Colors$bg(17),
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 0)
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$width(
						A2($mdgriffith$elm_ui$Element$maximum, 380, $mdgriffith$elm_ui$Element$fill)),
						$author$project$Ziege$UI$Colors$bg(0),
						$mdgriffith$elm_ui$Element$padding(15),
						$mdgriffith$elm_ui$Element$spacing(15),
						$mdgriffith$elm_ui$Element$Border$rounded(10),
						$author$project$Ziege$UI$Colors$borderColor(11),
						$mdgriffith$elm_ui$Element$Border$shadow(
						{
							f2: 5.0,
							gm: A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.25),
							hK: _Utils_Tuple2(0, 1),
							il: 2.0
						})
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(20),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							$mdgriffith$elm_ui$Element$text('Zusammenarbeit')),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_Nil,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(who + ' möchte in Ziege mit dir zusammenarbeiten.')
								]))
						]),
					function () {
						if (!currentPartners.$) {
							var partners = currentPartners.a;
							var bisher = $elm$core$List$isEmpty(partners) ? 'deiner bisherigen Beratung' : A2($elm$core$String$join, ', ', partners);
							return _Utils_ap(
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$spacing(10),
												$mdgriffith$elm_ui$Element$padding(10),
												$mdgriffith$elm_ui$Element$Border$width(2),
												$mdgriffith$elm_ui$Element$Border$rounded(4),
												$author$project$Ziege$UI$Colors$borderColor(12)
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$paragraph,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$Font$bold]),
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('Du arbeitest schon mit ' + (bisher + ' zusammen.'))
													])),
												A2(
												$mdgriffith$elm_ui$Element$paragraph,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$Font$size(15)
													]),
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('Nimmst du an, endet diese Zusammenarbeit: Deine bisherigen Ziele verschwinden aus der App. Ziege arbeitet immer nur mit einer Beratung zusammen. ' + (bisher + ' kann dich später wieder einladen.'))
													]))
											]))
									]),
								_Utils_ap(
									otherInvitesNote,
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$row,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$spacing(10)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ziege$UI$Button$buildWideButton,
													'Ablehnen',
													A2($author$project$Ziege$Model$AnswerRoomInvite, invite.i, false)),
													A2(
													$author$project$Ziege$UI$Button$buildDangerButton,
													'Wechseln',
													A2($author$project$Ziege$Model$AnswerRoomInvite, invite.i, true))
												]))
										])));
						} else {
							return A2(
								$elm$core$List$cons,
								A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Wenn du annimmst, tauscht Ziege mit dieser Person Ziele und Fortschritte aus.')
										])),
								_Utils_ap(
									carryOver ? _List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$paragraph,
											_List_Nil,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$text('Deine bisherigen Ziele und dein Verlauf werden dabei übernommen.')
												]))
										]) : _List_Nil,
									_Utils_ap(
										otherInvitesNote,
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$spacing(10)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ziege$UI$Button$buildWideButton,
														'Ablehnen',
														A2($author$project$Ziege$Model$AnswerRoomInvite, invite.i, false)),
														A2(
														$author$project$Ziege$UI$Button$buildWideButton,
														'Zusammenarbeiten',
														A2($author$project$Ziege$Model$AnswerRoomInvite, invite.i, true))
													]))
											]))));
						}
					}())));
	});
var $author$project$Main$roomInviteAttribs = function (model) {
	var _v0 = model.bp;
	if (_v0.b) {
		var invite = _v0.a;
		var others = _v0.b;
		var otherInvites = (!model.g) ? $elm$core$List$length(others) : 0;
		var currentRoom = $author$project$Main$ownClientRoom(model);
		var carryOver = (!model.g) && A2($author$project$Main$invitedByFormerPartner, model, invite);
		var currentPartners = ((!model.g) && ((!$elm$core$String$isEmpty(currentRoom)) && ((!_Utils_eq(currentRoom, invite.i)) && (_Utils_eq(
			$author$project$Main$counsellorsGone(model),
			$elm$core$Maybe$Nothing) && (!carryOver))))) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.I;
				},
				A2(
					$elm$core$List$filter,
					function (m) {
						return m.bj === 'join';
					},
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, currentRoom, model.aQ))))) : $elm$core$Maybe$Nothing;
		return _List_fromArray(
			[
				$mdgriffith$elm_ui$Element$inFront(
				A4($author$project$Ziege$UI$RoomInvites$buildRoomInvitePanel, currentPartners, carryOver, otherInvites, invite))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Main$buildLayout = function (model) {
	var today = model.af;
	var timeTravelAvailable = function () {
		var _v23 = model.N;
		if (_v23.$ === 2) {
			var p = _v23.a;
			return A2($author$project$Ziege$Pattern$hasFeature, 0, p);
		} else {
			return false;
		}
	}();
	var theLeftElement = function () {
		if (!$elm$core$String$isEmpty(model.al)) {
			return $author$project$Ziege$UI$Header$Icon(model.al);
		} else {
			var _v22 = model.N;
			if (_v22.$ === 2) {
				var p = _v22.a;
				return $elm$core$String$isEmpty(
					$author$project$Ziege$Pattern$getLogo(p)) ? $author$project$Ziege$UI$Header$Empty : $author$project$Ziege$UI$Header$Icon(
					$author$project$Ziege$Pattern$getLogo(p));
			} else {
				return $author$project$Ziege$UI$Header$Empty;
			}
		}
	}();
	var oneLevelUp = $author$project$Ziege$UI$Header$BackButton(
		$author$project$Ziege$Model$NavigateBackTo(
			$author$project$Main$pageDepth(model) - 1));
	var footer = timeTravelAvailable ? _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$inFront(
			A3($author$project$Ziege$UI$Footer$buildFooter, model.cR, model.bM, !model.bL))
		]) : _List_Nil;
	var defaultHeaderConfig = {
		a0: theLeftElement,
		h1: $author$project$Ziege$UI$Header$GoatButton($author$project$Ziege$Model$ToggleGoatMode),
		bq: '',
		j: ''
	};
	var clientHeadName = function (c) {
		var fname = $author$project$Ziege$Model$describeClient(c);
		var _v21 = c.b7;
		if (_v21 === '') {
			return fname;
		} else {
			return c.b7 + (' (' + (fname + ')'));
		}
	};
	var activeClientHeaderName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			clientHeadName,
			$author$project$Main$getActiveClient(model)));
	var headerConfig = function () {
		var _v9 = _Utils_Tuple2(model.f, model.g);
		_v9$8:
		while (true) {
			switch (_v9.a.$) {
				case 6:
					if (_v9.b === 1) {
						var _v12 = _v9.a;
						var _v13 = _v9.b;
						return _Utils_update(
							defaultHeaderConfig,
							{a0: oneLevelUp, bq: activeClientHeaderName, j: 'Performance-Bericht'});
					} else {
						break _v9$8;
					}
				case 0:
					switch (_v9.b) {
						case 1:
							var _v10 = _v9.a;
							var _v11 = _v9.b;
							return _Utils_update(
								defaultHeaderConfig,
								{a0: oneLevelUp, bq: activeClientHeaderName, j: 'Ziele'});
						case 0:
							var _v14 = _v9.a;
							var _v15 = _v9.b;
							var aktive_ziele = function (x) {
								return _Utils_ap(
									$elm$core$String$fromInt(x),
									function () {
										if (x === 1) {
											return ' aktives Ziel';
										} else {
											return ' aktive Ziele';
										}
									}());
							};
							var _v16 = $author$project$Main$getActiveClient(model);
							if (_v16.$ === 1) {
								return _Utils_update(
									defaultHeaderConfig,
									{
										j: aktive_ziele(0)
									});
							} else {
								var client = _v16.a;
								return _Utils_update(
									defaultHeaderConfig,
									{
										j: aktive_ziele(
											$elm$core$List$length(
												A2($author$project$Main$todayTodos, today, client)))
									});
							}
						default:
							break _v9$8;
					}
				case 5:
					var pendingtodo = _v9.a.a;
					return _Utils_update(
						defaultHeaderConfig,
						{
							a0: A2(
								$author$project$Ziege$UI$Header$CancelButton,
								'Abbrechen',
								$author$project$Ziege$Model$NavigateBackTo(1)),
							bq: activeClientHeaderName,
							j: _Utils_eq(pendingtodo.ao, $elm$core$Maybe$Nothing) ? 'Ziel erstellen' : 'Ziel anpassen'
						});
				case 3:
					return _Utils_update(
						defaultHeaderConfig,
						{a0: oneLevelUp, bq: activeClientHeaderName, j: 'Ziel wählen'});
				case 2:
					var _v18 = _v9.a;
					return _Utils_update(
						defaultHeaderConfig,
						{a0: oneLevelUp, j: 'Klient*in hinzufügen'});
				case 7:
					var _v19 = _v9.a;
					return _Utils_update(
						defaultHeaderConfig,
						{a0: oneLevelUp, bq: activeClientHeaderName, j: 'Verlauf'});
				case 8:
					var _v20 = _v9.a;
					return _Utils_update(
						defaultHeaderConfig,
						{a0: oneLevelUp, bq: activeClientHeaderName, j: 'Klienteneinstellungen'});
				default:
					break _v9$8;
			}
		}
		return defaultHeaderConfig;
	}();
	return A2(
		$mdgriffith$elm_ui$Element$layout,
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ziege$UI$Colors$bg(0),
					$author$project$Ziege$UI$Colors$fg(3),
					$mdgriffith$elm_ui$Element$inFront(
					$author$project$Ziege$UI$Header$buildHeader(headerConfig))
				]),
			_Utils_ap(
				footer,
				_Utils_ap(
					$author$project$Main$extraLayoutAttribs(model),
					_Utils_ap(
						$author$project$Main$roomInviteAttribs(model),
						$author$project$Main$cryptoPanelAttribs(model))))),
		A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$width(
					A2($mdgriffith$elm_ui$Element$maximum, $author$project$Ziege$Config$maxWidth, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$paddingEach(
					_Utils_update(
						$author$project$Ziege$UI$Utils$edges,
						{aS: $author$project$Ziege$Config$headerHeight})),
					$author$project$Ziege$UI$Footer$reserveBottomSpace(timeTravelAvailable)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(8),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					_Utils_ap(
						$author$project$Ziege$UI$CryptoPanel$buildCryptoBanner(model.aM),
						_Utils_ap(
							$author$project$Main$outdatedBanner(model),
							_Utils_ap(
								$author$project$Main$notificationBanner(model),
								_Utils_ap(
									$author$project$Main$buildMatrixError(model.bC),
									_Utils_ap(
										A3($author$project$Ziege$UI$CryptoPanel$buildDecryptionProblems, model.n, model.aM.bn, model.c3),
										_List_fromArray(
											[
												function () {
												var _v0 = _Utils_Tuple2(
													model.f,
													$author$project$Main$getActiveClient(model));
												_v0$9:
												while (true) {
													switch (_v0.a.$) {
														case 1:
															if (_v0.b.$ === 1) {
																var _v1 = _v0.a;
																var _v2 = _v0.b;
																return $author$project$Main$buildStartView(model);
															} else {
																break _v0$9;
															}
														case 2:
															var _v3 = _v0.a;
															return $author$project$Main$buildAddClientView(model);
														case 0:
															if (!_v0.b.$) {
																var _v4 = _v0.a;
																var client = _v0.b.a;
																return A7(
																	$author$project$Main$renderClient,
																	today,
																	model.g,
																	A2($author$project$Main$clientMembership, model.aQ, client),
																	$author$project$Main$counsellorsGone(model),
																	(model.g === 1) ? $elm$core$Maybe$Just(model.cf) : $elm$core$Maybe$Nothing,
																	{bg: model.bg, dE: model.cO},
																	_Utils_Tuple2(model.O, client));
															} else {
																break _v0$9;
															}
														case 6:
															if (!_v0.b.$) {
																var _v5 = _v0.a;
																return $author$project$Main$renderClientPerformanceView(model);
															} else {
																break _v0$9;
															}
														case 4:
															var _v6 = _v0.a;
															var error = _v6.a;
															var canReset = _v6.b;
															return A2($author$project$Ziege$UI$ErrorView$buildErrorView, error, canReset);
														case 3:
															if (!_v0.b.$) {
																var openCategories = _v0.a.a;
																return A2($author$project$Main$buildSelectorView, model, openCategories);
															} else {
																break _v0$9;
															}
														case 5:
															var pendingTodo = _v0.a.a;
															return A2($author$project$Main$buildEditorView, today, pendingTodo);
														case 7:
															if (!_v0.b.$) {
																var _v7 = _v0.a;
																var client = _v0.b.a;
																return A2($author$project$Ziege$UI$ClientCompletionLog$buildClientCompletionLog, model, client);
															} else {
																break _v0$9;
															}
														default:
															if (!_v0.b.$) {
																var _v8 = _v0.a;
																var client = _v0.b.a;
																return A2(
																	$mdgriffith$elm_ui$Element$column,
																	_List_fromArray(
																		[
																			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
																			$mdgriffith$elm_ui$Element$paddingEach(
																			_Utils_update(
																				$author$project$Ziege$UI$Utils$edges,
																				{X: 10}))
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$mdgriffith$elm_ui$Element$map,
																			$author$project$Ziege$Model$ClientEditNamesMsg(client),
																			A2($author$project$Ziege$UI$ClientEditSettings$buildClientEditNames, model.n, client)),
																			A2($author$project$Ziege$UI$Utils$sectionHeader, 'Technisches', ''),
																			$author$project$Ziege$UI$Utils$card(
																			_List_fromArray(
																				[
																					A2(
																					$mdgriffith$elm_ui$Element$map,
																					$author$project$Ziege$Model$ClientEditNamesMsg(client),
																					$author$project$Ziege$UI$ClientEditSettings$buildRoomIdLink(client)),
																					A4(
																					$author$project$Ziege$UI$DeviceList$buildDeviceList,
																					'Apps der Klient*in',
																					client.m,
																					'',
																					A2($elm$core$Dict$get, client.m, model.aN))
																				])),
																			$elm$core$List$isEmpty(
																			A2($author$project$Main$debugTools, model, client)) ? $mdgriffith$elm_ui$Element$none : A2(
																			$mdgriffith$elm_ui$Element$column,
																			_List_fromArray(
																				[
																					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
																				]),
																			_List_fromArray(
																				[
																					A2($author$project$Ziege$UI$Utils$sectionHeader, 'Fehlersuche', ''),
																					$author$project$Ziege$UI$Utils$card(
																					A2($author$project$Main$debugTools, model, client))
																				]))
																		]));
															} else {
																break _v0$9;
															}
													}
												}
												return $author$project$Main$buildStartView(model);
											}()
											])))))))
				])));
};
var $author$project$Main$buildSplash = function (model) {
	var status = function () {
		var _v0 = model.N;
		if (_v0.$ === 3) {
			var error = _v0.a;
			return _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$center,
							$author$project$Ziege$UI$Colors$fg(14)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Der Ziege-Server antwortet nicht (' + (error + '). Ohne ihn weiß Ziege noch nicht, ob dieses Konto einer Berater*in oder einer Klient*in gehört.'))
						])),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					A2($author$project$Ziege$UI$Button$buildButton, 'Erneut versuchen', $author$project$Ziege$Model$ResetPatternlist))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$mdgriffith$elm_ui$Element$text('Rolle wird abgefragt …'))
				]);
		}
	}();
	return A2(
		$mdgriffith$elm_ui$Element$layout,
		_List_fromArray(
			[
				$author$project$Ziege$UI$Colors$bg(0),
				$author$project$Ziege$UI$Colors$fg(3)
			]),
		A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$width(
					A2($mdgriffith$elm_ui$Element$maximum, 400, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$paddingEach(
					{X: 16, a$: 16, a4: 16, aS: 48}),
					$mdgriffith$elm_ui$Element$spacing(16)
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$image,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(96)),
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(96))
							]),
						{gy: '', iq: 'static/appicon.png'}),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$spacing(4)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$centerX,
										$mdgriffith$elm_ui$Element$Font$size(32)
									]),
								$mdgriffith$elm_ui$Element$text('ZieGE')),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$centerX,
										$mdgriffith$elm_ui$Element$Font$size(14)
									]),
								$mdgriffith$elm_ui$Element$text('Ziele Gemeinsam Erreichen'))
							])),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(16))
							]),
						$mdgriffith$elm_ui$Element$none)
					]),
				_Utils_ap(
					status,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$center,
									$mdgriffith$elm_ui$Element$Font$size(14),
									$author$project$Ziege$UI$Colors$fg(3)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(model.n + (' · Geräte-ID ' + model.cG))
								])),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$paddingEach(
									{X: 0, a$: 0, a4: 0, aS: 32}),
									$mdgriffith$elm_ui$Element$Font$size(13),
									$author$project$Ziege$UI$Colors$fg(5)
								]),
							$mdgriffith$elm_ui$Element$text('Version ' + (model.aI + (' · Build ' + $author$project$BuildInfo$gitHash))))
						])))));
};
var $author$project$Main$view = function (model) {
	return A2(
		$elm$browser$Browser$Document,
		'Ziege',
		_List_fromArray(
			[
				function () {
				var _v0 = model.g;
				switch (_v0) {
					case 0:
						return $author$project$Main$buildLayout(model);
					case 1:
						return $author$project$Main$buildLayout(model);
					default:
						var _v1 = model.f;
						if (_v1.$ === 4) {
							return $author$project$Main$buildLayout(model);
						} else {
							return $author$project$Main$buildSplash(model);
						}
				}
			}()
			]));
};
var $author$project$Main$main = $elm$browser$Browser$document(
	{g6: $author$project$Main$init, iz: $author$project$Main$subscriptions, i6: $author$project$Main$updateWithHistory, jb: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));